import React from 'react';
import $ from 'jquery';
import { getTeamId, getUserId } from '../utils/common_utils'
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faCheck, faExclamationTriangle, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './react-autosuggest.css';
import { Modal, Form, InputGroup } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Image from '../components/image';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import RcTooltip from 'rc-tooltip';
import moment from 'moment';
import Slider from 'react-rangeslider';
import Popover from 'react-bootstrap/Popover';
import { pipelineDetailsDatasetInfo, pipelineDetailsStagesInfo,/* pipelineTroubleShootStagesInfo, */getPipeline, getPipelineIntegration, getPipelineJobInfo, getLineageData, getPipelineMetadata, saveWatchList, deleteWatchList, getWatchList, updateWatchList, getEditWatchList, pipelineRunInfo, pipelineStagesInfo, getWebSocketUrl } from '../utils/realtimeEventHandle'
import { PIPELINE_DISPLAY_DATE_FORMAT } from "../utils/constant";
import { getApi } from "../utils/event_handling";
import QualdoDataTable from '../components/bootstrapTable';
import GanttChart from './pipelineGanttChart';
import PipelineLineage from '../monitor/components/pipelineLineage';
// import PipelineLineageErr from './pipelineLineageErrTroubleShoot';
import Load from '../components/loadAction';
import PipelineLeftPanel from './pipelineLeftPanel';
import { Toast } from 'react-bootstrap';
import { faCheckCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import AdvancedSearch from './pipeplineAdvancedSearch';
import _ from 'lodash';
import StackedBarChart from "./stackedBar";
import NoModelComponent from './noDataComponent';
import DateRangePicker from "react-bootstrap-daterangepicker";
import * as ReactDOM from 'react-dom';
import ProgressStatus from "../components/progressStatus"
import { io } from "socket.io-client";
import { ui_service_ip } from "../utils/ip_details";
// import { timeHours } from 'd3';
let timeslothrs = [];
let timeslotmin = [];
let run_info = null;  // Initialize as null, scoped to entire method

// const InfoLog = ({ data }) => {
//   return (
//     <div
//       style={{
//         backgroundColor: "#1E1E1E",
//         color: "#DCDCDC",
//         padding: "1rem",
//         borderRadius: "8px",
//         fontFamily: "monospace",
//         fontSize: "0.9rem",
//         whiteSpace: "pre-wrap",
//         overflowX: "auto",
//         lineHeight: "1.5"
//       }}
//     >
//       {JSON.stringify(data, null, 2)}
//     </div>
//   );
// };
// export default InfoLog;
export default class Pipeline extends React.Component {
  constructor(props, context) {
    super(props, context);

    let inidate = moment().utc();
    let startDate = moment().utc();
    let endDate = inidate;

    if (props.selectedDate) {
      const selectedDate = moment(props.selectedDate);
      if (inidate.isSame(selectedDate, 'day')) {
        endDate = moment().utc();
        startDate = moment();
      } else {
        const dateStr = selectedDate.format('YYYY-MM-DD');
        endDate = moment.utc(`${dateStr} 23:59:00`);
        startDate = moment(dateStr, 'YYYY-MM-DD');
      }
    }
    this.delaytime = null;
    this.socket = null;


    this.state = {
      newPipelineValues: [],
      updatedPipelineValues: [],
      showContent: false,
      cardName: "",
      inProgress: false,
      visiblePipelineCount: 20,
      nestedData: {},
      newData: {},
      showTreeView: false,
      initialSelection: {},
      isSearchHappened: false,
      errorOccurred: false,
      autoCompleteData: [],
      subString: null,
      searchCount: 0,
      fullData: [],
      isFilterOpen: false,
      isNoResult: false,
      saveWatchListSearchText: '',
      filteredData: [],
      isRedirect: false,
      value: '',
      suggestions: [],
      preSelectedEnv: null,
      preSelectedDataset: null,
      preSelectedDatasource: null,
      preSelectedAttribute: null,
      envCount: null,
      datasourceCount: null,
      datasetCount: null,
      attributeCount: null,
      autocompletemodal: false,
      show: false,
      watchListOpen: false,
      metricListRename: false,
      startDate: startDate,
      endDate: endDate,
      initialendDate: inidate,
      watchListName: '',
      environment: [],
      selectedWatchlistName: "All",
      editWatchlist: false,
      integration_details: "",
      showDeleteModal: false,
      disableDelete: false,
      metaData: {},
      search_text: "",
      selectedEnv: null,
      latest_env_name: null,
      isChecked: true,
      showToast: false,
      delete_watchlist_requsest: [],
      arrowIndicator: true,
      newValue: true,
      oldValue: true,
      rangeValue: 20,
      selectedChart: "Bar",
      filterData: [],
      // NEW Format
      selectedRange: '', // 1D Default selected range
      dateRanges: ['1D', '5D', '1M', '3M', '6M'],
      seletedTabId: 3,// DQ Selections
      selectedEnvId: this.props.selectedEnvId,
      selectedEnvName: this.props.selectedEnvName,
      selectedIntegrationId: "",
      selectedIntegrationName: "",
      selectedDatasetId: "",
      selectedDatasetName: "",
      selectedDatasetAttrId: "",
      selectedDatasetAttrName: "",
      selectedDatasetMeticsId: "",
      selectedDatasetMeticsName: "",
      selectedWatchListId: "",
      selectedWatchListName: "",
      selectedLeftPanelType: "",
      selectedMeticsName: "",
      selectedStartDate: moment().subtract(29, 'days'),
      selectedEndDate: moment().utc().endOf('day'),
      browserTabId: this.props.browserTabId,
      teamId: getTeamId(),
      userId: getUserId(),
      browsersessionId: this.props.browserSessionId,
      watchListInformation: {},
      integrationsInformation: "",
      menu: "monitor",
      leftPanelLoader: true,
      rightPanelLoader: true,
      showDeletePopup: false,
      confirmDeleteName: "",
      metricsValueResponse: {},
      bottomPanelData: "",
      chartData: "",
      incidentchartData: "",
      isCheckedIncidents: false, // Initial state of the checkbox
      incidentsPanelHeight: 90,
      incidentsPanelFullScreen: false,
      selectedTopMenu: "",
      showChartFullscreen: false,
      toggleIncidentPanel: false,
      dateFilterStartDate: null,
      dateFilterEndDate: null,
      dateFilterShowStartCalendar: true, // Start date picker shown by default
      dateFilterShowEndCalendar: false,
      checkedStates: {},
      chartGridWidth: "",
      isLoading: false, // Loading state for API call
      hasMoreData: true, // Flag to indicate if more data can be loaded
      visibleCharts: new Set(), // Tracks visible charts
      incidentStartDate: "",
      incidentEndDate: "",
      lastProcessedDate: "",
      pushDataList: [],
      integrationRequest: [],
      isCheackedActiveRuns: false, // Initial state of the checkbox
      incidentPanelState: props.data?.incidentPanelState || "minimized", // "minimized", "half", "full"
      customDatePickerErr: "Default Date",
      metaDataResponse: [],
      isInFullScreenMode: false,
      pipelinesource_data: "",
      piplineInfo: "",
      timefilter: "12",
      searchText: "",
      selectedJobId: "",
      p_integration_id: "",
      selectedJobRunsFullscreen: [],
      selectedRunsData: [],
      stackedbarchart: "",
      stackedbarchartfaild: "",
      gantt_chart_details: [],
      lienage_graph_type: "",
      gantt_chart_grid: [],
      gantt_chart_grid_temp: [],
      gantt_chart_grid_filter: [],
      gantt_chart_job_details: [],
      searchingTaskText: '',
      lineageData: null,
      run_level_lineageData: null,
      enableLoader: false,
      showLoader: true,
      watchListNameError: "",
      expandedPipelineRows: {},
      expandedPipeline: {},
      currentPage: 1,
      itemsPerPage: 3,
      totalItems: 0,
      toggledPipelineSource: {}, // Object to track expanded state for each pipeline
      inputData: null,
      searchData: null,
      tempPiplineInfo: '',
      enableFadeLoader: false,
      totalMatchedPipelines: 0,
      totalMatchedIntegrations: 0,
      selectedItems: [
        'pipeline-running',
        'pipeline-scheduled',
        'pipeline-progress',
        'pipeline-queued',
        'pipeline-done',
        'pipeline-failed',
        'pipeline-cancelled',
        'pipeline-stage_failure_run_success'
      ],
      pipelineIconMapping: null,
      selectedPipeline: null,
      lineageGraphExpanded: false,
      showIncidentToast: false,
      showFilterDropdown: false,
      loadMoreClickCount: 0,
      expandedIntegrationId: null,
      highlightText: false

    }
    this.chartRefs = {}; // Create references for chart containers
    this.socket = null;
    this.isLoaderRefreshInProgress = false;
    this.setFullScreen = this.setFullScreen.bind(this)
    this.getLineageDetailresponse = this.getLineageDetailresponse.bind(this);
    this.closeFullScreenMode = this.closeFullScreenMode.bind(this);
    this.pipelineTableComponent = this.pipelineTableComponent.bind(this)
    this.showDetailsPipeline = this.showDetailsPipeline.bind(this)
    this.getApi = getApi.bind(this)
    this.prevDate = this.prevDate.bind(this)
    this.nextDate = this.nextDate.bind(this)
    this.handleSearchJob = this.handleSearchJob.bind(this)
    this.nowDate = this.nowDate.bind(this)
    this.applystagefilter = this.applystagefilter.bind(this);
    this.gobackfullscreen = this.gobackfullscreen.bind(this);
    this.filterStageSearch = this.filterStageSearch.bind(this);
    this.searchJobs = this.searchJobs.bind(this);
    this.clearTask = this.clearTask.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handleWishListShow = this.handleWishListShow.bind(this)
    this.handleDeleteModalOpen = this.handleDeleteModalOpen.bind(this)
    this.handleCloseDeletePopup = this.handleCloseDeletePopup.bind(this)
    this.handleSaveWatchlistCheckboxChange = this.handleSaveWatchlistCheckboxChange.bind(this)
    this.handleCloseAutoCompleteModal = this.handleCloseAutoCompleteModal.bind(this);
    this.handleOpenAutoCompleteModal = this.handleOpenAutoCompleteModal.bind(this);
    this.renderSearchData = this.renderSearchData.bind(this);
    this.initialApi = this.initialApi.bind(this);

    this.handleToggleActiveRuns = this.handleToggleActiveRuns.bind(this);
    this.getGanttPopover = this.getGanttPopover.bind(this);
    this.pipelineStagesFormatData = this.pipelineStagesFormatData.bind(this);
    this.receivePushData = this.receivePushData.bind(this)

    this.resetLineage = this.resetLineage.bind(this);
    this.setRangeValue = this.setRangeValue.bind(this);
    this.retsetzoom = this.retsetzoom.bind(this);
    this.runsFormatData = this.runsFormatData.bind(this);
    this.pushResponseData = this.pushResponseData.bind(this);
    this.getPipelineResponse = this.getPipelineResponse.bind(this);

  }
  normalizeUrl(url) {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return "https://" + url; // auto fix
    }
    return url;
  }
  async receivePushData() {


    let requestParams = {
      "browser_tab_id": this.props.browserTabId, // DQ Tab
      "tenant_id": this.state.teamId, // Team Id
      "user_id": this.state.userId
    }

    let webSocketUrlResponse = await getWebSocketUrl(requestParams)
    if (webSocketUrlResponse === undefined) {
      this.setState({ errorOccurred: true });
    } else {


      if (webSocketUrlResponse.code === 200) {
        if (webSocketUrlResponse.type === "azure") {  // Azure WebSocket
          this.socket = new WebSocket(webSocketUrlResponse.response.url);
          this.socket.onopen = () => {
          };
          this.socket.onmessage = (event) => {
            const outerParsed = JSON.parse(event.data);
            const message = typeof outerParsed === "string" ? JSON.parse(outerParsed) : outerParsed;
            //C console.log("************");
            //C console.log(JSON.stringify(message))
            this.pushResponseData(message);

          };
          this.socket.onerror = (error) => {
            console.log("Error")
            console.log(error)
          };
          this.socket.onclose = (event) => {
            console.log("onclose")
            console.log(event)
          };
        } else {  // AWS WebSocket


          //Cconsole.log(" Connecting WebSocket...");
          const normalizedUrl = this.normalizeUrl(ui_service_ip);
          //C console.log("normalizeUrl:", normalizedUrl);
          if (typeof normalizedUrl !== "string") {
            console.error(" ERROR: normalizeUrl returned non-string!", normalizedUrl);
            return;
          }
          const urlObj = new URL(normalizedUrl);

          const baseUrl = urlObj.origin;

          const realtimePath = typeof urlObj.pathname === "string" ? urlObj.pathname : "";

          const socketPath = `${realtimePath}/socket.io`;

          this.socket = io(baseUrl, {
            path: socketPath,
            transports: ["polling"],
            query: {
              tab_id: this.props.browserTabId,
            },
          });
          // Connected
          this.socket.on("connect", () => {
            console.log("WebSocket CONNECTED");
          });

          // Realtime messages
          this.socket.on("realtime_messages", (payload) => {
            try {
              const data = typeof payload === "string" ? JSON.parse(payload) : payload;
              this.pushResponseData(data);
            } catch (err) {
              console.error("Invalid JSON payload:", err);
            }
          });

          // Disconnected

          this.socket.on("disconnect", () => {
            console.log("WebSocket DISCONNECTED");
          });

          // Connection error
          this.socket.on("connect_error", (err) => {
            console.error("WS ERROR:", err.message);
          });
          // Disconnected
          // this.socket.on("disconnect", () => {
          //   console.log("WebSocket DISCONNECTED");
          // });

          // // Connection error
          // this.socket.on("connect_error", (err) => {
          //   console.error("WS ERROR:", err.message);
          // });

          // Cleanup
          return () => {
            if (this.socket) this.socket.disconnect();
          };


        }
      }
    }
  }

  pushResponseData = (message) => {
    //  let pipeline_summary_metadata;
    //C
    //
    console.log("message", message);

    switch (message.ids_type) {
      case "pipeline_discovery_completed":
        if (message.data?.env_id === this.props.selectedEnvId &&
            this.isLoaderRefreshInProgress === false) {
          this.isLoaderRefreshInProgress = true;
          this.initialApi().finally(() => {
            this.isLoaderRefreshInProgress = false;
          });
        }
        break;
      case "pipeline_info":
        //C console.log("pipeline_info")
        //console.log(outerParsed)
        if (message.sub_type === "pipeline_summary_metadata") {
          const pipeline_summary_metadata = message.data;

          this.setState((prevState) => ({
            pipelineJobInfoResponse: {
              ...prevState.pipelineJobInfoResponse,

              pipeline_metadata: pipeline_summary_metadata.pipeline_metadata,
              run_summary: pipeline_summary_metadata.run_summary,

              last_processed_time: pipeline_summary_metadata.last_processed_time,
              pipeline_name: pipeline_summary_metadata.pipeline_name,
              pipeline_id: pipeline_summary_metadata.pipeline_id,
              env_id: pipeline_summary_metadata.env_id,
            },
          }));
        }
        else if (message.sub_type === "pipeline_counts") {
          let pipelineJobInfoResponse = this.state.pipelineJobInfoResponse;
          console.log(JSON.stringify(pipelineJobInfoResponse))
          let pieleine_cnt = message.data.pipeline_counts;
          // pipelineJobInfoResponse.pipeline_metadata = pipeline_summary_metadata.pipeline_metadata;
          // pipelineJobInfoResponse.run_summary = pipeline_summary_metadata.run_summary;
          pipelineJobInfoResponse.pipeline_count_details.pipeline_counts = pieleine_cnt;
          //C console.log("Modified Data")
          //            console.log(pipelineJobInfoResponse)
          //C console.log("**************")
          console.log(JSON.stringify(pipelineJobInfoResponse))

          this.setState({
            pipelineJobInfoResponse: pipelineJobInfoResponse,
          });
          // pipeline_summary_metadata = ""
        }
        break;
      case "runs_info":
        if (message.sub_type === "run_details") {
          //C  console.log(" runs_info run_details",this.state.selectedJobRunsFullscreen)
          run_info = Array.isArray(message.data) ? message.data : [];
          return;
        } else if (message.sub_type === "stage_details") {
          //C console.log("runs_info stage_details",this.state.selectedJobRunsFullscreen)

          // let existingruns = this.state.selectedJobRunsFullscreen;

          // //
          // let updatedata = existingruns;

          // updatedata.stage_data = message.data;

          // // Only update if run_info is valid array
          // if (Array.isArray(run_info)) {
          //     updatedata.run_data = run_info;
          // }

          // // Ensure run_data is always an array
          // if (!Array.isArray(existingruns.run_data)) {
          //     existingruns.run_data = [];
          // }

          // const existingRunMap = new Map();

          // existingruns.run_data.forEach((item, index) => {
          //     existingRunMap.set(item.p_run_id, index);
          // });

          // // Merge new entries (only if run_info exists)
          // if (Array.isArray(run_info)) {
          //     run_info.forEach(newRun => {
          //         if (existingRunMap.has(newRun.p_run_id)) {
          //             const index = existingRunMap.get(newRun.p_run_id);
          //             existingruns.run_data[index] = newRun;
          //         } else {
          //             existingruns.run_data.push(newRun);
          //         }
          //     });
          // }

          // this.runsFormatData(existingruns);
          // existing full response (first JSON)


          const currentRunsState = this.state.selectedJobRunsFullscreen;
          let existingruns = currentRunsState && typeof currentRunsState === "object" && !Array.isArray(currentRunsState)
            ? { ...currentRunsState }
            : {};

          existingruns.run_data = Array.isArray(existingruns.run_data) ? [...existingruns.run_data] : [];
          existingruns.stage_data = existingruns.stage_data && typeof existingruns.stage_data === "object"
            ? { ...existingruns.stage_data }
            : {};

          const incomingRuns = Array.isArray(run_info) ? run_info : [];
          incomingRuns.forEach((incomingRun) => {
            if (!incomingRun || incomingRun.p_run_id === undefined) {
              return;
            }
            const runIndex = existingruns.run_data.findIndex(item => item.p_run_id === incomingRun.p_run_id);
            if (runIndex !== -1) {
              existingruns.run_data[runIndex] = incomingRun;
            } else {
              existingruns.run_data.unshift(incomingRun);
            }
          });
          run_info = [];

          const stageUpdateData = message.data && typeof message.data === "object" ? message.data : {};
          Object.keys(stageUpdateData).forEach((scheduledKey) => {
            const stagesArray = Array.isArray(stageUpdateData[scheduledKey]) ? stageUpdateData[scheduledKey] : [];
            if (stagesArray.length === 0) {
              return;
            }

            const existingStages = Array.isArray(existingruns.stage_data[scheduledKey])
              ? [...existingruns.stage_data[scheduledKey]]
              : [];

            stagesArray.forEach((stage) => {
              if (!stage || stage.stage_id === undefined) {
                return;
              }
              const stageIndex = existingStages.findIndex(item => item.stage_id === stage.stage_id);
              if (stageIndex !== -1) {
                existingStages[stageIndex] = stage;
              } else {
                existingStages.unshift(stage);
              }
            });

            existingruns.stage_data[scheduledKey] = existingStages;
          });

          if (existingruns.run_data.length > 0) {
            this.runsFormatData(existingruns);
          } else {
            this.setState({ selectedJobRunsFullscreen: existingruns, selectedRunsData: existingruns });
          }
          // // second JSON data
          // // Ensure stage_data exists
          // if (!existingruns.stage_data) {
          //     existingruns.stage_data = {};
          // }
          // // Merge stage data (update only matching keys)
          // Object.keys(stageUpdateData).forEach(key => {
          //     existingruns.stage_data[key] = stageUpdateData[key];
          // });

          // console.log(existingruns)

          // Update state
          // this.setState(
          //   {
          //     selectedJobRunsFullscreen: existingruns
          //   },
          //   () => {
          // this.runsFormatData(existingruns);
          //   }
          // );


          /*let existingruns = this.state.selectedJobRunsFullscreen;
          let updatedata = this.state.selectedJobRunsFullscreen;
          updatedata.stage_data = message.data;
          updatedata.run_data = run_info;
          run_info = "";

          const newRuns = updatedata.run_data || [];
          const newStageData = updatedata.stage_data || {};
          const newSummary = updatedata.run_summary || {};

          // Get existing run IDs
          const existingRunIds = new Set((existingruns.run_data || []).map(run => run.p_run_id));

          // Filter only new run_data
          const filteredNewRuns = newRuns.filter(run => !existingRunIds.has(run.p_run_id));

          // Append only new runs
          existingruns.run_data = [...(existingruns.run_data || []), ...filteredNewRuns];

          // Update run_summary (optional: you may want to merge rather than override)
          existingruns.run_summary = newSummary;

          // Update or add stage_data by source_run_id
          for (const [sourceRunId, stages] of Object.entries(newStageData)) {
            existingruns.stage_data[sourceRunId] = stages;
          } */

          // console.log("Render");
          // console.log(JSON.stringify(existingruns));

          //this.runsFormatData(existingruns);

          // let existingruns = this.state.selectedJobRunsFullscreen;
          // let updatedata = this.state.selectedJobRunsFullscreen;
          // updatedata.stage_data = message.data;
          // updatedata.run_data = run_info;

          //  const existingRunMap = new Map();
          //   existingruns.run_data.forEach((item, index) => {
          //     if (item && item.p_run_id) {
          //       existingRunMap.set(item.p_run_id, index);
          //     }
          //   });
          // }

          // // Merge or add new entries from updatedata.run_data
          // if (Array.isArray(updatedata.run_data)) {
          //   updatedata.run_data.forEach(newRun => {
          //     if (newRun && newRun.p_run_id) {
          //       if (existingRunMap.has(newRun.p_run_id)) {
          //         // Update existing item
          //         const index = existingRunMap.get(newRun.p_run_id);
          //         existingruns.run_data[index] = newRun;
          //       } else {
          //         // Add new item
          //         existingruns.run_data.push(newRun);
          //       }
          //     }
          //   });
          //   this.runsFormatData(existingruns);
          // // Update run_summary
          // json.run_summary = updatejson.run_summary;

          // // Update stage_data
          // json.stage_data = updatejson.stage_data;
        }

        break;
      case "stage_info":
        // console.log("stage_info")
        // let temp = this.state.gantt_chart_grid;
        // this.pipelineStagesFormatData(message.data)

        // Deep-safe shallow copy

        //C console.log(message.data)
        //C console.log(this.state.gantt_chart_grid)

        let temp = {
          ...this.state.gantt_chart_grid,
          data: [...this.state.gantt_chart_grid_temp]
        };
        const latestStages = message.data; // array of stage objects


        this.setState({
          detailviewtiming: message?.additional_data?.run_start_time
            ? this.formatUTCDate(message.additional_data.run_start_time)
            : "--",
          detailviewduration: message?.additional_data?.duration != null
            ? this.millisecondToMinutesAndSeconds(message.additional_data.duration)
            : "--",
          detailviewstatus: message?.additional_data?.run_status_text || "--",
        });

        latestStages.forEach((latestStage) => {
          const index = temp.data.findIndex(
            item => item.stage_id === latestStage.stage_id
          );
          if (index !== -1) {
            //  Replace existing stage completely
            temp.data[index] = latestStage;
          } else {
            //  Append if not exists
            temp.data.push(latestStage);
          }
        });
        // Pass updated structure
        // console.log(temp)
        // console.log("&&&&&&&&&&&&&&&")  
        this.pipelineStagesFormatData(temp.data);
        break;
      case "pipeline_lineage":
        console.log("pipeline_lineage")
        this.setState({
          run_level_lineageData: message.data,
          detailviewtiming: message?.additional_data?.run_start_time
            ? this.formatUTCDate(message.additional_data.run_start_time)
            : "--",
          detailviewduration: message?.additional_data?.duration != null
            ? this.millisecondToMinutesAndSeconds(message.additional_data.duration)
            : "--",
          detailviewstatus: message?.additional_data?.run_status_text || "--",
        })
        break;
      case "pipeline_realtime":
        //C console.log("this.state.piplineInfo",this.state.piplineInfo)
        let original = this.state.piplineInfo;
        let pushData = message.data;

        // Update total counts
        original.total_integrations = pushData.total_integrations;
        original.total_pipelines = pushData.total_pipelines;
        original.total_active_count = pushData.total_active_count;

        // Update pipeline status count
        original.pipeline_status_count = { ...pushData.pipeline_status_count };

        // Update integrations
        pushData.integrations.map(pushIntegration => {
          const existingIndex = original.integrations.findIndex(
            orig => orig.value === pushIntegration.value
          );

          if (existingIndex !== -1) {
            original.integrations[existingIndex] = { ...pushIntegration };
          } else {
            original.integrations.push({ ...pushIntegration });
          }

          return pushIntegration.value;
        });

        // Update pipelines
        let updatedPipelines = new Set();
        let newPipelines = new Set();

        for (let key in pushData.pipelines) {
          if (!original.pipelines[key]) {
            original.pipelines[key] = [];
          }

          // Find matching pipeline by 'value' and update or push new one
          pushData.pipelines[key].forEach(pushPipeline => {
            const existingIndex = original.pipelines[key].findIndex(
              origPipeline => origPipeline.value === pushPipeline.value
            );

            if (existingIndex !== -1) {
              const existingPipeline = original.pipelines[key][existingIndex];

              // Compare if changed
              const isChanged = JSON.stringify(existingPipeline) !== JSON.stringify(pushPipeline);
              if (isChanged) {
                updatedPipelines.add(pushPipeline.value);
                original.pipelines[key][existingIndex] = { ...pushPipeline };
              }
            } else {
              newPipelines.add(pushPipeline.value);
              original.pipelines[key].push({ ...pushPipeline });            }
          });
        }
        //C console.log("original",original);

        this.setState({
          piplineInfo: original,
          tempPiplineInfo: original,
          pipeline_status_count: original.pipeline_status_count,
          updatedPipelineValues: Array.from(updatedPipelines),
          newPipelineValues: Array.from(newPipelines),
        });
        this.updateMetaData();
        setTimeout(() => {
          this.timeFilterRenderHtml();
        }, 1000);

        break;
      default:
        break;
    }
  }

  //check box selection in save watchlist
  handleSaveWatchlistCheckboxChange = (event, type, uniqueId, childNodes) => {
    const { checked } = event.target;

    this.setState((prevState) => {
      let updatedCheckedStates = { ...prevState.checkedStates };

      // Recursive function to update the checked state of all child nodes
      const updateChildNodes = (nodes, isChecked) => {
        nodes.forEach((node) => {
          const childKey = `${node.type}-${node.id}`;
          updatedCheckedStates[childKey] = { checked: isChecked, type: node.type };
          if (node.childNodes && node.childNodes.length > 0) {
            updateChildNodes(node.childNodes, isChecked);
          }
        });
      };

      updatedCheckedStates[uniqueId] = { checked, type };

      // If this node has child nodes, update them too
      if (childNodes && childNodes.length > 0) {
        updateChildNodes(childNodes, checked);
      }

      return { checkedStates: updatedCheckedStates };
    });
  };

  //Toggle Filter Dropdown
  toggleFilterDropdown = () => {
    this.setState((prevState) => ({ showFilterDropdown: !prevState.showFilterDropdown }));
  }
  handleFilterDropdownClose = () => {
    this.setState({ showFilterDropdown: false, appliedSelectedItems: [...this.state.selectedItems] })
    this.fetchFilteredPipelines();

  }

  // Calculate the range of items to display
  startItem = () => {
    return (this.state.currentPage - 1) * this.state.itemsPerPage + 1;
  };

  endItem = () => {
    return Math.min(this.state.currentPage * this.state.itemsPerPage, this.state.totalItems);
  };

  updateMetaData() {
    let metaDataList = this.state.pipelinesource_data;
    let selectedEnvId = this.props.selectedEnvId;
    if (selectedEnvId) {
      if (Array.isArray(metaDataList)) {
        metaDataList = metaDataList.filter(item => item.env_id === selectedEnvId);
      } else {
        // console.error("metaDataList is not an array:", metaDataList);
        metaDataList = [];
      }
    }
    if (metaDataList.length > 0) {
      let totalItems = metaDataList.length;
      let calculatedPages = Math.ceil(totalItems / this.state.itemsPerPage);

      let paginatedData = metaDataList.map(item => {
        let integrationMatch = this.state.piplineInfo !== undefined && this.state.piplineInfo.integrations !== undefined && this.state.piplineInfo.integrations.find(
          integration => integration.value === item.p_integration_id
        );

        return {
          ...item,
          integration_label: integrationMatch ? integrationMatch.label : item.p_integration_name,
          integration_value: integrationMatch ? integrationMatch.value : null,
          formatted_created_time: new Date(item.created_time).toLocaleString(),
          formatted_latest_job_run_time: item.latest_job_run_time
            ? new Date(item.latest_job_run_time).toLocaleString()
            : 'N/A',
          status: item.discovery_status_text || 'Unknown'
        };
      });
      this.setState({
        totalItems,
        totalPages: calculatedPages,
        defaultDatasource: paginatedData[0]?.integration_label
          ? { label: paginatedData[0].integration_label, value: paginatedData[0].integration_value }
          : {},
        paginatedData,
        tempPaginatedData: paginatedData
      });
    } else {
      this.setState({
        totalItems: 0,
        totalPages: 0,
        defaultDatasource: {},
        paginatedData: [],
        tempPaginatedData: []
      });
    }
  }


  async handleToggleActiveRuns() {
    const newCheckedState = !this.state.isCheackedActiveRuns;
    this.setState({
      isCheackedActiveRuns: newCheckedState,
      enableFadeLoader: true,
    });
    if (newCheckedState) {
      try {
        const pipelineResponse = await this.getPipelineResponse(this.state.selectedWatchListId, newCheckedState);

        const pipelines = (pipelineResponse.response && pipelineResponse.response.pipelines) ? pipelineResponse.response.pipelines : {};
        let pipelineMatchCount = 0;
        Object.keys(pipelines).forEach(key => {
          pipelineMatchCount += pipelines[key].length;
        });

        // If active count is 0, show toast and revert toggle
        let activeCount = this.state.piplineInfo.total_active_count ? this.state.piplineInfo.total_active_count : 0;

        if (activeCount === 0 || pipelineMatchCount === 0) {
          setTimeout(async () => {
            this.setState({
              isCheackedActiveRuns: false,
              enableFadeLoader: true,
              showIncidentToast: true
            });
            const fallbackResponse = await this.getPipelineResponse(this.state.selectedWatchListId, false);
            if (fallbackResponse && fallbackResponse.code === 200) {
              this.setState({
                piplineInfo: fallbackResponse.response,
                enableFadeLoader: false,
                tempPiplineInfo: fallbackResponse.response,
                pipeline_status_count: fallbackResponse.response.pipeline_status_count,
              });
              this.updateMetaData();
              setTimeout(() => {
                this.timeFilterRenderHtml();
              }, 1000);
            } else {
              this.setState({ enableFadeLoader: false });
            }
          }, 200);

          return;
        }
        if (pipelineResponse.code === 200) {
          const { count_details = {} } = pipelineResponse.response;
          const { total_integrations = 0, total_pipelines = 0 } = count_details;
          const enhancedData = Array.isArray(this.state.paginatedData)
            ? pipelineResponse.response.integrations.map(item => {
              // Try to find a matching integration from the response by ID

              return {
                ...item,
                label: item.label || item.integration_type || "Unknown",
                // count_details: {
                //   active_pipelines: item?.count_details?.active_pipelines || 0,
                //   total_pipelines: item?.count_details?.total_pipelines || 0,
                // },
                count_details: {
                  active_pipelines: item?.count_details?.active_pipelines || 0,
                  total_pipelines: item?.count_details?.total_pipelines || 0,
                },
                value: item.value,
              };
            })
            : [];


          const updatedPipelineInfo = {
            ...pipelineResponse.response,
            integrations: enhancedData,
            count_details: {
              // ...count_details,
              total_integrations,
              total_pipelines
            }
          };


          this.setState({
            piplineInfo: updatedPipelineInfo,
            enableFadeLoader: false,
            pipeline_status_count: pipelineResponse.response.pipeline_status_count,
            tempPiplineInfo: updatedPipelineInfo
          });

          this.updateMetaData();

          setTimeout(() => {
            this.timeFilterRenderHtml();
          }, 1000);
        } else {
          this.setState({ enableFadeLoader: false });
          console.error("Error fetching pipeline data", pipelineResponse);
        }
      } catch (error) {
        this.setState({ enableFadeLoader: false });
        console.error("API Error:", error);
      }
    }
    else {
      const pipelineResponse = await this.getPipelineResponse(this.state.selectedWatchListId, newCheckedState);
      if (pipelineResponse.code === 200) {
        this.setState({
          piplineInfo: pipelineResponse.response,
          enableFadeLoader: false,
          tempPiplineInfo: pipelineResponse.response,
          pipeline_status_count: pipelineResponse.response.pipeline_status_count,
        });
      }
      // this.setState({piplineInfo:this.state.tempPiplineInfo,
      //   enableFadeLoader: false ,
      //   pipeline_status_count :this.state.tempPiplineInfo.pipeline_status_count});

    }
  }

  changePage = (page) => {
    this.adjustHeight();
    const totalPages = Math.ceil(this.state.totalItems / this.state.itemsPerPage);

    if (page >= 1 && page <= totalPages) {
      this.setState({ currentPage: page, enableFadeLoader: true }, async () => {
        try {
          const pipelineResponse = await this.getPipelineResponse(
            this.state.selectedWatchListId,
            this.state.isCheackedActiveRuns,
            "",
            this.state.searchText,
            this.state.endDate.format("YYYY-MM-DD")
          );

          if (pipelineResponse.code === 200) {
            const pipelines = pipelineResponse.response.pipelines || {};
            let pipelineMatchCount = 0;
            Object.keys(pipelines).forEach(key => {
              pipelineMatchCount += pipelines[key].length;
            });

            const integrationMatchCount = (pipelineResponse.response.integrations || []).length;

            this.setState({
              piplineInfo: pipelineResponse.response,
              searchIntegrationData: pipelineResponse.response.integrations,
              totalMatchedPipelines: pipelineMatchCount,
              totalMatchedIntegrations: integrationMatchCount,
              enableFadeLoader: false,
              pipeline_status_count: pipelineResponse.response.pipeline_status_count

            });

            this.updateMetaData();

            setTimeout(() => {
              this.timeFilterRenderHtml();
            }, 1000);
          } else {
            this.setState({ enableFadeLoader: false });
            console.error("Error fetching pipeline data", pipelineResponse);
          }
        } catch (error) {
          this.setState({ enableFadeLoader: false });
          console.error("API Error:", error);
        }
      });
    } else {
      this.setState({
        piplineInfo: this.state.tempPiplineInfo,
        enableFadeLoader: false,
        pipeline_status_count: this.state.tempPiplineInfo.pipeline_status_count,
      });
    }
  };


  swDropdownOpen(menuId) {
    this.setState((prevState) => ({
      selectedTopMenu: prevState.selectedTopMenu === menuId ? null : menuId
    }));
    this.MenuScrollFix(menuId);

  }

  MenuScrollFix(event) {
    let divposition = window.scrollX + document.querySelector('#' + event).getBoundingClientRect().left
    let divpositionright = window.scrollX + document.querySelector('#' + event).getBoundingClientRect().right
    if ($(window).width() < divposition + $('#' + event + " > div:nth-child(2)").width()) {
      $('#' + event + " > div:nth-child(2)").css("right", function () {
        return $(window).width() - divpositionright;
      });
    } else {
      $('#' + event + " > div:nth-child(2)").css("left", function () {
        return $(this).parent().position().left
      });
    }
  }


  pipelineStagesInfoResponse() {


    let requestParams = {
      "tenant_id": this.state.teamId,
      "pipeline_id": this.state.selectedJobId,
      "p_integration_id": this.state.p_integration_id,
      "run_id": this.state.gantt_char_trunid,
      "menu_type": "monitor",
      "env_id": this.props.selectedEnvId,
      "session_id": this.props.browserSessionId,
      "user_id": this.state.userId,
      "tab_type": 3,
      "selected_ids": [this.state.p_run_id],
      "ids_type": "stage_info",
      "browser_tab_id": this.props.browserTabId
    }
    return pipelineStagesInfo(requestParams);
  }


  setRangeValue = (event) => {

    if (this.state.lineageData.hasOwnProperty("tasks")) {
      let eventscale = event > 20 ? event / 10 : event * 0.1
      let scale = $("#linenage svg g").first().attr("transform").split(" ")[0] + " scale(" + eventscale + ")";
      $("#linenage svg g").first().attr("transform", scale)
      this.setState({ rangeValue: event });
    }

  }


  retsetzoom() {

    if (this.state.lineageData.hasOwnProperty("tasks")) {
      let eventscale = 20;
      let scale = $("#linenage svg g").first().attr("transform").split(" ")[0] + " scale(" + eventscale + ")";
      $("#linenage svg g").first().attr("transform", scale)
      this.setState({ rangeValue: eventscale });
    }
  }


  resetLineage() {

    if (this.state.lineageData.hasOwnProperty("tasks")) {

      $('.lg-panel').removeClass('highlights-downstream').removeClass('disable-lineagenode');
      $(".highlights").removeClass('related-active')
      $('.lg-panel').removeClass('lg-panel--active');

      var $paths = $('path.lineage'); // Get all paths
      for (var i = 0; i < $paths.length; i++) { // Iterate through each one
        var $path = $($paths[i]); // This gets a single path
        $path.attr("stroke", "#CED4DA")
        $path.attr("marker-end", "url(#arrow)");
      }
    }
  }


  getPipelineRunResponse() {
    let requestParams = {
      "tenant_id": this.state.teamId,
      "pipeline_id": this.state.selectedJobId,
      "p_integration_id": this.state.p_integration_id,
      "env_id": this.props.selectedEnvId,
      "menu_type": "monitor",
      // "env_id":this.props.selectedEnvId,
      "session_id": this.props.browserSessionId,
      "user_id": this.state.userId,
      "tab_type": 3,
      "selected_ids": [this.state.selectedJobId],
      "ids_type": "pipeline_info",
      "browser_tab_id": this.props.browserTabId

    }
    return getPipelineJobInfo(requestParams);
  }


  runsFormatData(pmData) {


    let tempdata = pmData;

    let stackdata = pmData.run_data.map((run, index) => ({
      id: index,
      run_id: run.source_run_id,
      time: new Date(run.run_start_time).toISOString().replace("T", " ").substring(0, 19),
      value: run.duration,
      value_format: this.millisecondToMinutesAndSeconds(run.duration),
      stages: pmData.stage_data[run.source_run_id],
      hasError: run.run_status_text === "Failed" ? true : false
    }));

    let stackedbarchartfaild = pmData.run_data
      .filter(run => run.run_status_text === "Failed" || run.run_status_text === "stage_failure_run_success")
      .map((run, index) => ({
        id: index,
        run_id: run.source_run_id,
        time: new Date(run.run_start_time).toISOString().replace("T", " ").substring(0, 19),
        value: run.duration,
        value_format: this.millisecondToMinutesAndSeconds(run.duration),
        stages: pmData.stage_data[run.source_run_id],
        hasError: true
      }));

    this.setState({
      stackedbarchartfaild: stackedbarchartfaild,
      selectedJobRunsFullscreen: tempdata,
      selectedRunsData: tempdata,
      stackedbarchart: stackdata,
      showLoader: false
    })
  }

  openIncidentPipelineRuns(pipelineResponse, integrations) {
    const redirect = this.props.data;
    if (this._incidentRunsOpened || !redirect || redirect.type !== "PIPELINE" || redirect.show_all_runs !== true) {
      return;
    }
    const pipelineId = redirect.pipeline_id;
    const integrationId = redirect.p_integration_id;
    const pipelineName = String(redirect.pipeline_name || "").trim().toLowerCase();
    const integrationName = String(redirect.pipeline_integration_name || "").trim().toLowerCase();
    const pipelines = pipelineResponse?.pipelines || {};
    const sources = Array.isArray(integrations) ? integrations : [];
    const findJob = (strictIntegration) => {
      let found = null;
      sources.forEach((source) => {
        if (found) return;
        const sourceId = source.p_integration_id;
        const sourceLabel = String(source.label || source.pipeline_integration_name || source.integration_name || "").trim().toLowerCase();
        if (strictIntegration && integrationId != null && String(sourceId) !== String(integrationId)) return;
        if (strictIntegration && integrationName && sourceLabel && sourceLabel !== integrationName) return;
        const jobs = pipelines[sourceId] || [];
        const job = jobs.find((item) => {
          if (pipelineId != null && String(item.value) === String(pipelineId)) return true;
          return pipelineName && String(item.label || "").trim().toLowerCase() === pipelineName;
        });
        if (job) found = { source, job };
      });
      return found;
    };
    const match = findJob(true) || findJob(false);

    if (!match && (pipelineId == null || integrationId == null)) return;
    const source = match?.source;
    const job = match?.job;
    this._incidentRunsOpened = true;
    this.setFullScreen(
      source?.p_integration_id ?? integrationId,
      job?.value ?? pipelineId,
      source?.integration_type || job?.integration_type || "",
      source?.label || source?.pipeline_integration_name || redirect.pipeline_integration_name || "",
      job?.label || redirect.pipeline_name || ""
    );
  }

  setFullScreen(pipeline_integration_id, pipeline_job_id, type, pipelinename, jobname, tooltip, content) {
    // alert(jobname)
    // alert(type)
    // alert(pipelinename)
    //alert(this.state.activeTab)
    // Failed Run fr
    // Lienage td 
    // Job Info ji

    this.setState({
      isInFullScreenMode: true,
      activeTab: this.state.isInFullScreenMode ? this.state.activeTab === "navtroubleshooting" ? "jr" : this.state.activeTab : "jr",
      selectedMoreJobName: jobname,
      selectedMorePipelineType: type,
      selectedMorePipelineName: pipelinename,
      selectedJobId: pipeline_job_id,
      pipelineJobInfoResponse: null,
      enableLoader: true,
      p_integration_id: pipeline_integration_id,
      lienage_graph_type: "job-level",
      gantt_chart_grid_filter: []
    }, async () => {
      try {
        if (tooltip === true) {
          this.showDetailsPipeline(content)
        }
        if (this.state.activeTab === "ji") {
          let response = await this.getPipelineRunResponse();
          if (response.code === 200 && response.message !== "No entry found") {
            this.setState({
              pipelineJobInfoResponse: response.data,
              //selectedJobRunsFullscreen: response.run_data,
              showLoader: false,
              enableFadeLoader: false
            });
          } else {
            this.setState({
              showLoader: false,
              enableFadeLoader: false
            });
          }
        }

         
        if (this.state.activeTab === "td") {

          let lineageResponse = await this.getLineageresponse(this.state.lienage_graph_type)
          if (lineageResponse.code === 200) {
            //  this.setState({lineageData:dummyjson.lineage_data, showLoader : false})
            //this.setState({lineageData:lineageResponse.lineage_data, showLoader : false})
            let reseterror = lineageResponse.lineage_data
            reseterror.is_error = []
            this.setState({ lineageData: reseterror, showLoader: false })
          }
        }

        // let lineageDetailsResponse = await this.getLineageDetailresponse(this.state.lienage_graph_type)
        // if(lineageDetailsResponse.code === 200){
        //       this.setState({lineageRighPanelDetails:lineageDetailsResponse.data.stage_data})
        // }


        if (this.state.activeTab === "jr" || this.state.activeTab === "fr" || this.state.activeTab === undefined) {

       

          let runInfo = await this.getRunInforesponse()
          if (runInfo.code === 200 && runInfo.message !== "No entry found") {
            this.runsFormatData(runInfo.data)
            // let stackdata = runInfo.data.run_data.map((run, index) => ({
            //     id:index,
            //     run_id:run.source_run_id,
            //     time: new Date(run.run_start_time).toISOString().replace("T", " ").substring(0, 19),
            //     value: run.duration,
            //     value_format: this.millisecondToMinutesAndSeconds(run.duration),
            //     stages:runInfo.data.stage_data[run.source_run_id],
            //     hasError: run.run_status_text === "Failed" ? true : false
            //   }));

            //   let stackedbarchartfaild = runInfo.data.run_data
            //   .filter(run => run.run_status_text === "Failed")
            //   .map((run, index) => ({
            //     id: index,
            //     run_id: run.source_run_id,
            //     time: new Date(run.run_start_time).toISOString().replace("T", " ").substring(0, 19),
            //     value: run.duration,
            //     value_format: this.millisecondToMinutesAndSeconds(run.duration),
            //     stages: runInfo.data.stage_data[run.source_run_id],
            //     hasError: true
            //   }));
            // this.setState({stackedbarchartfaild:stackedbarchartfaild,selectedJobRunsFullscreen:runInfo.data, stackedbarchart:stackdata,showLoader : false})
          }
          else if (runInfo.code === 200 && runInfo.message === "No entry found") {
            this.setState({ stackedbarchart: "", showLoader: false, selectedJobRunsFullscreen: "", stackedbarchartfaild: "" })
          }
        }

      } catch (error) {
        console.error("Error fetching pipeline run data:", error);
      } finally {
        this.setState({ enableLoader: false, enableFadeLoader: false })
      }
    });
    $('body').css('overflow', 'hidden');
  }


  closeFullScreenMode = () => {
    this.setState({ selectedJobId: "", isInFullScreenMode: false });
    $('body').css('overflow', 'auto');
  }

  moreAction() {
    alert(11111)
  }

  timeFilter(pm) {
    this.setState({ timefilter: pm });
  }


  getPipelineResponse(watch_list_id, active_run_toggle, selectedFilter, searchText, formattedDate) {
    let requestParams = {
      // "tab_type": this.state.seletedTabId, // DQ Tab
      "tenant_id": this.state.teamId, // Team Id
      "page_no": this.state.currentPage,
      "env_id": this.props.selectedEnvId,
      "menu_type": "monitor",
      // "env_id":this.props.selectedEnvId,
      "session_id": this.props.browserSessionId,
      "user_id": this.state.userId,
      "tab_type": 3,
      "selected_ids": [],
      "ids_type": "pipeline_realtime",
      "browser_tab_id": this.props.browserTabId
    };
    let filter_date = this.state.endDate.format("YYYY-MM-DD")
    if (formattedDate) {
      requestParams["filter_date"] = formattedDate;
    }
    else {
      requestParams["filter_date"] = filter_date;
    }
    // If watch_list_id is provided, use it instead of env_id
    if (watch_list_id) {
      requestParams["watch_list_id"] = watch_list_id;
    }

    // Enable active pipeline filter if active_run_toggle is true
    if (active_run_toggle === true) {
      requestParams["active_pipelines_filter"] = true;
    }

    // Define mapping for pipeline statuses
    let pipelineStatusMap = {
      "pipeline-done": "Succeeded",
      "pipeline-failed": "Failed",
      "pipeline-running": "Running",
      "pipeline-progress": "InProgress",
      "pipeline-scheduled": "Scheduled",
      "pipeline-cancelled": "Cancelled",
      "pipeline-stage_failure_run_success": "stage_failure_run_success"
    };

    // Convert selectedFilter values to API-friendly pipeline statuses
    if (selectedFilter && selectedFilter.length > 0) {
      let mappedFilters = selectedFilter
        .map(filter => pipelineStatusMap[filter])
        .filter(Boolean); // Remove undefined values

      if (mappedFilters.length > 0) {
        requestParams["pipeline_status_filter"] = mappedFilters;
      }
    }

    if (searchText) {
      if (typeof searchText === "object") {
        if (searchText.dataset_name) {
          // requestParams["pipeline_name_filter"] = searchText.dataset_name;
          requestParams['p_integration_id'] = searchText.datasourceId
          delete requestParams['page_no']
        }
      }
      else if (typeof searchText === "string" && searchText.length > 0) {
        requestParams["pipeline_name_filter"] = searchText;
      }
    }

    return getPipeline(requestParams)
      .then((res) => {
        const apiResponse = res.response;
        if ((res.code === 401 && res.message === "No entry found") || (res.code === 200 && res.message === 'No Run Identifier')) {
          this.setState({ piplineInfo: "", showLoader: false })
          return
        }
        let filteredPipelines = apiResponse.pipelines;
        if (
          searchText &&
          typeof searchText === "object" &&
          searchText.datasourceId
        ) {
          filteredPipelines = {
            [searchText.datasourceId]:
              apiResponse.pipelines?.[searchText.datasourceId] || []
          };
        }

        this.setState({
          piplineInfo: {
            ...apiResponse,
            pipelines: filteredPipelines,
          },
          ...(typeof searchText === "object" && {
            currentPage: apiResponse.page_no,
          }),
          realtimeApiResponse: res,
          showLoader: false,
        });

        return res;
      })
      .catch((error) => {
        console.error("Pipeline API error", error);
        this.setState({ showLoader: false });
      });

  }



  getPipelineIntegrationResponse() {
    let requestParams = {
      "tab_type": this.state.seletedTabId, // DQ Tab
      "tenant_id": this.state.teamId, // Team Id
      "env_id": this.props.selectedEnvId,
      "user_id": this.state.userId
    }
    return getPipelineIntegration(requestParams);
  }


  getLineageresponse(lineage_type) {

    let requestParams = {
      tenant_id: this.state.teamId,
      pipeline_integration_id: this.state.p_integration_id,
      pipeline_job_id: this.state.selectedJobId,
      lineage_type: lineage_type
    };
    if (lineage_type === "run-level") {
      requestParams.job_run_id = this.state.detailviewid;
      requestParams.menu_type = "monitor";
      requestParams.env_id = this.props.selectedEnvId;
      requestParams.session_id = this.props.browserSessionId;
      requestParams.browser_tab_id = this.props.browserTabId;
      requestParams.user_id = this.state.userId;
      requestParams.tab_type = 3;
      requestParams.selected_ids = [this.state.p_run_id];
      requestParams.ids_type = "pipeline_lineage";
    }
    return getLineageData(requestParams);
  }


  async getLineageDetailresponse(payload, error) {
    if (!payload || !payload.selected) {
      return;
    }

    let requestParams = {
      tenant_id: this.state.teamId,
      p_integration_id: this.state.p_integration_id,
      // pipeline_job_id: this.state.selectedJobId,
      pipeline_id: this.state.selectedJobId,
      stage_id: payload.selected.task_id || payload.selected.lineage_dataset_id
    };
    if (error) {

      //"run_id": "run_20260110_193619"
      requestParams.run_id = this.state.detailviewid;
      let lineageDetailsResponse;
       if(payload.type === "task"){
         lineageDetailsResponse = await pipelineDetailsStagesInfo(requestParams)
          if(lineageDetailsResponse && lineageDetailsResponse.code === 200 && lineageDetailsResponse.data && lineageDetailsResponse.data.stage_data !== undefined){
        this.setState({lineageRighPanelDetails:lineageDetailsResponse.data.stage_data})
       }
       } else {
         lineageDetailsResponse = await pipelineDetailsDatasetInfo(requestParams)
           if(lineageDetailsResponse && lineageDetailsResponse.code === 200 && lineageDetailsResponse.data){
          const datasetDetails = lineageDetailsResponse.data.datasets_data !== undefined
            ? lineageDetailsResponse.data.datasets_data
            : lineageDetailsResponse.data;
          this.setState({lineageRighPanelDetails: datasetDetails})
       }
       }



      // requestParams.job_run_id = this.state.detailviewid;
      // requestParams.menu_type ="monitor";
      // requestParams.env_id = this.props.selectedEnvId;
      // requestParams.session_id = this.props.browserSessionId;
      // requestParams.browser_tab_id = this.props.browserTabId;
      // requestParams.user_id = this.state.userId;
      // requestParams.tab_type = 3 ;
      // requestParams.selected_ids = [this.state.p_run_id];
      // requestParams.ids_type = "pipeline_lineage";
      // let lineageDetailsResponse = await pipelineDetailsStagesInfo(requestParams)
      // if(lineageDetailsResponse.code === 200){
      //         this.setState({lineageRighPanelDetails:lineageDetailsResponse.data.stage_data})
      // }
      //return pipelineTroubleShootStagesInfo(requestParams);
    }
    else {
      let lineageDetailsResponse;
      if (payload.type === "task") {
        lineageDetailsResponse = await pipelineDetailsStagesInfo(requestParams)
        if (lineageDetailsResponse && lineageDetailsResponse.code === 200 && lineageDetailsResponse.data && lineageDetailsResponse.data.stage_data !== undefined) {
          this.setState({ lineageRighPanelDetails: lineageDetailsResponse.data.stage_data })
        }
      } else {
           lineageDetailsResponse = await pipelineDetailsDatasetInfo(requestParams)
           if(lineageDetailsResponse && lineageDetailsResponse.code === 200 && lineageDetailsResponse.data){
          const datasetDetails = lineageDetailsResponse.data.datasets_data !== undefined
            ? lineageDetailsResponse.data.datasets_data
            : lineageDetailsResponse.data;
          this.setState({lineageRighPanelDetails: datasetDetails})
        }
      }

    }
  }


  getRunInforesponse() {
    let requestParams = {
      "tenant_id": this.state.teamId,
      "pipeline_id": this.state.selectedJobId,
      "p_integration_id": this.state.p_integration_id,
      "filter_date": this.state.endDate.format("YYYY-MM-DD"),
      // "env_id":this.props.selectedEnvId,
      "menu_type": "monitor",
      "env_id": this.props.selectedEnvId,
      "session_id": this.props.browserSessionId,
      "user_id": this.state.userId,
      "tab_type": 3,
      "selected_ids": [this.state.selectedJobId],
      "ids_type": "runs_info",
      "browser_tab_id": this.props.browserTabId

    }
    return pipelineRunInfo(requestParams);

  }

  pipelieMetaDataResponse() {
    let requestParams = {
      "tenant_id": this.state.teamId,
      "env_id": this.props.selectedEnvId

    }
    return getPipelineMetadata(requestParams);
  }
  pipelineStatusFilter = () => {
    let { pipeline_status_count } = this.state;
    if (!pipeline_status_count) return;

    const filterStatus = { 'pipeline-done': 'Succeeded', 'pipeline-failed': 'Failed', 'pipeline-running': 'Running', 'pipeline-progress': 'InProgress', 'pipeline-queued': 'Queued', 'pipeline-scheduled': 'Scheduled', 'pipeline-cancelled': 'Cancelled', 'pipeline-stage_failure_run_success': 'stage_failure_run_success' };

    const defaultItems = this.state.selectedItems

    const validItems = defaultItems.filter(item => {
      const key = filterStatus[item];
      return pipeline_status_count[key] > 0;
    });

    this.setState({
      selectedItems: validItems,
      appliedSelectedItems: validItems
    });
  };
  async initialApi() {
    let pipelineIntegrationResponse = await this.getPipelineIntegrationResponse()
    let pipelineMetaDataResponse = await this.pipelieMetaDataResponse()
    this.setState({ inputData: pipelineMetaDataResponse.data })
    let watchListResponse = await this.getWatchListResponse()
    let watchlistRequest;
    // let minDate
    if (pipelineIntegrationResponse.code === 200) {
      let storedWatchlist = JSON.parse(sessionStorage.getItem("selectedPipelineWatchlist"));
      let integrations = pipelineIntegrationResponse.integrations || [];
      let selectedEnvId = this.props.selectedEnvId;
      let envIntegrations = integrations.filter(
        integration => integration.env_id === selectedEnvId
      );

      let progressStatus = envIntegrations.length > 0 && envIntegrations.every(
        integration => integration.discovery_status === "initialised"
      );

      if (progressStatus) {
        this.setState({ inProgress: true, progressStatus: 5 });
      } else {
        this.setState({ inProgress: false });
      }
      const pipelineIconMapping = {};
      if (pipelineIntegrationResponse.integrations) {
        pipelineIntegrationResponse.integrations.forEach(integration => {
          const id = integration.p_integration_id;
          const type = integration.integration_type;
          if (id !== undefined && type !== undefined) {
            pipelineIconMapping[id] = type;
          }
        });
      }
      this.setState({
        pipelineIconMapping: pipelineIconMapping,
      })
      if (storedWatchlist) {
        this.setState(
          {
            selectedWatchlistName: storedWatchlist.watchListName,
            selectedWatchListId: storedWatchlist.watchListId
          },
          async () => {
            // Call API with watchlistId if storedWatchlist exists
            const pipelineResponse = await this.getPipelineResponse(storedWatchlist.watchListId);
            if (pipelineResponse.code === 200) {
              const filterStatus = { 'pipeline-failed': 'Failed', 'pipeline-done': 'Succeeded', 'pipeline-cancelled': 'Cancelled', 'pipeline-running': 'Running', 'pipeline-progress': 'InProgress', 'pipeline-queued': 'Queued', 'pipeline-scheduled': 'Scheduled', 'pipeline-stage_failure_run_success': 'stage_failure_run_success' };
              const filteredItems = this.state.selectedItems.filter(item => {
                const key = filterStatus[item];
                return pipelineResponse.response.pipeline_status_count?.[key] > 0;
              });
              this.setState({
                pipelinesource_data: pipelineIntegrationResponse.integrations,
                piplineInfo: pipelineResponse.response,
                showLoader: false,
                tempPiplineInfo: pipelineResponse.response,
                pipeline_status_count: pipelineResponse.response.pipeline_status_count,
                appliedSelectedItems: filteredItems,
                no_Runs: false
              });
              this.pipelineStatusFilter();
              this.updateMetaData();
              this.openIncidentPipelineRuns(pipelineResponse.response, pipelineIntegrationResponse.integrations);

              setTimeout(() => {
                this.timeFilterRenderHtml();
              }, 1000);
            }
            else {
              this.setState({ showLoader: false })
            }
          }
        );
      } else {
        // Call API with null if no watchlist is stored
        const pipelineResponse = await this.getPipelineResponse(null);
        if (pipelineResponse !== undefined && pipelineResponse.code === 200 && pipelineResponse.message === 'Successfully fetched') {
          const filterStatus = { 'pipeline-failed': 'Failed', 'pipeline-done': 'Succeeded', 'pipeline-cancelled': 'Cancelled', 'pipeline-running': 'Running', 'pipeline-progress': 'InProgress', 'pipeline-queued': 'Queued', 'pipeline-scheduled': 'Scheduled', 'pipeline-stage_failure_run_success': 'stage_failure_run_success' };
          const filteredItems = this.state.selectedItems.filter(item => {
            const key = filterStatus[item];
            return pipelineResponse.response.pipeline_status_count?.[key] > 0;
          });
          this.setState({
            pipelinesource_data: pipelineIntegrationResponse.integrations,
            piplineInfo: pipelineResponse.response,
            tempPiplineInfo: pipelineResponse.response,
            showLoader: false,
            pipeline_status_count: pipelineResponse.response.pipeline_status_count,
            appliedSelectedItems: filteredItems,
            no_Runs: false

          });
          this.pipelineStatusFilter();
          this.updateMetaData();
          this.openIncidentPipelineRuns(pipelineResponse.response, pipelineIntegrationResponse.integrations);

          setTimeout(() => {
            this.timeFilterRenderHtml();
          }, 1000);
        }
        else {
          if (pipelineResponse === undefined) {
            // if ((pipelineResponse.code === 401 && pipelineResponse.message === 'No entry found') || (pipelineResponse.message === 'No Run Identifier' && pipelineResponse.code === 200)) {
            //   // Handle no data found scenario clearly
            //   this.setState({
            //     showLoader: false,
            //     piplineInfo: {},
            //     noPipeline: true,
            //   });
            // } else {
            // Handle other types of errors
            this.setState({
              showLoader: false,
              piplineInfo: {},
              // noPipeline: true,
              pipelinesource_data: pipelineIntegrationResponse.integrations,
              appliedSelectedItems: "",
              no_Runs: true

            });
            // }
          }
        }
      }
    }
    if (pipelineMetaDataResponse.code === 200) {
      if (pipelineMetaDataResponse.data.integrations.length !== 0) {
        this.setState({ metaDataResponse: pipelineMetaDataResponse.data, showLoader: false })
      }
      else {
        this.setState({ noPipeline: true, showLoader: false })
      }
    }
    if (watchListResponse === undefined) {
      this.setState({ errorOccurred: true });
    } else {
      if (watchListResponse.code === 200) {
        let watchListMapping = await this.extractMultipleWatchlistIds(watchListResponse)
        this.setState({ watchListMapping: watchListMapping })

        watchlistRequest = watchListResponse.result.watch_list;
        if (watchlistRequest.length > 0) {
          this.setState({ watchListInformation: watchlistRequest, leftPanelLoader: false });
        }
        else {
          this.setState({ watchListInformation: '', leftPanelLoader: false });
        }
      }
      else {
        this.setState({ watchListInformation: '', leftPanelLoader: false });
      }
    }

  }
  componentDidMount() {

    this.initialApi()
    this.adjustHeight()
    this.receivePushData()

  }

  //getPipeline
  nowDate() {
    let endDate = this.state.initialendDate;
    let filteredData = [];
    let dataFilteredValues = [];
    this.setState({
      startDate: endDate,
      endDate: endDate,
      dataFilteredValues: dataFilteredValues,
      timeFilterApplied: true,
      currListViewTableData: filteredData,
      enableFadeLoader: true
    }, () => {
      this.getDatewisePipline()
    })
  }

  nextDate() {
    var endDate = moment(this.state.endDate);
    let time = this.state.timefilter.replace("hr", "")
    endDate = endDate.add(time, "hours");
    const now = moment();
    if (endDate.isAfter(now)) {
      $("#btn_pipline_next").addClass("disabled");
      return;
    } else {
      $("#btn_pipline_next").removeClass("disabled");
    }
    endDate = this.state.initialendDate > endDate ? endDate : this.state.initialendDate;
    let filteredData = [];
    let dataFilteredValues = [];
    this.setState({
      startDate: endDate,
      endDate: endDate,
      dataFilteredValues: dataFilteredValues,
      timeFilterApplied: true,
      currListViewTableData: filteredData,
      enableFadeLoader: true
    }, () => {
      this.getDatewisePipline()
    });
  }

  prevDate() {

    var endDate = moment(this.state.endDate);



    let time = this.state.timefilter.replace("hr", "")
    endDate = endDate.subtract(time, "hours");

    let filteredData = [];
    let dataFilteredValues = [];

    this.setState({
      startDate: endDate,
      endDate: endDate,
      dataFilteredValues: dataFilteredValues,
      timeFilterApplied: true,
      currListViewTableData: filteredData,
      enableFadeLoader: true
    }, () => {
      this.getDatewisePipline()
    });
  }

  prevDate_() {
    let endDate = moment(this.state.endDate)
    let EndDate_prev = endDate;
    let PipelineCreatedTime = moment(this.state.pipeline_created_time);


    if (EndDate_prev.isSame(PipelineCreatedTime, 'day')) {
      $("#btn_pipline_prev").attr("disabled", "true");
    } else {
      $("#btn_pipline_prev").removeAttr("disabled");
    }

    if (endDate.isSame(moment(this.state.initialendDate), 'day')) {
      $("#btn_pipline_next").removeAttr("disabled");
    }

    let filteredData = [];
    let dataFilteredValues = [];
    this.setState({
      dataFilteredValues: dataFilteredValues,
      timeFilterApplied: true,
      currListViewTableData: filteredData,
      enableFadeLoader: true
    }, () => this.applyTimeFilter(this.state.timefilter, "datecall"));
  }

  applyTimeFilterNow() {
    this.setState({
      endDate: this.state.initialendDate,
      startDate: this.state.initialstartDate,
      enableFadeLoader: true
    }
    );
  }
  applyTimeFilter(time, calltype) {
    if (parseInt(time) === 12 || parseInt(time) === 24) {
      $("th").eq(3).html(
        `<div class="tbl-time-range">
                                                          <div class="tbl-time-range__header">
                                                              <label> Pipeline Run Status - <strong id="lastSechduleDate">`+ this.state.endDate.format(PIPELINE_DISPLAY_DATE_FORMAT) + `</strong> (UTC+00:00)</label>
                                                              <label>
                                                              </label>
                                                              <ul class="tbl-time-range__list">
                                                                  <li id="chart_time_1">&nbsp;</li>
                                                                  <li id="chart_time_2">&nbsp;</li>
                                                                  <li id="chart_time_3">&nbsp;</li>
                                                                  <li id="chart_time_4">&nbsp;</li>
                                                                  <li id="chart_time_5">&nbsp;</li>
                                                                  <li id="chart_time_6">&nbsp;</li>
                                                                  <li id="chart_time_7">&nbsp;</li>
                                                                  <li id="chart_time_8">&nbsp;</li>
                                                                  <li id="chart_time_9">&nbsp;</li>
                                                                  <li id="chart_time_10">&nbsp;</li>
                                                                  <li id="chart_time_11">&nbsp;</li>
                                                                  <li id="chart_time_12">&nbsp;</li>
                                                                  <li id="chart_time_13">&nbsp;</li>
                                                                  <!--<li id="chart_time_13">&nbsp;</li>-->
                                                              </ul>
                                                          </div>
                                                      </div>
      `
      );
    } else {

      $("th").eq(3).html(
        `<div class="tbl-time-range">
                                                              <div class="tbl-time-range__header">
                                                                  <label> Last Day Schedule - <strong id="lastSechduleDate">`+ this.state.endDate.format(PIPELINE_DISPLAY_DATE_FORMAT) + `</strong> (GMT)</label>
                                                                  <label>
                                                                  </label>
                                                                  <ul class="tbl-time-range__list">
                                                                  <!--<li id="chart_time">&nbsp;</li>-->
                                                                      <li id="chart_time_1">&nbsp;</li>
                                                                      <li id="chart_time_2">&nbsp;</li>
                                                                      <li id="chart_time_3">&nbsp;</li>
                                                                      <li id="chart_time_4">&nbsp;</li>
                                                                      <li id="chart_time_5">&nbsp;</li>
                                                                      <li id="chart_time_6">&nbsp;</li>
                                                                      <li id="chart_time_7">&nbsp;</li>
                                                                  </ul>
                                                              </div>
                                                          </div>
          `
      );
    }
    //this.timeFilterRenderHtml(time, calltype);
    if (time === "0") {
      this.setState({ "timefilter": parseInt(1), endDate: this.state.initialendDate, startDate: this.state.initialstartDate });
    } else {
      this.setState({ "timefilter": parseInt(time), enableFadeLoader: calltype === "functioncall" ? false : true });
    }
  }


  formatUTCDate(Your_Date) {
    if (!Your_Date) {
      return "-"
    }
    if (Your_Date === "NA") {
      return "NA"
    }
    else {
      return moment.utc(Your_Date).format("DD MMM HH:mm");
    }
  }

  // millisecondToMinutesAndSeconds(millis) {
  //   millis = parseInt(millis);
  //   if (isNaN(millis) === true) {
  //     return;
  //   }
  //   var minutes = Math.floor(millis / 60000);
  //   var seconds = ((millis % 60000) / 1000).toFixed(0);
  //   if (minutes < 1) {
  //     return seconds + "s";
  //   } else {
  //     return minutes + "m " + (seconds < 10 ? '' : '') + seconds + "s";
  //   }
  // }

  millisecondToTime(millis) {

    millis = parseInt(millis, 10);
    if (isNaN(millis)) return;

    const seconds = Math.floor((millis / 1000) % 60);
    const minutes = Math.floor((millis / (1000 * 60)) % 60);
    const hours = Math.floor((millis / (1000 * 60 * 60)) % 24);
    const days = Math.floor(millis / (1000 * 60 * 60 * 24));

    if (days > 0) {
      return `${days}d ${hours}h ${minutes}m ${seconds}s`;
    }

    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`;
    }

    if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    }

    return `${seconds}s`;
  }


  millisecondToMinutesAndSeconds(millis) {
    millis = parseInt(millis, 10);
    if (isNaN(millis)) return;

    const seconds = Math.floor((millis / 1000) % 60);
    const minutes = Math.floor((millis / (1000 * 60)) % 60);
    const hours = Math.floor((millis / (1000 * 60 * 60)) % 24);
    const days = Math.floor(millis / (1000 * 60 * 60 * 24));

    if (days > 0) {
      return `${days}d ${hours}h ${minutes}m ${seconds}s`;
    }

    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`;
    }

    if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    }

    return `${seconds}s`;
  }



  formPipelineRunsTableData(inputData) {

    let headers = ["Run ID", "Timing", "Job", "Status"];
    //let stackedbarchartdata;
    let final_op = [];
    let failed_run_op = [];
    let table_data = { "headers": headers, "data": final_op };
    if (inputData.run_data !== undefined) {




      for (let i = 0; i < inputData.run_data.length; i++) {

        let row = [];
        let pipeline = inputData['run_data'][i];
        let reqData = {}
        reqData['value'] = pipeline['run_start_time']
        reqData['duration'] = pipeline['duration']
        row.push({ "value": pipeline, "type": "td" });
        row.push({ "value": reqData, "type": "pipeline" });
        row.push({ "value": pipeline, "type": "pipeline" });
        row.push({ "value": pipeline['run_status_text'], "type": "td" });
        if (pipeline['run_status_text'] === "Failed" || pipeline['run_status_text'] === "stage_failure_run_success") {
          failed_run_op.push(row);
        }
        final_op.push(row);
      }
      if (this.state.activeTab === 'fr') {
        table_data = { "headers": headers, "data": failed_run_op }
      }
    }
    return table_data;
  }

  pipelineStagesFormatData(data) {
    if (data) {
      //let json = stageInfo.data.stage_data;
      let json = data;
      let tasks = [];
      let failed_task_cnt = 0, others_task_cnt = 0, success_task_cnt = 0;
      for (let loop = 0; loop < json.length; loop++) {
        var depends = []
        depends = depends.toString().split(",")
        let bg_color;

        if (json[loop]["stage_status_text"] === "Failed") {
          bg_color = "#F64E60";
          failed_task_cnt++;
        } else if (json[loop]["stage_status_text"] === "Succeeded") {
          bg_color = "#4ED2CC";
          success_task_cnt++;
        }
        else {
          bg_color = "#795548";
          others_task_cnt++;
        }

        let obj = {
          "start": new Date(json[loop]["stage_start_time"]),
          "end": new Date(json[loop]["stage_end_time"]),  // stage_end_time
          "name": json[loop]["stage_name"],
          "id": json[loop]["stage_name"],
          "type": "task",
          "hideChildren": false,
          "progress": 100,
          "isDisabled": true,
          //"dependencies": [depends],
          "dependencies": depends,
          "status": json[loop]["stage_status_text"],
          "TooltipContent": "<div>Testses</div>",
          "styles":
            { 'progressColor': bg_color, 'progressSelectedColor': bg_color, 'backgroundColor': bg_color, 'backgroundSelectedColor': bg_color },
        }
        tasks.push(obj)
      }

      this.setState({
        progress: 100,
        gantt_chart_details: tasks,
        gantt_chart_grid: json,
        gantt_chart_grid_temp: json,
        failed_task_cnt: failed_task_cnt,
        others_task_cnt: others_task_cnt,
        success_task_cnt: success_task_cnt
      });
    }
  }

  async showDetailsPipeline(pm, evt) {
    if (evt && typeof evt.preventDefault === 'function') {
      evt.preventDefault();
      if (typeof evt.stopPropagation === 'function') {
        evt.stopPropagation();
      }
    }
    if (!pm) return;

    this.setState({
      gannt_parms_json: JSON.stringify(pm),
      progress: 50,
      p_run_id: pm.p_run_id,
      detailJobId: this.state.selectedJobId,
      detailviewid: pm.source_run_id,
      detailviewstatus: pm.run_status_text,
      detailviewtiming: this.formatUTCDate(pm.run_start_time),
      detailviewsuccesscnt: "",
      detailviewfailedcnt: "",
      detailviewjobname: pm.lable,
      detailviewduration: this.millisecondToMinutesAndSeconds(pm.duration),
      detailviewstages: pm.stages,
      gantt_char_trunid: pm.source_run_id,
      gantt_chart_jobid: this.state.selectedJobId,
      lienage_graph_type: "run-level",
      activeTab: this.state.activeTab === "navtroubleshooting" ? "navtroubleshooting" : "tv",
    }, async () => {
      try {
        if (this.state.activeTab === "tv" || this.state.activeTab === "jr") {
          const stageInfo = await this.pipelineStagesInfoResponse();
          if (stageInfo && stageInfo.code === 200) {
            this.pipelineStagesFormatData(stageInfo.data.stage_data);
          }
        }

        if (this.state.activeTab === "navtroubleshooting") {
          const lineageResponse = await this.getLineageresponse(this.state.lienage_graph_type);
          if (lineageResponse && lineageResponse.code === 200) {
            this.setState({ run_level_lineageData: lineageResponse.lineage_data, showLoader: false });
          }
        }
      } catch (err) {
        console.error("showDetailsPipeline failed:", err);
      } finally {
        // Show run panel immediately (no 2s delay); hide job-level panel via React
        const $panel = $("#rt-pipeline-panel");
        if ($panel.length) {
          $panel.removeClass("d-none");
        }
        $("#fullscreendatefilter").hide();
        $("#datepicker_details").hide();
      }
    });
  }
  // NEW: escape HTML characters to avoid injection
  escapeHtml = (unsafe) => {
    if (unsafe === undefined || unsafe === null) return '';
    return String(unsafe)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  // NEW: format string/object for tooltip/popover (pretty JSON -> newline -> <br/>)
  formatForHtml = (raw, pretty = true) => {
    if (raw === undefined || raw === null) return "";
    let str;
    if (typeof raw === "string") {
      str = raw;
    } else if (typeof raw === "object") {
      // pretty print to get newline characters
      str = JSON.stringify(raw, null, pretty ? 2 : undefined);
    } else {
      str = String(raw);
    }

    const escaped = this.escapeHtml(str);
    return escaped.replace(/\r?\n/g, "<br/><br/>");
  };

  // NEW: format for inline small previews (one-line, truncated)
  formatForInline = (raw, maxLength = 200) => {
    if (raw === undefined || raw === null) return "";
    let str;
    if (typeof raw === "string") {
      str = raw;
    } else if (typeof raw === "object") {
      str = JSON.stringify(raw);
    } else {
      str = String(raw);
    }

    const firstLine = (str.split(/\r?\n/)[0] || "").trim();
    let truncated = firstLine.length > maxLength ? firstLine.substring(0, maxLength) + "…" : firstLine;
    return this.escapeHtml(truncated).replace(/\r?\n/g, "<br/><br/>");
  };

  // FIX: copy the actual text string to clipboard (previous version wrote index)
  handleTagClipboard = (key, text, type) => {
    if (!text && text !== "") return;
    const valueToCopy = typeof text === "string" ? text : JSON.stringify(text);
    try {
      navigator.clipboard.writeText(valueToCopy);
    } catch (err) {
      console.error("Clipboard write failed:", err);
    }
    // Maintain previous copied marker behavior
    this.setState({ tagTextCopied: `${type}_${key}` });
    setTimeout(() => {
      this.setState({ tagTextCopied: "" });
    }, 3000);
  };

  pipelineTableComponent(actionType, headerValue, cell, tableProps, row) {
    if (headerValue === "Run ID") {
      return (
        <a
          href="#!"
          className="text-info"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.showDetailsPipeline(cell, e);
          }}
        >
          {cell['source_run_id']}
        </a>
      )
    }

    if (headerValue === "Timing") {
      return (
        <dl>
          <dt>
            {this.formatUTCDate(cell.value)}
          </dt>
          <dd className="text-muted"><i><svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><g><g><path d="M15,1H9v2h6V1z M11,14h2V8h-2V14z M19.03,7.39l1.42-1.42c-0.43-0.51-0.9-0.99-1.41-1.41l-1.42,1.42 C16.07,4.74,14.12,4,12,4c-4.97,0-9,4.03-9,9s4.02,9,9,9s9-4.03,9-9C21,10.88,20.26,8.93,19.03,7.39z M12,20c-3.87,0-7-3.13-7-7 s3.13-7,7-7s7,3.13,7,7S15.87,20,12,20" /></g></g></g></svg></i> {this.millisecondToMinutesAndSeconds(cell.duration)}</dd>
        </dl>
      )
    }
    if (headerValue === "Job") {
      return (
        <dl>
          <dt className="mb-2"> {this.state.selectedMoreJobName} </dt>
          <dd style={{ Width: "600px", whiteSpace: 'normal' }}>
            {
              this.state.selectedJobRunsFullscreen &&
              this.state.selectedJobRunsFullscreen.stage_data &&
              this.state.selectedJobRunsFullscreen.stage_data[cell['source_run_id']] &&
              this.state.selectedJobRunsFullscreen.stage_data[cell['source_run_id']].map((stages) => {
                return (<span className={stages.stage_status_text === undefined ?
                  "badge badge-light mr-1 mb-1" :
                  stages.stage_status_text === "Succeeded" ? "badge badge-light-green mr-1 mb-1" :
                    stages.stage_status_text === "Failed" ? "badge badge-light-red mr-1 mb-1"
                      : "badge badge-light-brown mr-1 mb-1"} className1="badge badge-light mr-1 mb-1">{stages.stage_name}</span>)/* need to add badge-light-green for success and badge-light-red for failure */
              })
            }
          </dd>
        </dl>
      )
    }
    if (headerValue === "Status") {
      return (() => {
        const status = cell;
        if (!status) return "-";

        const run_status = status.toLowerCase();

        const statusMap = {
          succeeded: (
            <div className="badge badge-light-success bdr-light-success">
              <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9" /></svg><span className="ml-1">Success</span>
            </div>
          ),
          failed: (
            <div className="badge badge-light-danger bdr-light-danger">
              <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59" /></svg><span className="ml-1">Failed</span>
            </div>
          ),
          running: (
            <div className="d-flex align-items-center text-info">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_263_199)">
                  <path d="M16.24 7.76C15.07 6.59 13.54 6 12 6V12L7.76 16.24C10.1 18.58 13.9 18.58 16.25 16.24C18.59 13.9 18.59 10.1 16.24 7.76V7.76ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="#4CA3FF" />
                </g>
                <defs>
                  <clipPath id="clip0_263_199">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span className="ml-1 flex-grow-1">Running</span>
            </div>
          ),
          inprogress: (
            <div className='d-flex align-items-center text-primary'>
              <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="#495FB8"><g><rect fill="none" height="24" width="24" /></g><g><path d="M6,2l0.01,6L10,12l-3.99,4.01L6,22h12v-6l-4-4l4-3.99V2H6z M16,16.5V20H8v-3.5l4-4L16,16.5z" /></g></svg>
              <span className="ml-1 flex-grow-1">In Progress</span>
            </div>
          ),
          queued: (
            <div className='d-flex align-items-center text-primary'>
              <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#FFA800"><path d="M0 0h24v24H0z" fill="none" /><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z" /></svg>
              <span className="ml-1 flex-grow-1">Queued</span>
            </div>
          ),
          cancelled: (
            <div className='d-flex align-items-center text-primary'>
              <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#F64E60"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
              <span className="ml-1 flex-grow-1">Cancelled</span>
            </div>
          ),
          skipped: (
            <div className='d-flex align-items-center text-primary'>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.4758 12.2096V3.79102H12.6654V12.2096H11.4758ZM3.33203 12.2096V3.79102L9.64585 8.00029L3.33203 12.2096Z" fill="#495FB8" />
              </svg>
              <span className="ml-1 flex-grow-1">Skipped</span>
            </div>
          ),
          restart: (
            <div className='d-flex align-items-center text-primary'>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.2 14.9262C5.69947 14.7313 4.45767 14.0703 3.4746 12.9432C2.49153 11.816 2 10.4955 2 8.98159C2 8.16826 2.16053 7.38906 2.4816 6.64399C2.80267 5.89879 3.2524 5.24413 3.8308 4.67999L4.6862 5.53539C4.19487 5.98366 3.82433 6.50393 3.5746 7.09619C3.32487 7.68846 3.2 8.31693 3.2 8.98159C3.2 10.1549 3.5746 11.1891 4.3238 12.084C5.073 12.9788 6.03173 13.5262 7.2 13.7262V14.9262ZM8.8 14.9416V13.7416C9.95493 13.5077 10.9103 12.948 11.6662 12.0624C12.4221 11.1768 12.8 10.1499 12.8 8.98159C12.8 7.64826 12.3333 6.51493 11.4 5.58159C10.4667 4.64826 9.33333 4.18159 8 4.18159H7.717L8.797 5.26159L7.9538 6.10459L5.4308 3.58159L7.9538 1.05859L8.797 1.90159L7.717 2.98159H8C9.67387 2.98159 11.0923 3.56313 12.2554 4.72619C13.4185 5.88926 14 7.30773 14 8.98159C14 10.4872 13.5072 11.8011 12.5216 12.9232C11.5359 14.0452 10.2953 14.718 8.8 14.9416Z" fill="#FA4616" />
              </svg>
              <span className="ml-1 flex-grow-1">Restart</span>
            </div>
          ),
          none: (
            <div className='d-flex align-items-center text-primary'>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99993 14.6673C7.07782 14.6673 6.2111 14.4923 5.39975 14.1424C4.58841 13.7925 3.88267 13.3176 3.28256 12.7177C2.68244 12.1178 2.20729 11.4123 1.85712 10.6014C1.50706 9.79036 1.33203 8.92387 1.33203 8.00188C1.33203 7.07977 1.507 6.21305 1.85694 5.4017C2.20689 4.59036 2.6818 3.88463 3.28168 3.28451C3.88156 2.68439 4.587 2.20925 5.398 1.85907C6.20899 1.50901 7.07548 1.33398 7.99747 1.33398C8.91958 1.33398 9.7863 1.50895 10.5976 1.8589C11.409 2.20884 12.1147 2.68375 12.7148 3.28363C13.315 3.88352 13.7901 4.58896 14.1403 5.39995C14.4903 6.21094 14.6654 7.07743 14.6654 7.99942C14.6654 8.92153 14.4904 9.78825 14.1405 10.5996C13.7905 11.4109 13.3156 12.1167 12.7157 12.7168C12.1158 13.3169 11.4104 13.7921 10.5994 14.1422C9.78841 14.4923 8.92191 14.6673 7.99993 14.6673ZM7.33747 11.334H8.65993C9.00881 11.334 9.30747 11.2098 9.55589 10.9614C9.80431 10.7129 9.92852 10.4143 9.92852 10.0654V5.93591C9.92852 5.58703 9.80431 5.28837 9.55589 5.03995C9.30747 4.79153 9.00881 4.66732 8.65993 4.66732H7.33747C6.98858 4.66732 6.68993 4.79153 6.4415 5.03995C6.19308 5.28837 6.06887 5.58703 6.06887 5.93591V10.0654C6.06887 10.4143 6.19308 10.7129 6.4415 10.9614C6.68993 11.2098 6.98858 11.334 7.33747 11.334ZM7.33747 5.71995H8.65993C8.72297 5.71995 8.77472 5.74018 8.81519 5.78065C8.85566 5.82112 8.87589 5.87287 8.87589 5.93591V10.0654C8.87589 10.1284 8.85566 10.1802 8.81519 10.2207C8.77472 10.2611 8.72297 10.2814 8.65993 10.2814H7.33747C7.27443 10.2814 7.22267 10.2611 7.18221 10.2207C7.14174 10.1802 7.1215 10.1284 7.1215 10.0654V5.93591C7.1215 5.87287 7.14174 5.82112 7.18221 5.78065C7.22267 5.74018 7.27443 5.71995 7.33747 5.71995Z" fill="#6C757D" />
              </svg>
              <span className="ml-1 flex-grow-1">None</span>
            </div>
          ),
          stage_failure_run_success: (
            <div className='d-flex align-items-center'>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.6654 6.00065C8.08937 6.00065 5.9987 8.09132 5.9987 10.6673C5.9987 13.2433 8.08937 15.334 10.6654 15.334C13.2414 15.334 15.332 13.2433 15.332 10.6673C15.332 8.09132 13.2414 6.00065 10.6654 6.00065ZM9.4007 12.6693L7.72536 10.994C7.54337 10.812 7.54337 10.518 7.72536 10.336C7.90736 10.154 8.20136 10.154 8.38336 10.336L9.73203 11.68L12.9427 8.46932C13.1247 8.28732 13.4187 8.28732 13.6007 8.46932C13.7827 8.65132 13.7827 8.94532 13.6007 9.12732L10.0587 12.6693C9.88136 12.8513 9.5827 12.8513 9.4007 12.6693Z" fill="#50CD89" />
                <path d="M4.66536 6.33398C4.75981 6.33398 4.83898 6.30204 4.90286 6.23815C4.96675 6.17426 4.9987 6.0951 4.9987 6.00065C4.9987 5.90621 4.96675 5.82704 4.90286 5.76315C4.83898 5.69926 4.75981 5.66732 4.66536 5.66732C4.57092 5.66732 4.49175 5.69926 4.42786 5.76315C4.36398 5.82704 4.33203 5.90621 4.33203 6.00065C4.33203 6.0951 4.36398 6.17426 4.42786 6.23815C4.49175 6.30204 4.57092 6.33398 4.66536 6.33398ZM4.33203 5.00065H4.9987V3.00065H4.33203V5.00065ZM4.66536 8.00065C4.20425 8.00065 3.77092 7.91315 3.36536 7.73815C2.95981 7.56315 2.60703 7.32565 2.30703 7.02565C2.00703 6.72565 1.76953 6.37287 1.59453 5.96732C1.41953 5.56176 1.33203 5.12843 1.33203 4.66732C1.33203 4.20621 1.41953 3.77287 1.59453 3.36732C1.76953 2.96176 2.00703 2.60898 2.30703 2.30898C2.60703 2.00898 2.95981 1.77148 3.36536 1.59648C3.77092 1.42148 4.20425 1.33398 4.66536 1.33398C5.12648 1.33398 5.55981 1.42148 5.96536 1.59648C6.37092 1.77148 6.7237 2.00898 7.0237 2.30898C7.3237 2.60898 7.5612 2.96176 7.7362 3.36732C7.9112 3.77287 7.9987 4.20621 7.9987 4.66732C7.9987 5.12843 7.9112 5.56176 7.7362 5.96732C7.5612 6.37287 7.3237 6.72565 7.0237 7.02565C6.7237 7.32565 6.37092 7.56315 5.96536 7.73815C5.55981 7.91315 5.12648 8.00065 4.66536 8.00065ZM4.66536 7.33398C5.40981 7.33398 6.04036 7.07565 6.55703 6.55898C7.0737 6.04232 7.33203 5.41176 7.33203 4.66732C7.33203 3.92287 7.0737 3.29232 6.55703 2.77565C6.04036 2.25898 5.40981 2.00065 4.66536 2.00065C3.92092 2.00065 3.29036 2.25898 2.7737 2.77565C2.25703 3.29232 1.9987 3.92287 1.9987 4.66732C1.9987 5.41176 2.25703 6.04232 2.7737 6.55898C3.29036 7.07565 3.92092 7.33398 4.66536 7.33398Z" fill="#F04438" />
              </svg>  stage_failure_run_success
            </div>
          )
        };

        return statusMap[run_status] || "-";
      })()
    }
    return cell;
  }

  gobackfullscreen() {

    this.setState({
      detailviewid: "",
      lienage_graph_type: "job-level",
      activeTab: "jr"
    }
      , () => {
        $("#rt-pipeline-panel").addClass("d-none")
      }
    );
  }



  filterStageSearch(event) {
    let searchstage = event.target.value;
    clearTimeout(this.delaytime);
    this.setState({ searchingTaskText: searchstage });
    this.delaytime = setTimeout(() => {
      this.filterStageDetails(searchstage);
    }, 10);
  }

  filterStageDetails(searchstagevalue) {
    let searchstage = String(searchstagevalue).trim().toLowerCase();
    let gantt_chart_grid_temp;

    // Fast path: return all data if empty search
    if (!searchstage) {
      gantt_chart_grid_temp = this.state.gantt_chart_grid;
    } else {
      // Map user-friendly "success" to "succeeded"
      if (searchstage.includes("success")) {
        searchstage = searchstage.replace("success", "succeeded");
      }

      // Include filter string in search if available
      const filterStr = this.state.gantt_chart_grid_filter?.toString().toLowerCase() || "";
      const finalSearch = (searchstage + " " + filterStr).trim();

      // Tokenize the final search string if multiple keywords are used
      const searchTokens = finalSearch.split(/\s+/);

      // Use single pass filter with precomputed lowercase fields
      gantt_chart_grid_temp = this.state.gantt_chart_grid.filter(data => {
        const name = data.stage_name?.toLowerCase() || "";
        const type = data.stage_type?.toLowerCase() || "";
        const status = data.stage_status_text?.toLowerCase() || "";

        return searchTokens.some(token =>
          name.includes(token) || type.includes(token) || status.includes(token)
        );
      });
    }

    this.setState({
      gantt_chart_grid_temp,
      searchingTaskText: searchstagevalue
    });
  }

  searchJobs(event) {
    this.setState({
      searchingJobText: event.target.value
    });
  }
  showToast(status, msg) {
    this.setState({
      toastStatus: true,
      toastMsg: msg,
      toastClass: status === "success" ? "toast floating-top-toast toast-success" : "toast floating-top-toast toast-danger",
      toastIcon: status === "success" ? faCheckCircle : faTimes,
      toastHeading: status === "success" ? "Success!" : "Error!"
    });

    // Auto close after 3 seconds
    setTimeout(() => {
      this.setState({ toastStatus: false });
    }, 3000);
  }
  closeToast() {
    this.setState({ toastStatus: false });
  }

  //Toggle expand and collapse
  handleLineageExpand = () => {
    this.setState({ lineageGraphExpanded: !this.state.lineageGraphExpanded });
  }

  async handleSearchJob(event) {
    const searchText = event.target.value.trim().toLowerCase();

    if (this.searchTimeout) clearTimeout(this.searchTimeout);

    this.setState({ searchText }); // Just update the search text for now

    if (searchText.length === 0) {
      this.lastSearchTerm = '';
      const pipelineResponse = await this.getPipelineResponse(
        this.state.selectedWatchListId,
        this.state.isCheackedActiveRuns,
        "",
        null,
        this.state.endDate.format("YYYY-MM-DD")
      );

      if (pipelineResponse.code === 200) {
        const pipelines = pipelineResponse.response.pipelines || {};
        let pipelineMatchCount = 0;
        Object.keys(pipelines).forEach(key => {
          pipelineMatchCount += pipelines[key].length;
        });

        const integrationMatchCount = (pipelineResponse.response.integrations || []).length;

        this.setState({
          piplineInfo: pipelineResponse.response,
          searchIntegrationData: pipelineResponse.response.integrations,
          totalMatchedPipelines: pipelineMatchCount,
          totalMatchedIntegrations: integrationMatchCount,
          fetchingJobsloader: false,
          enableFadeLoader: false,
          pipeline_status_count: pipelineResponse.response.pipeline_status_count
        });
      } else {
        this.setState({ fetchingJobsloader: false, enableFadeLoader: false });
        console.error("Pipeline API error:", pipelineResponse.message);
      }
      return;
    }

    // Set debounce delay to 2 seconds (2000 ms)
    this.searchTimeout = setTimeout(async () => {
      this.setState({ fetchingJobsloader: true, highlightText: true });

      const isContinuation = this.lastSearchTerm && searchText.startsWith(this.lastSearchTerm);

      if (isContinuation && this.state.piplineInfo) {
        const filteredPipelines = {};
        const pipelines = this.state.piplineInfo?.pipelines || {};
        const integrations = this.state.piplineInfo?.integrations || [];

        let pipelineMatchCount = 0;
        const matchedIntegrationIds = new Set();

        const matchedIntegration = integrations.find(integration =>
          integration.name?.toLowerCase().includes(searchText)
        );

        if (matchedIntegration) {
          const integrationId = String(matchedIntegration.id);
          const allPipelines = pipelines[integrationId] || [];

          filteredPipelines[integrationId] = allPipelines;
          pipelineMatchCount = allPipelines.length;

          this.setState({
            piplineInfo: {
              ...this.state.piplineInfo,
              pipelines: filteredPipelines,
              integrations: [matchedIntegration],
            },
            fetchingJobsloader: false,
            highlightText: true,
            totalMatchedPipelines: pipelineMatchCount,
            totalMatchedIntegrations: 1,
          });
        } else {
          Object.keys(pipelines).forEach((integrationId) => {
            const matchedPipes = pipelines[integrationId].filter((item) =>
              item.label?.toLowerCase().includes(searchText)
            );

            if (matchedPipes.length > 0) {
              filteredPipelines[integrationId] = matchedPipes;
              pipelineMatchCount += matchedPipes.length;
              matchedIntegrationIds.add(String(integrationId));
            }
          });

          const filteredIntegrations = integrations.filter(integration =>
            matchedIntegrationIds.has(String(integration.value))
          );

          this.setState({
            piplineInfo: {
              ...this.state.piplineInfo,
              pipelines: filteredPipelines,
              integrations: filteredIntegrations,
            },
            fetchingJobsloader: false,
            highlightText: true,
            totalMatchedPipelines: pipelineMatchCount,
            totalMatchedIntegrations: filteredIntegrations.length,
          });
        }
      } else {
        try {
          const pipelineResponse = await this.getPipelineResponse(
            this.state.selectedWatchListId,
            this.state.isCheackedActiveRuns,
            "",
            searchText,
            null
          );

          if (pipelineResponse.code === 200) {
            const pipelines = pipelineResponse.response.pipelines || {};
            let pipelineMatchCount = 0;
            Object.keys(pipelines).forEach(key => {
              pipelineMatchCount += pipelines[key].length;
            });

            const integrationMatchCount = (pipelineResponse.response.integrations || []).length;

            this.setState({
              piplineInfo: pipelineResponse.response,
              searchIntegrationData: pipelineResponse.response.integrations,
              totalMatchedPipelines: pipelineMatchCount,
              totalMatchedIntegrations: integrationMatchCount,
              fetchingJobsloader: false,
              highlightText: true,
              pipeline_status_count: pipelineResponse.response.pipeline_status_count

            });
          } else {
            this.setState({ fetchingJobsloader: false, highlightText: false });
            console.error("Pipeline API error:", pipelineResponse.message);
          }
        } catch (error) {
          this.setState({ fetchingJobsloader: false, highlightText: false });
          console.error("Pipeline API exception:", error);
        }
      }

      this.lastSearchTerm = searchText;
    }, 2000); // 2 seconds debounce
  }



  clearTask() {
    this.setState({
      searchingTaskText: ""
    });
    this.filterStageDetails("")
  }

  clearSearch() {
    this.setState({
      searchingJobText: ''
    });
  }
  //delete watchlist
  deleteWatchListResponse = async () => {
    const { selectedWatchListId, userId } = this.state;
    let requestParams = {
      tab_type: this.state.seletedTabId,
      tenant_id: this.state.teamId,
      user_id: userId,
      env_id: this.props.selectedEnvId,
      watch_list_id: selectedWatchListId,
    };

    return deleteWatchList(requestParams)
  };
  getWatchListResponse() {
    let requestParams = {
      "tab_type": this.state.seletedTabId, // DQ Tab
      "tenant_id": this.state.teamId, // Team Id
      "env_id": this.props.selectedEnvId,
      "user_id": this.state.userId
    }
    return getWatchList(requestParams);
  }
  async saveWatchListResponse(metaDataResponse) {
    let checkedStates = this.state.checkedStates || {};

    let watchListData = {
      integrations: [],
      pipelines: {}
    };
    const selectedIntegrationIds = new Set();

    // First, collect selected pipelines and group them by their integration
    metaDataResponse.pipelines.forEach(pipeline => {
      const pipelineKey = `Pipeline-${pipeline.value}`;
      if (checkedStates[pipelineKey]?.checked) {
        const integrationId = pipeline.p_integration_id;

        if (integrationId) {
          selectedIntegrationIds.add(integrationId);

          if (!watchListData.pipelines[integrationId]) {
            watchListData.pipelines[integrationId] = [];
          }

          watchListData.pipelines[integrationId].push({
            label: pipeline.label,
            value: pipeline.value,
            status_code: true
          });
        }
      }
    });

    // Now, only include integrations related to selected pipelines
    metaDataResponse.integrations.forEach(integration => {
      const integrationKey = `Datasource-${integration.value}`; // Assuming "Datasource" is the type
      if (selectedIntegrationIds.has(integration.value)) {
        watchListData.integrations.push({
          label: integration.label,
          value: integration.value,
          status_code: true,
          is_checked: checkedStates[integrationKey]?.checked || false
        });

        if (!watchListData.pipelines[integration.value]) {
          watchListData.pipelines[integration.value] = [];
        }
      }
    });

    let inputParams = {
      tab_type: this.state.seletedTabId,
      tenant_id: this.state.teamId,
      env_id: this.props.selectedEnvId,
      user_id: this.state.userId,
      watch_list_name: this.state.watchListName,
      watch_list_data: watchListData,
    };

    try {
      if (this.state.selectedWatchListId && this.state.editWatchlist) {
        inputParams.watch_list_id = this.state.selectedWatchListId;
        const response = await updateWatchList(inputParams);
        if (response.code === 200) {
          this.handleWishListClose();
          const watchListResponse = await this.getWatchListResponse();
          if (watchListResponse?.code === 200) {
            let watchListMapping = await this.extractMultipleWatchlistIds(watchListResponse)
            this.setState({
              watchListMapping: watchListMapping,
              watchListInformation: watchListResponse.result.watch_list,
              selectedWatchlistName: this.state.watchListName // Update selected name to the new name
            });

            // Reload left panel and right panel with updated watchlist
            this.handleWatchlistChange(this.state.watchListName, this.state.selectedWatchListId);
          } else {
            this.setState({ watchListInformation: '' });
          }

          // **Show Success Toast for Update**
          this.showToast("success", "Watchlist successfully updated!");
        } else {

          // **Show Error Toast**
          this.showToast("error", response.message);
        }
      } else {
        let response = await saveWatchList(inputParams);
        if (response.code === 200) {
          this.handleWishListClose();
          const watchListResponse = await this.getWatchListResponse();
          if (watchListResponse?.code === 200) {
            let watchListMapping = await this.extractMultipleWatchlistIds(watchListResponse)
            // Find the newly created watchlist ID
            const newWatchlist = watchListResponse.result.watch_list.find(
              wl => wl.watch_list_name === this.state.watchListName
            );
            this.setState({
              watchListMapping: watchListMapping,
              watchListInformation: watchListResponse.result.watch_list,
              selectedWatchlistName: this.state.watchListName, // Select the new watchlist
              selectedWatchListId: newWatchlist?.watch_list_id || null // Set the new watchlist ID
            });

            // Reload left panel and right panel with new watchlist
            if (newWatchlist?.watch_list_id) {
              this.handleWatchlistChange(this.state.watchListName, newWatchlist.watch_list_id);
            }
          } else {
            this.setState({ watchListInformation: '' });
          }

          // **Show Success Toast for Save**
          this.showToast("success", "Watchlist successfully saved!");
        } else {

          if (response.message === "Watchlist name already exists in the tenant.") {
            this.setState({ watchListNameError: "Duplicate Watchlist name detected." })
            this.showToast("error", "The watchlist name already exists in the environment");
          }
          else {
            this.showToast("error", response.message);
          }
        }
      }
    } catch (error) {
      console.error("Save/Update Watchlist Error:", error);

      // **Show Error Toast**
      this.showToast("error", "An error occurred while saving/updating the watchlist.");
    }
  }
  closeLineageRightPanel() {
    $(".lineage-graph-sidebar").removeClass("show")
  }

  Rightpanelinfo(label, value) {
    if (value !== undefined && value !== "NA" && value !== null) {
      let icon;
      if (label === "Duration" || label === "Last Run Duration") {
        icon = (
          <i className="mr-1"><svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><g>
            <g><path d="M15,1H9v2h6V1z M11,14h2V8h-2V14z M19.03,7.39l1.42-1.42c-0.43-0.51-0.9-0.99-1.41-1.41l-1.42,1.42 C16.07,4.74,14.12,4,12,4c-4.97,0-9,4.03-9,9s4.02,9,9,9s9-4.03,9-9C21,10.88,20.26,8.93,19.03,7.39z M12,20c-3.87,0-7-3.13-7-7 s3.13-7,7-7s7,3.13,7,7S15.87,20,12,20" /></g></g></g></svg>
          </i>
        );
      } else if (label === "Job Name") {
        icon = (
          <i className="mr-1"><svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><path d="M15,22h4c1.1,0,2-0.9,2-2v-3c0-1.1-0.9-2-2-2h-1v-2c0-1.1-0.9-2-2-2h-3V9h1c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2h-4 C8.9,2,8,2.9,8,4v3c0,1.1,0.9,2,2,2h1v2H8c-1.1,0-2,0.9-2,2v2H5c-1.1,0-2,0.9-2,2v3c0,1.1,0.9,2,2,2h4c1.1,0,2-0.9,2-2v-3 c0-1.1-0.9-2-2-2H8v-2h8v2h-1c-1.1,0-2,0.9-2,2v3C13,21.1,13.9,22,15,22" /></g></svg></i>
        );
      } else if (label === "Start Time" || label === "End Time" || label === "Next Scheduled Run") {
        icon = (
          <i className="mr-1"><svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0" fill="none" /><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8" /><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67" /></svg>
          </i>
        );
      }
      else if (label === "Stage ID" || label === "Source Run ID") {
        icon = (
          <i className="mr-1"><svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="14px" viewBox="0 0 24 24" width="14px" fill="#86899A"><g><rect fill="none" height="24" width="24" /><path d="M0,0h24v24H0V0" fill="none" /></g><g><path d="M14,2H6C4.9,2,4.01,2.9,4.01,4L4,20c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M10.94,18L7.4,14.46l1.41-1.41 l2.12,2.12l4.24-4.24l1.41,1.41L10.94,18z M13,9V3.5L18.5,9H13" /></g></svg></i>
        );
      } else {
        // icon = <i>:</i>;
      }

      // {this.state.detailviewid?.length > 28 && (
      //    <>this.getShortId(this.state.detailviewid)
      //   <RcTooltip
      //     placement="top"
      //     overlay={this.state.detailviewid}
      //     trigger={['hover']}
      //   >
      //     <span>
      //       [...]
      //     </span>
      //   </RcTooltip></>
      // )}

      return (
        <p key={label}>
          <label>{label}:</label>
          <span>{icon}
            {value.length > 30 ? (
              <>
                {this.getShortId(value)}
                <RcTooltip
                  placement="top"
                  overlay={value}
                  trigger={['hover']}
                >
                  <span>[...]</span>
                </RcTooltip>
              </>
            ) : (
              value
            )}
          </span>
        </p>
      );
    }
    return null;
  }

  formatDbtCoreDetailValue(label, value) {
    if (value === undefined || value === null || value === "" || value === "NA") {
      return null;
    }
    if (Array.isArray(value)) {
      return value.length > 0 ? value.join(", ") : null;
    }
    if (label === "Duration") {
      return this.millisecondToMinutesAndSeconds(value);
    }
    if (label === "Execution Time" && typeof value === "number") {
      return `${value}s`;
    }
    return value;
  }

  formatLineageDetailLabel(key) {
    if (key === "datasets_details") return "Dataset Details";
    return String(key)
      .replace(/_/g, " ")
      .replace(/\b\w/g, character => character.toUpperCase());
  }

  renderLineageApiDetails(response) {
    const details = response && typeof response === "object" && response.data && typeof response.data === "object"
      ? response.data
      : response;

    if (!details || typeof details !== "object" || Array.isArray(details)) {
      return null;
    }

    const renderPair = (label, value) => (
      <p key={label}>
        <label>{label}:</label>
        <span>{value}</span>
      </p>
    );

    const renderValue = (value, quoteArray = false) => {
      if (value === null || value === undefined || value === "") return null;
      if (Array.isArray(value)) {
        const values = value.filter(item => item !== null && item !== undefined && item !== "");
        if (values.length === 0 || values.some(item => typeof item === "object")) return null;
        return values.map(item => quoteArray ? `"${String(item)}"` : String(item)).join(", ");
      }
      if (typeof value === "object") return null;
      return String(value);
    };

    const renderFields = (object, orderedKeys = Object.keys(object)) => orderedKeys
      .filter(key => Object.prototype.hasOwnProperty.call(object, key))
      .map(key => [key, object[key]])
      .filter(([, value]) => value !== null && value !== undefined && value !== "")
      .map(([key, value]) => {
        if (value && typeof value === "object" && !Array.isArray(value)) {
          return (
            <React.Fragment key={key}>
              <h5 className="lg-section__title">{this.formatLineageDetailLabel(key)}</h5>
              <div className="pipeline-details">
                {key === "consuming_details" || key === "producing_details"
                  ? Object.entries(value).map(([jobName, stages]) => {
                    const formattedStages = renderValue(stages);
                    return formattedStages ? renderPair(jobName, formattedStages) : null;
                  })
                  : renderFields(value)}
              </div>
            </React.Fragment>
          );
        }

        const formattedValue = renderValue(value);
        return formattedValue ? renderPair(this.formatLineageDetailLabel(key), formattedValue) : null;
      });

    const detailKeys = [
      "dataset_name",
      "dataset_uri",
      "datasets_details",
      "consuming_details",
      "producing_details"
    ];
    const remainingKeys = Object.keys(details).filter(key => !detailKeys.includes(key));
    return <>{renderFields(details, [...detailKeys, ...remainingKeys])}</>;
  }

  renderDbtCoreLineageDetails(showTroubleshootingDetails = false) {
    if (this.state.selectedMorePipelineType !== "dbt_core" || !this.state.lineageRighPanelDetails) {
      return null;
    }
    const details = this.state.lineageRighPanelDetails;
    const dbtCoreFields = [
      ["Stage ID", details.stage_id],
      ["Stage Start Time", details.stage_start_time],
      ["Stage End Time", details.stage_end_time],
      ...(showTroubleshootingDetails ? [["Duration", details.duration]] : []),
      ...(showTroubleshootingDetails ? [] : [["Execution Time", details.execution_time]]),
      ["Package", details.package_name],
      ["Resource Type", details.resource_type],
      ...(showTroubleshootingDetails ? [
        ["Stage Status Code", details.stage_status_code],
        ["Stage Status Text", details.stage_status_text],
      ] : []),
      ...(showTroubleshootingDetails ? [] : [["Status", details.status]]),
    ];
    return (
      <>
        {dbtCoreFields.map(([label, value]) => this.Rightpanelinfo(label, this.formatDbtCoreDetailValue(label, value)))}
      </>
    );
  }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.close();
    }
    document.removeEventListener("click", this.handleExternalLinkClick);
  }

  handleExternalLinkClick = (payload, error) => {
    if (!payload || typeof payload !== 'object') {
      return;
    }
    this.setState({
      selectedNodeName: payload.name || null,
      selectedNodeType: payload.type || null,
      selectedSelectedObject: payload.selected || null,
    });
    try {
      $(".lineage-graph-sidebar").addClass("show");
    } catch (e) {
      // ignore
    }
    this.getLineageDetailresponse(payload, error);
  };


  renderFullScreen(source, piplineInfo, tableData) {

    console.log("renderFullScreen");
    let { pipelineJobInfoResponse, pipelinesource_data } = this.state;
    let filteredPipelineJob = [];


    if (Array.isArray(pipelinesource_data) &&
      piplineInfo?.pipelines &&
      // pipelineJobInfoResponse?.pipeline_metadata?.job_name &&
      pipelineJobInfoResponse?.pipeline_name) {

      const selectedJobName = pipelineJobInfoResponse.pipeline_metadata.job_name;
      const jobPipelineName = pipelineJobInfoResponse.pipeline_count_details.p_integration_name;

      // Find the matching source entry by integration name
      const matchingSource = pipelinesource_data.find(
        source => source.p_integration_name === jobPipelineName
      );

      if (matchingSource) {
        filteredPipelineJob.push({
          pipeline_name: matchingSource.p_integration_name,
          pipeline_type: matchingSource.integration_type,
          job_name: selectedJobName
        });
      }

    }

    return (
      <>

        <Tab.Container activeKey={this.state.activeTab} onSelect={
          (key) => {
            this.setState({ activeTab: key }, () => {
              // This runs after activeTab has been updated

              this.setFullScreen(this.state.p_integration_id, this.state.selectedJobId, this.state.selectedMorePipelineType, this.state.selectedMorePipelineName, this.state.selectedMoreJobName)
            });
          }
        }
        >
          <div class="rt-pipeline-panel__head p-0">
            <div class="rt-pipeline-panel__caption">
              <div className="tabbable-line">
                <Nav variant="tabs">
                  <Nav.Item>
                    <Nav.Link eventKey="ji" >
                      <span className="qd-menu__link-text">Jobs Info</span>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="jr">
                      <span className="qd-menu__link-text">All Runs</span>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="fr">
                      <span className="qd-menu__link-text">Failed Runs</span>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="td">
                      <span className="qd-menu__link-text">Lineage</span>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
            </div>
            <div class="rt-pipeline-panel__action">
              <button className="btn close-btn" onClick={this.closeFullScreenMode}></button>
            </div>
          </div>
          <div className={this.state.activeTab === "td" ? "rt-pipeline-panel__body p-0 overflow-hidden" : "rt-pipeline-panel__body"}>

            {this.state.enableLoader === true ? <Load /> : <div className="qd-jobs__content">
              <Tab.Content>
                <Tab.Pane eventKey="ji">

                  {/* Start: Alert  */}
                  <div class="alert alert-sm moniker-alert alert-dismissible has-close">
                    <p class="mb-0">
                      <i className="mr-1">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.99775 12.6347C8.30388 12.6347 7.67094 12.4589 7.09894 12.1074C6.52694 11.7559 6.08563 11.285 5.775 10.6946C5.70675 10.5735 5.6945 10.4461 5.73825 10.3125C5.78213 10.1789 5.86731 10.0873 5.99381 10.0378C6.10081 9.98831 6.20988 9.9885 6.321 10.0384C6.432 10.0883 6.51781 10.1681 6.57844 10.2778C6.81369 10.7186 7.147 11.0725 7.57837 11.3396C8.00975 11.6068 8.48363 11.7403 9 11.7403C9.75688 11.7403 10.4028 11.4728 10.9378 10.9378C11.4728 10.4028 11.7403 9.75688 11.7403 9C11.7403 8.24313 11.4728 7.59719 10.9378 7.06219C10.4028 6.52719 9.75688 6.25969 9 6.25969C8.5875 6.25969 8.20094 6.34619 7.84031 6.51919C7.47981 6.69231 7.16013 6.93269 6.88125 7.24031H7.6875C7.81663 7.24031 7.92344 7.28256 8.00794 7.36706C8.09244 7.45144 8.13469 7.55813 8.13469 7.68712C8.13469 7.81625 8.09244 7.92313 8.00794 8.00775C7.92344 8.09238 7.81663 8.13469 7.6875 8.13469H6.04331C5.85119 8.13469 5.69019 8.06969 5.56031 7.93969C5.43031 7.80981 5.36531 7.64881 5.36531 7.45669V5.8125C5.36531 5.68338 5.40756 5.57656 5.49206 5.49206C5.57644 5.40756 5.68313 5.36531 5.81213 5.36531C5.94125 5.36531 6.04812 5.40756 6.13275 5.49206C6.21737 5.57656 6.25969 5.68338 6.25969 5.8125V6.59288C6.62219 6.21688 7.03925 5.91831 7.51087 5.69719C7.9825 5.47594 8.47888 5.36531 9 5.36531C10.0086 5.36531 10.8666 5.71894 11.5738 6.42619C12.2811 7.13344 12.6347 7.99137 12.6347 9C12.6347 10.0086 12.2811 10.8666 11.5738 11.5738C10.8666 12.2811 10.0079 12.6347 8.99775 12.6347ZM3.98081 15.375C3.60194 15.375 3.28125 15.2438 3.01875 14.9813C2.75625 14.7188 2.625 14.3981 2.625 14.0192V11.8125C2.625 11.6531 2.67894 11.5195 2.78681 11.4116C2.89469 11.3039 3.02831 11.25 3.18769 11.25C3.34719 11.25 3.48075 11.3039 3.58838 11.4116C3.69613 11.5195 3.75 11.6531 3.75 11.8125V14.0192C3.75 14.0769 3.77406 14.1298 3.82219 14.1778C3.87019 14.2259 3.92306 14.25 3.98081 14.25H6.1875C6.34688 14.25 6.4805 14.3039 6.58838 14.4118C6.69613 14.5197 6.75 14.6533 6.75 14.8127C6.75 14.9722 6.69613 15.1058 6.58838 15.2134C6.4805 15.3211 6.34688 15.375 6.1875 15.375H3.98081ZM14.0192 15.375H11.8125C11.6531 15.375 11.5195 15.3211 11.4116 15.2132C11.3039 15.1053 11.25 14.9717 11.25 14.8123C11.25 14.6528 11.3039 14.5192 11.4116 14.4116C11.5195 14.3039 11.6531 14.25 11.8125 14.25H14.0192C14.0769 14.25 14.1298 14.2259 14.1778 14.1778C14.2259 14.1298 14.25 14.0769 14.25 14.0192V11.8125C14.25 11.6531 14.3039 11.5195 14.4118 11.4116C14.5197 11.3039 14.6533 11.25 14.8127 11.25C14.9722 11.25 15.1058 11.3039 15.2134 11.4116C15.3211 11.5195 15.375 11.6531 15.375 11.8125V14.0192C15.375 14.3981 15.2438 14.7188 14.9813 14.9813C14.7188 15.2438 14.3981 15.375 14.0192 15.375ZM2.625 6.1875V3.98081C2.625 3.60194 2.75625 3.28125 3.01875 3.01875C3.28125 2.75625 3.60194 2.625 3.98081 2.625H6.1875C6.34688 2.625 6.4805 2.67894 6.58838 2.78681C6.69613 2.89469 6.75 3.02831 6.75 3.18769C6.75 3.34719 6.69613 3.48075 6.58838 3.58838C6.4805 3.69613 6.34688 3.75 6.1875 3.75H3.98081C3.92306 3.75 3.87019 3.77406 3.82219 3.82219C3.77406 3.87019 3.75 3.92306 3.75 3.98081V6.1875C3.75 6.34688 3.69606 6.4805 3.58819 6.58838C3.48031 6.69613 3.34669 6.75 3.18731 6.75C3.02781 6.75 2.89425 6.69613 2.78662 6.58838C2.67887 6.4805 2.625 6.34688 2.625 6.1875ZM14.25 6.1875V3.98081C14.25 3.92306 14.2259 3.87019 14.1778 3.82219C14.1298 3.77406 14.0769 3.75 14.0192 3.75H11.8125C11.6531 3.75 11.5195 3.69606 11.4116 3.58819C11.3039 3.48031 11.25 3.34669 11.25 3.18731C11.25 3.02781 11.3039 2.89425 11.4116 2.78662C11.5195 2.67887 11.6531 2.625 11.8125 2.625H14.0192C14.3981 2.625 14.7188 2.75625 14.9813 3.01875C15.2438 3.28125 15.375 3.60194 15.375 3.98081V6.1875C15.375 6.34688 15.3211 6.4805 15.2132 6.58838C15.1053 6.69613 14.9717 6.75 14.8123 6.75C14.6528 6.75 14.5192 6.69613 14.4116 6.58838C14.3039 6.4805 14.25 6.34688 14.25 6.1875Z" fill="#5F6368" />
                        </svg>
                      </i>
                      Last profiled at <strong>{this.state.pipelineJobInfoResponse !== null && this.state.pipelineJobInfoResponse.last_profiled_time}</strong>
                    </p>
                  </div>
                  {/* End: Alert  */}

                  <div className="row row-sm mb-3">
                    <div className="col-md-5">
                      <div class="pipeline-job-stat">
                        <div className="pipeline-job-stat__head">
                          <div className="pipeline-job-stat__title">
                            <i className="pipeline-job-stat__title-icon">
                              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.40547 6.92161H7.60393V8.11214H4.54284C4.16397 8.11214 3.85506 8.41565 3.85506 8.7879V10.0772H2.69307C2.31024 10.0772 2 10.3832 2 10.7581V13.8191C2 14.1952 2.31154 14.5 2.69307 14.5H5.80729C6.19015 14.5 6.50025 14.1939 6.50157 13.8191V10.7581C6.50157 10.382 6.19003 10.0772 5.8085 10.0772H4.64712V8.89035H11.3533V10.0771H10.1915C9.80863 10.0771 9.49839 10.3832 9.49839 10.7581V13.819C9.49839 14.1952 9.80993 14.5 10.1915 14.5H13.3069C13.6897 14.5 14 14.1939 14 13.819V10.7581C14 10.382 13.6884 10.0771 13.3069 10.0771H12.1468V8.7879C12.1468 8.41565 11.8379 8.11214 11.459 8.11214H8.39599V6.92161H9.59477C9.95647 6.92161 10.251 6.63236 10.2497 6.27698V3.14464C10.2497 2.78923 9.95527 2.5 9.59356 2.5H6.40547C6.04374 2.5 5.74936 2.78926 5.74936 3.14464V6.27698C5.74936 6.63238 6.04376 6.92161 6.40547 6.92161Z" fill="white" />
                              </svg>
                            </i>
                            <div className="pipeline-job-stat__title-text">
                              <h5>{this.state.pipelineJobInfoResponse !== null && this.state.pipelineJobInfoResponse.pipeline_metadata.job_name}</h5>
                              <p>{filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].pipeline_name}
                                <span class="dot"></span>
                                <small>
                                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.08301 10.5C3.11079 10.5 2.2844 10.1597 1.60384 9.47917C0.923286 8.79861 0.583008 7.97222 0.583008 7C0.583008 6.02778 0.923286 5.20139 1.60384 4.52083C2.2844 3.84028 3.11079 3.5 4.08301 3.5H9.91634C10.8886 3.5 11.715 3.84028 12.3955 4.52083C13.0761 5.20139 13.4163 6.02778 13.4163 7C13.4163 7.97222 13.0761 8.79861 12.3955 9.47917C11.715 10.1597 10.8886 10.5 9.91634 10.5H4.08301ZM4.08301 9.33333H9.91634C10.558 9.33333 11.1073 9.10486 11.5643 8.64792C12.0212 8.19097 12.2497 7.64167 12.2497 7C12.2497 6.35833 12.0212 5.80903 11.5643 5.35208C11.1073 4.89514 10.558 4.66667 9.91634 4.66667H4.08301C3.44134 4.66667 2.89204 4.89514 2.43509 5.35208C1.97815 5.80903 1.74967 6.35833 1.74967 7C1.74967 7.64167 1.97815 8.19097 2.43509 8.64792C2.89204 9.10486 3.44134 9.33333 4.08301 9.33333ZM9.91634 8.75C10.4025 8.75 10.8156 8.57986 11.1559 8.23958C11.4962 7.89931 11.6663 7.48611 11.6663 7C11.6663 6.51389 11.4962 6.10069 11.1559 5.76042C10.8156 5.42014 10.4025 5.25 9.91634 5.25C9.43023 5.25 9.01704 5.42014 8.67676 5.76042C8.33648 6.10069 8.16634 6.51389 8.16634 7C8.16634 7.48611 8.33648 7.89931 8.67676 8.23958C9.01704 8.57986 9.43023 8.75 9.91634 8.75Z" fill="#007BFF" />
                                  </svg>
                                  {this.state.pipelineJobInfoResponse?.pipeline_count_details?.pipeline_counts?.total_pipelines ?? 0}
                                </small>
                                <small>
                                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_13152_42925)">
                                      <path d="M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM4.645 8.145L2.85 6.35C2.655 6.155 2.655 5.84 2.85 5.645C3.045 5.45 3.36 5.45 3.555 5.645L5 7.085L8.44 3.645C8.635 3.45 8.95 3.45 9.145 3.645C9.34 3.84 9.34 4.155 9.145 4.35L5.35 8.145C5.16 8.34 4.84 8.34 4.645 8.145Z" fill="#50CD89" fill-opacity="0.75" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_13152_42925">
                                        <rect width="12" height="12" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  {this.state.pipelineJobInfoResponse?.pipeline_count_details?.pipeline_counts?.success_pipelines ?? 0}
                                </small>
                                <small>
                                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_13152_42930)">
                                      <path d="M6 1C3.235 1 1 3.235 1 6C1 8.765 3.235 11 6 11C8.765 11 11 8.765 11 6C11 3.235 8.765 1 6 1ZM8.15 8.15C7.955 8.345 7.64 8.345 7.445 8.15L6 6.705L4.555 8.15C4.36 8.345 4.045 8.345 3.85 8.15C3.655 7.955 3.655 7.64 3.85 7.445L5.295 6L3.85 4.555C3.655 4.36 3.655 4.045 3.85 3.85C4.045 3.655 4.36 3.655 4.555 3.85L6 5.295L7.445 3.85C7.64 3.655 7.955 3.655 8.15 3.85C8.345 4.045 8.345 4.36 8.15 4.555L6.705 6L8.15 7.445C8.34 7.635 8.34 7.955 8.15 8.15Z" fill="#F1416C" fill-opacity="0.75" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_13152_42930">
                                        <rect width="12" height="12" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  {this.state.pipelineJobInfoResponse?.pipeline_count_details?.pipeline_counts?.failed_pipelines ?? 0}
                                  {/* {filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].failedCount} */}
                                </small>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="pipeline-job-stat__body">
                          <div className="pl-job-metadata">
                            <div className="pl-job-metadata__title">
                              <h6>Meta data</h6>
                            </div>
                            <div className="pl-job-metadata__list">
                              <div className="pl-job-metadata__list-item">
                                <span class="value">{this.state.pipelineJobInfoResponse !== null && this.state.pipelineJobInfoResponse.run_summary.total_runs}</span>
                                <label>Total Runs</label>
                              </div>
                              <div className="pl-job-metadata__list-item">
                                <span class="value">{this.state.pipelineJobInfoResponse !== null && this.state.pipelineJobInfoResponse.run_summary.failed_runs}</span>
                                <label>Failed Runs</label>
                              </div>
                              <div className="pl-job-metadata__list-item">
                                <span class="value">GMT</span>
                                <label>Timezone</label>
                              </div>
                              <div className="pl-job-metadata__list-item">
                                <span className="value">
                                  {this.state.pipelineJobInfoResponse &&
                                    new Date(this.state.pipelineJobInfoResponse.run_summary.latest_run_time).toLocaleString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: false,
                                      timeZone: "UTC"
                                    })}
                                </span>
                                <label>Latest Tick</label>
                              </div>
                              {this.state.pipelineJobInfoResponse?.pipeline_metadata?.scheduled && <div className="pl-job-metadata__list-item">
                                <span class="value" style={{ "font-size": "10px" }}>{this.state.pipelineJobInfoResponse !== null && this.state.pipelineJobInfoResponse.pipeline_metadata.scheduled}</span>
                                <label>Schedule</label>
                              </div>}
                            </div>
                          </div>
                          <div className="pl-job-metadata">
                            <div className="pl-job-metadata__title">
                              <h6>Run Summary</h6>
                            </div>
                            <div className="pl-job-metadata__list">
                              <div className="pl-job-metadata__list-item bg-light-success">
                                <span class="value">
                                  <i className="mr-1">
                                    <svg className="d-block" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6.02299 10.5C5.89272 10.5 5.78352 10.4559 5.6954 10.3678C5.60728 10.2797 5.56322 10.1705 5.56322 10.0402V3.06322L3.77011 4.84483C3.68582 4.92912 3.58046 4.97318 3.45402 4.97701C3.32759 4.98084 3.21839 4.93678 3.12644 4.84483C3.04215 4.76054 3 4.65326 3 4.52299C3 4.39272 3.04215 4.28544 3.12644 4.20115L5.70115 1.62644C5.74713 1.58046 5.79693 1.54789 5.85057 1.52874C5.90421 1.50958 5.96169 1.5 6.02299 1.5C6.08429 1.5 6.14176 1.50958 6.1954 1.52874C6.24904 1.54789 6.29885 1.58046 6.34483 1.62644L8.91954 4.20115C9.00383 4.28544 9.04598 4.3908 9.04598 4.51724C9.04598 4.64368 9.00383 4.75287 8.91954 4.84483C8.82759 4.93678 8.71839 4.98276 8.59195 4.98276C8.46552 4.98276 8.35632 4.93678 8.26437 4.84483L6.48276 3.06322V10.0402C6.48276 10.1705 6.4387 10.2797 6.35057 10.3678C6.26245 10.4559 6.15326 10.5 6.02299 10.5Z" fill="#198754" />
                                    </svg>
                                  </i>{this.state.pipelineJobInfoResponse !== null && (this.state.pipelineJobInfoResponse.run_summary.success_rate?.toFixed(2) + '%')}</span>
                                <label>Success rate</label>
                              </div>
                              <div className="pl-job-metadata__list-item  bg-light-blue">
                                <span class="value">{this.state.pipelineJobInfoResponse !== null && this.millisecondToMinutesAndSeconds(this.state.pipelineJobInfoResponse.run_summary.avg_duration)}</span>
                                <label>Avg. Duration</label>
                              </div>
                              <div className="pl-job-metadata__list-item bg-light-blue">
                                <span class="value">{this.state.pipelineJobInfoResponse !== null && this.millisecondToMinutesAndSeconds(this.state.pipelineJobInfoResponse.run_summary.min_duration)}</span>
                                <label>Min. Duration</label>
                              </div>
                              <div className="pl-job-metadata__list-item bg-light-blue">
                                <span class="value">{this.state.pipelineJobInfoResponse !== null && this.millisecondToMinutesAndSeconds(this.state.pipelineJobInfoResponse.run_summary.max_duration)}</span>
                                <label>Max. Duration</label>
                              </div>
                              {/* <div className="pl-job-metadata__list-item bg-light-blue">
                          <span class="value">24 MB</span>
                          <label>Avg. Data Volume</label>
                        </div>
                        <div className="pl-job-metadata__list-item bg-light-blue">
                          <span class="value">012 MB</span>
                          <label>Min. Data Volume</label>
                        </div>
                        <div className="pl-job-metadata__list-item bg-light-blue">
                          <span class="value">26 MB</span>
                          <label>Data Volume</label>
                        </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-7">
                      <table className="table rt-pipeline-info-tbl">
                        <tbody>
                          <tr>
                            <td width="220">Pipeline Connector</td>
                            <td>
                              {filteredPipelineJob?.[0] && (<><Image className="mr-1" width="24px" height="24px" src={`connector_icon_${(filteredPipelineJob[0].pipeline_type === "airflow" ? "airflow" : filteredPipelineJob[0].pipeline_type === "glue" ? "glue" : filteredPipelineJob[0].pipeline_type === "adf" ? "data_factory" : filteredPipelineJob[0].pipeline_type === "composer" ? "composer" :
                                (filteredPipelineJob[0].pipeline_type === "dbt" || filteredPipelineJob[0].pipeline_type === "dbt_core") ? "dbt" :
                                  filteredPipelineJob[0].pipeline_type === "mwa_airflow" ? "amazon_mwaa" :
                                    "azure"
                              ).toLowerCase()}`}
                                alt=""
                              />{filteredPipelineJob[0].pipeline_name}</>)}
                            </td>
                          </tr>
                          {Object.entries(this.state.pipelineJobInfoResponse !== null && this.state.pipelineJobInfoResponse.pipeline_metadata)
                            .filter(([_, value]) => value !== "NA")
                            .map(([key, value]) => (
                              <tr key={key}>
                                <td width="220">{key}</td>
                                <td>
                                  <div
                                    style={{
                                      maxHeight: "auto",
                                      whiteSpace: "normal",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {key.toLowerCase().includes("last_update_time", "last_parsed_time") && (
                                      <i className="mr-1">
                                        <svg className="d-inline-block" width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <g clip-path="url(#clip0_13022_61303)">
                                            <path d="M7.99301 2.20898C4.31301 2.20898 1.33301 5.25208 1.33301 9.00161C1.33301 12.7511 4.31301 15.7942 7.99301 15.7942C11.6797 15.7942 14.6663 12.7511 14.6663 9.00161C14.6663 5.25208 11.6797 2.20898 7.99301 2.20898ZM7.99967 14.4357C5.05301 14.4357 2.66634 12.004 2.66634 9.00161C2.66634 5.99927 5.05301 3.56751 7.99967 3.56751C10.9463 3.56751 13.333 5.99927 13.333 9.00161C13.333 12.004 10.9463 14.4357 7.99967 14.4357ZM7.85301 5.6053H7.81301C7.54634 5.6053 7.33301 5.82266 7.33301 6.09437V9.30049C7.33301 9.53823 7.45301 9.76239 7.65967 9.88465L10.4263 11.576C10.653 11.7119 10.9463 11.6439 11.0797 11.413C11.2197 11.182 11.1463 10.8764 10.913 10.7405L8.33301 9.17822V6.09437C8.33301 5.82266 8.11967 5.6053 7.85301 5.6053Z" fill="#5E6278" />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_13022_61303">
                                              <rect width="16" height="16.3023" fill="white" transform="translate(0 0.849609)" />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      </i>)}
                                    {value === null ? "-" : typeof value === "object" ? JSON.stringify(value, null, 2) : String(value)}
                                  </div>
                                </td>
                              </tr>
                            ))}


                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="portlet mb-3 d-none">
                    <div className="portlet-title">
                      <div class="caption">
                        <span class="font-dark">Stages</span>
                      </div>
                    </div>
                    <div class="portlet-body">
                      <Tab.Container defaultActiveKey="wv">
                        <div className="tabbable-line">
                          <Nav variant="tabs">
                            {/* <Nav.Item>
                        <Nav.Link eventKey="fv" >
                            <span className="qd-menu__link-text">Flat View</span>
                        </Nav.Link>
                      </Nav.Item> */}
                            <Nav.Item>
                              <Nav.Link eventKey="wv">
                                <span className="qd-menu__link-text">Waterfall View</span>
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>
                        </div>
                        <Tab.Content>
                          <Tab.Pane eventKey="fv">
                            <div className="pipeline-custom-tree">
                              <ul className="pipeline-ct__nodes">
                                <li className="pipeline-ct__node">
                                  <div className="pipeline-ct__node-item">Data Ingestion Pipeline</div>
                                  <ul className="pipeline-ct__nodes">
                                    <li className="pipeline-ct__node">
                                      <div className="pipeline-ct__node-item">Data Quality Check Pipeline</div>
                                    </li>
                                    <li className="pipeline-ct__node">
                                      <div className="pipeline-ct__node-item">ML Training Pipeline</div>
                                    </li>
                                    <li className="pipeline-ct__node">
                                      <div className="pipeline-ct__node-item">Data Dashboarding Pipeline</div>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="wv">
                            <div className="pipeline-custom-tree">
                              <ul className="pipeline-ct__nodes">
                                <li className="pipeline-ct__node">
                                  <div className="pipeline-ct__node-item">Data Ingestion Pipeline</div>
                                  <ul className="pipeline-ct__nodes">
                                    <li className="pipeline-ct__node">
                                      <div className="pipeline-ct__node-item">Data Quality Check Pipeline</div>
                                    </li>
                                    <li className="pipeline-ct__node">
                                      <div className="pipeline-ct__node-item">ML Training Pipeline</div>
                                    </li>
                                    <li className="pipeline-ct__node">
                                      <div className="pipeline-ct__node-item">Data Dashboarding Pipeline</div>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </div>
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="jr">

                  <input
                    type="button d-none"
                    className="btn btn-sm btn-default mb-3 d-none"
                    value="Run"
                    onClick={() => this.pushResponseData({
                      "ids_type": "runs_info",
                      "sub_type": "run_details",
                      "data": [
                        {
                          "p_run_id": 408,
                          "source_run_id": "scheduled__2026-02-23T11:50:00+00:00",
                          "run_start_time": "2026-02-23 12:21:29",
                          "duration": 1253000,
                          "run_status_text": "Failed",
                          "pipeline_name": "data_transformation_pipeline",
                          "stage_counts": {
                            "act_total": 5,
                            "act_success_cnt": 4,
                            "act_failed_cnt": 0,
                            "act_running_cnt": 0,
                            "act_queued_cnt": 1,
                            "act_cancelled_cnt": 0,
                            "act_skipped_cnt": 0,
                            "act_restart_count": 0
                          },
                          "env_id": 2,
                          "run_end_time": null,
                          "pipeline_id": 6
                        }
                      ]
                    })}
                  />

                  <input
                    type="button"
                    className="btn btn-sm btn-default mb-3 d-none"
                    value="Stage"
                    onClick={() => this.pushResponseData({
                      "ids_type": "runs_info",
                      "sub_type": "stage_details",
                      "data": {
                        "scheduled__2026-02-23T11:50:00+00:00": [
                          {
                            "stage_id": 1655,
                            "stage_name": "validate_data_task",
                            "stage_start_time": "2026-02-23 12:39:41",
                            "stage_status_code": 1,
                            "stage_status_text": "Failed",
                            "duration": 973,
                            "env_id": 2
                          }
                        ]
                      }
                    })}
                  />

                  {tableData.data.length > 0 ? (
                    <>

                      <StackedBarChart
                        runId={this.state.selectedJobRunsFullscreen['run_data'][0]["source_run_id"]}
                        runDuration={this.millisecondToMinutesAndSeconds(this.state.selectedJobRunsFullscreen['run_data'][0]["duration"])}
                        avg_duration={this.state.selectedJobRunsFullscreen.run_summary !== undefined && this.state.selectedJobRunsFullscreen.run_summary.avg_duration !== undefined && this.state.selectedJobRunsFullscreen.run_summary.avg_duration !== undefined ? this.millisecondToMinutesAndSeconds(this.state.selectedJobRunsFullscreen.run_summary.avg_duration) : ""}
                        //connectorIcon={`connector_icon_${(filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].pipeline_type === "airflow"?'airflow':filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].pipeline_type === "glue"?'glue':filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].pipeline_type === "adf"?'data_factory':'azure').toLowerCase()}`}
                        //  jobName = {this.state.pipelineJobInfoResponse !== null && this.state.pipelineJobInfoResponse.pipeline_metadata.job_name}
                        connectorIcon={(this.state.selectedMorePipelineType === "airflow" ? "connector_icon_airflow" : this.state.selectedMorePipelineType === "glue" ? "connector_icon_glue" : (this.state.selectedMorePipelineType === "dbt" || this.state.selectedMorePipelineType === "dbt_core") ? "connector_icon_dbt" : this.state.selectedMorePipelineType === "mwa_airflow" ? "connector_icon_amazon_mwaa" : this.state.selectedMorePipelineType === "adf" ? "connector_icon_data_factory" : this.state.selectedMorePipelineType === "composer" ? "connector_icon_composer" : "connector_icon_azure").toLowerCase()}
                        jobName={this.state.selectedMoreJobName}
                        pipelineName={this.state.selectedMorePipelineName}
                        //pipelineName = {filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].pipeline_name}
                        success_rate={this.state.selectedJobRunsFullscreen.run_summary !== undefined && this.state.selectedJobRunsFullscreen.run_summary.success_rate !== undefined && this.state.selectedJobRunsFullscreen.run_summary.success_rate !== null ? this.state.selectedJobRunsFullscreen.run_summary.success_rate : ""}
                        data={this.state.stackedbarchart}
                        type={'all'}
                      />


                      <div class="portlet mb-3">
                        <div className="portlet-title">
                          <div class="caption">
                            <span class="font-dark"><span class="text-muted mr-1">Job:</span>{this.state.selectedMoreJobName}</span>
                          </div>
                        </div>
                        <div class="portlet-body">
                          <QualdoDataTable
                            key={"pipelineListView"}
                            paginationSize={5}
                            component_name="Realt-time-pipelineListRunTable"
                            data={tableData}
                            customGetActionComponent={this.pipelineTableComponent}
                            current_tab={this.state.current_tab}
                            formatUTCDate={this.formatUTCDate}
                            millisecondToMinutesAndSeconds={this.millisecondToMinutesAndSeconds}
                            selectedJobRunsFullscreen={this.state.selectedJobRunsFullscreen}
                            selectedMoreJobName={this.state.selectedMoreJobName} />
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="placeholder-msg">
                      <div className="placeholder-msg__icon">
                        <Image src="icon_placeholder_no_pipeline_data" />
                      </div>
                      <p>
                        Pipeline <b>{this.state.selectedMorePipelineName}</b> did not have any runs on <b>{this.state.endDate && this.state.endDate.format ? this.state.endDate.format("YYYY-MM-DD") : "selected date"}</b>.
                      </p>
                    </div>
                  )}
                </Tab.Pane>

                <Tab.Pane eventKey="fr">
                  {tableData.data.length > 0 ?
                    <><StackedBarChart
                      runId={this.state.selectedJobRunsFullscreen['run_data'][0]["source_run_id"]}
                      runDuration={this.millisecondToMinutesAndSeconds(this.state.selectedJobRunsFullscreen['run_data'][0]["duration"])}
                      avg_duration={this.state.selectedJobRunsFullscreen.run_summary !== undefined && this.state.selectedJobRunsFullscreen.run_summary.avg_duration !== undefined && this.state.selectedJobRunsFullscreen.run_summary.avg_duration !== undefined ? this.millisecondToMinutesAndSeconds(this.state.selectedJobRunsFullscreen.run_summary.avg_duration) : ""}
                      //  connectorIcon={`connector_icon_${(filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].pipeline_type === "airflow"?'airflow':filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].pipeline_type === "glue"?'glue':'azure').toLowerCase()}`}
                      // jobName = {this.state.pipelineJobInfoResponse !== null && this.state.pipelineJobInfoResponse.pipeline_metadata.job_name}
                      connectorIcon={(this.state.selectedMorePipelineType === "airflow" ? "connector_icon_airflow" : this.state.selectedMorePipelineType === "glue" ? "connector_icon_glue" : (this.state.selectedMorePipelineType === "dbt" || this.state.selectedMorePipelineType === "dbt_core") ? "connector_icon_dbt" : this.state.selectedMorePipelineType === "mwa_airflow" ? "connector_icon_amazon_mwaa" : this.state.selectedMorePipelineType === "adf" ? "connector_icon_data_factory" : this.state.selectedMorePipelineType === "composer" ? "connector_icon_composer" : "connector_icon_azure").toLowerCase()}
                      jobName={this.state.selectedMoreJobName}
                      pipelineName={this.state.selectedMorePipelineName}
                      //  pipelineName = {filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].pipeline_name}
                      success_rate={this.state.selectedJobRunsFullscreen.run_summary !== undefined && this.state.selectedJobRunsFullscreen.run_summary.success_rate !== undefined && this.state.selectedJobRunsFullscreen.run_summary.success_rate !== null ? this.state.selectedJobRunsFullscreen.run_summary.success_rate : ""}
                      data={this.state.stackedbarchartfaild}
                      type={'failed'}


                    // avg_duration = {this.state.selectedJobRunsFullscreen.run_summary!==undefined &&this.state.selectedJobRunsFullscreen.run_summary.avg_duration!==undefined && this.state.selectedJobRunsFullscreen.run_summary.avg_duration!==undefined ? this.millisecondToMinutesAndSeconds(this.state.selectedJobRunsFullscreen.run_summary.avg_duration) : ""  }
                    // connectorIcon={`connector_icon_${(filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].pipeline_type === "airflow"?'airflow':filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].pipeline_type === "glue"?'glue':'azure').toLowerCase()}`}
                    // jobName = {this.state.pipelineJobInfoResponse !== null && this.state.pipelineJobInfoResponse.pipeline_metadata.job_name}
                    // pipelineName = {filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].pipeline_name}
                    // data = {this.state.stackedbarchartfaild}
                    // type={'falied'}

                    />

                      <div class="portlet mb-3">
                        <div className="portlet-title">
                          <div class="caption">
                            <span class="font-dark"><span class="text-muted mr-1">Job:</span>{this.state.selectedMoreJobName}</span>
                          </div>
                        </div>
                        <div class="portlet-body">
                          <QualdoDataTable
                            key={"pipelineListView"}
                            paginationSize={5}
                            component_name="Realt-time-pipelineListRunTable"
                            data={tableData}
                            customGetActionComponent={this.pipelineTableComponent}
                            current_tab={this.state.activeTab}
                            formatUTCDate={this.formatUTCDate}
                            millisecondToMinutesAndSeconds={this.millisecondToMinutesAndSeconds}
                            selectedJobRunsFullscreen={this.state.selectedJobRunsFullscreen}
                            selectedMoreJobName={this.state.selectedMoreJobName} />
                        </div>
                      </div></> : <div className="placeholder-msg">
                      <div className="placeholder-msg__icon">
                        <Image src="icon_placeholder_no_pipeline_data" />
                      </div>
                      <p>
                        Pipeline <b>{this.state.selectedMorePipelineName}</b> did not have any failed runs on <b>{this.state.endDate && this.state.endDate.format ? this.state.endDate.format("YYYY-MM-DD") : "the selected date"}</b>.
                      </p>
                    </div>}
                </Tab.Pane>


                <Tab.Pane eventKey="td">
                  <div className={this.state.lineageGraphExpanded === true ? "portlet lineage-graph-portlet lineage-graph-portlet--is-expanded border-0" : "portlet lineage-graph-portlet border-0"}>
                    <div className="portlet-title">
                      <div className="caption">
                        <span className="font-dark text-dark">Pipeline: <strong className='font-weight-semibold'>{this.state.selectedMoreJobName}</strong></span>
                        <div class="pipeline-summary">
                          <div class="pipeline-summary__item">
                            <div class="pipeline-summary__icon">
                              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.41797 10.4993C5.80547 10.4993 5.23429 10.3924 4.70443 10.1785C4.17457 9.96463 3.70547 9.67296 3.29714 9.30352C3.18047 9.19657 3.127 9.06775 3.13672 8.91706C3.14644 8.76636 3.2145 8.63754 3.34089 8.5306C3.46727 8.42365 3.61311 8.37261 3.77839 8.37747C3.94366 8.38234 4.0895 8.43824 4.21589 8.54518C4.527 8.79796 4.86484 8.9924 5.22943 9.12852C5.59401 9.26463 5.99019 9.33268 6.41797 9.33268C7.39019 9.33268 8.21658 8.9924 8.89714 8.31185C9.57769 7.63129 9.91797 6.8049 9.91797 5.83268C9.91797 4.86046 9.57769 4.03407 8.89714 3.35352C8.21658 2.67296 7.39019 2.33268 6.41797 2.33268C5.61102 2.33268 4.89887 2.57574 4.28151 3.06185C3.66415 3.54796 3.25339 4.16532 3.04922 4.91393C3.00061 5.07921 2.91311 5.22504 2.78672 5.35143C2.66033 5.47782 2.5145 5.54102 2.34922 5.54102C2.18394 5.54102 2.05026 5.47539 1.94818 5.34414C1.84609 5.21289 1.8145 5.06463 1.85339 4.89935C2.077 3.8299 2.60929 2.94032 3.45026 2.2306C4.29123 1.52088 5.28047 1.16602 6.41797 1.16602C7.72075 1.16602 8.82422 1.6181 9.72839 2.52227C10.6326 3.42643 11.0846 4.5299 11.0846 5.83268C11.0846 6.37713 10.9971 6.88997 10.8221 7.37122C10.6471 7.85247 10.4041 8.2924 10.093 8.69102L12.4263 11.0243C12.5332 11.1313 12.5867 11.2674 12.5867 11.4327C12.5867 11.598 12.5332 11.7341 12.4263 11.841C12.3194 11.948 12.1832 12.0014 12.018 12.0014C11.8527 12.0014 11.7166 11.948 11.6096 11.841L9.2763 9.50768C8.87769 9.81879 8.43776 10.0618 7.95651 10.2368C7.47526 10.4118 6.96241 10.4993 6.41797 10.4993ZM6.22839 6.62018L6.76797 4.9431C6.79714 4.86532 6.84332 4.7997 6.90651 4.74622C6.96971 4.69275 7.04505 4.66602 7.13255 4.66602H7.48255C7.56033 4.66602 7.62839 4.68546 7.68672 4.72435C7.74505 4.76324 7.79366 4.81671 7.83255 4.88477L8.60547 6.41602C8.73186 6.41602 8.83637 6.45733 8.91901 6.53997C9.00165 6.62261 9.04297 6.72713 9.04297 6.85352C9.04297 6.9799 9.00165 7.08442 8.91901 7.16706C8.83637 7.2497 8.73186 7.29102 8.60547 7.29102H8.34297C8.26519 7.29102 8.18984 7.26914 8.11693 7.22539C8.04401 7.18164 7.98811 7.12088 7.94922 7.0431L7.38047 5.92018L6.7388 7.88893C6.70964 7.97643 6.66102 8.04449 6.59297 8.0931C6.52491 8.14171 6.44714 8.16602 6.35964 8.16602H6.09714C6.00964 8.16602 5.92943 8.13928 5.85651 8.08581C5.78359 8.03234 5.73255 7.96185 5.70339 7.87435L4.87214 5.13268L4.21589 6.99935C4.18672 7.08685 4.13568 7.15734 4.06276 7.21081C3.98984 7.26428 3.90477 7.29102 3.80755 7.29102H1.60547C1.47908 7.29102 1.37457 7.2497 1.29193 7.16706C1.20929 7.08442 1.16797 6.9799 1.16797 6.85352C1.16797 6.72713 1.20929 6.62261 1.29193 6.53997C1.37457 6.45733 1.47908 6.41602 1.60547 6.41602H3.5013L4.36172 3.92227C4.39089 3.83477 4.44193 3.76671 4.51484 3.7181C4.58776 3.66949 4.66797 3.64518 4.75547 3.64518H5.03255C5.12977 3.64518 5.21241 3.67435 5.28047 3.73268C5.34852 3.79102 5.39714 3.86393 5.4263 3.95143L6.22839 6.62018Z" fill="#7D7D7D" />
                              </svg>
                            </div>
                            <div class="pipeline-summary__content">
                              <span class="pipeline-summary__label">Upstream jobs:</span>
                              <span class="pipeline-summary__count" id="pipeline_upstream_jobs">0</span>
                              <RcTooltip
                                placement="top"
                                overlay={<span>Upstream jobs are the jobs that run before the current job and provide required inputs or dependencies.</span>}
                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                              >
                                <i className='icon-info ml-1'>
                                  <svg className='d-block' width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 8.25C6.1275 8.25 6.23438 8.20688 6.32063 8.12063C6.40688 8.03438 6.45 7.9275 6.45 7.8V6C6.45 5.8725 6.40688 5.76562 6.32063 5.67938C6.23438 5.59313 6.1275 5.55 6 5.55C5.8725 5.55 5.76562 5.59313 5.67938 5.67938C5.59313 5.76562 5.55 5.8725 5.55 6V7.8C5.55 7.9275 5.59313 8.03438 5.67938 8.12063C5.76562 8.20688 5.8725 8.25 6 8.25ZM6 4.65C6.1275 4.65 6.23438 4.60688 6.32063 4.52063C6.40688 4.43438 6.45 4.3275 6.45 4.2C6.45 4.0725 6.40688 3.96563 6.32063 3.87937C6.23438 3.79313 6.1275 3.75 6 3.75C5.8725 3.75 5.76562 3.79313 5.67938 3.87937C5.59313 3.96563 5.55 4.0725 5.55 4.2C5.55 4.3275 5.59313 4.43438 5.67938 4.52063C5.76562 4.60688 5.8725 4.65 6 4.65ZM6 10.5C5.3775 10.5 4.7925 10.3819 4.245 10.1456C3.6975 9.90938 3.22125 9.58875 2.81625 9.18375C2.41125 8.77875 2.09063 8.3025 1.85438 7.755C1.61813 7.2075 1.5 6.6225 1.5 6C1.5 5.3775 1.61813 4.7925 1.85438 4.245C2.09063 3.6975 2.41125 3.22125 2.81625 2.81625C3.22125 2.41125 3.6975 2.09063 4.245 1.85438C4.7925 1.61813 5.3775 1.5 6 1.5C6.6225 1.5 7.2075 1.61813 7.755 1.85438C8.3025 2.09063 8.77875 2.41125 9.18375 2.81625C9.58875 3.22125 9.90938 3.6975 10.1456 4.245C10.3819 4.7925 10.5 5.3775 10.5 6C10.5 6.6225 10.3819 7.2075 10.1456 7.755C9.90938 8.3025 9.58875 8.77875 9.18375 9.18375C8.77875 9.58875 8.3025 9.90938 7.755 10.1456C7.2075 10.3819 6.6225 10.5 6 10.5ZM6 9.6C7.005 9.6 7.85625 9.25125 8.55375 8.55375C9.25125 7.85625 9.6 7.005 9.6 6C9.6 4.995 9.25125 4.14375 8.55375 3.44625C7.85625 2.74875 7.005 2.4 6 2.4C4.995 2.4 4.14375 2.74875 3.44625 3.44625C2.74875 4.14375 2.4 4.995 2.4 6C2.4 7.005 2.74875 7.85625 3.44625 8.55375C4.14375 9.25125 4.995 9.6 6 9.6Z" fill="#99A1B7" />
                                  </svg>
                                </i>
                              </RcTooltip>
                            </div>
                          </div>
                          <div class="pipeline-summary__item">
                            <div class="pipeline-summary__icon">
                              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.2596 5.19102L13.1263 7.05768L12.3096 7.87435L10.443 6.00768C10.2388 6.12435 10.0201 6.22157 9.78672 6.29935C9.55339 6.37713 9.30547 6.41602 9.04297 6.41602C8.3138 6.41602 7.69401 6.16081 7.18359 5.65039C6.67318 5.13997 6.41797 4.52018 6.41797 3.79102C6.41797 3.06185 6.67318 2.44206 7.18359 1.93164C7.69401 1.42122 8.3138 1.16602 9.04297 1.16602C9.77214 1.16602 10.3919 1.42122 10.9023 1.93164C11.4128 2.44206 11.668 3.06185 11.668 3.79102C11.668 4.05352 11.6291 4.30143 11.5513 4.53477C11.4735 4.7681 11.3763 4.98685 11.2596 5.19102ZM9.04297 5.24935C9.4513 5.24935 9.79644 5.10838 10.0784 4.82643C10.3603 4.54449 10.5013 4.19935 10.5013 3.79102C10.5013 3.38268 10.3603 3.03754 10.0784 2.7556C9.79644 2.47365 9.4513 2.33268 9.04297 2.33268C8.63464 2.33268 8.2895 2.47365 8.00755 2.7556C7.72561 3.03754 7.58464 3.38268 7.58464 3.79102C7.58464 4.19935 7.72561 4.54449 8.00755 4.82643C8.2895 5.10838 8.63464 5.24935 9.04297 5.24935ZM10.1805 7.40768L11.668 8.89518V11.666C11.668 11.9868 11.5537 12.2615 11.3253 12.49C11.0968 12.7184 10.8221 12.8327 10.5013 12.8327H2.33464C2.0138 12.8327 1.73915 12.7184 1.51068 12.49C1.2822 12.2615 1.16797 11.9868 1.16797 11.666V3.49935C1.16797 3.17852 1.2822 2.90386 1.51068 2.67539C1.73915 2.44692 2.0138 2.33268 2.33464 2.33268H5.54297C5.43602 2.57574 5.36311 2.82608 5.32422 3.08372C5.28533 3.34136 5.26589 3.59657 5.26589 3.84935C5.26589 4.90907 5.64019 5.79379 6.3888 6.50352C7.13741 7.21324 8.027 7.5681 9.05755 7.5681C9.24227 7.5681 9.427 7.55595 9.61172 7.53164C9.79644 7.50733 9.98602 7.46602 10.1805 7.40768Z" fill="#7D7D7D" />
                              </svg>
                            </div>
                            <div class="pipeline-summary__content">
                              <span class="pipeline-summary__label">Downstream jobs:</span>
                              <span class="pipeline-summary__count" id="pipeline_downstream_jobs">0</span>
                              <RcTooltip
                                placement="top"
                                overlay={<span>Downstream jobs are the jobs that run after the current job and depend on its output or completion.</span>}
                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                              >
                                <i className='icon-info ml-1'>
                                  <svg className='d-block' width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 8.25C6.1275 8.25 6.23438 8.20688 6.32063 8.12063C6.40688 8.03438 6.45 7.9275 6.45 7.8V6C6.45 5.8725 6.40688 5.76562 6.32063 5.67938C6.23438 5.59313 6.1275 5.55 6 5.55C5.8725 5.55 5.76562 5.59313 5.67938 5.67938C5.59313 5.76562 5.55 5.8725 5.55 6V7.8C5.55 7.9275 5.59313 8.03438 5.67938 8.12063C5.76562 8.20688 5.8725 8.25 6 8.25ZM6 4.65C6.1275 4.65 6.23438 4.60688 6.32063 4.52063C6.40688 4.43438 6.45 4.3275 6.45 4.2C6.45 4.0725 6.40688 3.96563 6.32063 3.87937C6.23438 3.79313 6.1275 3.75 6 3.75C5.8725 3.75 5.76562 3.79313 5.67938 3.87937C5.59313 3.96563 5.55 4.0725 5.55 4.2C5.55 4.3275 5.59313 4.43438 5.67938 4.52063C5.76562 4.60688 5.8725 4.65 6 4.65ZM6 10.5C5.3775 10.5 4.7925 10.3819 4.245 10.1456C3.6975 9.90938 3.22125 9.58875 2.81625 9.18375C2.41125 8.77875 2.09063 8.3025 1.85438 7.755C1.61813 7.2075 1.5 6.6225 1.5 6C1.5 5.3775 1.61813 4.7925 1.85438 4.245C2.09063 3.6975 2.41125 3.22125 2.81625 2.81625C3.22125 2.41125 3.6975 2.09063 4.245 1.85438C4.7925 1.61813 5.3775 1.5 6 1.5C6.6225 1.5 7.2075 1.61813 7.755 1.85438C8.3025 2.09063 8.77875 2.41125 9.18375 2.81625C9.58875 3.22125 9.90938 3.6975 10.1456 4.245C10.3819 4.7925 10.5 5.3775 10.5 6C10.5 6.6225 10.3819 7.2075 10.1456 7.755C9.90938 8.3025 9.58875 8.77875 9.18375 9.18375C8.77875 9.58875 8.3025 9.90938 7.755 10.1456C7.2075 10.3819 6.6225 10.5 6 10.5ZM6 9.6C7.005 9.6 7.85625 9.25125 8.55375 8.55375C9.25125 7.85625 9.6 7.005 9.6 6C9.6 4.995 9.25125 4.14375 8.55375 3.44625C7.85625 2.74875 7.005 2.4 6 2.4C4.995 2.4 4.14375 2.74875 3.44625 3.44625C2.74875 4.14375 2.4 4.995 2.4 6C2.4 7.005 2.74875 7.85625 3.44625 8.55375C4.14375 9.25125 4.995 9.6 6 9.6Z" fill="#99A1B7" />
                                  </svg>
                                </i>
                              </RcTooltip>
                            </div>
                          </div>
                          {/* <span class="divider-line"></span> 
                          <div class="pipeline-summary__item">
                            <div class="pipeline-summary__icon">
                              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.41797 10.4993C5.80547 10.4993 5.23429 10.3924 4.70443 10.1785C4.17457 9.96463 3.70547 9.67296 3.29714 9.30352C3.18047 9.19657 3.127 9.06775 3.13672 8.91706C3.14644 8.76636 3.2145 8.63754 3.34089 8.5306C3.46727 8.42365 3.61311 8.37261 3.77839 8.37747C3.94366 8.38234 4.0895 8.43824 4.21589 8.54518C4.527 8.79796 4.86484 8.9924 5.22943 9.12852C5.59401 9.26463 5.99019 9.33268 6.41797 9.33268C7.39019 9.33268 8.21658 8.9924 8.89714 8.31185C9.57769 7.63129 9.91797 6.8049 9.91797 5.83268C9.91797 4.86046 9.57769 4.03407 8.89714 3.35352C8.21658 2.67296 7.39019 2.33268 6.41797 2.33268C5.61102 2.33268 4.89887 2.57574 4.28151 3.06185C3.66415 3.54796 3.25339 4.16532 3.04922 4.91393C3.00061 5.07921 2.91311 5.22504 2.78672 5.35143C2.66033 5.47782 2.5145 5.54102 2.34922 5.54102C2.18394 5.54102 2.05026 5.47539 1.94818 5.34414C1.84609 5.21289 1.8145 5.06463 1.85339 4.89935C2.077 3.8299 2.60929 2.94032 3.45026 2.2306C4.29123 1.52088 5.28047 1.16602 6.41797 1.16602C7.72075 1.16602 8.82422 1.6181 9.72839 2.52227C10.6326 3.42643 11.0846 4.5299 11.0846 5.83268C11.0846 6.37713 10.9971 6.88997 10.8221 7.37122C10.6471 7.85247 10.4041 8.2924 10.093 8.69102L12.4263 11.0243C12.5332 11.1313 12.5867 11.2674 12.5867 11.4327C12.5867 11.598 12.5332 11.7341 12.4263 11.841C12.3194 11.948 12.1832 12.0014 12.018 12.0014C11.8527 12.0014 11.7166 11.948 11.6096 11.841L9.2763 9.50768C8.87769 9.81879 8.43776 10.0618 7.95651 10.2368C7.47526 10.4118 6.96241 10.4993 6.41797 10.4993ZM6.22839 6.62018L6.76797 4.9431C6.79714 4.86532 6.84332 4.7997 6.90651 4.74622C6.96971 4.69275 7.04505 4.66602 7.13255 4.66602H7.48255C7.56033 4.66602 7.62839 4.68546 7.68672 4.72435C7.74505 4.76324 7.79366 4.81671 7.83255 4.88477L8.60547 6.41602C8.73186 6.41602 8.83637 6.45733 8.91901 6.53997C9.00165 6.62261 9.04297 6.72713 9.04297 6.85352C9.04297 6.9799 9.00165 7.08442 8.91901 7.16706C8.83637 7.2497 8.73186 7.29102 8.60547 7.29102H8.34297C8.26519 7.29102 8.18984 7.26914 8.11693 7.22539C8.04401 7.18164 7.98811 7.12088 7.94922 7.0431L7.38047 5.92018L6.7388 7.88893C6.70964 7.97643 6.66102 8.04449 6.59297 8.0931C6.52491 8.14171 6.44714 8.16602 6.35964 8.16602H6.09714C6.00964 8.16602 5.92943 8.13928 5.85651 8.08581C5.78359 8.03234 5.73255 7.96185 5.70339 7.87435L4.87214 5.13268L4.21589 6.99935C4.18672 7.08685 4.13568 7.15734 4.06276 7.21081C3.98984 7.26428 3.90477 7.29102 3.80755 7.29102H1.60547C1.47908 7.29102 1.37457 7.2497 1.29193 7.16706C1.20929 7.08442 1.16797 6.9799 1.16797 6.85352C1.16797 6.72713 1.20929 6.62261 1.29193 6.53997C1.37457 6.45733 1.47908 6.41602 1.60547 6.41602H3.5013L4.36172 3.92227C4.39089 3.83477 4.44193 3.76671 4.51484 3.7181C4.58776 3.66949 4.66797 3.64518 4.75547 3.64518H5.03255C5.12977 3.64518 5.21241 3.67435 5.28047 3.73268C5.34852 3.79102 5.39714 3.86393 5.4263 3.95143L6.22839 6.62018Z" fill="#7D7D7D"/>
                              </svg>
                            </div>
                            <div class="pipeline-summary__content">
                              <span class="pipeline-summary__label">Upstream Datasets:</span>
                              <span class="pipeline-summary__count">7</span>
                              <RcTooltip 
                                  placement="top" 
                                  overlay={<span>Info</span>}
                                  arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                              >
                                <i className='icon-info ml-1'>
                                  <svg className='d-block' width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 8.25C6.1275 8.25 6.23438 8.20688 6.32063 8.12063C6.40688 8.03438 6.45 7.9275 6.45 7.8V6C6.45 5.8725 6.40688 5.76562 6.32063 5.67938C6.23438 5.59313 6.1275 5.55 6 5.55C5.8725 5.55 5.76562 5.59313 5.67938 5.67938C5.59313 5.76562 5.55 5.8725 5.55 6V7.8C5.55 7.9275 5.59313 8.03438 5.67938 8.12063C5.76562 8.20688 5.8725 8.25 6 8.25ZM6 4.65C6.1275 4.65 6.23438 4.60688 6.32063 4.52063C6.40688 4.43438 6.45 4.3275 6.45 4.2C6.45 4.0725 6.40688 3.96563 6.32063 3.87937C6.23438 3.79313 6.1275 3.75 6 3.75C5.8725 3.75 5.76562 3.79313 5.67938 3.87937C5.59313 3.96563 5.55 4.0725 5.55 4.2C5.55 4.3275 5.59313 4.43438 5.67938 4.52063C5.76562 4.60688 5.8725 4.65 6 4.65ZM6 10.5C5.3775 10.5 4.7925 10.3819 4.245 10.1456C3.6975 9.90938 3.22125 9.58875 2.81625 9.18375C2.41125 8.77875 2.09063 8.3025 1.85438 7.755C1.61813 7.2075 1.5 6.6225 1.5 6C1.5 5.3775 1.61813 4.7925 1.85438 4.245C2.09063 3.6975 2.41125 3.22125 2.81625 2.81625C3.22125 2.41125 3.6975 2.09063 4.245 1.85438C4.7925 1.61813 5.3775 1.5 6 1.5C6.6225 1.5 7.2075 1.61813 7.755 1.85438C8.3025 2.09063 8.77875 2.41125 9.18375 2.81625C9.58875 3.22125 9.90938 3.6975 10.1456 4.245C10.3819 4.7925 10.5 5.3775 10.5 6C10.5 6.6225 10.3819 7.2075 10.1456 7.755C9.90938 8.3025 9.58875 8.77875 9.18375 9.18375C8.77875 9.58875 8.3025 9.90938 7.755 10.1456C7.2075 10.3819 6.6225 10.5 6 10.5ZM6 9.6C7.005 9.6 7.85625 9.25125 8.55375 8.55375C9.25125 7.85625 9.6 7.005 9.6 6C9.6 4.995 9.25125 4.14375 8.55375 3.44625C7.85625 2.74875 7.005 2.4 6 2.4C4.995 2.4 4.14375 2.74875 3.44625 3.44625C2.74875 4.14375 2.4 4.995 2.4 6C2.4 7.005 2.74875 7.85625 3.44625 8.55375C4.14375 9.25125 4.995 9.6 6 9.6Z" fill="#99A1B7"/>
                                  </svg>
                                </i>
                              </RcTooltip>
                            </div>
                          </div>
                          <div class="pipeline-summary__item">
                            <div class="pipeline-summary__icon">
                              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.2596 5.19102L13.1263 7.05768L12.3096 7.87435L10.443 6.00768C10.2388 6.12435 10.0201 6.22157 9.78672 6.29935C9.55339 6.37713 9.30547 6.41602 9.04297 6.41602C8.3138 6.41602 7.69401 6.16081 7.18359 5.65039C6.67318 5.13997 6.41797 4.52018 6.41797 3.79102C6.41797 3.06185 6.67318 2.44206 7.18359 1.93164C7.69401 1.42122 8.3138 1.16602 9.04297 1.16602C9.77214 1.16602 10.3919 1.42122 10.9023 1.93164C11.4128 2.44206 11.668 3.06185 11.668 3.79102C11.668 4.05352 11.6291 4.30143 11.5513 4.53477C11.4735 4.7681 11.3763 4.98685 11.2596 5.19102ZM9.04297 5.24935C9.4513 5.24935 9.79644 5.10838 10.0784 4.82643C10.3603 4.54449 10.5013 4.19935 10.5013 3.79102C10.5013 3.38268 10.3603 3.03754 10.0784 2.7556C9.79644 2.47365 9.4513 2.33268 9.04297 2.33268C8.63464 2.33268 8.2895 2.47365 8.00755 2.7556C7.72561 3.03754 7.58464 3.38268 7.58464 3.79102C7.58464 4.19935 7.72561 4.54449 8.00755 4.82643C8.2895 5.10838 8.63464 5.24935 9.04297 5.24935ZM10.1805 7.40768L11.668 8.89518V11.666C11.668 11.9868 11.5537 12.2615 11.3253 12.49C11.0968 12.7184 10.8221 12.8327 10.5013 12.8327H2.33464C2.0138 12.8327 1.73915 12.7184 1.51068 12.49C1.2822 12.2615 1.16797 11.9868 1.16797 11.666V3.49935C1.16797 3.17852 1.2822 2.90386 1.51068 2.67539C1.73915 2.44692 2.0138 2.33268 2.33464 2.33268H5.54297C5.43602 2.57574 5.36311 2.82608 5.32422 3.08372C5.28533 3.34136 5.26589 3.59657 5.26589 3.84935C5.26589 4.90907 5.64019 5.79379 6.3888 6.50352C7.13741 7.21324 8.027 7.5681 9.05755 7.5681C9.24227 7.5681 9.427 7.55595 9.61172 7.53164C9.79644 7.50733 9.98602 7.46602 10.1805 7.40768Z" fill="#7D7D7D"/>
                              </svg>
                            </div>
                            <div class="pipeline-summary__content">
                              <span class="pipeline-summary__label">Downstream Datasets:</span>
                              <span class="pipeline-summary__count">3</span>
                              <RcTooltip 
                                  placement="top" 
                                  overlay={<span>Info</span>}
                                  arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                              >
                                <i className='icon-info ml-1'>
                                  <svg className='d-block' width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 8.25C6.1275 8.25 6.23438 8.20688 6.32063 8.12063C6.40688 8.03438 6.45 7.9275 6.45 7.8V6C6.45 5.8725 6.40688 5.76562 6.32063 5.67938C6.23438 5.59313 6.1275 5.55 6 5.55C5.8725 5.55 5.76562 5.59313 5.67938 5.67938C5.59313 5.76562 5.55 5.8725 5.55 6V7.8C5.55 7.9275 5.59313 8.03438 5.67938 8.12063C5.76562 8.20688 5.8725 8.25 6 8.25ZM6 4.65C6.1275 4.65 6.23438 4.60688 6.32063 4.52063C6.40688 4.43438 6.45 4.3275 6.45 4.2C6.45 4.0725 6.40688 3.96563 6.32063 3.87937C6.23438 3.79313 6.1275 3.75 6 3.75C5.8725 3.75 5.76562 3.79313 5.67938 3.87937C5.59313 3.96563 5.55 4.0725 5.55 4.2C5.55 4.3275 5.59313 4.43438 5.67938 4.52063C5.76562 4.60688 5.8725 4.65 6 4.65ZM6 10.5C5.3775 10.5 4.7925 10.3819 4.245 10.1456C3.6975 9.90938 3.22125 9.58875 2.81625 9.18375C2.41125 8.77875 2.09063 8.3025 1.85438 7.755C1.61813 7.2075 1.5 6.6225 1.5 6C1.5 5.3775 1.61813 4.7925 1.85438 4.245C2.09063 3.6975 2.41125 3.22125 2.81625 2.81625C3.22125 2.41125 3.6975 2.09063 4.245 1.85438C4.7925 1.61813 5.3775 1.5 6 1.5C6.6225 1.5 7.2075 1.61813 7.755 1.85438C8.3025 2.09063 8.77875 2.41125 9.18375 2.81625C9.58875 3.22125 9.90938 3.6975 10.1456 4.245C10.3819 4.7925 10.5 5.3775 10.5 6C10.5 6.6225 10.3819 7.2075 10.1456 7.755C9.90938 8.3025 9.58875 8.77875 9.18375 9.18375C8.77875 9.58875 8.3025 9.90938 7.755 10.1456C7.2075 10.3819 6.6225 10.5 6 10.5ZM6 9.6C7.005 9.6 7.85625 9.25125 8.55375 8.55375C9.25125 7.85625 9.6 7.005 9.6 6C9.6 4.995 9.25125 4.14375 8.55375 3.44625C7.85625 2.74875 7.005 2.4 6 2.4C4.995 2.4 4.14375 2.74875 3.44625 3.44625C2.74875 4.14375 2.4 4.995 2.4 6C2.4 7.005 2.74875 7.85625 3.44625 8.55375C4.14375 9.25125 4.995 9.6 6 9.6Z" fill="#99A1B7"/>
                                  </svg>
                                </i>
                              </RcTooltip>
                            </div>
                          </div>*/}
                        </div>
                      </div>
                      <div className="actions">
                        <div className="lg-toolbar">
                          <div className="lg-toolbar-item">
                            {/* <p className="text-muted m-0 text-right">Last sync:<strong className="text-dark d-block">Today at 04:00:00 PM</strong></p> */}
                          </div>
                          <div className="lg-toolbar-item pr-2 d-none">
                            <Form>
                              <Form.Group controlId="formBasicRangeCustom" className="form-inline flex-nowrap mb-0">
                                <Form.Label className="d-none d-xxl-inline-block">Zoom</Form.Label>
                                <Slider
                                  min={1}
                                  max={100}
                                  tooltip={false}
                                  value={this.state.rangeValue}
                                  onChange={this.setRangeValue}
                                />
                                <span className="rangeslider__label bg-transparent">{this.state.rangeValue + "%"}</span>
                              </Form.Group>
                            </Form>
                            <RcTooltip
                              placement="top"
                              overlay={<span>Zoom Reset</span>}
                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                              <i className='icon-wrapper cursor-pointer' onClick={this.retsetzoom}>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12 17.4205C10.8603 17.4205 9.85717 17.0701 8.9905 16.3695C8.12383 15.6688 7.561 14.7883 7.302 13.728H8.54425C8.78658 14.4678 9.21833 15.0695 9.8395 15.533C10.4607 15.9963 11.1808 16.228 12 16.228C13.0115 16.228 13.8733 15.8719 14.5855 15.1597C15.2977 14.4476 15.6538 13.5857 15.6538 12.5742C15.6538 11.5627 15.2977 10.7009 14.5855 9.98872C13.8733 9.27655 13.0115 8.92047 12 8.92047C11.4525 8.92047 10.9352 9.03839 10.448 9.27422C9.96083 9.51005 9.5365 9.82797 9.175 10.228H10.8463V11.4205H7.15375V7.72797H8.34625V9.36472C8.80892 8.87355 9.35633 8.47797 9.9885 8.17797C10.6205 7.87797 11.291 7.72797 12 7.72797C13.3385 7.72797 14.4808 8.20105 15.427 9.14722C16.3732 10.0934 16.8462 11.2357 16.8462 12.5742C16.8462 13.9127 16.3732 15.0551 15.427 16.0012C14.4808 16.9474 13.3385 17.4205 12 17.4205ZM5.30775 21.0742C4.80258 21.0742 4.375 20.8992 4.025 20.5492C3.675 20.1992 3.5 19.7716 3.5 19.2665V15.5742H5V19.2665C5 19.3435 5.03208 19.414 5.09625 19.478C5.16025 19.5421 5.23075 19.5742 5.30775 19.5742H9V21.0742H5.30775ZM15 21.0742V19.5742H18.6923C18.7692 19.5742 18.8398 19.5421 18.9038 19.478C18.9679 19.414 19 19.3435 19 19.2665V15.5742H20.5V19.2665C20.5 19.7716 20.325 20.1992 19.975 20.5492C19.625 20.8992 19.1974 21.0742 18.6923 21.0742H15ZM3.5 9.57422V5.88197C3.5 5.3768 3.675 4.94922 4.025 4.59922C4.375 4.24922 4.80258 4.07422 5.30775 4.07422H9V5.57422H5.30775C5.23075 5.57422 5.16025 5.6063 5.09625 5.67047C5.03208 5.73447 5 5.80497 5 5.88197V9.57422H3.5ZM19 9.57422V5.88197C19 5.80497 18.9679 5.73447 18.9038 5.67047C18.8398 5.6063 18.7692 5.57422 18.6923 5.57422H15V4.07422H18.6923C19.1974 4.07422 19.625 4.24922 19.975 4.59922C20.325 4.94922 20.5 5.3768 20.5 5.88197V9.57422H19Z" fill="#A1A5B7" />
                                </svg>
                              </i>
                            </RcTooltip>
                          </div>
                          <div className="lg-toolbar-item">
                            {/* <button class="btn btn-light-secondary" onClick={this.resetLineage}>Clear Selection</button> */}
                            <RcTooltip
                              placement="top"
                              overlay={<span>{this.state.lineageGraphExpanded === true ? "Collapse" : "Expand"}</span>}
                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                              <i className='ml-2 icon-wrapper cursor-pointer' onClick={this.handleLineageExpand}>
                                {
                                  this.state.lineageGraphExpanded === true ?
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="rgba(0, 0, 0, 0.5"><path d="M182.77-140.39 140-183.15l194-193.39H221.16v-60h214.99v215h-59.99v-112.85l-193.39 194Zm341.08-383.84v-215h59.99v112.85l193.39-194L820-777.61 626-584.23h112.84v60H523.85Z" /></svg>
                                    :
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="rgba(0, 0, 0, 0.5"><path d="M140-140v-300h60v198.23L718.23-760H520v-60h300v300h-60v-198.23L241.77-200H440v60H140Z" /></svg>
                                }
                              </i>
                            </RcTooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="portlet-body p-0">
                      <div className="lineage-graph-container" id="lineage-container" style={{ cursor: "move", height: "calc(100vh - 78px)" }}>

                        {this.state.lineageData !== null && this.state.activeTab === "td" ?
                          <PipelineLineage
                            error={false}
                            height="100%"
                            chart_id="linenage"
                            data={this.state.lineageData}
                            lineageGraphExpanded={this.state.lineageGraphExpanded}
                            handleExternalLinkClick={this.handleExternalLinkClick}
                          /> : ""}
                      </div>
                      {this.state.activeTab === "td" &&
                        (<div className="lineage-graph-sidebar">
                          <div className="lg-sidebar__content">
                            <div className="lg-sidebar__header">
                              <div className="caption">

                                <p><Image src={`connector_icon_${this.state.selectedMorePipelineType === "airflow" ? "airflow" : this.state.selectedMorePipelineType === "glue" ? "glue" : this.state.selectedMorePipelineType === "azure" ? "azure" : this.state.selectedMorePipelineType === "adf" ? "data_factory" : this.state.selectedMorePipelineType === "composer" ? "composer" :
                                  (this.state.selectedMorePipelineType === "dbt" || this.state.selectedMorePipelineType === "dbt_core") ? "dbt" :
                                    this.state.selectedMorePipelineType === "mwa_airflow" ? "amazon_mwaa" :
                                      !this.state.selectedMorePipelineType || this.state.selectedMorePipelineType === "" ? "default" :
                                        "default"
                                  }`}
                                  alt={this.state.selectedMorePipelineType || "default"} width={14} height={14} className="mr-2" /><span id="task_dataset_name">
                                    {this.state.selectedNodeType === 'dataset' ? 'Dataset' : 'Task'}{' '}
                                    {(this.state.selectedSelectedObject && (this.state.selectedNodeType === 'dataset'
                                      ? `[${this.state.selectedSelectedObject.pipeline_data_set_name}]`
                                      : `[${this.state.selectedSelectedObject.task_name}]`))
                                      || (this.state.selectedNodeName ? `[${this.state.selectedNodeName}]` : '')}
                                  </span></p>
                              </div>
                              <div className="action">
                                <button type="button" onClick={this.closeLineageRightPanel} className="close"><span className="sr-only">Close</span></button>
                              </div>
                            </div>
                            <div className="lg-sidebar__body">
                              <div className="lg-section">
                                <h5 className="lg-section__title">Origin</h5>
                                <div className="lg-section__body">
                                  <div className="pipeline-details">
                                    <p><label>Pipeline Name:</label><span><i><Image src={`connector_icon_${this.state.selectedMorePipelineType === "airflow" ? "airflow" : this.state.selectedMorePipelineType === "glue" ? "glue" : this.state.selectedMorePipelineType === "azure" ? "azure" : this.state.selectedMorePipelineType === "adf" ? "data_factory" : this.state.selectedMorePipelineType === "composer" ? "composer" :
                                      (this.state.selectedMorePipelineType === "dbt" || this.state.selectedMorePipelineType === "dbt_core") ? "dbt" :
                                        this.state.selectedMorePipelineType === "mwa_airflow" ? "amazon_mwaa" :
                                          !this.state.selectedMorePipelineType || this.state.selectedMorePipelineType === "" ? "default" :
                                            "default"
                                      }`}
                                      alt={this.state.selectedMorePipelineType || "default"} width={14} height={14} className="mr-2" />
                                    </i>{this.state.selectedMorePipelineName}</span></p>
                                    {this.state.selectedMoreJobName &&
                                      this.Rightpanelinfo("Job Name", this.state.selectedMoreJobName)
                                    }



                                          {this.state.lineageRighPanelDetails && (this.state.lineageRighPanelDetails.dataset_name || this.state.lineageRighPanelDetails.data?.dataset_name) ? (
                                            this.renderLineageApiDetails(this.state.lineageRighPanelDetails)
                                          ) : this.state.lineageRighPanelDetails && (
                                            <>
                                              {/* {this.state.selectedMorePipelineType === "dbt_core" ? this.renderDbtCoreLineageDetails() : ( */}
                                                <>
                                                  {this.Rightpanelinfo("Stage Name", this.state.lineageRighPanelDetails.stage_name)}
                                                  {this.Rightpanelinfo("Stage ID", this.state.lineageRighPanelDetails.stage_id)}
                                                  {this.Rightpanelinfo("Dag Id", this.state.lineageRighPanelDetails.data_transformation_pipeline)}
                                                  {this.Rightpanelinfo("Operator", this.state.lineageRighPanelDetails.operator)}
                                                  {this.Rightpanelinfo("Max Tries", this.state.lineageRighPanelDetails.max_tries)}
                                                  {this.Rightpanelinfo("Pool", this.state.lineageRighPanelDetails.pool)}
                                                  {this.Rightpanelinfo("Queue", this.state.lineageRighPanelDetails.queue)}
                                                  {this.Rightpanelinfo("Hostname", this.state.lineageRighPanelDetails.hostname)}
                                                  {this.Rightpanelinfo("External Dag Id", this.state.lineageRighPanelDetails.external_dag_id)}
                                                  {this.Rightpanelinfo("External Task Id", this.state.lineageRighPanelDetails.external_task_id)}
                                                  {this.Rightpanelinfo("Task Name", this.state.lineageRighPanelDetails.task_name)}
                                                  {this.Rightpanelinfo("Task Id", this.state.lineageRighPanelDetails.task_id)}
                                                </>
                                              {/* )} */}

                                            </>
                                          ) }
                                    </div>
                                </div>
                              </div>
                              {/* <div className="lg-section">
                 <h5 className="lg-section__title">Impact Analysis</h5>
              <div className="lg-section__body">
                <Tab.Container defaultActiveKey="aj">
                    <div className="tabbable-line">
                        <Nav variant="tabs" id="page-nav-tabs">
                            <Nav.Item>
                                <Nav.Link eventKey="aj" >
                                    <span className="qd-menu__link-text">Affected Jobs <span className="badge badge-circle badge-light-danger ml-1">{affectedJobs.length > 0 ? affectedJobs.length : 0}</span></span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="ad">
                                    <span className="qd-menu__link-text">Affected Datasets <span className="badge badge-circle badge-light-danger ml-1">{affectedDatasets.length > 0 ? affectedDatasets.length : 0}</span></span>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <Tab.Content className="pt-2">
                        <Tab.Pane eventKey="aj">
                          <ul className="pipeline-affected-list">
                               {affectedJobs.length > 0 ? affectedJobs.map((job, idx) => (
                                          <li key={idx}>
                                            <a href="#!">
                                        <i>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                                <g id="icon_job" transform="translate(-8449 726)">
                                                    <rect id="Rectangle_1919" data-name="Rectangle 1919" width="24" height="24" transform="translate(8449 -726)" fill="none"/>
                                                    <path id="icon_tree" d="M8.359,8.383h1.8v1.785H5.564a1.025,1.025,0,0,0-1.032,1.011v1.937H2.789A1.032,1.032,0,0,0,1.75,14.137v4.591A1.031,1.031,0,0,0,2.789,19.75H7.46A1.034,1.034,0,0,0,8.5,18.728V14.137a1.032,1.032,0,0,0-1.041-1.022H5.72V11.336H15.78v1.779H14.038A1.032,1.032,0,0,0,13,14.137v4.591a1.032,1.032,0,0,0,1.041,1.022h4.673a1.032,1.032,0,0,0,1.039-1.022V14.137a1.032,1.032,0,0,0-1.041-1.022H16.973V11.182a1.025,1.025,0,0,0-1.032-1.013H11.347V8.383h1.8a.974.974,0,0,0,.982-.967v-4.7a.977.977,0,0,0-.984-.969H8.359a.977.977,0,0,0-.982.967v4.7a.977.977,0,0,0,.984.969Z" transform="translate(8450.25 -724.75)" fill="currentColor" fill-rule="evenodd"/>
                                                </g>
                                            </svg>
                                        </i><span>{job}</span><i className="arrow-icon"><FontAwesomeIcon icon={faChevronRight} /></i>
                                    </a>
                                </li>)) : <li>No affected jobs.</li>}
            </ul>
                   </Tab.Pane>
                    <Tab.Pane eventKey="ad">
                        <ul className="pipeline-affected-list">
                          {affectedDatasets.length > 0 ? affectedDatasets.map((dataset, idx) => (
                            <li key={idx}>
                               <a href="#!">
                                                <i>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                                        <g id="icon_job" transform="translate(-8449 726)">
                                                            <rect id="Rectangle_1919" data-name="Rectangle 1919" width="24" height="24" transform="translate(8449 -726)" fill="none"/>
                                                            <path id="icon_tree" d="M8.359,8.383h1.8v1.785H5.564a1.025,1.025,0,0,0-1.032,1.011v1.937H2.789A1.032,1.032,0,0,0,1.75,14.137v4.591A1.031,1.031,0,0,0,2.789,19.75H7.46A1.034,1.034,0,0,0,8.5,18.728V14.137a1.032,1.032,0,0,0-1.041-1.022H5.72V11.336H15.78v1.779H14.038A1.032,1.032,0,0,0,13,14.137v4.591a1.032,1.032,0,0,0,1.041,1.022h4.673a1.032,1.032,0,0,0,1.039-1.022V14.137a1.032,1.032,0,0,0-1.041-1.022H16.973V11.182a1.025,1.025,0,0,0-1.032-1.013H11.347V8.383h1.8a.974.974,0,0,0,.982-.967v-4.7a.977.977,0,0,0-.984-.969H8.359a.977.977,0,0,0-.982.967v4.7a.977.977,0,0,0,.984.969Z" transform="translate(8450.25 -724.75)" fill="currentColor" fill-rule="evenodd"/>
                                                        </g>
                                                    </svg>
                                                </i><span>{dataset}</span><i className="arrow-icon"><FontAwesomeIcon icon={faChevronRight} /></i>
                                                </a>
                                        </li>)) : <li>No affected datasets.</li>}
                                </ul>
                                </Tab.Pane></Tab.Content></Tab.Container>
                                </div>
                                </div> */}
                            </div>

                          </div>
                        </div>)}
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </div>}
          </div>
        </Tab.Container>

      </>
    )
  }
  getShortId = (id, visibleChars = 30) => {
    if (!id) return "";
    return id.length > visibleChars
      ? id.slice(0, visibleChars)
      : id;
  };

  renderRunsPanel() {
    console.log("renderrunspanel");
    let { selectedMoreJobName, lineageData } = this.state;
    let tasksUnderSelectedJob = lineageData?.tasks?.[selectedMoreJobName] || [];
    let affectedJobs = tasksUnderSelectedJob.flatMap(task => task.affected_jobs || []);
    let affectedDatasets = tasksUnderSelectedJob.flatMap(task => task.affected_datasets || []);
    return (
      <>
        <div id="rt-pipeline-panel" class="rt-pipeline-panel rt-pl-jobrun">
          <div class="rt-pipeline-panel__head">
            <div class="rt-pipeline-panel__caption">
              <div className="rt-pl-jobrun__title">
                <h4 className='d-flex align-items-center'>
                  <a href="#!" className="text-blue" onClick={this.gobackfullscreen}>
                    <i className="icon-back-arrow" >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_13282_35391)">
                          <path d="M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z" fill="currentColor" />
                        </g>
                        <defs>
                          <clipPath id="clip0_13282_35391">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </i>Runs
                  </a><span className="ml-2">/ {this.getShortId(this.state.detailviewid)}

                    {this.state.detailviewid?.length > 28 && (
                      <RcTooltip
                        placement="top"
                        overlay={this.state.detailviewid}
                        trigger={['hover']}
                      >
                        <span>
                          [...]
                        </span>
                      </RcTooltip>
                    )}
                  </span></h4>
                <div className="divider"></div>
                {(() => {
                  const status = this.state.detailviewstatus
                  if (!status) return "-";

                  const run_status = status.toLowerCase();

                  const statusMap = {
                    succeeded: (
                      <div className="badge badge-light-success mr-1">
                        <i className="mr-1"><svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9" /></svg>
                        </i> {this.state.detailviewstatus}
                      </div>
                    ),
                    failed: (
                      <div className="badge badge-light-danger mr-1">
                        <i className="mr-1">
                          <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59" /></svg>
                        </i> {this.state.detailviewstatus}
                      </div>
                    ),
                    running: (
                      <div className="d-flex align-items-center text-info">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_263_199)">
                            <path d="M16.24 7.76C15.07 6.59 13.54 6 12 6V12L7.76 16.24C10.1 18.58 13.9 18.58 16.25 16.24C18.59 13.9 18.59 10.1 16.24 7.76V7.76ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="#4CA3FF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_263_199">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <span className="ml-1 flex-grow-1">{this.state.detailviewstatus}  </span>
                      </div>
                    ),
                    inprogress: (
                      <div className='d-flex align-items-center text-primary'>
                        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="#495FB8"><g><rect fill="none" height="24" width="24" /></g><g><path d="M6,2l0.01,6L10,12l-3.99,4.01L6,22h12v-6l-4-4l4-3.99V2H6z M16,16.5V20H8v-3.5l4-4L16,16.5z" /></g></svg>
                        <span className="ml-1 flex-grow-1">{this.state.detailviewstatus}  </span>
                      </div>
                    ),
                    queued: (
                      <div className='d-flex align-items-center text-primary'>
                        <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#FFA800"><path d="M0 0h24v24H0z" fill="none" /><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z" /></svg>
                        <span className="ml-1 flex-grow-1">{this.state.detailviewstatus}  </span>
                      </div>
                    ),
                    cancelled: (
                      <div className='d-flex align-items-center text-primary'>
                        <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#F64E60"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
                        <span className="ml-1 flex-grow-1">{this.state.detailviewstatus}  </span>
                      </div>
                    ),
                    skipped: (
                      <div className='d-flex align-items-center text-primary'>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.4758 12.2096V3.79102H12.6654V12.2096H11.4758ZM3.33203 12.2096V3.79102L9.64585 8.00029L3.33203 12.2096Z" fill="#495FB8" />
                        </svg>
                        <span className="ml-1 flex-grow-1">{this.state.detailviewstatus}  </span>
                      </div>
                    ),
                    restart: (
                      <div className='d-flex align-items-center text-primary'>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.2 14.9262C5.69947 14.7313 4.45767 14.0703 3.4746 12.9432C2.49153 11.816 2 10.4955 2 8.98159C2 8.16826 2.16053 7.38906 2.4816 6.64399C2.80267 5.89879 3.2524 5.24413 3.8308 4.67999L4.6862 5.53539C4.19487 5.98366 3.82433 6.50393 3.5746 7.09619C3.32487 7.68846 3.2 8.31693 3.2 8.98159C3.2 10.1549 3.5746 11.1891 4.3238 12.084C5.073 12.9788 6.03173 13.5262 7.2 13.7262V14.9262ZM8.8 14.9416V13.7416C9.95493 13.5077 10.9103 12.948 11.6662 12.0624C12.4221 11.1768 12.8 10.1499 12.8 8.98159C12.8 7.64826 12.3333 6.51493 11.4 5.58159C10.4667 4.64826 9.33333 4.18159 8 4.18159H7.717L8.797 5.26159L7.9538 6.10459L5.4308 3.58159L7.9538 1.05859L8.797 1.90159L7.717 2.98159H8C9.67387 2.98159 11.0923 3.56313 12.2554 4.72619C13.4185 5.88926 14 7.30773 14 8.98159C14 10.4872 13.5072 11.8011 12.5216 12.9232C11.5359 14.0452 10.2953 14.718 8.8 14.9416Z" fill="#FA4616" />
                        </svg>
                        <span className="ml-1 flex-grow-1">{this.state.detailviewstatus}  </span>
                      </div>
                    ),
                    none: (
                      <div className='d-flex align-items-center text-primary'>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.99993 14.6673C7.07782 14.6673 6.2111 14.4923 5.39975 14.1424C4.58841 13.7925 3.88267 13.3176 3.28256 12.7177C2.68244 12.1178 2.20729 11.4123 1.85712 10.6014C1.50706 9.79036 1.33203 8.92387 1.33203 8.00188C1.33203 7.07977 1.507 6.21305 1.85694 5.4017C2.20689 4.59036 2.6818 3.88463 3.28168 3.28451C3.88156 2.68439 4.587 2.20925 5.398 1.85907C6.20899 1.50901 7.07548 1.33398 7.99747 1.33398C8.91958 1.33398 9.7863 1.50895 10.5976 1.8589C11.409 2.20884 12.1147 2.68375 12.7148 3.28363C13.315 3.88352 13.7901 4.58896 14.1403 5.39995C14.4903 6.21094 14.6654 7.07743 14.6654 7.99942C14.6654 8.92153 14.4904 9.78825 14.1405 10.5996C13.7905 11.4109 13.3156 12.1167 12.7157 12.7168C12.1158 13.3169 11.4104 13.7921 10.5994 14.1422C9.78841 14.4923 8.92191 14.6673 7.99993 14.6673ZM7.33747 11.334H8.65993C9.00881 11.334 9.30747 11.2098 9.55589 10.9614C9.80431 10.7129 9.92852 10.4143 9.92852 10.0654V5.93591C9.92852 5.58703 9.80431 5.28837 9.55589 5.03995C9.30747 4.79153 9.00881 4.66732 8.65993 4.66732H7.33747C6.98858 4.66732 6.68993 4.79153 6.4415 5.03995C6.19308 5.28837 6.06887 5.58703 6.06887 5.93591V10.0654C6.06887 10.4143 6.19308 10.7129 6.4415 10.9614C6.68993 11.2098 6.98858 11.334 7.33747 11.334ZM7.33747 5.71995H8.65993C8.72297 5.71995 8.77472 5.74018 8.81519 5.78065C8.85566 5.82112 8.87589 5.87287 8.87589 5.93591V10.0654C8.87589 10.1284 8.85566 10.1802 8.81519 10.2207C8.77472 10.2611 8.72297 10.2814 8.65993 10.2814H7.33747C7.27443 10.2814 7.22267 10.2611 7.18221 10.2207C7.14174 10.1802 7.1215 10.1284 7.1215 10.0654V5.93591C7.1215 5.87287 7.14174 5.82112 7.18221 5.78065C7.22267 5.74018 7.27443 5.71995 7.33747 5.71995Z" fill="#6C757D" />
                        </svg>
                        <span className="ml-1 flex-grow-1">{this.state.detailviewstatus}  </span>
                      </div>
                    ),
                    stage_failure_run_success: (
                      <div className='d-flex align-items-center text-success tw-w-[200px]'>
                        <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.6654 6.00065C8.08937 6.00065 5.9987 8.09132 5.9987 10.6673C5.9987 13.2433 8.08937 15.334 10.6654 15.334C13.2414 15.334 15.332 13.2433 15.332 10.6673C15.332 8.09132 13.2414 6.00065 10.6654 6.00065ZM9.4007 12.6693L7.72536 10.994C7.54337 10.812 7.54337 10.518 7.72536 10.336C7.90736 10.154 8.20136 10.154 8.38336 10.336L9.73203 11.68L12.9427 8.46932C13.1247 8.28732 13.4187 8.28732 13.6007 8.46932C13.7827 8.65132 13.7827 8.94532 13.6007 9.12732L10.0587 12.6693C9.88136 12.8513 9.5827 12.8513 9.4007 12.6693Z" fill="#50CD89" />
                          <path d="M4.66536 6.33398C4.75981 6.33398 4.83898 6.30204 4.90286 6.23815C4.96675 6.17426 4.9987 6.0951 4.9987 6.00065C4.9987 5.90621 4.96675 5.82704 4.90286 5.76315C4.83898 5.69926 4.75981 5.66732 4.66536 5.66732C4.57092 5.66732 4.49175 5.69926 4.42786 5.76315C4.36398 5.82704 4.33203 5.90621 4.33203 6.00065C4.33203 6.0951 4.36398 6.17426 4.42786 6.23815C4.49175 6.30204 4.57092 6.33398 4.66536 6.33398ZM4.33203 5.00065H4.9987V3.00065H4.33203V5.00065ZM4.66536 8.00065C4.20425 8.00065 3.77092 7.91315 3.36536 7.73815C2.95981 7.56315 2.60703 7.32565 2.30703 7.02565C2.00703 6.72565 1.76953 6.37287 1.59453 5.96732C1.41953 5.56176 1.33203 5.12843 1.33203 4.66732C1.33203 4.20621 1.41953 3.77287 1.59453 3.36732C1.76953 2.96176 2.00703 2.60898 2.30703 2.30898C2.60703 2.00898 2.95981 1.77148 3.36536 1.59648C3.77092 1.42148 4.20425 1.33398 4.66536 1.33398C5.12648 1.33398 5.55981 1.42148 5.96536 1.59648C6.37092 1.77148 6.7237 2.00898 7.0237 2.30898C7.3237 2.60898 7.5612 2.96176 7.7362 3.36732C7.9112 3.77287 7.9987 4.20621 7.9987 4.66732C7.9987 5.12843 7.9112 5.56176 7.7362 5.96732C7.5612 6.37287 7.3237 6.72565 7.0237 7.02565C6.7237 7.32565 6.37092 7.56315 5.96536 7.73815C5.55981 7.91315 5.12648 8.00065 4.66536 8.00065ZM4.66536 7.33398C5.40981 7.33398 6.04036 7.07565 6.55703 6.55898C7.0737 6.04232 7.33203 5.41176 7.33203 4.66732C7.33203 3.92287 7.0737 3.29232 6.55703 2.77565C6.04036 2.25898 5.40981 2.00065 4.66536 2.00065C3.92092 2.00065 3.29036 2.25898 2.7737 2.77565C2.25703 3.29232 1.9987 3.92287 1.9987 4.66732C1.9987 5.41176 2.25703 6.04232 2.7737 6.55898C3.29036 7.07565 3.92092 7.33398 4.66536 7.33398Z" fill="#F04438" />
                        </svg>  <span className='text-danger mr-1'>Stage Failure</span> Run Success
                      </div>
                    )
                  };

                  return statusMap[run_status] || "-";
                })()}
                <div className="badge badge-light-gray mr-1">
                  <i className="mr-1 text-muted"><svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0V0" fill="none" /><path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8" /></svg></i>Run of <strong>
                    {this.state.selectedMoreJobName}</strong>
                </div>
                <div className="badge badge-light-gray mr-1">
                  <i className="mr-1"><svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0" fill="none" /><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8" /><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67" /></svg></i>
                  {this.state.detailviewtiming} GMT
                </div>
                <div className="badge badge-light-gray mr-1">
                  <i className="mr-1"><svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><g><g><path d="M15,1H9v2h6V1z M11,14h2V8h-2V14z M19.03,7.39l1.42-1.42c-0.43-0.51-0.9-0.99-1.41-1.41l-1.42,1.42 C16.07,4.74,14.12,4,12,4c-4.97,0-9,4.03-9,9s4.02,9,9,9s9-4.03,9-9C21,10.88,20.26,8.93,19.03,7.39z M12,20c-3.87,0-7-3.13-7-7 s3.13-7,7-7s7,3.13,7,7S15.87,20,12,20" /></g></g></g></svg></i>
                  {this.state.detailviewduration}
                </div>
              </div>
            </div>
            {/* <div class="rt-pipeline-panel__action">
                    <button className="btn close-btn"></button>
                  </div> */}
          </div>
          <div className={this.state.activeTab === "td" || this.state.activeTab === "navtroubleshooting" ? "rt-pipeline-panel__body p-0 overflow-hidden" : "rt-pipeline-panel__body p-0"}>
            <Tab.Container activeKey={this.state.activeTab === "navtroubleshooting" ? "navtroubleshooting" : "tv"} onSelect={
              (key) => {
                this.setState({ activeTab: key }, () => {
                  this.showDetailsPipeline(JSON.parse(this.state.gannt_parms_json), 'test')
                });
              }
            }>
              <div className="tabbable-line">
                <Nav variant="tabs pl-3">
                  <Nav.Item>
                    <Nav.Link eventKey="tv" >
                      <span className="qd-menu__link-text">Timed view</span>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="navtroubleshooting">
                      <span className="qd-menu__link-text">Troubleshooting & Diagnosing</span>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
              <Tab.Content>
                <Tab.Pane eventKey="tv">
                  <div className="col">

                    <input
                      type="button"
                      className="btn btn-sm btn-default mb-3 d-none"
                      value="Stage"
                      onClick={() => this.pushResponseData(
                        {
                          "ids_type": "stage_info",
                          "data": [
                            {
                              "stage_id": 16435,
                              "stage_name": "wait_processing_task",
                              "stage_start_time": "2026-02-24 16:05:01",
                              "stage_status_code": -100,
                              "stage_status_text": "Failed",
                              "duration": 0,
                              "activity_output": "default_host\nError fetching the logs. Try number 0 is invalid.\n",
                              "error_message": null,
                              "stage_end_time": "2026-02-24 16:05:01",
                              "env_id": 2,
                              "p_run_id": 4641,
                              "pipeline_id": 8,
                              "source_run_id": "scheduled__2026-02-24T13:50:00+00:00"
                            }
                          ],
                          "additional_data": {
                            "duration": 6246000,
                            "run_start_time": "2026-02-24 14:20:47",
                            "run_status_text": "Running"
                          }
                        }

                      )}
                    />

                    <div style={{ "width": "98%" }}>
                      {this.state.gantt_chart_details.length > 0 ?
                        <GanttChart data={this.state.gantt_chart_details} /> : ""}
                    </div></div>
                  <div className="pipeline-stage-wrap">
                    <div className="pipeline-stage__head">
                      <h5 className="title">
                        <i className="mr-1">
                          <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_13335_18732)">
                              <path d="M12.94 5.44016L9.72 2.22016C9.47333 1.9735 9.13333 1.8335 8.78 1.8335H4C3.26666 1.8335 2.67333 2.4335 2.67333 3.16683L2.66666 13.8335C2.66666 14.5668 3.26 15.1668 3.99333 15.1668H12C12.7333 15.1668 13.3333 14.5668 13.3333 13.8335V6.38683C13.3333 6.0335 13.1933 5.6935 12.94 5.44016ZM6.82 12.0268L5.40666 10.6135C5.14666 10.3535 5.14666 9.9335 5.40666 9.6735C5.66666 9.4135 6.08666 9.4135 6.34666 9.6735L7.28666 10.6135L9.64666 8.2535C9.90666 7.9935 10.3267 7.9935 10.5867 8.2535C10.8467 8.5135 10.8467 8.9335 10.5867 9.1935L7.76 12.0202C7.50666 12.2868 7.08 12.2868 6.82 12.0268ZM9.33333 6.50016C8.96666 6.50016 8.66666 6.20016 8.66666 5.8335V2.8335L12.3333 6.50016H9.33333Z" fill="#ADB5BD" />
                            </g>
                            <defs>
                              <clipPath id="clip0_13335_18732">
                                <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                              </clipPath>
                            </defs>
                          </svg>
                        </i> Tasks
                      </h5>
                      <div className="qd-search-bar has-btn-close qd-search-bar--bg-light-gray mr-2">
                        <div className="input-group h-34px">
                          <div className="input-group-prepend">
                            <button id="button-addon4" type="button" className="btn">
                              <svg class="d-block" width="20" height="20" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.889 12.5237L10.35 9.98474C10.1222 9.75694 9.75283 9.75694 9.52502 9.98474C9.29722 10.2126 9.29722 10.5819 9.52502 10.8097L12.064 13.3487C12.2918 13.5765 12.6612 13.5765 12.889 13.3487C13.1168 13.1209 13.1168 12.7515 12.889 12.5237Z" fill="#99A1B7"></path><path d="M6.41667 11.8333C3.82408 11.8333 1.75 9.75923 1.75 7.16667C1.75 4.57408 3.82408 2.5 6.41667 2.5C9.00923 2.5 11.0833 4.57408 11.0833 7.16667C11.0833 9.75923 9.00923 11.8333 6.41667 11.8333ZM6.41667 3.66667C4.39444 3.66667 2.91667 5.14444 2.91667 7.16667C2.91667 9.18891 4.39444 10.6667 6.41667 10.6667C8.43891 10.6667 9.91667 9.18891 9.91667 7.16667C9.91667 5.14444 8.43891 3.66667 6.41667 3.66667Z" fill="#99A1B7"></path></svg>
                            </button>
                          </div>
                          <input type="search" placeholder="Search..." class="form-control" onChange={this.filterStageSearch} value={this.state.searchingTaskText} />
                        </div>
                        {this.state.searchingTaskText && <button class="btn btn-clear" title="clear" onClick={this.clearTask}><i class="icon-close"></i></button>}

                      </div>
                      <div className="btn-toolbar">
                        <div className="btn-toolbar__wrap">
                          <div className="btn-toolbar__item">
                            <div className="dropdown">
                              <Dropdown>
                                <Dropdown.Toggle variant="" id="dropdown-basic">
                                  {this.state.gantt_chart_grid_filter.length === 0 ?
                                    <svg className="" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="18"
                                      viewBox="0 0 24 24" width="18">
                                      <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                                      <path d="M0 0h24v24H0z" fill="none" />
                                    </svg> : ""
                                  }
                                  {/* <span className={filterCount > 0 ? "filter-count d-inline-flex" : "filter-count d-none"}>{filterCount}</span> */}
                                  <span className={this.state.gantt_chart_grid_filter.length > 0 ? "filter-count d-inline-flex" : "filter-count d-none"}>{this.state.gantt_chart_grid_filter.length}</span>
                                  <span className="ml-1">Filter</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item href="#/action-1" className="py-1">
                                    <div className="custom-control custom-checkbox custom-control-inline">
                                      <Form.Control
                                        type="checkbox"
                                        value="Succeeded"
                                        className="custom-control-input"
                                        name="stageFilter"
                                        onClick={this.applystagefilter}
                                        id="pipeline-done"
                                      />
                                      <Form.Label className="custom-control-label" for="pipeline-done">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>
                                        <span className="ml-1">Success</span>
                                      </Form.Label>
                                    </div>
                                  </Dropdown.Item>
                                  <Dropdown.Item href="#/action-2" className="py-1">
                                    <div className="custom-control custom-checkbox custom-control-inline">
                                      <Form.Control
                                        type="checkbox"
                                        className="custom-control-input"
                                        value="Failed"
                                        onClick={this.applystagefilter}
                                        name="stageFilter"
                                        id="pipeline-failed"
                                      />
                                      <Form.Label className="custom-control-label" for="pipeline-failed">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59" /></svg>
                                        <span className="ml-1">Failed</span>
                                      </Form.Label>
                                    </div>
                                  </Dropdown.Item>
                                  <Dropdown.Item href="#/action-2" className="py-1">
                                    <div className="custom-control custom-checkbox custom-control-inline">
                                      <Form.Control
                                        type="checkbox"
                                        className="custom-control-input"
                                        value="Others"
                                        onClick={this.applystagefilter}
                                        name="stageFilter"
                                        id="pipeline-others"
                                      />
                                      <Form.Label className="custom-control-label" for="pipeline-others">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59" /></svg>
                                        <span className="ml-1">Others</span>
                                      </Form.Label>
                                    </div>
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="pipeline-stage__content">
                      <div className="table-responsive custom-tbl">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Timestamp</th>
                              <th>Task Name</th>
                              <th>Task Type</th>
                              <th>Status</th>
                              <th>Output</th>
                              <th>Error</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              this.state.gantt_chart_grid_temp.length > 0 ?
                                this.state.gantt_chart_grid_temp.map((data, key) => {
                                  return (<tr>
                                    <td>{key + 1}</td>
                                    <td>
                                      {/* Need to Check stage_end */}
                                      {
                                        data?.stage_end_time ? `${moment(data.stage_end_time.replace("GMT", "")).format('hh:mm:ss')} GMT` : "--"
                                      }</td>
                                    <td>{data.stage_name}</td>
                                    <td>  {data.stage_type || data.stage_metadata?.activityType || "NA"}</td>
                                    <td>
                                      {
                                        data.stage_status_text === "Succeeded" ?
                                          <div class="badge badge-light-success bdr-light-success">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor">
                                              <path d="M0 0h24v24H0" fill="none"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9"></path>
                                            </svg>
                                            <span class="ml-1">Success</span>
                                          </div> : data.stage_status_text === "Failed" ? <div class="badge badge-light-danger bdr-light-danger">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor">
                                              <path d="M0 0h24v24H0" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59" />
                                            </svg>
                                            <span class="ml-1">Failed</span>
                                          </div> : <div class="badge badge-light-brown bdr-light-brown">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="currentColor"><path d="M320-280q17 0 28.5-11.5T360-320q0-17-11.5-28.5T320-360q-17 0-28.5 11.5T280-320q0 17 11.5 28.5T320-280Zm0-160q17 0 28.5-11.5T360-480q0-17-11.5-28.5T320-520q-17 0-28.5 11.5T280-480q0 17 11.5 28.5T320-440Zm0-160q17 0 28.5-11.5T360-640q0-17-11.5-28.5T320-680q-17 0-28.5 11.5T280-640q0 17 11.5 28.5T320-600Zm160 320h160q17 0 28.5-11.5T680-320q0-17-11.5-28.5T640-360H480q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm0-160h160q17 0 28.5-11.5T680-480q0-17-11.5-28.5T640-520H480q-17 0-28.5 11.5T440-480q0 17 11.5 28.5T480-440Zm0-160h160q17 0 28.5-11.5T680-640q0-17-11.5-28.5T640-680H480q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Z" /></svg>
                                            <span class="ml-1">Others</span>
                                            <RcTooltip
                                              placement="top"
                                              overlay={
                                                <span>{data.stage_status_text}</span>
                                              }
                                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                            >
                                              <i className="icon-info-circle icon-info-circle-sm ml-1"></i>
                                            </RcTooltip>
                                          </div>
                                      }
                                    </td>
                                    <td>
                                      <span className="tbl-tag has-copy-icon">
                                        <RcTooltip placement="top"
                                          overlay={
                                            // <span dangerouslySetInnerHTML={{ __html: String(JSON.stringify(data.activity_output)).replace(/\n/g, "<br><br><br>")}} ></span>
                                            <div
                                              dangerouslySetInnerHTML={{ __html: this.formatForHtml(data.activity_output, true) }} />
                                          }
                                          arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                          overlayClassName="tooltip-auto-width"
                                        >
                                          {/* <span className="tbl-tag__text">{this.formatForInline(data.activity_output)}</span> */}
                                          <span className="tbl-tag__text" dangerouslySetInnerHTML={{ __html: this.formatForInline(data.activity_output) }}></span>
                                        </RcTooltip>
                                        <span className="tbl-tag__action">
                                          {this.state.tagTextCopied === "output_" + key ?
                                            <RcTooltip placement="top"
                                              overlay={
                                                <span>Copied!</span>
                                              }
                                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                            >
                                              <i className="icon-done"></i>
                                            </RcTooltip>
                                            :
                                            <RcTooltip placement="top"
                                              overlay={
                                                <span>Copy to clipboard</span>
                                              }
                                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                            >
                                              <i className="icon-clipboard" id={"output_" + key} onClick={this.handleTagClipboard.bind(this, key, JSON.stringify(data.activity_output), 'output')}></i>
                                            </RcTooltip>
                                          }
                                        </span>
                                      </span>
                                    </td>
                                    <td>
                                      <span className="tbl-tag has-copy-icon">
                                        <RcTooltip placement="top"
                                          style={{ width: "100% !important", overflowWrap: "break-word", maxWidth: "100% !important" }}
                                          overlay={
                                            <div dangerouslySetInnerHTML={{ __html: this.formatForHtml(data.error_message, true) }} />
                                            // <span dangerouslySetInnerHTML={{ __html:  String(JSON.stringify(data.error_message)).replace(/\n/g, "<br><br><br>")}} ></span>
                                          }
                                          arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                          overlayClassName="w-25"
                                        >
                                          {/* <span className="tbl-tag__text">{JSON.stringify(data.error_message)}</span> */}
                                          <span className="tbl-tag__text" dangerouslySetInnerHTML={{ __html: this.formatForInline(data.error_message) }}></span>
                                        </RcTooltip>
                                        <span className="tbl-tag__action">
                                          {this.state.tagTextCopied === "err_" + key ?
                                            <RcTooltip placement="top"
                                              overlay={
                                                <span>Copied!</span>
                                              }
                                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                            >
                                              <i className="icon-done"></i>
                                            </RcTooltip>
                                            :
                                            <RcTooltip placement="topRight"
                                              overlay={
                                                <span>Copy to clipboard</span>
                                              }
                                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                            >
                                              <i className="icon-clipboard" id={"err_" + key} onClick={this.handleTagClipboard.bind(this, key, JSON.stringify(data.error_message), 'err')}></i>
                                            </RcTooltip>
                                          }
                                        </span>
                                      </span>
                                    </td>
                                  </tr>)
                                }) : <tr><td colspan="7"><div className="row text-center">
                                  <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                                    <div className="placeholder-msg">
                                      <div className="placeholder-msg__icon">
                                        <Image src="icon_placeholder_no_pipeline_data" />
                                      </div>
                                      <p>No Tasks Found</p>
                                    </div>
                                  </div>
                                </div></td></tr>}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="navtroubleshooting">
                  {/* <div className="portlet lineage-graph-portlet border-0">
                    <div className="portlet-title">
                      <div className="caption">
                        <span className="font-dark">Pipeline: <strong>{this.state.detailviewjobname}</strong></span>
                        <p>Click on task or dataset in order to see their downstream</p>
                      </div>
                      <div className="actions">
                        <div className="lg-toolbar">
                          <div className="lg-toolbar-item">
                            <p className="text-muted m-0">Last sync: <strong className="text-dark">Today at 04:00:00 PM</strong></p>
                          </div>
                          <div className="lg-toolbar-item">
                            <Form className="mr-3">
                              <Form.Group controlId="formBasicRangeCustom" className="form-inline flex-nowrap mb-0">
                                <Form.Label className="d-none d-xl-inline-block">Zoom</Form.Label>
                                <Slider
                                  min={0}
                                  max={100}
                                  tooltip={false}
                                  value={this.state.rangeValue}
                                  onChange={this.setRangeValue}
                                />
                                <span className="rangeslider__label">{this.state.rangeValue + "%"}</span>
                              </Form.Group>
                            </Form>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip>Zoom Reset</Tooltip>
                              }
                            >
                              <i>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g clip-path="url(#clip0_2066_27139)">
                                    <path d="M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM4 15C3.45 15 3 15.45 3 16V19C3 20.1 3.9 21 5 21H8C8.55 21 9 20.55 9 20C9 19.45 8.55 19 8 19H6C5.45 19 5 18.55 5 18V16C5 15.45 4.55 15 4 15ZM5 6C5 5.45 5.45 5 6 5H8C8.55 5 9 4.55 9 4C9 3.45 8.55 3 8 3H5C3.9 3 3 3.9 3 5V8C3 8.55 3.45 9 4 9C4.55 9 5 8.55 5 8V6ZM19 3H16C15.45 3 15 3.45 15 4C15 4.55 15.45 5 16 5H18C18.55 5 19 5.45 19 6V8C19 8.55 19.45 9 20 9C20.55 9 21 8.55 21 8V5C21 3.9 20.1 3 19 3ZM19 18C19 18.55 18.55 19 18 19H16C15.45 19 15 19.45 15 20C15 20.55 15.45 21 16 21H19C20.1 21 21 20.1 21 19V16C21 15.45 20.55 15 20 15C19.45 15 19 15.45 19 16V18Z" fill="#A1A5B7" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_2066_27139">
                                      <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </i>
                            </OverlayTrigger>
                          </div>
                          <div className="lg-toolbar-item">
                            <button class="btn btn-light-secondary">Clear Selection</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="portlet-body p-0">
                      <div className="lineage-graph-container">
                      {this.state.run_level_lineageData!==null ?
                                                            <PipelineLineageErr
                                                            height="calc(100vh - 78px)"
                                                            chart_id="linenage"
                                                            // selectedNode = {this.state.selectedPipelineInfo.job_name}
                                                            data={this.state.run_level_lineageData}
                                                              />:""}
                      </div>
                    </div>
                  </div> */}

                  <div className={this.state.lineageGraphExpanded === true ? "portlet lineage-graph-portlet lineage-graph-portlet--is-expanded border-0" : "portlet lineage-graph-portlet border-0"}>
                    <div className="portlet-title">
                      <div className="caption">
                        {/* <span className="font-dark">Pipeline: <strong>{filteredPipelineJob !== undefined && filteredPipelineJob[0] !== undefined && filteredPipelineJob[0].job_name}</strong></span> */}
                        <p>Click on task or dataset in order to see their downstream</p>
                      </div>
                      <div className="actions">
                        <div className="lg-toolbar">
                          <div className="lg-toolbar-item">
                            {/* <p className="text-muted m-0"><span className="d-none d-xxl-inline-block">Last sync:</span> <strong className="text-dark d-none">Today at 04:00:00 PM</strong></p> */}
                          </div>
                          <div className="lg-toolbar-item pr-2">
                            {/* <Form>
                                <Form.Group controlId="formBasicRangeCustom" className="form-inline flex-nowrap mb-0">
                                    <Form.Label className="d-none d-xxl-inline-block">Zoom</Form.Label>
                                    <Slider
                                        min={1}
                                        max={100}
                                        tooltip={false}
                                        value={this.state.rangeValue}
                                        onChange={this.setRangeValue}
                                    />
                                    <span className="rangeslider__label bg-transparent">{this.state.rangeValue + "%"}</span>
                                </Form.Group>
                            </Form> */}
                            {/* <RcTooltip 
                                placement="top" 
                                overlay={<span>Zoom Reset</span>}
                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                              <i className='icon-wrapper cursor-pointer' onClick={this.retsetzoom}>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12 17.4205C10.8603 17.4205 9.85717 17.0701 8.9905 16.3695C8.12383 15.6688 7.561 14.7883 7.302 13.728H8.54425C8.78658 14.4678 9.21833 15.0695 9.8395 15.533C10.4607 15.9963 11.1808 16.228 12 16.228C13.0115 16.228 13.8733 15.8719 14.5855 15.1597C15.2977 14.4476 15.6538 13.5857 15.6538 12.5742C15.6538 11.5627 15.2977 10.7009 14.5855 9.98872C13.8733 9.27655 13.0115 8.92047 12 8.92047C11.4525 8.92047 10.9352 9.03839 10.448 9.27422C9.96083 9.51005 9.5365 9.82797 9.175 10.228H10.8463V11.4205H7.15375V7.72797H8.34625V9.36472C8.80892 8.87355 9.35633 8.47797 9.9885 8.17797C10.6205 7.87797 11.291 7.72797 12 7.72797C13.3385 7.72797 14.4808 8.20105 15.427 9.14722C16.3732 10.0934 16.8462 11.2357 16.8462 12.5742C16.8462 13.9127 16.3732 15.0551 15.427 16.0012C14.4808 16.9474 13.3385 17.4205 12 17.4205ZM5.30775 21.0742C4.80258 21.0742 4.375 20.8992 4.025 20.5492C3.675 20.1992 3.5 19.7716 3.5 19.2665V15.5742H5V19.2665C5 19.3435 5.03208 19.414 5.09625 19.478C5.16025 19.5421 5.23075 19.5742 5.30775 19.5742H9V21.0742H5.30775ZM15 21.0742V19.5742H18.6923C18.7692 19.5742 18.8398 19.5421 18.9038 19.478C18.9679 19.414 19 19.3435 19 19.2665V15.5742H20.5V19.2665C20.5 19.7716 20.325 20.1992 19.975 20.5492C19.625 20.8992 19.1974 21.0742 18.6923 21.0742H15ZM3.5 9.57422V5.88197C3.5 5.3768 3.675 4.94922 4.025 4.59922C4.375 4.24922 4.80258 4.07422 5.30775 4.07422H9V5.57422H5.30775C5.23075 5.57422 5.16025 5.6063 5.09625 5.67047C5.03208 5.73447 5 5.80497 5 5.88197V9.57422H3.5ZM19 9.57422V5.88197C19 5.80497 18.9679 5.73447 18.9038 5.67047C18.8398 5.6063 18.7692 5.57422 18.6923 5.57422H15V4.07422H18.6923C19.1974 4.07422 19.625 4.24922 19.975 4.59922C20.325 4.94922 20.5 5.3768 20.5 5.88197V9.57422H19Z" fill="#A1A5B7"/>
                                </svg>
                              </i>
                            </RcTooltip> */}
                          </div>
                          <div className="lg-toolbar-item">
                            {/* <button class="btn btn-light-secondary" onClick={this.resetLineage}>Clear Selection</button> */}
                            <RcTooltip
                              placement="top"
                              overlay={<span>{this.state.lineageGraphExpanded === true ? "Collapse" : "Expand"}</span>}
                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                              <i className='ml-2 icon-wrapper cursor-pointer' onClick={this.handleLineageExpand}>
                                {
                                  this.state.lineageGraphExpanded === true ?
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#484848"><path d="M182.77-140.39 140-183.15l194-193.39H221.16v-60h214.99v215h-59.99v-112.85l-193.39 194Zm341.08-383.84v-215h59.99v112.85l193.39-194L820-777.61 626-584.23h112.84v60H523.85Z" /></svg>
                                    :
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#484848"><path d="M140-140v-300h60v198.23L718.23-760H520v-60h300v300h-60v-198.23L241.77-200H440v60H140Z" /></svg>
                                }
                              </i>
                            </RcTooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="portlet-body p-0">
                      <div className="lineage-graph-container" id="lineage-container-trouble" style={{ cursor: "move", height: "calc(100vh - 78px)" }}>
                        {this.state.run_level_lineageData !== null && this.state.activeTab === "navtroubleshooting" ?
                          <PipelineLineage
                            height="100%"
                            error={true}
                            chart_id="linenagetrouble"
                            data={this.state.run_level_lineageData}
                            lineageGraphExpanded={this.state.lineageGraphExpanded}
                            handleExternalLinkClick={this.handleExternalLinkClick}
                            focusNode={this.state.selectedMoreJobName || this.state.selectedJobId}
                          /> : ""}
                      </div>
                      {this.state.activeTab === "navtroubleshooting" &&
                        (<div className="lineage-graph-sidebar">
                          <div className="lg-sidebar__content">
                            <div className="lg-sidebar__header">
                              <div className="caption">
                                <p><span id="task_dataset_name">Task</span></p>
                                {/* <p> <Image src={`connector_icon_${this.state.selectedMorePipelineType === "airflow" ? "airflow": this.state.selectedMorePipelineType === "glue" ? "glue" :this.state.selectedMorePipelineType === "azure" ? "azure" :this.state.selectedMorePipelineType === "adf" ? "data_factory" :this.state.selectedMorePipelineType === "composer" ? "composer" :
                                          this.state.selectedMorePipelineType === "dbt" ? "dbt" :
                                          this.state.selectedMorePipelineType === "mwa_airflow" ? "amazon_mwaa" :
                                          !this.state.selectedMorePipelineType || this.state.selectedMorePipelineType === "" ? "default" :
                                          "default"
                                        }`}
                                        alt={this.state.selectedMorePipelineType || "default"} width={14} height={14} className="mr-2"/>{this.state.selectedMorePipelineName}</p> */}
                              </div>
                              <div className="action">
                                <button type="button" onClick={this.closeLineageRightPanel} className="close"><span className="sr-only">Close</span></button>
                              </div>
                            </div>
                            <div className="lg-sidebar__body">
                              <div className="lg-section">
                                <h5 className="lg-section__title">Origin</h5>
                                <div className="lg-section__body">
                                  <div className="pipeline-details">
                                    <p><label>Pipeline:</label><span><i><Image src={`connector_icon_${this.state.selectedMorePipelineType === "airflow" ? "airflow" : this.state.selectedMorePipelineType === "glue" ? "glue" : this.state.selectedMorePipelineType === "azure" ? "azure" : this.state.selectedMorePipelineType === "adf" ? "data_factory" : this.state.selectedMorePipelineType === "composer" ? "composer" :
                                      (this.state.selectedMorePipelineType === "dbt" || this.state.selectedMorePipelineType === "dbt_core") ? "dbt" :
                                        this.state.selectedMorePipelineType === "mwa_airflow" ? "amazon_mwaa" :
                                          !this.state.selectedMorePipelineType || this.state.selectedMorePipelineType === "" ? "default" :
                                            "default"
                                      }`}
                                      alt={this.state.selectedMorePipelineType || "default"} width={14} height={14} className="mr-2" />
                                    </i>{this.state.selectedMorePipelineName}</span></p>
                                    {this.state.selectedMoreJobName &&
                                      this.Rightpanelinfo("Job Name", this.state.selectedMoreJobName)
                                    }

                                            {this.state.lineageRighPanelDetails &&  (this.state.lineageRighPanelDetails.dataset_name || this.state.lineageRighPanelDetails.data?.dataset_name) ? (
                                            this.renderLineageApiDetails(this.state.lineageRighPanelDetails)
                                          ) : this.state.lineageRighPanelDetails && (
                                            <>
                                              {/* {this.state.selectedMorePipelineType === "dbt_core" ? this.renderDbtCoreLineageDetails(true) : ( */}
                                                <>
                                                  {this.Rightpanelinfo("Stage Name", this.state.lineageRighPanelDetails.stage_name)}
                                                  {this.Rightpanelinfo("Stage ID", this.state.lineageRighPanelDetails.stage_id)}
                                                  {this.Rightpanelinfo("Stage Start Time", this.state.lineageRighPanelDetails.stage_start_time)}
                                                  {this.Rightpanelinfo("Stage End Time", this.state.lineageRighPanelDetails.stage_end_time)}
                                                  {this.Rightpanelinfo("Duration", this.millisecondToMinutesAndSeconds(this.state.lineageRighPanelDetails.duration))}
                                                  {this.Rightpanelinfo("Stage Status Code", this.state.lineageRighPanelDetails.stage_status_code)}
                                                  {this.Rightpanelinfo("Stage Status Text", this.state.lineageRighPanelDetails.stage_status_text)}
                                                  {this.Rightpanelinfo("Task Name", this.state.lineageRighPanelDetails.task_name)}
                                                  {this.Rightpanelinfo("Task Id", this.state.lineageRighPanelDetails.task_id)}
                                                </>

                                              {/* {this.Rightpanelinfo("Max Tries", this.state.lineageRighPanelDetails.max_tries)}
                                              {this.Rightpanelinfo("Pool", this.state.lineageRighPanelDetails.pool)}
                                              {this.Rightpanelinfo("Queue", this.state.lineageRighPanelDetails.queue)}
                                              {this.Rightpanelinfo("Hostname", this.state.lineageRighPanelDetails.hostname)}
                                              {this.Rightpanelinfo("External Dag Id", this.state.lineageRighPanelDetails.external_dag_id)}
                                              {this.Rightpanelinfo("External Task Id", this.state.lineageRighPanelDetails.external_task_id)} */}
                                      </>)}


                                    {/* {this.state.selectedStageDetails && (
                                            <>
                                              {this.Rightpanelinfo("Stage Name", this.state.selectedStageDetails.stage_name)}
                                              {this.Rightpanelinfo("Stage ID", this.state.selectedStageDetails.stage_id)}
                                              {this.Rightpanelinfo("Duration", `${this.state.selectedStageDetails.duration} ms`)}
                                              {this.Rightpanelinfo("Start Time", this.formatUTCDate(this.state.selectedStageDetails.stage_start_time))}
                                              {this.Rightpanelinfo("Status Code", this.state.selectedStageDetails.stage_status_code)}
                                              {this.Rightpanelinfo("Status", this.state.selectedStageDetails.stage_status_text)}
                                              {this.Rightpanelinfo("Source Run ID", this.state.selectedStageDetails.source_run_id)}
                                            </>
                                          ) } */}
                                  </div>
                                </div>
                              </div>
                              <div className="lg-section">
                                <h5 className="lg-section__title">Impact Analysis</h5>
                                <div className="lg-section__body">
                                  <Tab.Container defaultActiveKey="aj">
                                    <div className="tabbable-line">
                                      <Nav variant="tabs" id="page-nav-tabs">
                                        <Nav.Item>
                                          <Nav.Link eventKey="aj" >
                                            <span className="qd-menu__link-text">Affected Jobs <span className="badge badge-circle badge-light-danger ml-1">{affectedJobs.length > 0 ? affectedJobs.length : 0}</span></span>
                                          </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                          <Nav.Link eventKey="ad">
                                            <span className="qd-menu__link-text">Affected Datasets <span className="badge badge-circle badge-light-danger ml-1">{affectedDatasets.length > 0 ? affectedDatasets.length : 0}</span></span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </Nav>
                                    </div>
                                    <Tab.Content className="pt-2">
                                      <Tab.Pane eventKey="aj">
                                        <ul className="pipeline-affected-list">
                                          {affectedJobs.length > 0 ? affectedJobs.map((job, idx) => (
                                            <li key={idx}>
                                              <a href="#!">
                                                <i>
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                                    <g id="icon_job" transform="translate(-8449 726)">
                                                      <rect id="Rectangle_1919" data-name="Rectangle 1919" width="24" height="24" transform="translate(8449 -726)" fill="none" />
                                                      <path id="icon_tree" d="M8.359,8.383h1.8v1.785H5.564a1.025,1.025,0,0,0-1.032,1.011v1.937H2.789A1.032,1.032,0,0,0,1.75,14.137v4.591A1.031,1.031,0,0,0,2.789,19.75H7.46A1.034,1.034,0,0,0,8.5,18.728V14.137a1.032,1.032,0,0,0-1.041-1.022H5.72V11.336H15.78v1.779H14.038A1.032,1.032,0,0,0,13,14.137v4.591a1.032,1.032,0,0,0,1.041,1.022h4.673a1.032,1.032,0,0,0,1.039-1.022V14.137a1.032,1.032,0,0,0-1.041-1.022H16.973V11.182a1.025,1.025,0,0,0-1.032-1.013H11.347V8.383h1.8a.974.974,0,0,0,.982-.967v-4.7a.977.977,0,0,0-.984-.969H8.359a.977.977,0,0,0-.982.967v4.7a.977.977,0,0,0,.984.969Z" transform="translate(8450.25 -724.75)" fill="currentColor" fill-rule="evenodd" />
                                                    </g>
                                                  </svg>
                                                </i><span>{job}</span><i className="arrow-icon"><FontAwesomeIcon icon={faChevronRight} /></i>
                                              </a>
                                            </li>)) : <li>No affected jobs.</li>}
                                        </ul>
                                      </Tab.Pane>
                                      <Tab.Pane eventKey="ad">
                                        <ul className="pipeline-affected-list">
                                          {affectedDatasets.length > 0 ? affectedDatasets.map((dataset, idx) => (
                                            <li key={idx}>
                                              <a href="#!">
                                                <i>
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                                    <g id="icon_job" transform="translate(-8449 726)">
                                                      <rect id="Rectangle_1919" data-name="Rectangle 1919" width="24" height="24" transform="translate(8449 -726)" fill="none" />
                                                      <path id="icon_tree" d="M8.359,8.383h1.8v1.785H5.564a1.025,1.025,0,0,0-1.032,1.011v1.937H2.789A1.032,1.032,0,0,0,1.75,14.137v4.591A1.031,1.031,0,0,0,2.789,19.75H7.46A1.034,1.034,0,0,0,8.5,18.728V14.137a1.032,1.032,0,0,0-1.041-1.022H5.72V11.336H15.78v1.779H14.038A1.032,1.032,0,0,0,13,14.137v4.591a1.032,1.032,0,0,0,1.041,1.022h4.673a1.032,1.032,0,0,0,1.039-1.022V14.137a1.032,1.032,0,0,0-1.041-1.022H16.973V11.182a1.025,1.025,0,0,0-1.032-1.013H11.347V8.383h1.8a.974.974,0,0,0,.982-.967v-4.7a.977.977,0,0,0-.984-.969H8.359a.977.977,0,0,0-.982.967v4.7a.977.977,0,0,0,.984.969Z" transform="translate(8450.25 -724.75)" fill="currentColor" fill-rule="evenodd" />
                                                    </g>
                                                  </svg>
                                                </i><span>{dataset}</span><i className="arrow-icon"><FontAwesomeIcon icon={faChevronRight} /></i>
                                              </a>
                                            </li>)) : <li>No affected datasets.</li>}
                                        </ul>
                                      </Tab.Pane></Tab.Content></Tab.Container>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>)}
                    </div>
                  </div>

                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </>
    )

  }

  handleTagClipboard_ = (pm, index, text, type) => {
    navigator.clipboard.writeText(index);
    this.setState({ tagTextCopied: text + "_" + pm });
    setTimeout(() => {
      this.setState({ tagTextCopied: "" });
    }, 3000);

  }
  applystagefilter() {
    let filter = [];
    $('input:checkbox[name=stageFilter]:checked').each(function () {
      filter.push($(this).val().toLowerCase());
    });


    let gantt_chart_grid_temp = [];

    // Filter active only when 1 or 2 filters selected
    if (filter.length === 1 || filter.length === 2) {
      const hasSucceeded = filter.includes("succeeded");
      const hasFailed = filter.includes("failed");
      const hasOthers = filter.includes("others");

      gantt_chart_grid_temp = this.state.gantt_chart_grid.filter((data) => {
        const stageText = data.stage_status_text?.toLowerCase() || "";
        if (hasSucceeded && stageText === "succeeded") return true;
        if (hasFailed && stageText === "failed") return true;
        if (hasOthers && stageText !== "succeeded" && stageText !== "failed") return true;
        return false;
      });

    } else {
      // If 0 or more than 2 filters are selected, show all
      gantt_chart_grid_temp = this.state.gantt_chart_grid;
    }


    this.setState({
      gantt_chart_grid_temp: gantt_chart_grid_temp,
      gantt_chart_grid_filter: filter
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedDate !== this.props.selectedDate) {
      let inidate = moment().utc();
      let startDate = moment().utc();
      let endDate = inidate;

      if (this.props.selectedDate) {
        const selectedDate = moment(this.props.selectedDate);
        if (inidate.isSame(selectedDate, 'day')) {
          endDate = moment().utc();
          startDate = moment();
        } else {
          const dateStr = selectedDate.format('YYYY-MM-DD');
          endDate = moment.utc(`${dateStr} 23:59:00`);
          startDate = moment(dateStr, 'YYYY-MM-DD');
        }
      }
      
      this.setState({
        startDate: startDate,
        endDate: endDate,
        enableFadeLoader: true, currentPage: 1, pipelinesource_data: "", showLoader: true, isInFullScreenMode: false, searchText: "", selectedItems: [
          'pipeline-running',
          'pipeline-scheduled',
          'pipeline-progress',
          'pipeline-queued',
          'pipeline-done',
          'pipeline-failed',
          'pipeline-cancelled',
          'pipeline-stage_failure_run_success'
        ],
      }, () => {
        this.initialApi().finally(() => {
          this.setState({ enableFadeLoader: false, showLoader: false });
        });
      });
    }
    // Prevent infinite loop by checking if metaDataList has changed
    else if (prevProps.selectedEnvId !== this.props.selectedEnvId) {
      this.setState({
        enableFadeLoader: true, currentPage: 1, pipelinesource_data: "", showLoader: true, isInFullScreenMode: false, searchText: "", selectedItems: [
          'pipeline-running',
          'pipeline-scheduled',
          'pipeline-progress',
          'pipeline-queued',
          'pipeline-done',
          'pipeline-failed',
          'pipeline-cancelled',
          'pipeline-stage_failure_run_success'
        ],
      }, () => {
        this.initialApi().finally(() => {
          this.setState({ enableFadeLoader: false, showLoader: false });
        });
      });
    }
    if (prevProps.selectedEnvId !== this.props.selectedEnvId) {
      sessionStorage.removeItem("selectedPipelineWatchlist");
      this.setState({ selectedWatchlistName: "All" });
    }
    if (prevState.totalItems !== this.state.totalItems || prevState.currentPage !== this.state.currentPage || prevProps.selectedEnvId !== this.props.selectedEnvId) {
      this.updateMetaData();
    }
    this.adjustHeight()
    this.timeFilterRenderHtml()
  }


  componentDidUpdate_old(prevProps, prevState) {
    // Prevent infinite loop by checking if metaDataList has changed
    if (prevProps.selectedEnvId !== this.props.selectedEnvId) {
      this.setState({ enableFadeLoader: true, currentPage: 1, pipelinesource_data: "", showLoader: true, isInFullScreenMode: false, searchText: "" }, () => {
        this.initialApi().finally(() => {
          this.setState({ enableFadeLoader: false, showLoader: false });
        });
      });
    }
    if (prevProps.selectedEnvId !== this.props.selectedEnvId) {
      sessionStorage.removeItem("selectedPipelineWatchlist");
      this.setState({ selectedWatchlistName: "All" });
    }
    if (prevState.totalItems !== this.state.totalItems || prevState.currentPage !== this.state.currentPage || prevProps.selectedEnvId !== this.props.selectedEnvId) {
      this.updateMetaData();
    }
    this.adjustHeight()
    this.timeFilterRenderHtml()
  }


  timeFilterRenderHtml() {


    let time = this.state.timefilter.replace("hr", "")
    let timelen;
    if (parseInt(time) === 12 || parseInt(time) === 24) {
      timelen = 13;
    }
    else {
      timelen = 7;
    }
    // Keep headers on the same UTC base as getGanttSlotBounds / run_start_time
    let curdate = this.getGanttBaseTime();


    let timeserieshrs = parseInt(time);
    let timeseriesmins = moment.utc(curdate)
      .subtract({ 'hours': parseInt(time) })
      .format('mm');
    // timeseriesmins = 0;

    timeslothrs.length = 0;
    timeslotmin.length = 0;



    $(".tbl-time-range__list").html("")

    for (let loop = 1; loop <= timelen; loop++) {
      if (parseInt(time) === 12 || parseInt(time) === 24 || parseInt(time) === 6) {
        $("#chart_time_" + loop).removeClass("d-none")

        if (parseInt(time) === 12 || parseInt(time) === 6) {
          const slotMoment = moment.utc(curdate).subtract({ 'hours': timeserieshrs });
          $(".tbl-time-range__list").append(`<li><span className='timeslots' id="chart_time_` + loop + `">` + slotMoment.format('hh A') + `</span></li>`);

          timeslothrs.push(slotMoment.clone());

          timeserieshrs = parseInt(timeserieshrs) - 1
        } else if (parseInt(time) === 24) {

          const slotMoment = moment.utc(curdate).subtract({ 'hours': timeserieshrs });
          $(".tbl-time-range__list").append(`<li><span className='timeslots' id="chart_time_` + loop + `">` + slotMoment.format('hh A') + `</span></li>`);

          timeslothrs.push(slotMoment.clone());

          timeserieshrs = parseInt(timeserieshrs) - 2

        }
      } else {

        const slotMoment = moment.utc(curdate).subtract({ 'minutes': timeseriesmins });
        $(".tbl-time-range__list").prepend(`<li><span className='timeslots' id="chart_time_` + loop + `">` + slotMoment.format('hh:mm A') + `</span></li>`)



        timeslothrs.push(slotMoment.clone())


        if (loop === 1) {
          timeseriesmins = parseInt(timeseriesmins) + parseInt(9)
        } else {
          timeseriesmins = parseInt(timeseriesmins) + parseInt(10)
        }

        timeslotmin.push(timeseriesmins)
      }
    }
  }


  showGraph(pmstatus, status) {

  

    let TIME_SLOT = []
    let time = parseInt(this.state.timefilter);
    let timelen;
    if (parseInt(time) === 12 || parseInt(time) === 24) {
      timelen = 13;
    }
    else {
      timelen = 7;
    }

    let curdate = this.state.initialendDate === this.state.endDate ? moment().utc() : moment(this.state.endDate)
    let timeserieshrs = parseInt(time);

    if (parseInt(time) === 1) {
      curdate = moment(curdate)
        .subtract({ 'hours': 2, minutes: 0 })
      curdate = moment(curdate)
        .add({ minutes: 1 })

    }

    let timeseriesmins = moment(curdate)
      .subtract({ 'hours': timeserieshrs })
      .format('mm');
    timeseriesmins = 50;


    for (let loop = 1; loop <= timelen; loop++) {
      if (parseInt(time) === 12 || parseInt(time) === 24 || parseInt(time) === 6) {
        if (parseInt(time) === 12 || parseInt(time) === 6) {
          TIME_SLOT.push(moment(curdate)
            .subtract({ 'hours': timeserieshrs })
            .format('HH'));
          timeserieshrs = parseInt(timeserieshrs) - 1
        } else if (parseInt(time) === 24) {
          TIME_SLOT.push(moment(curdate)
            .subtract({ 'hours': timeserieshrs })
            .format('HH'));
          timeserieshrs = parseInt(timeserieshrs) - 2
        }
      } else {

        TIME_SLOT.push(moment(curdate)
          .add({ 'minutes': timeseriesmins })
          .format('HH:mm'));
        timeseriesmins = parseInt(timeseriesmins) + parseInt(10)
      }
    }

    let runtimehours = [];
    let runtimemins = [];
    let runstatus = [];
    let runduration = [];
    // let rundate        = [];




    if (pmstatus["payload"][this.state.endDate.format("Y-MM-DD")] !== undefined) {

      pmstatus.runsjob = pmstatus["payload"][this.state.endDate.format("Y-MM-DD")];

      for (let loop = 0; loop < pmstatus.runsjob.length; loop++) {
        if (pmstatus.runsjob[loop]["run_started_time"] !== undefined) {
          let timeformat = pmstatus.runsjob[loop]["run_started_time"].split(".")[0].replace("T", " ")
          timeformat = timeformat.split(" ");
          // let datearr = timeformat[0].split("-");
          timeformat = timeformat[1].split(":");
          let hours = timeformat[0]
          let mins = timeformat[1]
          runtimehours.push(hours);
          runtimemins.push(mins);
          // rundate.push(datearr[2])
          runstatus.push(pmstatus.runsjob[loop]["status"]);

          let durationdiff = moment.duration(moment(pmstatus.runsjob[loop]["run_end_time"]).diff(moment(pmstatus.runsjob[loop]["run_started_time"])));
          let durationdiffmin = durationdiff.asMinutes();
          let width = 2;
          let roundduration = parseInt(Math.ceil(durationdiffmin / 60))
          if (roundduration === 1) {
            width = 4
          }
          else if (roundduration > 1 && roundduration <= 3) {
            width = 5
          }
          else {
            width = 6
          }
          runduration.push(width)
        }
      }
    }



    let chartcolor;
    return <div class="tbl-time-range__content">
      <div class="tbl-time-range__cols">
        <div class="tbl-time-range__col">
          <RcTooltip placement="top"
            overlay={
              <span>Previous Run Date: <strong className="font-weight-bold text-nowrap">{pmstatus.previousdate}</strong></span>
            }
            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="24" height="24" rx="4" fill="#F9FBFD" />
              <g clip-path="url(#clip0_923_34)">
                <path d="M8 13H12V11H8V8L4 12L8 16V13ZM15 13C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11C14.45 11 14 11.45 14 12C14 12.55 14.45 13 15 13Z" fill="currentColor" />
                <path d="M18 4H20C20.5523 4 21 4.44772 21 5V19C21 19.5523 20.5523 20 20 20H18V4Z" fill="currentColor" />
              </g>
              <defs>
                <clipPath id="clip0_923_34">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </RcTooltip>
        </div>
        {
          TIME_SLOT.map((person, i) => {
            let show = false;
            let width, marginleft = 0;
            if (time === 12 || time === 6) {

              chartcolor = this.statusColor(runstatus[runtimehours.indexOf(person)])
              show = runtimehours.indexOf(person) > -1 && pmstatus.gant_show_flag === 1
              width = runduration[runtimehours.indexOf(person)]
              marginleft = this.minsPosition(runtimehours.indexOf(person, time, runtimemins));
            }
            if (time === 24) {
              chartcolor = this.statusColor(runstatus[runtimehours.indexOf(person)])
              let tw_hrs = parseInt(person) + 1;
              if (tw_hrs < 10) {
                tw_hrs = String("0" + tw_hrs);
              } else {
                tw_hrs = String(tw_hrs);
              }

              chartcolor = this.statusColor(runstatus[runtimehours.indexOf(person)])
              if (chartcolor === undefined) {
                chartcolor = this.statusColor(runstatus[runtimehours.indexOf(tw_hrs)])
              }
              show = ((runtimehours.indexOf(person) > -1 && pmstatus.gant_show_flag === 1 && i !== 0) || (runtimehours.indexOf(tw_hrs) > -1 && pmstatus.gant_show_flag === 1))
              width = runduration[runtimehours.indexOf(person)] === "" ? runduration[runtimehours.indexOf(tw_hrs)] : runduration[runtimehours.indexOf(person)]
              marginleft = this.minsPosition(runtimehours.indexOf(person, time, runtimemins));
            }

            else if (time === 1) {
              let onehrs_hh = person.split(":")[0]
              let onehrs_mm = person.split(":")[1]
              for (let onehrsloop = 0; onehrsloop < runtimehours.length; onehrsloop++) {
                if (runtimehours[onehrsloop] + ":" + runtimemins <= onehrs_hh + ":" + onehrs_mm && runtimehours[onehrsloop] + ":" + runtimemins >= onehrs_hh + ":" + onehrs_mm) {
                  show = true;
                  width = runduration[runtimehours.indexOf(onehrs_hh)]
                  chartcolor = this.statusColor(runstatus[runtimehours.indexOf(onehrs_hh)])
                  marginleft = this.minsPosition(runtimehours.indexOf(onehrs_hh, time, runtimemins));
                } else {
                  show = false;
                }
              }
            }
            return (<div class="tbl-time-range__col">
              {
                show === true ?
                  <>
                    <OverlayTrigger trigger="click" rootClose placement="right" overlay={
                      <Popover className="pipeline-popover">
                        <Popover.Title as="h3" id="pipeline_popover_title"></Popover.Title>
                        <Popover.Content>
                          <div id="pipeline_popover_content">
                          </div>
                        </Popover.Content>
                      </Popover>
                    }>
                      <span className={pmstatus.status_code !== undefined ? pmstatus.status_code === 2 ? "bg-striped-lines--green" : "" : ""} style={{ width: width + "px", height: "16px", backgroundColor: chartcolor, position: 'absolute', left: marginleft }}>{{ width: width + "px", height: "16px", backgroundColor: chartcolor, position: 'absolute', left: marginleft }}{pmstatus.status_code}</span>
                    </OverlayTrigger>
                  </>
                  : ""

              }
              {i + 1 === TIME_SLOT.length ?
                <RcTooltip placement="top"
                  overlay={
                    <span>Next Run Date: <strong className="font-weight-bold text-nowrap">{pmstatus.nextDate}</strong>
                    </span>
                  }
                  arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="24" height="24" rx="4" transform="matrix(-1 0 0 1 24 0)" fill="#F9FBFD" />
                    <g clip-path="url(#clip0_923_40)">
                      <path d="M16 13H12V11H16V8L20 12L16 16V13ZM9 13C8.45 13 8 12.55 8 12C8 11.45 8.45 11 9 11C9.55 11 10 11.45 10 12C10 12.55 9.55 13 9 13Z" fill="currentColor" />
                      <path d="M6 4H4C3.44772 4 3 4.44772 3 5V19C3 19.5523 3.44772 20 4 20H6V4Z" fill="currentColor" />
                    </g>
                    <defs>
                      <clipPath id="clip0_923_40">
                        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                      </clipPath>
                    </defs>
                  </svg>
                </RcTooltip> : ""}
            </div>)
          })
        }
      </div>
      {

        this.state.endDate.format(PIPELINE_DISPLAY_DATE_FORMAT)
          === this.state.initialendDate.format(PIPELINE_DISPLAY_DATE_FORMAT) ?
          <div class="tbl-time-range__now d-none">
          </div> : ""
      }
    </div>
  }


  minsPosition(index, time, mins) {
    // mins[index]
    if (time === 12 || time === 6) {
      if (mins[index] < 15) {
        return "5px"
      }
      else if (mins[index] > 15 || mins[index] < 30) {
        return "10px"
      }
      else if (mins[index] > 30 || mins[index] < 45) {
        return "15px"
      }
      else {
        return "20px"
      }
    }
    return "10px"
    // return 10;
  }


  // Handle watchlist change
  handleWatchlistChange = (watchlistName, watch_list_id) => {
    // Update the state with the selected watchlist details
    this.setState(
      {
        selectedWatchlistName: watchlistName,
        selectedWatchListId: watch_list_id,
        enableFadeLoader: true,
      },
      async () => {
        sessionStorage.setItem("selectedPipelineWatchlist", JSON.stringify({
          watchListName: watchlistName,
          watchListId: watch_list_id,
        }));

        // After state update, fetch metrics
        if (watch_list_id || watchlistName === "All") {
          try {
            let pipelineResponse = await this.getPipelineResponse(watch_list_id);

            if (!pipelineResponse) {
              this.setState({ errorOccurred: true, enableFadeLoader: false });
              return;
            } else if (pipelineResponse.code === 200) {
              let { integrations } = pipelineResponse.response;

              let integrationNames = integrations.map(integration => integration.label);

              let filteredPaginatedData = watchlistName === "All"
                ? this.state.pipelinesource_data.filter(data => integrationNames.includes(data.p_integration_name))
                : this.state.paginatedData.filter(data => integrationNames.includes(data.p_integration_name));

              this.setState({
                piplineInfo: pipelineResponse.response,
                paginatedData: filteredPaginatedData,
                errorOccurred: false,
                enableFadeLoader: false,
                tempPiplineInfo: pipelineResponse.response,
                pipeline_status_count: pipelineResponse.response.pipeline_status_count,
                searchText: ''

              });
            } else {
              this.setState({ errorOccurred: true, enableFadeLoader: false });
            }
          } catch (error) {
            console.error("Error fetching metrics value response:", error);
            this.setState({ errorOccurred: true, enableFadeLoader: false });
          }
        }
        else {
          this.setState({ errorOccurred: true, enableFadeLoader: false });
        }
      }
    );
  };

  statusColor(status) {
    let color;
    if (status === "Succeeded") {
      color = "#4ED2CC";
    }
    if (status === "Failed") {
      color = "#F64E60";
    }
    if (status === "Cancelled") {
      color = "#F64E60";
    }
    return color;
  }

  /** Map API integration_type → connector_icon_* asset name */
  getConnectorIconSrc(integrationType) {
    const type = (integrationType || "").toLowerCase();
    const map = {
      airflow: "airflow",
      glue: "glue",
      synapse: "azure",
      azure: "azure",
      adf: "data_factory",
      composer: "composer",
      dbt: "dbt",
      mwa_airflow: "amazon_mwaa",
    };
    return `connector_icon_${map[type] || "default"}`;
  }

  /** Collect all runs that start inside a gantt time slot (API runs_list). */
  parseRunStartTime(runStartTime) {
    if (!runStartTime) return null;
    const normalized = String(runStartTime).trim().replace(" ", "T").replace(/Z$/i, "");
    const parsed = moment.utc(normalized);
    return parsed.isValid() ? parsed : null;
  }

  getRunIdentity(run) {
    if (!run) return null;
    if (run.source_run_id != null && run.source_run_id !== "") {
      return `src:${run.source_run_id}`;
    }
    if (run.p_run_id != null && run.p_run_id !== "") {
      return `id:${run.p_run_id}`;
    }
    return null;
  }

  /**
   * Align with job_runs_summary:
   * run_success_count = Succeeded only
   * run_failed_count  = Failed / Cancelled / stage_failure_run_success
   * run_running_count = Running (not counted as success)
   */
  getRunStatusCategory(status) {
    if (status === "Failed" || status === "Cancelled" || status === "stage_failure_run_success") {
      return "failed";
    }
    if (status === "Succeeded") {
      return "success";
    }
    if (status === "Running" || status === "In progress" || status === "InProgress") {
      return "running";
    }
    return "other";
  }

  getRunStatusRank(status) {
    const category = this.getRunStatusCategory(status);
    if (category === "failed" || category === "success") return 3;
    if (category === "other") return 2;
    if (category === "running") return 1;
    return 0;
  }

  /**
   * Deduplicate runs_list the way API summaries do:
   * same source_run_id / p_run_id can appear as Running then Failed.
   * Prefer the terminal status so slot totals match run_success_count / run_failed_count.
   */
  normalizeRunsList(runsList) {
    if (!Array.isArray(runsList) || runsList.length === 0) {
      return [];
    }
    const byKey = new Map();
    const unkeyed = [];

    runsList.forEach((run, index) => {
      const key = this.getRunIdentity(run);
      if (key == null) {
        unkeyed.push(run);
        return;
      }
      const existing = byKey.get(key);
      if (!existing) {
        byKey.set(key, run);
        return;
      }
      const existingRank = this.getRunStatusRank(existing.run_status_text);
      const nextRank = this.getRunStatusRank(run.run_status_text);
      // Prefer terminal status; if equal, keep later list entry (fresher snapshot)
      if (nextRank >= existingRank) {
        byKey.set(key, run);
      }
    });

    return [...byKey.values(), ...unkeyed];
  }

  getAttemptCountsFromPipeline(pipelineJob) {
    const summary = pipelineJob?.job_runs_summary;
    // Runs Count is day-level from API — do not change with 1hr/6hr/12hr/24hr filter
    if (summary && (summary.run_success_count != null || summary.run_failed_count != null)) {
      return {
        success: summary.run_success_count ?? 0,
        failed: summary.run_failed_count ?? 0,
      };
    }
    const normalized = this.normalizeRunsList(pipelineJob?.runs_list);
    if (!normalized.length) {
      return { success: "-", failed: "-" };
    }
    let success = 0;
    let failed = 0;
    normalized.forEach((run) => {
      const category = this.getRunStatusCategory(run.run_status_text);
      if (category === "success") success += 1;
      if (category === "failed") failed += 1;
    });
    return { success, failed };
  }

  getRunsInTimeSlot(runsList, slotStart, slotEnd) {
    if (!Array.isArray(runsList) || !slotStart || !slotEnd) {
      return [];
    }
    const start = moment.utc(slotStart);
    const end = moment.utc(slotEnd);
    if (!start.isValid() || !end.isValid()) {
      return [];
    }
    return runsList.filter((run) => {
      const runStart = this.parseRunStartTime(run?.run_start_time);
      if (!runStart) return false;
      return (runStart.isSame(start) || runStart.isAfter(start)) && runStart.isBefore(end);
    });
  }

  /** Same base instant used by timeline headers (UTC). */
  getGanttBaseTime() {
    const endDate = this.state.endDate;
    if (!endDate) {
      return moment.utc();
    }
    return moment.utc(endDate);
  }

  /**
   * Slot bounds mirror timeFilterRenderHtml column headers exactly (UTC),
   * so badge hour/min placement and Runs Count stay aligned.
   */
  getGanttSlotBounds(index, slotCount) {
    const rawFilter = String(this.state.timefilter || "").replace("hr", "");
    const timeFilterHours = parseInt(rawFilter, 10) || 12;
    const baseTime = this.getGanttBaseTime();

    if (timeFilterHours === 24) {
      // Headers: base-24, base-22, ... base-0 (2-hour steps)
      const hoursFromEnd = (slotCount - 1 - index) * 2;
      const slotStart = baseTime.clone().subtract(hoursFromEnd, "hours");
      return { slotStart, slotEnd: slotStart.clone().add(2, "hours") };
    }

    if (timeFilterHours === 12 || timeFilterHours === 6) {
      // Headers: base-N, base-(N-1), ... base-0 (1-hour steps)
      const hoursFromEnd = timeFilterHours - index;
      const slotStart = baseTime.clone().subtract(Math.max(hoursFromEnd, 0), "hours");
      return { slotStart, slotEnd: slotStart.clone().add(1, "hours") };
    }

    // 1hr view: 7 columns, ~10 minute steps (first step 9 then 10), oldest → newest left→right
    // Header DOM is prepended; column index 0 is the oldest label.
    let minutesFromEnd = parseInt(baseTime.clone().subtract(1, "hours").format("mm"), 10);
    if (Number.isNaN(minutesFromEnd)) {
      minutesFromEnd = 0;
    }
    const offsets = [];
    for (let loop = 0; loop < slotCount; loop++) {
      offsets.push(minutesFromEnd);
      minutesFromEnd += loop === 0 ? 9 : 10;
    }
    // offsets[0] is nearest to "now"-1h window start used by header push order;
    // visual left (index 0) is the largest offset (oldest).
    const startOffset = offsets[slotCount - 1 - index];
    const endOffset = index < slotCount - 1 ? offsets[slotCount - 2 - index] : Math.max(startOffset - 10, 0);
    const slotStart = baseTime.clone().subtract(startOffset, "minutes");
    const slotEnd = index < slotCount - 1
      ? baseTime.clone().subtract(endOffset, "minutes")
      : baseTime.clone();
    return { slotStart, slotEnd };
  }

  /**
   * Split slot runs into success / failed groups for timeline badges.
   * Only terminal outcomes (green/red) are shown; running is omitted.
   */
  getRunStatusGroups(runsInSlot) {
    const successRuns = [];
    const failedRuns = [];
    this.normalizeRunsList(runsInSlot).forEach((run) => {
      const category = this.getRunStatusCategory(run?.run_status_text);
      if (category === "success") successRuns.push(run);
      else if (category === "failed") failedRuns.push(run);
    });
    const groups = [];
    if (successRuns.length) {
      groups.push({ runs: successRuns, status: "success" });
    }
    if (failedRuns.length) {
      groups.push({ runs: failedRuns, status: "failed" });
    }
    return groups;
  }

  isFailedRunStatus(status) {
    return this.getRunStatusCategory(status) === "failed";
  }
  DropdownOpen(event) {
    $('.metric-list-dropdown').toggleClass("open");
    $('.rt-dropdown_backdrop').addClass("show");
  }
  getEditWatchlistResponse() {
    let requestParams = {

      "tab_type": this.state.seletedTabId,
      "tenant_id": this.state.teamId,
      "user_id": this.state.userId,
      "env_id": this.props.selectedEnvId,
      "watch_list_id": this.state.selectedWatchListId

    }
    return getEditWatchList(requestParams)
  }
  // Trigger validation when user clicks "Save" without entering a name
  handleSaveClick = () => {
    if (!this.state.watchListName) {
      this.setState({ watchListNameError: "Watchlist name is required." });
    } else {
      this.saveWatchListResponse(this.state.metaDataResponse);
    }
  };
  handleWishListShow = async (isEditing = false, selectedWatchlistName) => {
    try {

      const checkedStates = {};
      if (isEditing) {
        let EditWatchlistResponse = await this.getEditWatchlistResponse();
        const watchlistData = EditWatchlistResponse.data[0].watch_list_data;

        // Handle integrations (Datasources)
        watchlistData.integrations.forEach(integration => {
          checkedStates[`Datasource-${integration.value}`] = {
            checked: integration.is_checked,
            type: "Datasource"
          };
        });

        // Handle pipelines
        Object.keys(watchlistData.pipelines).forEach(integrationId => {
          watchlistData.pipelines[integrationId].forEach(pipeline => {
            checkedStates[`Pipeline-${pipeline.value}`] = {
              checked: pipeline.status_code,
              type: "Pipeline"
            };
          });
        });
      }

      // Set the state with the retrieved values to open the edit modal
      this.setState({
        watchListOpen: true,
        editWatchlist: isEditing,
        watchListName: isEditing ? selectedWatchlistName : "",
        checkedStates: checkedStates, // Store the checked states for attributes, datasets, and integrations
      });
    } catch (error) {
      console.error("Error loading watchlist for edit:", error);
    }
  };

  handleDeleteWatchlist = async (selectedWatchlistName) => {
    let { confirmDeleteName } = this.state;

    // Ensure correct watchlist name is selected for deletion
    this.setState({ selectedWatchlistName });

    if (confirmDeleteName.trim() !== selectedWatchlistName.trim()) {
      this.setState({ errors: "Name does not match." });
      return;
    }

    try {
      // Delete watchlist
      const deleteWatchListResponse = await this.deleteWatchListResponse();

      if (deleteWatchListResponse?.code !== 200) {
        throw new Error("Failed to delete watchlist.");
      }

      this.showToast("success", deleteWatchListResponse.message);
      sessionStorage.removeItem("selectedPipelineWatchlist");

      // Get updated watchlist
      const watchListResponse = await this.getWatchListResponse();

      if (watchListResponse?.code === 200) {
        const updatedWatchlist = watchListResponse.result?.watch_list || [];
        const watchListMapping = await this.extractMultipleWatchlistIds(watchListResponse);

        // Default selection logic
        const newSelectedWatchList = updatedWatchlist[0] || { watch_list_name: "All", watch_list_id: null };

        // Save to session
        sessionStorage.setItem("pipelineWatchListInformation", JSON.stringify({
          watchListName: newSelectedWatchList.watch_list_name,
          watchListId: newSelectedWatchList.watch_list_id
        }));

        sessionStorage.setItem("selectedPipelineWatchlist", JSON.stringify({
          watchListName: newSelectedWatchList.watch_list_name,
          watchListId: newSelectedWatchList.watch_list_id
        }));

        this.setState({
          watchListMapping,
          watchListInformation: updatedWatchlist,
          selectedWatchlistName: newSelectedWatchList.watch_list_name,
          selectedWatchListId: newSelectedWatchList.watch_list_id
        }, async () => {
          const pipelineResponse = await this.getPipelineResponse(this.state.selectedWatchListId);

          if (!pipelineResponse || pipelineResponse.code !== 200) {
            this.setState({ errorOccurred: true, enableFadeLoader: false });
            return;
          }

          this.setState({
            piplineInfo: pipelineResponse.response,
            tempPiplineInfo: pipelineResponse.response,
            showLoader: false,
            pipeline_status_count: pipelineResponse.response.pipeline_status_count,
            paginatedData: this.state.pipelinesource_data
          });
        });

      } else if (watchListResponse?.code === 401) {

        sessionStorage.removeItem("selectedPipelineWatchlist");

        this.setState({
          selectedWatchlistName: "All",
          watchListInformation: ""
        }, async () => {
          const pipelineResponse = await this.getPipelineResponse(null);

          if (!pipelineResponse || pipelineResponse.code !== 200) {
            this.setState({ errorOccurred: true, enableFadeLoader: false });
            return;
          }

          this.setState({
            piplineInfo: pipelineResponse.response,
            tempPiplineInfo: pipelineResponse.response,
            showLoader: false,
            pipeline_status_count: pipelineResponse.response.pipeline_status_count,
            paginatedData: this.state.pipelinesource_data
          });
        });

      } else {
        throw new Error(watchListResponse?.message || "Failed to fetch updated watchlist.");
      }

    } catch (error) {
      console.error("Error during delete or fetching watchlist:", error);
      this.showToast("error", error.message || "An error occurred while deleting the watchlist.");

      this.setState({
        watchListInformation: [],
        selectedWatchlistName: "All",
      });

      sessionStorage.removeItem("pipelineWatchListInformation");
      sessionStorage.setItem("selectedPipelineWatchlist", JSON.stringify({ watchListName: "All", watchListId: null }));
    } finally {
      // Cleanup state after delete operation
      this.setState({
        showDeletePopup: false,
        confirmDeleteName: "",
        errors: null,
      });
    }
  };

  // save watchist
  handleWishListClose = () => {
    this.setState({
      watchListOpen: !this.state.watchListOpen,
    })
  }
  handleDeleteModalOpen() {
    this.setState({ showDeletePopup: true });
  }
  // Close the delete modal
  handleCloseDeletePopup() {
    this.setState({ showDeletePopup: false, confirmDeleteName: "" });
  }

  //watchlist name change
  handleWatchlistNameChange = (event) => {
    let watchListName = event.target.value.trim();
    let onlySpecialChars = /^[^a-zA-Z0-9]+$/;

    let watchListNameError = "";
    if (!watchListName) {
      watchListNameError = "Watchlist name is required.";
    } else if (onlySpecialChars.test(watchListName)) {
      watchListNameError = "Watchlist name cannot contain only special characters.";
    } else if (watchListName.length > 25) {
      watchListNameError = "Watchlist name cannot exceed 25 characters.";
    }

    this.setState({ watchListName, watchListNameError });
  };

  //watchlist search
  handleWatchlistSearch = (e) => {
    const searchText = e.target.value;

    this.setState({ saveWatchListSearchText: searchText });
  }


  toggleForPipeline = (pipelineId) => {
    this.setState((prevState) => ({
      expandedPipelineRows: {
        ...prevState.expandedPipelineRows,
        [pipelineId]: !prevState.expandedPipelineRows[pipelineId],
      },
    }));
  };

  handleToggle = (pipelineId) => {
    this.setState((prevState) => ({
      toggledPipelineSource: {
        ...prevState.toggledPipelineSource,
        [pipelineId]: !prevState.toggledPipelineSource[pipelineId]
      },
    }));

  };

  adjustHeight() {

    let nowcheck = this.state.initialendDate === this.state.endDate &&
      Object.keys(this.state.piplineInfo?.pipelines || {}).length > 0


    setTimeout(() => {
      const tableHeight = $('.rt-pipeline-tbl').height();
      const metaHeight = $('#metaDataBody').height();

      const remainingHeight = tableHeight - metaHeight;

      const $content = $('.emptyrow .tbl-time-range__content');
      // const $now = $('.tbl-time-range__now');

      if (remainingHeight > 0) {
        $content.height(remainingHeight);

        if (nowcheck) {
          // $now.height(remainingHeight);
        }


        $('.rt-pipeline-tbl').css({
          'overflow-y': 'hidden',
          'overflow-x': 'auto'
        });
      } else {
        $content.height(0);

        $('.rt-pipeline-tbl').css({
          'overflow-y': 'auto',
          'overflow-x': 'auto'
        });
      }
    }, 200);
  }


  handleCloseAutoCompleteModal(data) {
    this.setState({ autocompletemodal: false })

    if (data === undefined || data === null) {
      return null
    }

    if (data.type === "Dataset") {
      this.setState({
        preSelectedDataset: { "value": data.id, "label": data.name },
        preSelectedDatasource: { "value": data.datasourceId, "label": data.datasourceName },
      })
    }
    else if (data.type === "Datasource") {
      this.setState({
        preSelectedDataset: null,
        preSelectedDatasource: { "value": data.id, "label": data.name },
      })
    }
  }

  handleOpenAutoCompleteModal() {
    this.setState({ autocompletemodal: true })
  }

  renderSearchData(data = null) {
    // let searchText = data
    // this.handleWatchlistChange("All",null)
    if (data.type === "Dataset") {
      this.getPipelineResponse(this.state.selectedWatchListId, this.state.isCheackedActiveRuns, "", { dataset_name: data.datasetName, datasource_name: data.datasourceName, datasourceId: data.datasourceId })
      this.setState({
        preSelectedDataset: { "value": data.id, "label": data.name },
        preSelectedDatasource: { "value": data.datasourceId, "label": data.datasourceName },
      })
    }
    else {
      this.setState({
        preSelectedDataset: null,
        preSelectedDatasource: { "value": data.id, "label": data.name },
      })
    }

  }
  pipelineFilterSelection = async (event) => {
    const { id, checked } = event.target;

    this.setState(prevState => {
      let selectedItems = Array.isArray(prevState.selectedItems) ? prevState.selectedItems : [];

      return {
        selectedItems: checked
          ? [...new Set([...selectedItems, id])]
          : selectedItems.filter(item => item !== id)
      };
    });
  };
  fetchFilteredPipelines = async () => {
    this.setState({ enableFadeLoader: true });

    if (this.state.selectedItems.length > 0) {
      try {
        const pipelineResponse = await this.getPipelineResponse(
          this.state.selectedWatchListId,
          this.state.isCheackedActiveRuns,
          this.state.selectedItems,
          this.state.searchText,
          null
        );

        if (pipelineResponse.code === 200) {
          this.setState({
            piplineInfo: pipelineResponse.response,
            enableFadeLoader: false,
            pipeline_status_count: this.state.tempPiplineInfo.pipeline_status_count
          });

          this.updateMetaData();

          setTimeout(() => {
            this.timeFilterRenderHtml();
          }, 1000);
        } else {
          this.setState({ enableFadeLoader: false });
          console.error("Error fetching pipeline data", pipelineResponse);
        }
      } catch (error) {
        this.setState({ enableFadeLoader: false });
        console.error("API Error:", error);
      }
    } else {
      this.setState({
        piplineInfo: this.state.tempPiplineInfo,
        enableFadeLoader: false,
        pipeline_status_count: this.state.tempPiplineInfo.pipeline_status_count
      });
    }
  };
  handleSelectAll = async () => {
    const filterStatus = {
      'pipeline-done': 'Succeeded',
      'pipeline-failed': 'Failed',
      'pipeline-running': 'Running',
      'pipeline-progress': 'InProgress',
      'pipeline-queued': 'Queued',
      'pipeline-scheduled': 'Scheduled',
      'pipeline-cancelled': 'Cancelled',
      'pipeline-stage_failure_run_success': 'stage_failure_run_success'
    };

    const filteredItems = [
      'pipeline-running',
      'pipeline-scheduled',
      'pipeline-progress',
      'pipeline-queued',
      'pipeline-done',
      'pipeline-failed',
      'pipeline-cancelled',
      'pipeline-stage_failure_run_success'
    ];

    const finalOptions = filteredItems.filter(item => {
      const key = filterStatus[item];
      return this.state.pipeline_status_count?.[key] > 0;
    });


    this.setState({
      selectedItems: finalOptions,
    });
  };

  handleClearAll = async () => {
    this.setState({ enableFadeLoader: true });
    await this.setState({ selectedItems: [] });
    this.setState({ enableFadeLoader: false, pipeline_status_count: this.state.tempPiplineInfo.pipeline_status_count });
  };


  handlePipelineTimeFilter = async (event, picker) => {
    const selectedDate = picker.startDate; // Moment object
    let endDate;
    let startDateForPicker = selectedDate;

    if (this.state.initialendDate.isSame(selectedDate, 'day')) {
      endDate = moment().utc();
      startDateForPicker = moment();
    } else {
      const dateStr = selectedDate.format('YYYY-MM-DD');
      endDate = moment.utc(`${dateStr} 23:59:00`);
      startDateForPicker = moment(dateStr, 'YYYY-MM-DD');
    }

    this.setState({
      startDate: startDateForPicker,
      endDate: endDate,
      enableFadeLoader: true
    }, () => {
      this.getDatewisePipline();
    });
  };


  getDatewisePipline = async () => {

    if (this.state.isInFullScreenMode) {
      this.setFullScreen(this.state.p_integration_id, this.state.selectedJobId, this.state.selectedMorePipelineType, this.state.selectedMorePipelineName, this.state.selectedMoreJobName);
      return;
    }
    try {
      const pipelineResponse = await this.getPipelineResponse(
        this.state.selectedWatchListId,
        this.state.isCheackedActiveRuns,
        "",
        this.state.searchText,
        this.state.endDate.format("YYYY-MM-DD")
      );
      if (pipelineResponse.code === 200) {
        if (this.state.isCheackedActiveRuns) {
          const { count_details = {} } = pipelineResponse.response;
          const { total_integrations = 0, total_pipelines = 0, active_pipelines = 0 } = count_details;

          const enhancedData = Array.isArray(this.state.paginatedData)
            ? this.state.paginatedData.map(item => {
              const matchingIntegration = pipelineResponse.response.integrations.find(integration =>
                integration.value === item.p_integration_id
              );

              return {
                ...item,
                label: item.p_integration_name || item.integration_type || "Unknown",
                count_details: matchingIntegration ? matchingIntegration.count_details : {
                  active_pipelines: active_pipelines,
                  total_pipelines: total_pipelines || 0,
                },
                value: item.p_integration_id,
              };
            })
            : [];

          const updatedPipelineInfo = {
            ...pipelineResponse.response,
            integrations: enhancedData,
            count_details: {
              ...count_details,
              total_integrations,
              total_pipelines,
            }
          };

          this.setState({
            piplineInfo: updatedPipelineInfo,
            enableFadeLoader: false,
            pipeline_status_count: pipelineResponse.response.pipeline_status_count,
          });
        } else {
          this.setState({
            piplineInfo: pipelineResponse.response,
            enableFadeLoader: false, // Hide loader after successful fetch
            pipeline_status_count: pipelineResponse.response.pipeline_status_count

          });
        }
      }

      // Handle the response as needed
    } catch (error) {
      console.error("Error fetching pipeline response:", error);
    }
    finally {
      this.setState({ enableFadeLoader: false });
    }

  }


  handleClearSearch = async () => {
    this.setState({
      searchText: "",
      enableFadeLoader: true,
      fetchingJobsloader: true,
      highlightText: false
    });

    this.lastSearchTerm = "";

    try {
      const pipelineResponse = await this.getPipelineResponse(
        this.state.selectedWatchListId,
        this.state.isCheackedActiveRuns,
        "",
        null,
        this.state.endDate.format("YYYY-MM-DD")
      );

      if (pipelineResponse.code === 200) {
        const pipelines = pipelineResponse.response.pipelines || {};
        let pipelineMatchCount = 0;
        Object.keys(pipelines).forEach(key => {
          pipelineMatchCount += pipelines[key].length;
        });

        const integrationMatchCount = (pipelineResponse.response.integrations || []).length;

        this.setState({
          piplineInfo: pipelineResponse.response,
          searchIntegrationData: pipelineResponse.response.integrations,
          totalMatchedPipelines: pipelineMatchCount,
          totalMatchedIntegrations: integrationMatchCount,
          fetchingJobsloader: false,
          enableFadeLoader: false,
          pipeline_status_count: pipelineResponse.response.pipeline_status_count
        });
      } else {
        this.setState({ fetchingJobsloader: false, enableFadeLoader: false });
        console.error("Pipeline API error:", pipelineResponse.message);
      }
    } catch (error) {
      this.setState({ fetchingJobsloader: false, enableFadeLoader: false });
      console.error("Pipeline API call failed:", error);
    }
  };

  highlightText(text, searchText) {
    if (!searchText) return text;

    const escapedSearchText = searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    const parts = text.split(new RegExp(`(${escapedSearchText})`, 'gi'));

    return parts.map((part, index) =>
      part.toLowerCase() === searchText.toLowerCase() ? (
        <span key={index} className='search-text-highlight'>{part}</span>
      ) : (
        part
      )
    );
  }

  extractMultipleWatchlistIds(data) {
    if (
      typeof data !== 'object' ||
      data === null ||
      !data.result ||
      !Array.isArray(data.result.watch_list)
    ) {
      return {};
    }

    const allWatchlistIds = {};

    data.result.watch_list.forEach(watchlistItem => {
      const watchlistId = watchlistItem.watch_list_id;
      const watchlistName = watchlistItem.watch_list_name;
      if (typeof watchlistId !== 'undefined') {
        const watchlistData = watchlistItem.watch_list_data || {};
        const integrations = watchlistData.integrations || [];
        const pipelines = watchlistData.pipelines || {};

        const metaData_ids = [];

        // Extract metadata IDs from integrations
        if (Array.isArray(integrations)) {
          integrations.forEach(integration => {
            if (integration && typeof integration.value !== 'undefined') {
              metaData_ids.push(integration.value);
            }
          });
        }

        // Extract metadata IDs from pipelines
        for (const pipelineGroup of Object.values(pipelines)) {
          if (Array.isArray(pipelineGroup)) {
            pipelineGroup.forEach(pipeline => {
              if (pipeline && typeof pipeline.value !== 'undefined') {
                metaData_ids.push(pipeline.value);
              }
            });
          }
        }

        allWatchlistIds[watchlistId] = {
          watchlist_id: watchlistId,
          watchlist_name: watchlistName,
          metadata_ids: [...new Set(metaData_ids)].sort((a, b) => a - b),
        };
      }
    });

    return allWatchlistIds;
  }
  loadMorePipelines = (integration_id) => {
    let { visiblePipelineCount, loadMoreClickCount, expandedIntegrationId } = this.state;
    let total = this.state.piplineInfo?.pipelines?.[integration_id]?.length || 0;

    // If clicking a new integration, reset count
    if (expandedIntegrationId !== integration_id) {
      this.setState({
        visiblePipelineCount: Math.min(visiblePipelineCount + 20, total),
        loadMoreClickCount: 1,
        expandedIntegrationId: integration_id,
      });
      return;
    }

    // Same integration: increment logic
    if (loadMoreClickCount >= 2) {
      this.setState({
        visiblePipelineCount: total,
        loadMoreClickCount: loadMoreClickCount + 1,
      });
    } else {
      let nextCount = Math.min(visiblePipelineCount + 20, total);
      this.setState({
        visiblePipelineCount: nextCount,
        loadMoreClickCount: loadMoreClickCount + 1,
      });
    }
  };


  handleCloseIncidentToast = () => {
    this.setState({ showIncidentToast: !this.state.showIncidentToast })
  }
  getGanttPopover(contentOrRuns, pipelineType, filteredPipeline) {

    let pipeline_popover_content = document.getElementById("pipeline_popover_content")
    let pipeline_popover_title = document.getElementById("pipeline_popover_title")
    let tooltip = true
    const runs = Array.isArray(contentOrRuns)
      ? contentOrRuns
      : (contentOrRuns ? [contentOrRuns] : []);

    if (pipeline_popover_content) {
      ReactDOM.render(
        <div className="job-details-list">
          {runs.map((content, idx) => {
            const statusCategory = this.getRunStatusCategory(content["run_status_text"]);
            const runId = content["source_run_id"] || content["p_run_id"] || `run-${idx}`;
            const statusLabel = content["run_status_text"] === "Succeeded" ? "Success" : content["run_status_text"];
            const statusBadge =
              statusCategory === "failed" ? (
                <span className="badge badge-light-danger mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59" /></svg>
                  {statusLabel}
                </span>
              ) : statusCategory === "running" ? (
                <span className="badge badge-light-primary mr-2">
                  {statusLabel}
                </span>
              ) : (
                <span className="badge badge-light-success mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>
                  {statusLabel}
                </span>
              );
            return (
              <div className="job-details" key={runId}>
                <p>
                  <span>
                    <label>Run ID:</label>
                    <span
                      title={runId}
                      style={{
                        color: "#5867dd",
                        textDecoration: "none",
                        backgroundColor: "transparent",
                        cursor: "pointer",
                      }}
                      onClick={() => this.setFullScreen(pipelineType.p_integration_id, filteredPipeline.value, pipelineType.integration_type, pipelineType.label, filteredPipeline.label)}
                    >
                      {runId}
                    </span>
                  </span>
                  <span className="job-details__action">
                    {statusBadge}
                    <span className="job-runtime">
                      <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><g><g><path d="M15,1H9v2h6V1z M11,14h2V8h-2V14z M19.03,7.39l1.42-1.42c-0.43-0.51-0.9-0.99-1.41-1.41l-1.42,1.42 C16.07,4.74,14.12,4,12,4c-4.97,0-9,4.03-9,9s4.02,9,9,9s9-4.03,9-9C21,10.88,20.26,8.93,19.03,7.39z M12,20c-3.87,0-7-3.13-7-7 s3.13-7,7-7s7,3.13,7,7S15.87,20,12,20z" /></g></g></g></svg>
                      {this.millisecondToMinutesAndSeconds(content["duration"])}
                    </span>
                  </span>
                </p>
                <p><span><label>Started:</label>{content["run_start_time"]}</span></p>
                <p><span><label>End:</label>{content["run_end_time"]}</span></p>
                <p>
                  <span>
                    <label>Troubleshooting and Diagnosis:</label>
                    <span
                      style={{
                        color: "#5867dd",
                        textDecoration: "none",
                        backgroundColor: "transparent",
                        cursor: "pointer",
                      }}
                      onClick={() => this.setFullScreen(pipelineType.p_integration_id, filteredPipeline.value, pipelineType.integration_type, pipelineType.label, filteredPipeline.label, tooltip, content)}
                    >
                      Check here
                    </span>
                  </span>
                </p>
              </div>
            );
          })}
        </div>,
        document.getElementById("pipeline_popover_content"))
    }

    if (pipeline_popover_title) {

      ReactDOM.render(
        filteredPipeline.label, document.getElementById("pipeline_popover_title"))
    }
  }
  getSelectedStatusJobCount = () => {
    const { pipeline_status_count, selectedItems } = this.state;
    if (!pipeline_status_count || !selectedItems) return 0;

    const statusKeyMap = {
      'pipeline-failed': 'Failed',
      'pipeline-done': 'Succeeded',
      'pipeline-cancelled': 'Cancelled',
      'pipeline-running': 'Running',
      'pipeline-progress': 'In progress',
      'pipeline-scheduled': 'Scheduled',
      'pipeline-stage_failure_run_success': 'stage_failure_run_success'
    };

    let count = 0;
    for (let statusId of selectedItems) {
      const key = statusKeyMap[statusId];
      if (key && pipeline_status_count[key]) {
        count += pipeline_status_count[key];
      }
    }
    return count;
  };

  filterIntegrationAndPipelines = () => {
    const { inputData, piplineInfo } = this.state;
    if (!inputData || !piplineInfo) return null;

    const validIntegrationIds = (piplineInfo.integrations || []).map(
      (info) => info.value
    );

    const filteredIntegrations = (inputData.integrations || []).filter((integration) =>
      validIntegrationIds.includes(integration.value)
    );

    const filteredPipelines = (inputData.pipelines || []).filter((pipeline) =>
      validIntegrationIds.includes(pipeline.p_integration_id)
    );

    const mergedIntegrations = filteredIntegrations.map((integration) => {
      const matched = (piplineInfo.integrations || []).find(
        (info) => info.value === integration.value
      );
      return {
        ...integration,
        count_details: matched?.count_details || {},
      };
    });

    return {
      integrations: mergedIntegrations,
      pipelines: filteredPipelines,
    };
  };

  render() {
    // let advanced_filter_data = this.filterIntegrationAndPipelines();
    let { selectedWatchlistName, watchListInformation, watchListName, paginatedData, pipelinesource_data, piplineInfo, tempPiplineInfo } = _.cloneDeep(this.state);
    // let totalWatchlistJobs = ""
    // if(Object.keys(watchListInformation).length > 0 ){
    //   totalWatchlistJobs = watchListInformation.reduce((acc, item) => acc + item.job_count, 0);
    // }
    let Integrations = Array.isArray(this.state.piplineInfo?.integrations)
      ? this.state.piplineInfo.integrations.map((integration) => {
        let matchedPipeline = Array.isArray(this.state.tempPaginatedData)
          ? this.state.tempPaginatedData.find(
            (pipeline) => pipeline.p_integration_name === integration.label || pipeline.p_integration_id === integration.value
          )
          : null;

        return {
          ...integration,
          integration_type: matchedPipeline?.integration_type,
          p_integration_id: matchedPipeline?.p_integration_id
        };
      })
      : [];

    if (this.state.searchData !== null && paginatedData !== undefined && paginatedData.length > 0) {
      paginatedData = paginatedData.filter((data) => data.p_integration_id === this.state.searchData.datasourceId)
      if (this.state.searchData.type !== "Datasource")
        piplineInfo['pipelines'][this.state.searchData['datasourceId']] = piplineInfo['pipelines'][this.state.searchData['datasourceId']].filter((data) => data.value === this.state.searchData['datasetId'])
    }
    const storedWatchlist = JSON.parse(sessionStorage.getItem("selectedPipelineWatchlist")) || {};
    const selectedPipelineWatchlistName = storedWatchlist.watchListName || "";

    // Condition to display the name
    const displayWatchlistName =
      selectedWatchlistName === selectedPipelineWatchlistName
        ? selectedPipelineWatchlistName
        : selectedWatchlistName;
    let tableData = null
    let headers = ["Run ID", "Timing", "Job", "Status"];
    let final_op = [];
    tableData = { "headers": headers, "data": final_op };

    if (this.state.selectedJobRunsFullscreen !== undefined) {
      let resulttableData = this.formPipelineRunsTableData(this.state.selectedJobRunsFullscreen)
      tableData = resulttableData
    }
    let checkedStates = this.state.checkedStates;

    let isDataSourceSelected = Object.keys(checkedStates).some(
      key => checkedStates[key]?.type === "Pipeline" && checkedStates[key].checked
    );
    let isWatchListNameValid = watchListName && watchListName.trim() && watchListName.toLowerCase() !== "all";
    let isSaveDisabled = !isDataSourceSelected || !isWatchListNameValid;

    let preSelectedDataset = this.state.preSelectedDataset
    let preSelectedDatasource = this.state.preSelectedDatasource
    if (preSelectedDataset === null && preSelectedDatasource === null) {
      if (tempPiplineInfo?.integrations && tempPiplineInfo?.pipelines) {

        let matchedIntegration = null;
        let matchedPipeline = null;

        //  Find datasource that contains the selected job
        if (this.state.selectedJobId) {
          tempPiplineInfo.integrations.some((integration) => {
            const pipelines = tempPiplineInfo.pipelines[integration.value];

            if (pipelines?.length) {
              const pipeline = pipelines.find(
                p => p.value === this.state.selectedJobId
              );

              if (pipeline) {
                matchedIntegration = integration;
                matchedPipeline = pipeline;
                return true; // stop loop
              }
            }
            return false;
          });
        }

        //  Set datasource & dataset from job match
        if (matchedIntegration && matchedPipeline) {
          preSelectedDatasource = {
            value: matchedIntegration.value,
            label: matchedIntegration.label
          };

          preSelectedDataset = {
            value: matchedPipeline.value,
            label: matchedPipeline.label
          };
        }
        //  Fallback (no job selected / job not found)
        else {
          const firstIntegration = tempPiplineInfo.integrations[0];
          const pipelines = tempPiplineInfo.pipelines[firstIntegration.value];

          if (firstIntegration && pipelines?.length) {
            preSelectedDatasource = {
              value: firstIntegration.value,
              label: firstIntegration.label
            };

            preSelectedDataset = {
              value: pipelines[0].value,
              label: pipelines[0].label
            };
          }
        }
      }
    }

    const hasPipelineTableData = Object.values(piplineInfo?.pipelines || {}).some(
      pipelines => Array.isArray(pipelines) && pipelines.length > 0
    );
    const shouldShowBlockingProgress = this.state.inProgress === true && !hasPipelineTableData;



    return (
      <>

        {
          this.state.showLoader === true && pipelinesource_data === ""
            ?
            <div className='portlet w-100 h-100 d-flex align-items-center justify-content-center'>
              <div className='portlet-body'>
                <Load />
              </div>
            </div>
            : shouldShowBlockingProgress
              ? (
                <ProgressStatus
                  addOnClass="portlet w-100 h-100 d-flex align-items-center justify-content-center"
                  progressStatus={this.state.progressStatus}
                />
              )
              : this.state.noPipeline && Object.keys(this.state.piplineInfo?.pipelines || {}).length === 0 ?
                <NoModelComponent
                  noContentSubtext={"No pipeline found for this selected environment"}
                  customButtonName={"Configure Pipeline"}
                  navigatePage={"/pipeline"}
                  realtime={true}
                  noDataFound={this.state.noPipeline}
                  selectedTab={"PIPELINE"} />

                :
                (pipelinesource_data !== "" && <div class="rt-pipeline__content">
                  <div class="rt-pipeline__top">
                    <div className={`qd-rt_aside${this.state.leftMenuCollapsed ? " qd-rt_aside--collapsed" : ""}`}>
                      <div className="qd-rt_aside-header">
                        <div className="caption p-0">
                          <div className="metric-list-dropdown" onClick={this.DropdownOpen.bind(this, "topmenuduration")}>
                            <button className="btn dropdown-toggle" >{displayWatchlistName}</button>
                            <div className="dropdown-menu">
                              <div className="dropdown-header">
                                <label>Your Lists</label>
                              </div>
                              <div
                                className={`dropdown-item ${selectedWatchlistName === "All" ? "active" : ""}`}
                                onClick={() => {
                                  this.setState({ selectedWatchlistName: "All", selectedWatchlistId: null });
                                  this.handleWatchlistChange("All")
                                }}>
                                All
                                <span className="menu-badge"></span>
                              </div>
                              {Array.isArray(watchListInformation) && watchListInformation.slice().sort((a, b) => a.watch_list_name.localeCompare(b.watch_list_name)).map((watchlist) => (
                                <div key={watchlist._id} className={`dropdown-item ${selectedWatchlistName === watchlist.watch_list_name ? "active" : ""}`} onClick={() => {
                                  this.handleWatchlistChange(watchlist.watch_list_name, watchlist.watch_list_id);
                                  this.setState({ selectedWatchListId: watchlist.watch_list_id, selectedWatchlistName: watchlist.watch_list_name });
                                }}>{watchlist.watch_list_name}{" "}
                                  <span className="menu-badge">{watchlist.job_count}</span>
                                </div>))}
                            </div>
                          </div>
                        </div>
                        <div className="actions">
                          <RcTooltip
                            placement="top"
                            overlay={
                              <span>Create a list</span>
                            }
                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                          >
                            <button className="btn action-btn" onClick={() => this.handleWishListShow(false)}>
                              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.5 12.5H6V11.5H11.5V6H12.5V11.5H18V12.5H12.5V18H11.5V12.5Z" fill="#484848" />
                              </svg>
                            </button>
                          </RcTooltip>
                          <Dropdown alignRight className="wishlist-dropdown">
                            <RcTooltip
                              placement="top"
                              overlay={
                                <span>Settings</span>
                              }
                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                              <Dropdown.Toggle variant="" id="dropdown-basic" className="action-btn dropdown-caret-hide">
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12 18.5385C11.725 18.5385 11.4896 18.4406 11.2938 18.2447C11.0979 18.0489 11 17.8135 11 17.5385C11 17.2635 11.0979 17.0281 11.2938 16.8322C11.4896 16.6364 11.725 16.5385 12 16.5385C12.275 16.5385 12.5104 16.6364 12.7063 16.8322C12.9021 17.0281 13 17.2635 13 17.5385C13 17.8135 12.9021 18.0489 12.7063 18.2447C12.5104 18.4406 12.275 18.5385 12 18.5385ZM12 13C11.725 13 11.4896 12.9021 11.2938 12.7062C11.0979 12.5104 11 12.275 11 12C11 11.725 11.0979 11.4896 11.2938 11.2937C11.4896 11.0979 11.725 11 12 11C12.275 11 12.5104 11.0979 12.7063 11.2937C12.9021 11.4896 13 11.725 13 12C13 12.275 12.9021 12.5104 12.7063 12.7062C12.5104 12.9021 12.275 13 12 13ZM12 7.46149C11.725 7.46149 11.4896 7.36357 11.2938 7.16774C11.0979 6.9719 11 6.73649 11 6.46149C11 6.18649 11.0979 5.95107 11.2938 5.75524C11.4896 5.5594 11.725 5.46149 12 5.46149C12.275 5.46149 12.5104 5.5594 12.7063 5.75524C12.9021 5.95107 13 6.18649 13 6.46149C13 6.73649 12.9021 6.9719 12.7063 7.16774C12.5104 7.36357 12.275 7.46149 12 7.46149Z" fill="#484848" />
                                </svg>
                              </Dropdown.Toggle>
                            </RcTooltip>
                            <Dropdown.Menu>
                              <Dropdown.Item onClick={() => this.handleWishListShow(true, displayWatchlistName)}
                                disabled={selectedWatchlistName === "All"} >                                  <i>
                                  <svg id="icon_rename" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                    <rect id="Rectangle_2979" data-name="Rectangle 2979" width="24" height="24" fill="none" />
                                    <g id="Group_5099" data-name="Group 5099" transform="translate(2.302 17.34) rotate(-45)">
                                      <path id="Union_12" data-name="Union 12" d="M19.626,6.162l-16.1-.04A.5.5,0,0,1,3.2,6L.176,3.427a.5.5,0,0,1,0-.763L3.2.117A.5.5,0,0,1,3.524,0l16.1.007A1.721,1.721,0,0,1,21.267,1.8V4.374a1.721,1.721,0,0,1-1.639,1.788Zm0-1a.727.727,0,0,0,.638-.788V1.8a.727.727,0,0,0-.639-.788h-1.2V5.159Zm-2.2-.005V1.007h-1.1V5.154Zm-2.1-.005V3.581H4.937V5.126ZM1.274,3.049,3.709,5.123h.228V1h-.23Zm14.057-.468V1.006L4.937,1V2.581Z" fill="currentColor" />
                                    </g>
                                  </svg>
                                </i>
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item onClick={this.handleDeleteModalOpen} disabled={selectedWatchlistName === "All"}>
                                <i>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                    <g id="icon_clear-list" transform="translate(-1951 -3066)">
                                      <g id="Group_5101" data-name="Group 5101" transform="translate(534.081 1515.731)">
                                        <path id="Union_13" data-name="Union 13" d="M-530.43-1496.732a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h6.605a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5Zm-3.15-1.565a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h11.737a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5Zm7.212-2.6a.5.5,0,0,1-.354-.146l-4.739-4.739a.5.5,0,0,1-.147-.354.5.5,0,0,1,.147-.354l10.1-10.1a.5.5,0,0,1,.354-.147.5.5,0,0,1,.354.147l6.431,6.43a.5.5,0,0,1,0,.707l-8.4,8.4a.5.5,0,0,1-.354.146Zm6.574-4.452,4.507-4.451-5.724-5.724-4.489,4.487Z" transform="translate(1953 3069)" fill="currentColor" />
                                      </g>
                                      <rect id="Rectangle_2983" data-name="Rectangle 2983" width="24" height="24" transform="translate(1951 3066)" fill="none" />
                                    </g>
                                  </svg>
                                </i>
                                Delete List
                              </Dropdown.Item>
                              <Form noValidate name="delete-deployment">
                                {/* Modal Delete Confirmation */}
                                <Modal show={this.state.showDeletePopup} centered size="sm">
                                  <Modal.Body className="p-0">
                                    <div className="modal_confirmation-alert">
                                      <div className="confirmation-alert_img">
                                        <Image src="logo" />
                                      </div>
                                      <div className="confirmation-alert_text">
                                        <h4>Delete Watchlist</h4>
                                        <p>
                                          Please confirm the name of the watchlist to delete:{" "}
                                          <strong>{selectedWatchlistName || "My_Deployment"}</strong>
                                        </p>
                                      </div>
                                      <div className="confirmation-alert_form">
                                        <Form.Group controlId="watchlist-name" className='mx-auto' style={{ width: '85%' }}>
                                          {/* <Form.Label>
                                                      Deployment Name <span style={{ color: "red" }}>*</span>
                                                    </Form.Label> */}
                                          <InputGroup bsPrefix="icon-input-group">
                                            <Form.Control
                                              type="text"
                                              placeholder="Enter watchlist name to confirm"
                                              className="mb-3 text-center pl-3 font-weight-medium"
                                              value={this.state.confirmDeleteName}
                                              onChange={(e) =>
                                                this.setState({ confirmDeleteName: e.target.value })
                                              }
                                            />
                                          </InputGroup>
                                        </Form.Group>
                                        {this.state.errors && (
                                          <div className="alert alert-danger text-left">
                                            <i className="text-danger mr-2">
                                              <FontAwesomeIcon icon={faExclamationTriangle} />
                                            </i>
                                            {this.state.errors}
                                          </div>
                                        )}
                                        <div className="alert alert-danger text-left">
                                          <i className="text-danger mr-2">
                                            <FontAwesomeIcon icon={faExclamationTriangle} />
                                          </i>
                                          Deleting this watchlist is irreversible. Only the watchlist will be deleted, Pipelines and its configurations will not be affected.                                          </div>
                                        <div className="confirmation-alert_action">
                                          <button
                                            type="button"
                                            onClick={this.handleCloseDeletePopup}
                                            className="btn btn-outline btn-grey btn-circle mr-2"
                                          >
                                            Cancel
                                          </button>
                                          <button
                                            type="button"
                                            onClick={() => this.handleDeleteWatchlist(selectedWatchlistName)}
                                            className="btn btn-primary btn-circle mr-2"
                                            disabled={
                                              this.state.confirmDeleteName !== selectedWatchlistName
                                            }
                                          >
                                            <FontAwesomeIcon icon={faCheck} />
                                            Confirm
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </Modal.Body>
                                </Modal>
                              </Form>
                            </Dropdown.Menu>
                          </Dropdown>
                          <RcTooltip
                            placement="top"
                            overlay={<span>{this.state.leftMenuCollapsed ? "Expand" : "Collapse"}</span>}
                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                          >
                            <button
                              type="button"
                              className="btn action-btn left-menu-toggle"
                              aria-label={this.state.leftMenuCollapsed ? "Expand left menu" : "Collapse left menu"}
                              onClick={() => this.setState(
                                (prev) => ({ leftMenuCollapsed: !prev.leftMenuCollapsed }),
                                () => window.dispatchEvent(new Event("resize"))
                              )}
                            >
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3.5" y="4.5" width="17" height="15" rx="2" stroke="#484848" strokeWidth="1.6" />
                                <path d="M9 4.5v15" stroke="#484848" strokeWidth="1.6" />
                                {this.state.leftMenuCollapsed
                                  ? <path d="M13 9.5l3 2.5-3 2.5" stroke="#484848" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                  : <path d="M16 9.5l-3 2.5 3 2.5" stroke="#484848" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />}
                              </svg>
                            </button>
                          </RcTooltip>
                        </div>
                        <Modal
                          size="md"
                          show={this.state.watchListOpen}
                          onHide={this.handleWishListClose}
                          className="modal-tree-view"
                          centered
                        >
                          <Modal.Header closeButton>
                            <h5 className="modal-title">{this.state.editWatchlist ? "Edit a List" : "Create a New List"}
                            </h5>
                          </Modal.Header>
                          <Modal.Body className="p-0">
                            <div className="modal-tree-view__top">
                              <Form.Group>
                                <Form.Control
                                  size="lg"
                                  type="text"
                                  placeholder="Enter name of the list"
                                  value={this.state.watchListName}
                                  onChange={this.handleWatchlistNameChange}
                                  isInvalid={!!this.state.watchListNameError}
                                  maxLength={20}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {this.state.watchListNameError}
                                </Form.Control.Feedback>
                              </Form.Group>

                              <div className="qd-search-bar has-btn-close qd-search-bar--bg-gray">
                                <div className="input-group">
                                  <div className="input-group-prepend">
                                    <button id="button-addon4" type="button" className="btn">
                                      <svg className='d-block' width="20" height="20" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.889 12.5237L10.35 9.98474C10.1222 9.75694 9.75283 9.75694 9.52502 9.98474C9.29722 10.2126 9.29722 10.5819 9.52502 10.8097L12.064 13.3487C12.2918 13.5765 12.6612 13.5765 12.889 13.3487C13.1168 13.1209 13.1168 12.7515 12.889 12.5237Z" fill="#99A1B7" />
                                        <path d="M6.41667 11.8333C3.82408 11.8333 1.75 9.75923 1.75 7.16667C1.75 4.57408 3.82408 2.5 6.41667 2.5C9.00923 2.5 11.0833 4.57408 11.0833 7.16667C11.0833 9.75923 9.00923 11.8333 6.41667 11.8333ZM6.41667 3.66667C4.39444 3.66667 2.91667 5.14444 2.91667 7.16667C2.91667 9.18891 4.39444 10.6667 6.41667 10.6667C8.43891 10.6667 9.91667 9.18891 9.91667 7.16667C9.91667 5.14444 8.43891 3.66667 6.41667 3.66667Z" fill="#99A1B7" />
                                      </svg>
                                    </button>
                                  </div>
                                  <input type="search" placeholder="Search here..." className="form-control h-100" value={this.state.saveWatchListSearchText} onChange={this.handleWatchlistSearch} />
                                </div>
                                {this.state.saveWatchListSearchText && <button className="btn btn-clear" title="clear" onClick={() => this.setState({ saveWatchListSearchText: '' })}><i className="icon-close"></i></button>}
                              </div>
                            </div>
                            {this.state.watchListOpen && <PipelineLeftPanel
                              leftPanelLoader={false}
                              metaDataResponse={this.state.metaDataResponse}
                              watchListOpen={this.state.watchListOpen}
                              selectedEnvId={this.props.selectedEnvId}
                              selectedWatchlistId={this.state.selectedWatchListId}
                              handleSaveWatchlistCheckboxChange={this.handleSaveWatchlistCheckboxChange}
                              checkedStates={this.state.checkedStates}
                              saveWatchListSearchText={this.state.saveWatchListSearchText}
                              pipelinesource_data={paginatedData}
                              pipelinesource_data_leftpanel={pipelinesource_data}
                            />}
                          </Modal.Body>
                          <Modal.Footer>
                            <button className="btn btn-outline btn-grey btn-circle" onClick={this.handleWishListClose}>Cancel</button>
                            <button className="btn btn-primary btn-circle" name="save_watchlist" onClick={() => this.handleSaveClick()} disabled={isSaveDisabled}><FontAwesomeIcon icon={faCheck} /> Save</button>
                          </Modal.Footer>
                        </Modal>
                        <div className={this.state.metricListRename ? "rename-input-box has-btn-close" : "rename-input-box d-none"}>
                          <Form.Control type="text" placeholder="Enter Name" />
                          <button className="btn btn-clear" title="clear"><i className="icon-close"></i></button>
                        </div>
                      </div>
                    </div>
                    <div className="qd-toolbar w-100 overflow-visible">
                      <div className="qd-toolbar-wrap">
                        <div className="qd-toolbar-left">
                          <div className="qd-toolbar-col">
                            <div className="qd-toolbar-btn toolbar-highlight justify-content-start" onClick={this.handleOpenAutoCompleteModal} style={{ minWidth: '250px' }}>
                              <svg className='d-block' width="20" height="20" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.889 12.5237L10.35 9.98474C10.1222 9.75694 9.75283 9.75694 9.52502 9.98474C9.29722 10.2126 9.29722 10.5819 9.52502 10.8097L12.064 13.3487C12.2918 13.5765 12.6612 13.5765 12.889 13.3487C13.1168 13.1209 13.1168 12.7515 12.889 12.5237Z" fill="#99A1B7" />
                                <path d="M6.41667 11.8333C3.82408 11.8333 1.75 9.75923 1.75 7.16667C1.75 4.57408 3.82408 2.5 6.41667 2.5C9.00923 2.5 11.0833 4.57408 11.0833 7.16667C11.0833 9.75923 9.00923 11.8333 6.41667 11.8333ZM6.41667 3.66667C4.39444 3.66667 2.91667 5.14444 2.91667 7.16667C2.91667 9.18891 4.39444 10.6667 6.41667 10.6667C8.43891 10.6667 9.91667 9.18891 9.91667 7.16667C9.91667 5.14444 8.43891 3.66667 6.41667 3.66667Z" fill="#99A1B7" />
                              </svg>
                              <span className="qd-toolbar-text">{(preSelectedDataset !== null && preSelectedDataset.label) || (preSelectedDatasource !== null && preSelectedDatasource.label)}</span>
                            </div>
                          </div>
                          {this.state.selectedJobId === "" && <div className="qd-toolbar-col">
                            <div class="qd-toolbar-btn-group">
                              <div class="qd-toolbar-btn" onClick={this.prevDate}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.01155 12.7508H18.373C18.5859 12.7508 18.764 12.679 18.9075 12.5353C19.0512 12.3918 19.123 12.2136 19.123 12.0008C19.123 11.788 19.0512 11.6098 18.9075 11.4663C18.764 11.3226 18.5859 11.2508 18.373 11.2508H7.01155L10.3038 7.95856C10.4525 7.80973 10.5259 7.63565 10.524 7.43631C10.522 7.23698 10.4486 7.05973 10.3038 6.90456C10.1486 6.74956 9.97046 6.66948 9.7693 6.66431C9.56796 6.65915 9.38971 6.73415 9.23455 6.88931L4.7558 11.3681C4.66213 11.4617 4.59613 11.5605 4.5578 11.6643C4.5193 11.7681 4.50005 11.8803 4.50005 12.0008C4.50005 12.1213 4.5193 12.2335 4.5578 12.3373C4.59613 12.4411 4.66213 12.5399 4.7558 12.6336L9.23455 17.1123C9.38338 17.261 9.55996 17.3344 9.7643 17.3326C9.9688 17.3306 10.1486 17.2521 10.3038 17.0971C10.4486 16.9419 10.5236 16.7662 10.5288 16.5701C10.534 16.3739 10.459 16.1982 10.3038 16.0431L7.01155 12.7508Z" fill="#5F6368" />
                                </svg>
                              </div>
                              <div class="qd-toolbar-btn" onClick={this.nowDate}>Now</div>
                              <div class="qd-toolbar-btn" id="btn_pipline_next" onClick={this.nextDate}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M16.6115 12.7508H5.25C5.03717 12.7508 4.859 12.679 4.7155 12.5353C4.57183 12.3918 4.5 12.2136 4.5 12.0008C4.5 11.788 4.57183 11.6098 4.7155 11.4663C4.859 11.3226 5.03717 11.2508 5.25 11.2508H16.6115L13.3193 7.95856C13.1706 7.80973 13.0972 7.63565 13.099 7.43631C13.101 7.23698 13.1744 7.05973 13.3193 6.90456C13.4744 6.74956 13.6526 6.66948 13.8538 6.66431C14.0551 6.65915 14.2333 6.73415 14.3885 6.88931L18.8673 11.3681C18.9609 11.4617 19.0269 11.5605 19.0652 11.6643C19.1038 11.7681 19.123 11.8803 19.123 12.0008C19.123 12.1213 19.1038 12.2335 19.0652 12.3373C19.0269 12.4411 18.9609 12.5399 18.8673 12.6336L14.3885 17.1123C14.2397 17.261 14.0631 17.3344 13.8587 17.3326C13.6542 17.3306 13.4744 17.2521 13.3193 17.0971C13.1744 16.9419 13.0994 16.7662 13.0943 16.5701C13.0891 16.3739 13.1641 16.1982 13.3193 16.0431L16.6115 12.7508Z" fill="#5F6368" />
                                </svg>
                              </div>
                            </div>
                          </div>}
                          {this.state.selectedJobId === "" && <div className="qd-toolbar-col">
                            <div class="qd-toolbar-btn-group">
                              <div className={this.state.timefilter === "1" ? "qd-toolbar-btn  --is-clicked" : "qd-toolbar-btn"} onClick={this.timeFilter.bind(this, "1")}>1hr</div>
                              <div className={this.state.timefilter === "6" ? "qd-toolbar-btn  --is-clicked" : "qd-toolbar-btn"} onClick={this.timeFilter.bind(this, "6")}>6hr</div>
                              <div className={this.state.timefilter === "12" ? "qd-toolbar-btn  --is-clicked" : "qd-toolbar-btn"} onClick={this.timeFilter.bind(this, "12")}>12hr</div>
                              <div className={this.state.timefilter === "24" ? "qd-toolbar-btn  --is-clicked" : "qd-toolbar-btn"} onClick={this.timeFilter.bind(this, "24")}>24hr</div>
                            </div>
                          </div>}
                          <div className="qd-toolbar-col" style={{ display: this.state.lienage_graph_type === "run-level" ? "none" : "block" }}>
                            <DateRangePicker
                              startDate={this.state.startDate}
                              maxDate={moment(this.state.initialendDate)}
                              singleDatePicker={true}
                              showDropdowns={true}
                              onApply={this.handlePipelineTimeFilter}>
                              <div className="qd-toolbar_dropdown-wrap" id="topmenuduration" >
                                <div className="qd-toolbar-btn ">
                                  {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8 13.9423C7.75517 13.9423 7.5465 13.8561 7.374 13.6838C7.20167 13.5113 7.1155 13.3026 7.1155 13.0578C7.1155 12.8129 7.20167 12.6043 7.374 12.4318C7.5465 12.2593 7.75517 12.173 8 12.173C8.24483 12.173 8.4535 12.2593 8.626 12.4318C8.79833 12.6043 8.8845 12.8129 8.8845 13.0578C8.8845 13.3026 8.79833 13.5113 8.626 13.6838C8.4535 13.8561 8.24483 13.9423 8 13.9423ZM12 13.9423C11.7552 13.9423 11.5465 13.8561 11.374 13.6838C11.2017 13.5113 11.1155 13.3026 11.1155 13.0578C11.1155 12.8129 11.2017 12.6043 11.374 12.4318C11.5465 12.2593 11.7552 12.173 12 12.173C12.2448 12.173 12.4535 12.2593 12.626 12.4318C12.7983 12.6043 12.8845 12.8129 12.8845 13.0578C12.8845 13.3026 12.7983 13.5113 12.626 13.6838C12.4535 13.8561 12.2448 13.9423 12 13.9423ZM16 13.9423C15.7552 13.9423 15.5465 13.8561 15.374 13.6838C15.2017 13.5113 15.1155 13.3026 15.1155 13.0578C15.1155 12.8129 15.2017 12.6043 15.374 12.4318C15.5465 12.2593 15.7552 12.173 16 12.173C16.2448 12.173 16.4535 12.2593 16.626 12.4318C16.7983 12.6043 16.8845 12.8129 16.8845 13.0578C16.8845 13.3026 16.7983 13.5113 16.626 13.6838C16.4535 13.8561 16.2448 13.9423 16 13.9423ZM5.30775 21.5C4.80258 21.5 4.375 21.325 4.025 20.975C3.675 20.625 3.5 20.1974 3.5 19.6923V6.30777C3.5 5.8026 3.675 5.37502 4.025 5.02502C4.375 4.67502 4.80258 4.50002 5.30775 4.50002H6.69225V3.15377C6.69225 2.9346 6.76567 2.7516 6.9125 2.60477C7.05933 2.4581 7.24233 2.38477 7.4615 2.38477C7.68083 2.38477 7.86383 2.4581 8.0105 2.60477C8.15733 2.7516 8.23075 2.9346 8.23075 3.15377V4.50002H15.8077V3.13477C15.8077 2.92193 15.8795 2.74368 16.023 2.60002C16.1667 2.45652 16.3449 2.38477 16.5577 2.38477C16.7706 2.38477 16.9488 2.45652 17.0922 2.60002C17.2359 2.74368 17.3077 2.92193 17.3077 3.13477V4.50002H18.6923C19.1974 4.50002 19.625 4.67502 19.975 5.02502C20.325 5.37502 20.5 5.8026 20.5 6.30777V19.6923C20.5 20.1974 20.325 20.625 19.975 20.975C19.625 21.325 19.1974 21.5 18.6923 21.5H5.30775ZM5.30775 20H18.6923C18.7692 20 18.8398 19.9679 18.9038 19.9038C18.9679 19.8398 19 19.7693 19 19.6923V10.3078H5V19.6923C5 19.7693 5.03208 19.8398 5.09625 19.9038C5.16025 19.9679 5.23075 20 5.30775 20ZM5 8.80777H19V6.30777C19 6.23077 18.9679 6.16026 18.9038 6.09626C18.8398 6.0321 18.7692 6.00002 18.6923 6.00002H5.30775C5.23075 6.00002 5.16025 6.0321 5.09625 6.09626C5.03208 6.16026 5 6.23077 5 6.30777V8.80777Z" fill="#484848" />
                                    </svg> */}

                                  <i>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8 13.9423C7.75517 13.9423 7.5465 13.8561 7.374 13.6838C7.20167 13.5113 7.1155 13.3026 7.1155 13.0578C7.1155 12.8129 7.20167 12.6043 7.374 12.4318C7.5465 12.2593 7.75517 12.173 8 12.173C8.24483 12.173 8.4535 12.2593 8.626 12.4318C8.79833 12.6043 8.8845 12.8129 8.8845 13.0578C8.8845 13.3026 8.79833 13.5113 8.626 13.6838C8.4535 13.8561 8.24483 13.9423 8 13.9423ZM12 13.9423C11.7552 13.9423 11.5465 13.8561 11.374 13.6838C11.2017 13.5113 11.1155 13.3026 11.1155 13.0578C11.1155 12.8129 11.2017 12.6043 11.374 12.4318C11.5465 12.2593 11.7552 12.173 12 12.173C12.2448 12.173 12.4535 12.2593 12.626 12.4318C12.7983 12.6043 12.8845 12.8129 12.8845 13.0578C12.8845 13.3026 12.7983 13.5113 12.626 13.6838C12.4535 13.8561 12.2448 13.9423 12 13.9423ZM16 13.9423C15.7552 13.9423 15.5465 13.8561 15.374 13.6838C15.2017 13.5113 15.1155 13.3026 15.1155 13.0578C15.1155 12.8129 15.2017 12.6043 15.374 12.4318C15.5465 12.2593 15.7552 12.173 16 12.173C16.2448 12.173 16.4535 12.2593 16.626 12.4318C16.7983 12.6043 16.8845 12.8129 16.8845 13.0578C16.8845 13.3026 16.7983 13.5113 16.626 13.6838C16.4535 13.8561 16.2448 13.9423 16 13.9423ZM5.30775 21.5C4.80258 21.5 4.375 21.325 4.025 20.975C3.675 20.625 3.5 20.1974 3.5 19.6923V6.30777C3.5 5.8026 3.675 5.37502 4.025 5.02502C4.375 4.67502 4.80258 4.50002 5.30775 4.50002H6.69225V3.15377C6.69225 2.9346 6.76567 2.7516 6.9125 2.60477C7.05933 2.4581 7.24233 2.38477 7.4615 2.38477C7.68083 2.38477 7.86383 2.4581 8.0105 2.60477C8.15733 2.7516 8.23075 2.9346 8.23075 3.15377V4.50002H15.8077V3.13477C15.8077 2.92193 15.8795 2.74368 16.023 2.60002C16.1667 2.45652 16.3449 2.38477 16.5577 2.38477C16.7706 2.38477 16.9488 2.45652 17.0922 2.60002C17.2359 2.74368 17.3077 2.92193 17.3077 3.13477V4.50002H18.6923C19.1974 4.50002 19.625 4.67502 19.975 5.02502C20.325 5.37502 20.5 5.8026 20.5 6.30777V19.6923C20.5 20.1974 20.325 20.625 19.975 20.975C19.625 21.325 19.1974 21.5 18.6923 21.5H5.30775ZM5.30775 20H18.6923C18.7692 20 18.8398 19.9679 18.9038 19.9038C18.9679 19.8398 19 19.7693 19 19.6923V10.3078H5V19.6923C5 19.7693 5.03208 19.8398 5.09625 19.9038C5.16025 19.9679 5.23075 20 5.30775 20ZM5 8.80777H19V6.30777C19 6.23077 18.9679 6.16026 18.9038 6.09626C18.8398 6.0321 18.7692 6.00002 18.6923 6.00002H5.30775C5.23075 6.00002 5.16025 6.0321 5.09625 6.09626C5.03208 6.16026 5 6.23077 5 6.30777V8.80777Z" fill="#484848" />
                                    </svg> </i>
                                  <span class="divider"></span>
                                  <span className="qd-toolbar-text">{this.state.endDate.format(PIPELINE_DISPLAY_DATE_FORMAT)} (GMT)</span>
                                </div>
                              </div>
                            </DateRangePicker>
                          </div>
                        </div>
                        {this.state.selectedJobId === "" && <div className="qd-toolbar-col">

                          <div className="qd-toolbar-btn">
                            {/* <Form.Check
                                  type="switch"
                                  id="custom-switch"
                                  label="&nbsp;Active Runs Only"
                                  className="custom-switch-sm mr-3"
                                  checked
                                /> */}
                            <div class="custom-control custom-switch custom-switch-sm">
                              <input type="checkbox" class="custom-control-input" id="activeRuns"
                                checked={this.state.isCheackedActiveRuns} // Controlled by state
                                onChange={this.handleToggleActiveRuns} // Call handler on change
                              />
                              <label class="custom-control-label" for="activeRuns"
                                style={{ cursor: "pointer" }}
                              ><span className="ml-1">Active Runs Only <span className='text-muted'>({this.state.piplineInfo.total_active_count ? this.state.piplineInfo.total_active_count : 0})</span></span></label>
                            </div>
                          </div>
                        </div>}
                        <div className="qd-toolbar-col mr-0">
                          {this.state.selectedJobId === "" && <div className={this.state.selectedTopMenu === "topmenugraph" ? "qd-toolbar_dropdown-wrap open" : "qd-toolbar_dropdown-wrap "} id="topmenugraph" >
                            <div className="qd-toolbar-btn" style={{ minWidth: '58.68px' }} onClick={this.swDropdownOpen.bind(this, "topmenugraph")}>
                              <Dropdown className="hide-dropdown-arrow qd-filter-dropdown" show={this.state.showFilterDropdown}>
                                <Dropdown.Toggle variant=" " id="dropdown-basic" className='p-0 d-flex align-items-center' onClick={this.toggleFilterDropdown}>
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11 18C10.7167 18 10.4792 17.9042 10.2875 17.7125C10.0958 17.5208 10 17.2833 10 17C10 16.7167 10.0958 16.4792 10.2875 16.2875C10.4792 16.0958 10.7167 16 11 16H13C13.2833 16 13.5208 16.0958 13.7125 16.2875C13.9042 16.4792 14 16.7167 14 17C14 17.2833 13.9042 17.5208 13.7125 17.7125C13.5208 17.9042 13.2833 18 13 18H11ZM7 13C6.71667 13 6.47917 12.9042 6.2875 12.7125C6.09583 12.5208 6 12.2833 6 12C6 11.7167 6.09583 11.4792 6.2875 11.2875C6.47917 11.0958 6.71667 11 7 11H17C17.2833 11 17.5208 11.0958 17.7125 11.2875C17.9042 11.4792 18 11.7167 18 12C18 12.2833 17.9042 12.5208 17.7125 12.7125C17.5208 12.9042 17.2833 13 17 13H7ZM4 8C3.71667 8 3.47917 7.90417 3.2875 7.7125C3.09583 7.52083 3 7.28333 3 7C3 6.71667 3.09583 6.47917 3.2875 6.2875C3.47917 6.09583 3.71667 6 4 6H20C20.2833 6 20.5208 6.09583 20.7125 6.2875C20.9042 6.47917 21 6.71667 21 7C21 7.28333 20.9042 7.52083 20.7125 7.7125C20.5208 7.90417 20.2833 8 20 8H4Z" fill="#484848" />
                                  </svg>
                                  <div class="filter-counter-stack d-none">
                                    {this.state.selectedItems.includes('pipeline-done') && this.state.pipeline_status_count?.Succeeded > 0 && (<OverlayTrigger
                                      trigger="hover"
                                      placement={"bottom"}
                                      overlay={
                                        <Popover className="popover-dark">
                                          <Popover.Content>
                                            <ul className='popover-stat-list'>
                                              <li className='justify-content-between'>
                                                <label className='text-success'>
                                                  <i className='mr-1'>
                                                    <svg className='d-block' xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>
                                                  </i>
                                                  Done
                                                </label>
                                                <strong className='ml-2'>{this.state.pipeline_status_count?.Succeeded}</strong>
                                              </li>
                                            </ul>
                                          </Popover.Content>
                                        </Popover>
                                      }
                                    >
                                      <div class="filter-counter bg-success text-white">{this.state.pipeline_status_count?.Succeeded}</div>
                                    </OverlayTrigger>)}
                                    {this.state.selectedItems.includes('pipeline-failed') && this.state.pipeline_status_count?.Failed > 0 && (
                                      <OverlayTrigger
                                        trigger="hover"
                                        placement={"bottom"}
                                        overlay={
                                          <Popover className="popover-dark">
                                            <Popover.Content>
                                              <ul className='popover-stat-list'>
                                                <li className='justify-content-between'>
                                                  <label className='text-danger'>
                                                    <i className='mr-1'>
                                                      <svg className='d-block' xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
                                                    </i>
                                                    Failed
                                                  </label>
                                                  <strong className='ml-2'>{this.state.pipeline_status_count?.Failed}</strong>
                                                </li>
                                              </ul>
                                            </Popover.Content>
                                          </Popover>
                                        }
                                      >
                                        <div class="filter-counter bg-danger text-white">{this.state.pipeline_status_count?.Failed}</div>
                                      </OverlayTrigger>)}
                                    {this.state.selectedItems.length > 2 && this.state.pipeline_status_count !== undefined && (
                                      <OverlayTrigger
                                        trigger="hover"
                                        placement={"bottom"}
                                        overlay={
                                          <Popover className="popover-dark">
                                            <Popover.Content>
                                              <ul className='popover-stat-list'>
                                                {this.state.selectedItems.includes('pipeline-done') &&
                                                  <li className='justify-content-between'>
                                                    <label className='text-success'>
                                                      <i className='mr-1'>
                                                        <svg className='d-block' xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>
                                                      </i>
                                                      Done
                                                    </label>
                                                    <strong className='ml-2'>{this.state.pipeline_status_count?.Succeeded}</strong>
                                                  </li>}
                                                {this.state.selectedItems.includes('pipeline-failed') &&
                                                  <li className='justify-content-between'>
                                                    <label className='text-danger'>
                                                      <i className='mr-1'>
                                                        <svg className='d-block' xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
                                                      </i>
                                                      Failed
                                                    </label>
                                                    <strong className='ml-2'>{this.state.pipeline_status_count?.Failed}</strong>
                                                  </li>}
                                                {this.state.selectedItems.includes('pipeline-running') && <li className='justify-content-between'>
                                                  <label className='text-blue'>
                                                    <i className='mr-1'>
                                                      <svg className='d-block' xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><path d="M6,2l0.01,6L10,12l-3.99,4.01L6,22h12v-6l-4-4l4-3.99V2H6z M16,16.5V20H8v-3.5l4-4L16,16.5z" /></g></svg>
                                                    </i>
                                                    Running
                                                  </label>
                                                  <strong className='ml-2'>{this.state.pipeline_status_count?.Running}</strong>
                                                </li>}
                                                {this.state.selectedItems.includes('pipeline-progress') && <li className='justify-content-between'>
                                                  <label className='text-blue'>
                                                    <i className='mr-1'>
                                                      <svg className='d-block' xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><path d="M6,2l0.01,6L10,12l-3.99,4.01L6,22h12v-6l-4-4l4-3.99V2H6z M16,16.5V20H8v-3.5l4-4L16,16.5z" /></g></svg>
                                                    </i>
                                                    In Progress
                                                  </label>
                                                  <strong className='ml-2'>{this.state.pipeline_status_count?.InProgress}</strong>
                                                </li>}
                                                {this.state.selectedItems.includes('pipeline-queued') && <li className='justify-content-between'>
                                                  <label className='text-warning'>
                                                    <i className='mr-1'>
                                                      <svg className='d-block' xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z" /></svg>
                                                    </i>
                                                    Queued
                                                  </label>
                                                  <strong className='ml-2'>{this.state.pipeline_status_count?.Queued}</strong>
                                                </li>}
                                                {this.state.selectedItems.includes('pipeline-scheduled') && <li className='justify-content-between'>
                                                  <label className='text-purple'>
                                                    <i className='mr-1'>
                                                      <svg className='d-block' xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><g><rect fill="none" height="24" width="24" /></g><g><g><g><path d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z" /></g></g></g></svg>
                                                    </i>
                                                    Scheduled
                                                  </label>
                                                  <strong className='ml-2'>{this.state.pipeline_status_count?.Scheduled}</strong>
                                                </li>}
                                                {this.state.selectedItems.includes('pipeline-cancelled') && <li className='justify-content-between'>
                                                  <label className='text-warning'>
                                                    <i className='mr-1'>
                                                      <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
                                                    </i>
                                                    Cancelled
                                                  </label>
                                                  <strong className='ml-2'>{this.state.pipeline_status_count?.Cancelled}</strong>
                                                </li>}
                                              </ul>
                                            </Popover.Content>
                                          </Popover>
                                        }
                                      >
                                        <div class="filter-counter p-0">+{this.state.selectedItems.length - 2}</div>
                                      </OverlayTrigger>)}
                                  </div>
                                  <div class="filter-count">{this.state.appliedSelectedItems.length}</div>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className='qd-filter-dropdown__menu'>
                                  <Dropdown.Header>Filter</Dropdown.Header>
                                  {/* <div class="filter-count"></div> */}
                                  <div className='px-2'>
                                    <Dropdown.ItemText className='d-flex align-items-center mt-1'>
                                      <a href="#/action-3" className='text-nowrap text-blue' onClick={this.handleSelectAll}>Select all</a>
                                      <span class="dot-separator"></span>
                                      <a href="#/action-3" className='text-blue' onClick={this.handleClearAll}>Clear</a>
                                    </Dropdown.ItemText>
                                    {this.state.pipeline_status_count?.Succeeded > 0 && <Dropdown.Item href="#/action-3" disabled={!this.state.pipeline_status_count?.Succeeded}>
                                      <div className="custom-control custom-checkbox">
                                        <Form.Control
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="defaulErrorCheck"
                                          id="pipeline-done"
                                          onChange={this.pipelineFilterSelection}
                                          checked={this.state.selectedItems.includes('pipeline-done')} />
                                        <Form.Label className="custom-control-label d-flex align-items-center" for="pipeline-done">
                                          <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#4ED2CC"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>
                                          <span className="ml-1 mr-3 flex-grow-1">Success</span>
                                          <span className='text-muted'>{this.state.pipeline_status_count !== undefined && this.state.pipeline_status_count.Succeeded !== undefined ? this.state.pipeline_status_count.Succeeded : 0}</span>
                                        </Form.Label>
                                      </div>
                                    </Dropdown.Item>}
                                    {this.state.pipeline_status_count?.Failed > 0 && <Dropdown.Item href="#/action-3" disabled={!this.state.pipeline_status_count?.Failed}>
                                      <div className="custom-control custom-checkbox">
                                        <Form.Control
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="defaulErrorCheck"
                                          id="pipeline-failed"
                                          onChange={this.pipelineFilterSelection}
                                          checked={this.state.selectedItems.includes('pipeline-failed')} />
                                        <Form.Label className="custom-control-label d-flex align-items-center" for="pipeline-failed">
                                          <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#F64E60"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
                                          <span className="ml-1 mr-3 flex-grow-1">Failed</span>
                                          <span className='text-muted'>{this.state.pipeline_status_count !== undefined && this.state.pipeline_status_count.Failed !== undefined ? this.state.pipeline_status_count.Failed : 0}</span>
                                        </Form.Label>
                                      </div>
                                    </Dropdown.Item>}
                                    {this.state.pipeline_status_count?.Running > 0 && <Dropdown.Item href="#/action-3" disabled={!this.state.pipeline_status_count?.Running}>
                                      <div className="custom-control custom-checkbox">
                                        <Form.Control
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="defaulErrorCheck"
                                          id="pipeline-running"
                                          onChange={this.pipelineFilterSelection}
                                          checked={this.state.selectedItems.includes('pipeline-running')} />
                                        <Form.Label className="custom-control-label d-flex align-items-center" for="pipeline-running">
                                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_263_199)">
                                              <path d="M16.24 7.76C15.07 6.59 13.54 6 12 6V12L7.76 16.24C10.1 18.58 13.9 18.58 16.25 16.24C18.59 13.9 18.59 10.1 16.24 7.76V7.76ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="#4CA3FF" />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_263_199">
                                                <rect width="24" height="24" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <span className="ml-1 mr-3 flex-grow-1">Running</span>
                                          <span className='text-muted'>{this.state.pipeline_status_count !== undefined && this.state.pipeline_status_count.Running !== undefined ? this.state.pipeline_status_count.Running : 0}</span>
                                        </Form.Label>
                                      </div>
                                    </Dropdown.Item>}
                                    {this.state.pipeline_status_count?.InProgress > 0 && <Dropdown.Item href="#/action-3" disabled={!this.state.pipeline_status_count?.InProgress}>
                                      <div className="custom-control custom-checkbox">
                                        <Form.Control
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="defaulErrorCheck"
                                          id="pipeline-progress"
                                          onChange={this.pipelineFilterSelection}
                                          checked={this.state.selectedItems.includes('pipeline-progress')} />
                                        <Form.Label className="custom-control-label d-flex align-items-center" for="pipeline-progress">
                                          <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="#495FB8"><g><rect fill="none" height="24" width="24" /></g><g><path d="M6,2l0.01,6L10,12l-3.99,4.01L6,22h12v-6l-4-4l4-3.99V2H6z M16,16.5V20H8v-3.5l4-4L16,16.5z" /></g></svg>
                                          <span className="ml-1 mr-3 flex-grow-1">In Progress</span>
                                          <span className='text-muted'>{this.state.pipeline_status_count !== undefined && this.state.pipeline_status_count.InProgress !== undefined ? this.state.pipeline_status_count.InProgress : 0}</span>
                                        </Form.Label>
                                      </div>
                                    </Dropdown.Item>}
                                    {this.state.pipeline_status_count?.Queued > 0 && <Dropdown.Item href="#/action-3" disabled={!this.state.pipeline_status_count?.Queued}>
                                      <div className="custom-control custom-checkbox">
                                        <Form.Control
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="defaulErrorCheck"
                                          id="pipeline-queued"
                                          onChange={this.pipelineFilterSelection}
                                          checked={this.state.selectedItems.includes('pipeline-queued')} />
                                        <Form.Label className="custom-control-label d-flex align-items-center" for="pipeline-queued">
                                          <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#FFA800"><path d="M0 0h24v24H0z" fill="none" /><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z" /></svg>
                                          <span className="ml-1 mr-3 flex-grow-1">Queued</span>
                                          <span className='text-muted'>{this.state.pipeline_status_count !== undefined && this.state.pipeline_status_count.Queued !== undefined ? this.state.pipeline_status_count.Queued : 0}</span>
                                        </Form.Label>
                                      </div>
                                    </Dropdown.Item>}
                                    {this.state.pipeline_status_count?.Scheduled > 0 && <Dropdown.Item href="#/action-3" disabled={!this.state.pipeline_status_count?.Scheduled}>
                                      <div className="custom-control custom-checkbox">
                                        <Form.Control
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="defaulErrorCheck"
                                          id="pipeline-scheduled"
                                          onChange={this.pipelineFilterSelection}
                                          checked={this.state.selectedItems.includes('pipeline-scheduled')} />
                                        <Form.Label className="custom-control-label d-flex align-items-center" for="pipeline-scheduled">
                                          <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="#915EF9"><g><rect fill="none" height="24" width="24" /></g><g><g><g><path d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z" /></g></g></g></svg>
                                          <span className="ml-1 mr-3 flex-grow-1">Scheduled</span>
                                          <span className='text-muted'>{this.state.pipeline_status_count !== undefined && this.state.pipeline_status_count.Scheduled !== undefined ? this.state.pipeline_status_count.Scheduled : 0}</span>
                                        </Form.Label>
                                      </div>
                                    </Dropdown.Item>}
                                    {this.state.pipeline_status_count?.Cancelled > 0 && <Dropdown.Item href="#/action-3" disabled={!this.state.pipeline_status_count?.Cancelled}>
                                      <div className="custom-control custom-checkbox">
                                        <Form.Control
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="defaulErrorCheck"
                                          id="pipeline-cancelled"
                                          onChange={this.pipelineFilterSelection}
                                          checked={this.state.selectedItems.includes('pipeline-cancelled')} />
                                        <Form.Label className="custom-control-label d-flex align-items-center" for="pipeline-cancelled">
                                          <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#F64E60"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
                                          <span className="ml-1 mr-3 flex-grow-1">Cancelled</span>
                                          <span className='text-muted'>{this.state.pipeline_status_count !== undefined && this.state.pipeline_status_count.Cancelled !== undefined ? this.state.pipeline_status_count.Cancelled : 0}</span>
                                        </Form.Label>
                                      </div>
                                    </Dropdown.Item>}
                                    {this.state.pipeline_status_count?.Skipped > 0 && <Dropdown.Item>
                                      <div className="custom-control custom-checkbox">
                                        <Form.Control
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="defaulErrorCheck"
                                          id="pipeline-cancelled"
                                          onChange={this.pipelineFilterSelection}
                                        />
                                        <Form.Label className="custom-control-label d-flex align-items-center" for="pipeline-cancelled">
                                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.4758 12.2096V3.79102H12.6654V12.2096H11.4758ZM3.33203 12.2096V3.79102L9.64585 8.00029L3.33203 12.2096Z" fill="#495FB8" />
                                          </svg>
                                          <span className="ml-1 mr-3 flex-grow-1">Skipped</span>
                                          <span className='text-muted'>{this.state.pipeline_status_count !== undefined && this.state.pipeline_status_count.Skipped !== undefined ? this.state.pipeline_status_count.Skipped : 0}</span>
                                        </Form.Label>
                                      </div>
                                    </Dropdown.Item>}
                                    {this.state.pipeline_status_count?.Restart > 0 && <Dropdown.Item>
                                      <div className="custom-control custom-checkbox">
                                        <Form.Control
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="defaulErrorCheck"
                                          id="pipeline-cancelled"
                                          onChange={this.pipelineFilterSelection}
                                        />
                                        <Form.Label className="custom-control-label d-flex align-items-center" for="pipeline-cancelled">
                                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.2 14.9262C5.69947 14.7313 4.45767 14.0703 3.4746 12.9432C2.49153 11.816 2 10.4955 2 8.98159C2 8.16826 2.16053 7.38906 2.4816 6.64399C2.80267 5.89879 3.2524 5.24413 3.8308 4.67999L4.6862 5.53539C4.19487 5.98366 3.82433 6.50393 3.5746 7.09619C3.32487 7.68846 3.2 8.31693 3.2 8.98159C3.2 10.1549 3.5746 11.1891 4.3238 12.084C5.073 12.9788 6.03173 13.5262 7.2 13.7262V14.9262ZM8.8 14.9416V13.7416C9.95493 13.5077 10.9103 12.948 11.6662 12.0624C12.4221 11.1768 12.8 10.1499 12.8 8.98159C12.8 7.64826 12.3333 6.51493 11.4 5.58159C10.4667 4.64826 9.33333 4.18159 8 4.18159H7.717L8.797 5.26159L7.9538 6.10459L5.4308 3.58159L7.9538 1.05859L8.797 1.90159L7.717 2.98159H8C9.67387 2.98159 11.0923 3.56313 12.2554 4.72619C13.4185 5.88926 14 7.30773 14 8.98159C14 10.4872 13.5072 11.8011 12.5216 12.9232C11.5359 14.0452 10.2953 14.718 8.8 14.9416Z" fill="#FA4616" />
                                          </svg>
                                          <span className="ml-1 mr-3 flex-grow-1">Restart</span>
                                          <span className='text-muted'>{this.state.pipeline_status_count !== undefined && this.state.pipeline_status_count.Restart !== undefined ? this.state.pipeline_status_count.Restart : 0}</span>
                                        </Form.Label>
                                      </div>
                                    </Dropdown.Item>}
                                    {this.state.pipeline_status_count?.none > 0 && <Dropdown.Item>
                                      <div className="custom-control custom-checkbox">
                                        <Form.Control
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="defaulErrorCheck"
                                          id="pipeline-cancelled"
                                          onChange={this.pipelineFilterSelection}
                                        />
                                        <Form.Label className="custom-control-label d-flex align-items-center" for="pipeline-cancelled">
                                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.99993 14.6673C7.07782 14.6673 6.2111 14.4923 5.39975 14.1424C4.58841 13.7925 3.88267 13.3176 3.28256 12.7177C2.68244 12.1178 2.20729 11.4123 1.85712 10.6014C1.50706 9.79036 1.33203 8.92387 1.33203 8.00188C1.33203 7.07977 1.507 6.21305 1.85694 5.4017C2.20689 4.59036 2.6818 3.88463 3.28168 3.28451C3.88156 2.68439 4.587 2.20925 5.398 1.85907C6.20899 1.50901 7.07548 1.33398 7.99747 1.33398C8.91958 1.33398 9.7863 1.50895 10.5976 1.8589C11.409 2.20884 12.1147 2.68375 12.7148 3.28363C13.315 3.88352 13.7901 4.58896 14.1403 5.39995C14.4903 6.21094 14.6654 7.07743 14.6654 7.99942C14.6654 8.92153 14.4904 9.78825 14.1405 10.5996C13.7905 11.4109 13.3156 12.1167 12.7157 12.7168C12.1158 13.3169 11.4104 13.7921 10.5994 14.1422C9.78841 14.4923 8.92191 14.6673 7.99993 14.6673ZM7.33747 11.334H8.65993C9.00881 11.334 9.30747 11.2098 9.55589 10.9614C9.80431 10.7129 9.92852 10.4143 9.92852 10.0654V5.93591C9.92852 5.58703 9.80431 5.28837 9.55589 5.03995C9.30747 4.79153 9.00881 4.66732 8.65993 4.66732H7.33747C6.98858 4.66732 6.68993 4.79153 6.4415 5.03995C6.19308 5.28837 6.06887 5.58703 6.06887 5.93591V10.0654C6.06887 10.4143 6.19308 10.7129 6.4415 10.9614C6.68993 11.2098 6.98858 11.334 7.33747 11.334ZM7.33747 5.71995H8.65993C8.72297 5.71995 8.77472 5.74018 8.81519 5.78065C8.85566 5.82112 8.87589 5.87287 8.87589 5.93591V10.0654C8.87589 10.1284 8.85566 10.1802 8.81519 10.2207C8.77472 10.2611 8.72297 10.2814 8.65993 10.2814H7.33747C7.27443 10.2814 7.22267 10.2611 7.18221 10.2207C7.14174 10.1802 7.1215 10.1284 7.1215 10.0654V5.93591C7.1215 5.87287 7.14174 5.82112 7.18221 5.78065C7.22267 5.74018 7.27443 5.71995 7.33747 5.71995Z" fill="#6C757D" />
                                          </svg>
                                          <span className="ml-1 mr-3 flex-grow-1">None</span>
                                          <span className='text-muted'>{this.state.pipeline_status_count !== undefined && this.state.pipeline_status_count.None !== undefined ? this.state.pipeline_status_count.None : 0}</span>
                                        </Form.Label>
                                      </div>
                                    </Dropdown.Item>}
                                    {this.state.pipeline_status_count?.stage_failure_run_success > 0 && <Dropdown.Item href="#/action-3" disabled={!this.state.pipeline_status_count?.stage_failure_run_success}>
                                      <div className="custom-control custom-checkbox">
                                        <Form.Control
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="defaulErrorCheck"
                                          id="pipeline-stage_failure_run_success"
                                          onChange={this.pipelineFilterSelection}
                                          checked={this.state.selectedItems.includes('pipeline-stage_failure_run_success')}

                                        />
                                        <Form.Label className="custom-control-label d-flex align-items-center" for="pipeline-stage_failure_run_success">
                                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.6654 6.00065C8.08937 6.00065 5.9987 8.09132 5.9987 10.6673C5.9987 13.2433 8.08937 15.334 10.6654 15.334C13.2414 15.334 15.332 13.2433 15.332 10.6673C15.332 8.09132 13.2414 6.00065 10.6654 6.00065ZM9.4007 12.6693L7.72536 10.994C7.54337 10.812 7.54337 10.518 7.72536 10.336C7.90736 10.154 8.20136 10.154 8.38336 10.336L9.73203 11.68L12.9427 8.46932C13.1247 8.28732 13.4187 8.28732 13.6007 8.46932C13.7827 8.65132 13.7827 8.94532 13.6007 9.12732L10.0587 12.6693C9.88136 12.8513 9.5827 12.8513 9.4007 12.6693Z" fill="#50CD89" />
                                            <path d="M4.66536 6.33398C4.75981 6.33398 4.83898 6.30204 4.90286 6.23815C4.96675 6.17426 4.9987 6.0951 4.9987 6.00065C4.9987 5.90621 4.96675 5.82704 4.90286 5.76315C4.83898 5.69926 4.75981 5.66732 4.66536 5.66732C4.57092 5.66732 4.49175 5.69926 4.42786 5.76315C4.36398 5.82704 4.33203 5.90621 4.33203 6.00065C4.33203 6.0951 4.36398 6.17426 4.42786 6.23815C4.49175 6.30204 4.57092 6.33398 4.66536 6.33398ZM4.33203 5.00065H4.9987V3.00065H4.33203V5.00065ZM4.66536 8.00065C4.20425 8.00065 3.77092 7.91315 3.36536 7.73815C2.95981 7.56315 2.60703 7.32565 2.30703 7.02565C2.00703 6.72565 1.76953 6.37287 1.59453 5.96732C1.41953 5.56176 1.33203 5.12843 1.33203 4.66732C1.33203 4.20621 1.41953 3.77287 1.59453 3.36732C1.76953 2.96176 2.00703 2.60898 2.30703 2.30898C2.60703 2.00898 2.95981 1.77148 3.36536 1.59648C3.77092 1.42148 4.20425 1.33398 4.66536 1.33398C5.12648 1.33398 5.55981 1.42148 5.96536 1.59648C6.37092 1.77148 6.7237 2.00898 7.0237 2.30898C7.3237 2.60898 7.5612 2.96176 7.7362 3.36732C7.9112 3.77287 7.9987 4.20621 7.9987 4.66732C7.9987 5.12843 7.9112 5.56176 7.7362 5.96732C7.5612 6.37287 7.3237 6.72565 7.0237 7.02565C6.7237 7.32565 6.37092 7.56315 5.96536 7.73815C5.55981 7.91315 5.12648 8.00065 4.66536 8.00065ZM4.66536 7.33398C5.40981 7.33398 6.04036 7.07565 6.55703 6.55898C7.0737 6.04232 7.33203 5.41176 7.33203 4.66732C7.33203 3.92287 7.0737 3.29232 6.55703 2.77565C6.04036 2.25898 5.40981 2.00065 4.66536 2.00065C3.92092 2.00065 3.29036 2.25898 2.7737 2.77565C2.25703 3.29232 1.9987 3.92287 1.9987 4.66732C1.9987 5.41176 2.25703 6.04232 2.7737 6.55898C3.29036 7.07565 3.92092 7.33398 4.66536 7.33398Z" fill="#F04438" />
                                          </svg>
                                          <span className="ml-1 mr-3 flex-grow-1">Stage Failure Run Success</span>
                                          <span className='text-muted'>{this.state.pipeline_status_count !== undefined && this.state.pipeline_status_count.stage_failure_run_success !== undefined ? this.state.pipeline_status_count.stage_failure_run_success : 0}</span>
                                        </Form.Label>
                                      </div>
                                    </Dropdown.Item>}
                                    <div class="py-2">
                                      {this.state.selectedItems.length === 0 && <span class="error-text mb-1 mt-0 text-center d-block">Please select at least one status</span>}
                                      {/* {this.getSelectedStatusJobCount() === 0 && this.state.selectedItems.length !== 0 &&  <span class="error-text mb-1 mt-0 text-center d-block">Please select a valid section</span>} */}
                                      <button className='btn btn-dark btn-block' onClick={this.handleFilterDropdownClose} disabled={this.getSelectedStatusJobCount() === 0}>Show {this.getSelectedStatusJobCount()} Jobs</button>
                                    </div>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>}
                        </div>
                        <div className="qd-toolbar-col d-none">
                          <RcTooltip
                            placement="top"
                            overlay={
                              <span>Fullscreen mode</span>
                            }
                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                          >
                            <div className="qd-toolbar-btn">
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 20V15.577H5V19H8.423V20H4ZM15.5962 20V19H19.0193V15.577H20.0193V20H15.5962ZM4 8.423V4H8.423V5H5V8.423H4ZM19.0193 8.423V5H15.5962V4H20.0193V8.423H19.0193Z" fill="#484848" />
                              </svg>
                            </div>
                          </RcTooltip>
                        </div>
                        <div className="qd-toolbar-col d-none">
                          <div className="qd-toolbar_dropdown-wrap" id="topmenucamera1">
                            <RcTooltip
                              placement="top"
                              overlay={
                                <span>Take s snapshot</span>
                              }
                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                              <div className="qd-toolbar-btn">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12 16.7308C13.0448 16.7308 13.9278 16.3702 14.649 15.649C15.3702 14.9278 15.7308 14.0448 15.7308 13C15.7308 11.9552 15.3702 11.0722 14.649 10.351C13.9278 9.62983 13.0448 9.26925 12 9.26925C10.9552 9.26925 10.0722 9.62983 9.351 10.351C8.62983 11.0722 8.26925 11.9552 8.26925 13C8.26925 14.0448 8.62983 14.9278 9.351 15.649C10.0722 16.3702 10.9552 16.7308 12 16.7308ZM12 15.7308C11.223 15.7308 10.5737 15.4698 10.052 14.948C9.53017 14.4263 9.26925 13.777 9.26925 13C9.26925 12.223 9.53017 11.5737 10.052 11.052C10.5737 10.5302 11.223 10.2693 12 10.2693C12.777 10.2693 13.4263 10.5302 13.948 11.052C14.4698 11.5737 14.7308 12.223 14.7308 13C14.7308 13.777 14.4698 14.4263 13.948 14.948C13.4263 15.4698 12.777 15.7308 12 15.7308ZM4.6155 20C4.15517 20 3.77083 19.8458 3.4625 19.5375C3.15417 19.2292 3 18.8448 3 18.3845V7.6155C3 7.15517 3.15417 6.77083 3.4625 6.4625C3.77083 6.15417 4.15517 6 4.6155 6H7.573L9.423 4H14.577L16.427 6H19.3845C19.8448 6 20.2292 6.15417 20.5375 6.4625C20.8458 6.77083 21 7.15517 21 7.6155V18.3845C21 18.8448 20.8458 19.2292 20.5375 19.5375C20.2292 19.8458 19.8448 20 19.3845 20H4.6155ZM4.6155 19H19.3845C19.564 19 19.7115 18.9423 19.827 18.827C19.9423 18.7115 20 18.564 20 18.3845V7.6155C20 7.436 19.9423 7.2885 19.827 7.173C19.7115 7.05767 19.564 7 19.3845 7H15.9885L14.1443 5H9.85575L8.0115 7H4.6155C4.436 7 4.2885 7.05767 4.173 7.173C4.05767 7.2885 4 7.436 4 7.6155V18.3845C4 18.564 4.05767 18.7115 4.173 18.827C4.2885 18.9423 4.436 19 4.6155 19Z" fill="#484848" />
                                </svg>
                              </div>
                            </RcTooltip>

                          </div>
                        </div>

                      </div>
                      <div className="toolbar_fade-left"></div>
                      <div className="toolbar_fade-right"></div>
                    </div>
                  </div>
                  <div className={parseInt(this.state.timefilter.replace("hr", "")) === 12 || parseInt(this.state.timefilter.replace("hr", "")) === 24 ? "rt-pipeline-tbl" : "rt-pipeline-tbl tbl-time-range--selected"
                  }>{/* Add Class "tbl-time-range--selected" for 6hr and 1hr */}
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            <div className="tbl-tree">
                              <div class="tbl-tree__header">
                                <div className="qd_tree-view-top px-0 w-100">
                                  <div className="title">
                                    <div className="title-left">
                                      <label>Jobs</label>
                                    </div>
                                  </div>
                                  <div className="qd-search-bar has-btn-close qd-search-bar--bg-gray">
                                    <div className="input-group">
                                      <div className="input-group-prepend">
                                        <button id="button-addon4" type="button" className="btn">
                                          <svg className='d-block' width="20" height="20" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.889 12.5237L10.35 9.98474C10.1222 9.75694 9.75283 9.75694 9.52502 9.98474C9.29722 10.2126 9.29722 10.5819 9.52502 10.8097L12.064 13.3487C12.2918 13.5765 12.6612 13.5765 12.889 13.3487C13.1168 13.1209 13.1168 12.7515 12.889 12.5237Z" fill="#99A1B7" />
                                            <path d="M6.41667 11.8333C3.82408 11.8333 1.75 9.75923 1.75 7.16667C1.75 4.57408 3.82408 2.5 6.41667 2.5C9.00923 2.5 11.0833 4.57408 11.0833 7.16667C11.0833 9.75923 9.00923 11.8333 6.41667 11.8333ZM6.41667 3.66667C4.39444 3.66667 2.91667 5.14444 2.91667 7.16667C2.91667 9.18891 4.39444 10.6667 6.41667 10.6667C8.43891 10.6667 9.91667 9.18891 9.91667 7.16667C9.91667 5.14444 8.43891 3.66667 6.41667 3.66667Z" fill="#99A1B7" />
                                          </svg>
                                        </button>
                                      </div>
                                      <input type="search" placeholder="Search Connector/Jobs" className="form-control" value={this.state.searchText} onChange={this.handleSearchJob} />
                                    </div>
                                    {this.state.searchText !== "" && <button className="btn btn-clear" title="clear"><i className="icon-close" onClick={this.handleClearSearch}></i></button>}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </th>
                          <th>
                            <div className={`tbl-time-range ${this.state.initialendDate !== this.state.endDate ? "no-active-timeline" : ""}`}>
                              <div className="tbl-time-range__head">
                                <label>Pipeline Run Status - {this.state.endDate.format(PIPELINE_DISPLAY_DATE_FORMAT)} (UTC+00:00)</label>
                                <ul class="tbl-time-range__list">
                                  <li><span className='timeslots' id="chart_time_1">05 PM</span></li>
                                  <li><span className='timeslots' id="chart_time_2">06 PM</span></li>
                                  <li><span className='timeslots' id="chart_time_3">07 PM</span></li>
                                  <li><span className='timeslots' id="chart_time_4">08 PM</span></li>
                                  <li><span className='timeslots' id="chart_time_5">09 PM</span></li>
                                  <li><span className='timeslots' id="chart_time_6">10 PM</span></li>
                                  <li><span className='timeslots' id="chart_time_7">11 PM</span></li>
                                  <li><span className='timeslots' id="chart_time_8">12 PM</span></li>
                                  <li><span className='timeslots' id="chart_time_9">01 AM</span></li>
                                  <li><span className='timeslots' id="chart_time_10">02 AM</span></li>
                                  <li><span className='timeslots' id="chart_time_11">03 AM</span></li>
                                  <li><span className='timeslots' id="chart_time_12">04 AM</span></li>
                                  <li><span className='timeslots' id="chart_time_13">05 AM</span></li>
                                </ul>
                              </div>
                            </div>
                          </th>
                          <th>Last Run</th>
                          <th>Last Run <br />Duration</th>
                          <th>Avg. <br />Duration</th>
                          <th>Next <br />Scheduled <br />Run</th>
                          <th>Runs Count</th>
                          <th>Last Run Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody id="metaDataBody">
                        {
                          !this.state.fetchingJobsloader &&
                          Object.keys(this.state.piplineInfo?.pipelines || {}).length === 0 && this.state.isCheackedActiveRuns !== true &&
                          (
                            <tr className='tbl-tree__parent'>
                              <td>
                                <div className="tbl-tree__node">
                                  <span className="text-light-gray">{this.state.no_Runs === true ? "No Runs Identifier." : "No result found."}</span>
                                </div>
                              </td>
                              <td>
                                <div class="tbl-time-range__cols d-none">
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                  <div class="tbl-time-range__col d-none"></div>
                                </div>
                                {
                                  this.state.initialendDate === this.state.endDate
                                  &&
                                  //Object.keys(this.state.piplineInfo?.pipelines || {}).length > 0 &&
                                  <div className="tbl-time-range__now d-none"></div>
                                }

                              </td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                          )
                        }
                        {this.state.fetchingJobsloader && this.state.searchText && (
                          <tr>
                            <td colSpan="10" >
                              <div className="tbl-tree__node">
                                <Image width="12px" src={"icon_preloader"} alt="loader" className="ml-2" />
                                <span className="text-light-gray">Fetching Connectors...</span>
                              </div>
                            </td>
                          </tr>
                        )}
                        {this.state.fetchingJobsloader && this.state.searchText && (
                          <tr class="tbl-tree__nested">
                            <td colSpan="10" >
                              <div className="tbl-tree__node">
                                <Image width="12px" src={"icon_preloader"} alt="loader" className="ml-2" />
                                <span className="text-light-gray">Fetching Jobs...</span>
                              </div>
                            </td>
                          </tr>)}
                        {this.state.searchText && !this.state.fetchingJobsloader && this.state.totalMatchedPipelines !== 0 && Object.keys(this.state.piplineInfo?.pipelines || {}).length !== 0 && (
                          <tr className='tbl-tree__parent'>
                            <td>
                              <div className="tbl-tree__node">
                                <span>{this.state.totalMatchedPipelines} matches in {this.state.totalMatchedIntegrations} Pipeline connectors</span>
                              </div>
                            </td>
                            <td>
                              {/* <div className={`tbl-time-range ${(this.state.initialendDate !== this.state.endDate) || this.state.searchText  ? "no-active-timeline" : ""}`}> */}
                              {/* <div class="tbl-time-range__now"> */}
                              <div class="tbl-time-range__cols">
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                                <div class="tbl-time-range__col"></div>
                              </div>
                              {/* <div class="tbl-time-range__col"></div> */}
                              {/* {(this.state.initialendDate === this.state.endDate) ?
                                  <div className="tbl-time-range__now"></div> : ""} */}
                              {/* </div> */}
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        )}
                        {

                          !this.state.fetchingJobsloader &&
                          Integrations &&
                          Integrations.length > 0 &&
                          Integrations.map((pipeline, index) => (

                            <>
                              {!this.state.fetchingJobsloader && <tr className={`tbl-tree__parent ${!this.state.toggledPipelineSource[pipeline.p_integration_id] ? "tbl-tree--expanded" : ""}`}>
                                <td>
                                  <div class="tbl-tree__node">
                                    <div class="tbl-tree__node-label">
                                      <i class="toggle-icon-wrap" onClick={() => this.handleToggle(pipeline.p_integration_id)}>
                                        <span class="toggle-icon"></span>
                                      </i>
                                      <i class="tbl-tree__node-icon">
                                        <Image src={this.getConnectorIconSrc(pipeline.integration_type)}
                                          alt={pipeline.integration_type || "default"}
                                        /></i>
                                      <div class="tbl-tree__node-text"><span class="portlet-table-value">{this.state.searchText && this.state.highlightText ? this.highlightText(pipeline.label, this.state.searchText) : pipeline.label}</span></div>
                                      <div class="tree-runs-count">
                                        <div class="tree-runs-count__active">
                                          {pipeline?.count_details?.active_pipelines}
                                        </div>
                                        <div class="tree-runs-count__total">
                                          {pipeline?.count_details?.total_pipelines}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tbl-tree__node-action">
                                    </div>
                                  </div>
                                  {(this.state.isCheackedActiveRuns === true) &&
                                    // Check if pipelines are empty or filtered pipelines are empty
                                    (!this.state.piplineInfo?.pipelines?.[pipeline.p_integration_id] || this.state.piplineInfo.pipelines[pipeline.p_integration_id].length === 0) &&
                                    <div className='tbl-tree__no-runs'>
                                      <i>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M8.16992 1.83398C8.36019 1.83783 8.54695 1.88031 8.71973 1.95703L8.8877 2.04492C9.04976 2.14449 9.18965 2.2752 9.2998 2.42871L9.40039 2.58984L14.4463 12.0713C14.5329 12.2341 14.5876 12.4114 14.6064 12.5938L14.6133 12.7773C14.6069 13.0233 14.5368 13.2637 14.4102 13.4746C14.2834 13.6856 14.1039 13.8602 13.8896 13.9814C13.6755 14.1027 13.4336 14.167 13.1875 14.167H2.5918L2.40527 14.1553C2.21972 14.1307 2.03995 14.07 1.87695 13.9756C1.71406 13.8812 1.5725 13.7551 1.45898 13.6064L1.35547 13.4502C1.26182 13.2869 1.20145 13.1074 1.17773 12.9219L1.16602 12.7354C1.16682 12.547 1.20486 12.361 1.27734 12.1885L1.36133 12.0215L6.91016 2.54004C7.00629 2.37582 7.13394 2.23257 7.28516 2.11914L7.44434 2.01562C7.61034 1.9227 7.79269 1.86405 7.98047 1.84277L8.16992 1.83398Z" fill="#6C757D" stroke="#6C757D" />
                                          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.78784 5.41992L8.65376 10.1677H7.32855L7.19968 5.41992H8.78784ZM8.89689 11.8122C8.91031 11.9937 8.86874 12.175 8.7776 12.3326C8.68647 12.4901 8.54999 12.6165 8.38596 12.6953C8.22193 12.7742 8.03796 12.8018 7.85802 12.7745C7.67808 12.7473 7.51052 12.6665 7.37718 12.5426C7.24385 12.4187 7.15092 12.2576 7.11051 12.0801C7.07009 11.9027 7.08407 11.7172 7.15062 11.5478C7.21717 11.3784 7.33321 11.233 7.4836 11.1305C7.634 11.028 7.81178 10.9732 7.99377 10.9733C8.11036 10.9589 8.22869 10.9702 8.34045 11.0064C8.45222 11.0426 8.55472 11.1028 8.64076 11.1827C8.72681 11.2627 8.79432 11.3606 8.83857 11.4694C8.88281 11.5782 8.90271 11.6949 8.89689 11.8122Z" fill="white" />
                                        </svg>
                                      </i>
                                      <span>No Active runs</span>
                                    </div>
                                  }
                                </td>
                                <td>
                                  <div class="tbl-time-range__content">
                                    <div class="tbl-time-range__cols">
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                    </div>
                                    {/* <div class="tbl-time-range__col"></div> */}
                                    {this.state.initialendDate === this.state.endDate ?
                                      <div className="tbl-time-range__now">
                                      </div> : ""}
                                  </div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>}
                              <tr class="tbl-tree__nested">
                                <td colspan="9" className="p-0 border-0">
                                  <table className="table m-0">
                                    <tbody>
                                      {(this.state.selectedItems !== undefined && this.state.selectedItems.length > 0) &&
                                        // Check if pipelines are empty or filtered pipelines are empty
                                        (!this.state.piplineInfo?.pipelines?.[pipeline.p_integration_id] || this.state.piplineInfo.pipelines[pipeline.p_integration_id].length === 0) ?
                                        ""
                                        : !this.state.toggledPipelineSource[pipeline.p_integration_id] && (

                                          piplineInfo?.pipelines?.[pipeline.p_integration_id]?.slice(0, this.state.visiblePipelineCount).map((filteredPipeline, subIndex) => (
                                            <>
                                              {!this.state.fetchingJobsloader &&
                                                <tr className={`tbl-tree__parent ${this.state.expandedPipelineRows[filteredPipeline.value] ? "tbl-tree--expanded" : ""} ${this.state.selectedJobId === filteredPipeline.value ? "--is-active" : !this.state.selectedJobId && preSelectedDataset?.value === filteredPipeline.value ? "--is-active" : ""}`}
                                                  onClick={() => this.toggleForPipeline(filteredPipeline.is_parent === true && filteredPipeline.value)}>
                                                  <td>
                                                    <div class="tbl-tree__node">
                                                      {/* <span class={`latest-run-indicator${(this.state.newPipelineValues?.includes(filteredPipeline.value) || this.state.updatedPipelineValues?.includes(filteredPipeline.value)) ? ' latest-run-indicator--success' : ''}`}></span> */}
                                                      <div class="tbl-tree__node-label">
                                                        {(filteredPipeline.is_parent === false || filteredPipeline.no_runs_found === true) ? <RcTooltip placement="top"
                                                          overlay={
                                                            <span>No Dependent Jobs</span>
                                                          }
                                                          arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                        >
                                                          <i className="toggle-icon-wrap">
                                                            <span class="toggle-icon"></span>

                                                            {/* <span className="spinner-border spinner-border-xs spinner-border-gray"></span> */}
                                                          </i>
                                                        </RcTooltip> : <i className="toggle-icon-wrap">
                                                          <span class="toggle-icon" onClick={(e) => {
                                                            e.stopPropagation(); // Prevents row click event from firing
                                                            this.toggleForPipeline(filteredPipeline.is_parent === true && filteredPipeline.value);
                                                          }}></span>
                                                        </i>}

                                                        <i class="tbl-tree__node-icon">
                                                          <Image
                                                            src={this.getConnectorIconSrc(
                                                              filteredPipeline.integration_type ||
                                                              filteredPipeline.pipeline_type ||
                                                              pipeline.integration_type ||
                                                              this.state.pipelineIconMapping?.[pipeline.p_integration_id]
                                                            )}
                                                            alt={filteredPipeline.integration_type || pipeline.integration_type || "default"}
                                                            width="14"
                                                            height="14"
                                                          />
                                                        </i>
                                                        <div className="tbl-tree__node-text !tw-pr-0 !tw-flex !tw-overflow-visible !tw-items-center tw-w-full tw-whitespace-nowrap tw-flex-nowrap !tw-flex-row" onClick={() => {
                                                          if (filteredPipeline.no_runs_found === true) {
                                                            this.showToast("error", "No runs found");
                                                            return;
                                                          }
                                                          if (this.state.isInFullScreenMode) {
                                                            this.setFullScreen(pipeline.p_integration_id, filteredPipeline.value, pipeline.integration_type, pipeline.label, filteredPipeline.label);
                                                          }
                                                        }}
                                                          style={{ cursor: 'pointer' }}
                                                        >

                                              <div className="tw-flex tw-items-center tw-min-w-0">
                                                <RcTooltip
                                                  placement="top"
                                                  overlay={<span>{filteredPipeline.label}</span>}
                                                  arrowContent={<div className="rc-tooltip-arrow-inner" />}
                                                >
                                                  <span className="portlet-table-value tw-truncate tw-min-w-0 tw-flex-1">
                                                    {this.state.searchText && this.state.highlightText
                                                      ? this.highlightText(
                                                          filteredPipeline.label,
                                                          this.state.searchText
                                                        )
                                                      : filteredPipeline.label}
                                                  </span>
                                                </RcTooltip>

                                                {filteredPipeline.pipeline_status === "suspended" && (
                                                  <span className="qd-badge-unmapped tw-inline-flex tw-items-center tw-px-1.5 tw-text-[10px] tw-font-medium tw-text-[#535862] dark:tw-text-[#B2B5BE] tw-bg-[#F4F4F5] dark:tw-bg-[#27272A] tw-border tw-border-solid tw-border-[#E4E4E7] dark:tw-border-[#3F3F46] tw-rounded tw-shrink-0 tw-whitespace-nowrap tw-ml-1.5">
                                                    Suspended
                                                  </span>
                                                )}
                                              </div>
                                                        </div>
                                                      </div>
                                                      <div className="tbl-tree__node-action">
      
                                                        <Dropdown alignRight className="wishlist-dropdown d-none">
                                                          <Dropdown.Toggle variant="" id="dropdown-basic" className="action-btn dropdown-caret-hide">
                                                            <i className="action-icon"><FontAwesomeIcon icon={faEllipsisV} /></i>
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu>
                                                            <Dropdown.Item>
                                                              <i></i>Jobs Info
                                                            </Dropdown.Item>
                                                            <Dropdown.Item>
                                                              <i></i>All Runs
                                                            </Dropdown.Item>
                                                            <Dropdown.Item>
                                                              <i></i>Failed Runs
                                                            </Dropdown.Item>
                                                            <Dropdown.Item>
                                                              <i></i>Lineage
                                                            </Dropdown.Item>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <div class="tbl-time-range__content">
                                                      <div class="tbl-time-range__cols">
                                                        <div class="tbl-time-range__col">
                                                          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M8 13.5H12V11.5H8V8.5L4 12.5L8 16.5V13.5ZM15 13.5C15.55 13.5 16 13.05 16 12.5C16 11.95 15.55 11.5 15 11.5C14.45 11.5 14 11.95 14 12.5C14 13.05 14.45 13.5 15 13.5Z" fill="#B5B8C2" />
                                                            <path d="M18 4.5H20C20.5523 4.5 21 4.94772 21 5.5V19.5C21 20.0523 20.5523 20.5 20 20.5H18V4.5Z" fill="#B5B8C2" />
                                                          </svg>
                                                        </div>



                                                        {(() => {

                                                          /*
                                                           Gannt Chart - Fixed time slot calculation
                                                          */

                                                          const rawFilter = this.state.timefilter.replace("hr", "");
                                                          const slotCount = ["12", "24"].includes(rawFilter) ? 13 : 7;

                                                          return Array.from({ length: slotCount }).map((_, index) => {
                                                            const { slotStart, slotEnd } = this.getGanttSlotBounds(index, slotCount);

                                                            if (!filteredPipeline?.runs_list) {
                                                              return (
                                                                <div key={index} className="tbl-time-range__col" style={{ position: 'relative' }}>
                                                                  <span />
                                                                </div>
                                                              );
                                                            }

                                                            const normalizedRuns = this.normalizeRunsList(filteredPipeline.runs_list);
                                                            const runsInSlot = this.getRunsInTimeSlot(normalizedRuns, slotStart, slotEnd);
                                                            const statusGroups = this.getRunStatusGroups(runsInSlot);

                                                            if (!statusGroups.length) {
                                                              return (
                                                                <div key={index} className="tbl-time-range__col" style={{ position: 'relative' }}>
                                                                  <span />
                                                                </div>
                                                              );
                                                            }

                                                            return (
                                                              !this.state.isInFullScreenMode && (
                                                                <div key={index} className="tbl-time-range__col" style={{ position: 'relative', overflow: 'hidden' }}>
                                                                  {(() => {
                                                                    const allSlotRuns = statusGroups.reduce((acc, group) => acc.concat(group.runs), []);
                                                                    return (
                                                                      <OverlayTrigger
                                                                        trigger="click"
                                                                        rootClose
                                                                        placement="right"
                                                                        overlay={
                                                                          <Popover className="pipeline-popover">
                                                                            <Popover.Title as="h3" id="pipeline_popover_title"></Popover.Title>
                                                                            <Popover.Content>
                                                                              <div id="pipeline_popover_content"></div>
                                                                            </Popover.Content>
                                                                          </Popover>
                                                                        }
                                                                        onEntered={() => this.getGanttPopover(allSlotRuns, pipeline, filteredPipeline)}
                                                                      >
                                                                        <div
                                                                          className={`pipeline-run-cell${statusGroups.length > 1 ? ' pipeline-run-cell--multi' : ''}`}
                                                                          style={{
                                                                            position: 'absolute',
                                                                            left: '50%',
                                                                            top: '50%',
                                                                            transform: 'translate(-50%, -50%)',
                                                                            cursor: 'pointer',
                                                                            pointerEvents: 'auto',
                                                                          }}
                                                                        >
                                                                          {statusGroups.map((group) => (
                                                                            <span
                                                                              key={group.status}
                                                                              className={`pipeline-run-badge pipeline-run-badge--${group.status}`}
                                                                            >
                                                                              {group.runs.length}
                                                                            </span>
                                                                          ))}
                                                                        </div>
                                                                      </OverlayTrigger>
                                                                    );
                                                                  })()}
                                                                </div>
                                                              )
                                                            );
                                                          });
                                                        })()}

                                                        <div class="tbl-time-range__col">
                                                          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M16 13.5H12V11.5H16V8.5L20 12.5L16 16.5V13.5ZM9 13.5C8.45 13.5 8 13.05 8 12.5C8 11.95 8.45 11.5 9 11.5C9.55 11.5 10 11.95 10 12.5C10 13.05 9.55 13.5 9 13.5Z" fill="#B5B8C2" />
                                                            <path d="M6 4.5H4C3.44772 4.5 3 4.94772 3 5.5V19.5C3 20.0523 3.44772 20.5 4 20.5H6V4.5Z" fill="#B5B8C2" />
                                                          </svg>
                                                        </div>
                                                      </div>
                                                      {
                                                        this.state.initialendDate === this.state.endDate ?
                                                          <div className="tbl-time-range__now"></div> : ""
                                                      }
                                                    </div>

                                                  </td>
                                                  <td>{filteredPipeline.job_runs_summary !== undefined ? this.formatUTCDate(filteredPipeline.job_runs_summary.last_run) : "-"}</td>
                                                  <td>
                                                    {filteredPipeline.job_runs_summary !== undefined ? this.millisecondToMinutesAndSeconds(filteredPipeline.job_runs_summary.last_run_duration) : "-"}
                                                  </td>
                                                  <td>
                                                    {filteredPipeline.job_runs_summary !== undefined ? this.millisecondToMinutesAndSeconds(filteredPipeline.job_runs_summary.avg_duration) : "-"}
                                                  </td>
                                                  <td>{filteredPipeline.job_runs_summary !== undefined ? this.formatUTCDate(filteredPipeline.job_runs_summary.next_schedule_run) : "-"}</td>
                                                  <td>
                                                    <div class="tbl-job-attempts">
                                                      <div class="badge success-attempt-badge">
                                                        <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor">
                                                          <path d="M0 0h24v24H0z" fill="none"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path>
                                                        </svg>
                                                        <span class="text-dark">
                                                          {(() => {
                                                            const counts = this.getAttemptCountsFromPipeline(filteredPipeline);
                                                            return counts.success;
                                                          })()}
                                                        </span>
                                                      </div>
                                                      <div class="badge failed-attempt-badge ml-2">
                                                        <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor">
                                                          <path d="M0 0h24v24H0z" fill="none"></path><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path>
                                                        </svg>
                                                        <span class="text-dark">
                                                          {(() => {
                                                            const counts = this.getAttemptCountsFromPipeline(filteredPipeline);
                                                            return counts.failed;
                                                          })()}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td>
                                                    {(() => {
                                                      const status = filteredPipeline?.job_runs_summary?.last_run_status;
                                                      if (!status) return "-";

                                                      const run_status = status.toLowerCase();

                                                      const statusMap = {
                                                        succeeded: (
                                                          <div class="d-flex align-items-center text-success">
                                                            <svg xmlns="http://www.w3.org/2000/svg" height="16px" class="mr-1" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>
                                                            Done
                                                          </div>
                                                        ),
                                                        failed: (
                                                          <div class="d-flex align-items-center text-danger"><svg xmlns="http://www.w3.org/2000/svg" height="16px" class="mr-1" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path></svg>Failed</div>

                                                        ),
                                                        running: (
                                                          <div className="d-flex align-items-center text-info">
                                                            <svg class="mr-1" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <g clip-path="url(#clip0_263_199)">
                                                                <path d="M16.24 7.76C15.07 6.59 13.54 6 12 6V12L7.76 16.24C10.1 18.58 13.9 18.58 16.25 16.24C18.59 13.9 18.59 10.1 16.24 7.76V7.76ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="#4CA3FF" />
                                                              </g>
                                                              <defs>
                                                                <clipPath id="clip0_263_199">
                                                                  <rect width="24" height="24" fill="white" />
                                                                </clipPath>
                                                              </defs>
                                                            </svg>
                                                            &nbsp;Running
                                                          </div>
                                                        ),
                                                        inprogress: (
                                                          <div className='d-flex align-items-center text-primary'>
                                                            <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="#495FB8"><g><rect fill="none" height="24" width="24" /></g><g><path d="M6,2l0.01,6L10,12l-3.99,4.01L6,22h12v-6l-4-4l4-3.99V2H6z M16,16.5V20H8v-3.5l4-4L16,16.5z" /></g></svg>
                                                            In Progress
                                                          </div>
                                                        ),
                                                        queued: (
                                                          <div className='d-flex align-items-center text-primary'>
                                                            <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#FFA800"><path d="M0 0h24v24H0z" fill="none" /><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z" /></svg>
                                                            Queued
                                                          </div>
                                                        ),
                                                        cancelled: (
                                                          <div className='d-flex align-items-center text-primary'>
                                                            <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#F64E60"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
                                                            Cancelled
                                                          </div>
                                                        ),
                                                        skipped: (
                                                          <div className='d-flex align-items-center text-primary'>
                                                            <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <path d="M11.4758 12.2096V3.79102H12.6654V12.2096H11.4758ZM3.33203 12.2096V3.79102L9.64585 8.00029L3.33203 12.2096Z" fill="#495FB8" />
                                                            </svg>
                                                            Skipped
                                                          </div>
                                                        ),
                                                        restart: (
                                                          <div class="mr-1" className='d-flex align-items-center text-primary'>
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <path d="M7.2 14.9262C5.69947 14.7313 4.45767 14.0703 3.4746 12.9432C2.49153 11.816 2 10.4955 2 8.98159C2 8.16826 2.16053 7.38906 2.4816 6.64399C2.80267 5.89879 3.2524 5.24413 3.8308 4.67999L4.6862 5.53539C4.19487 5.98366 3.82433 6.50393 3.5746 7.09619C3.32487 7.68846 3.2 8.31693 3.2 8.98159C3.2 10.1549 3.5746 11.1891 4.3238 12.084C5.073 12.9788 6.03173 13.5262 7.2 13.7262V14.9262ZM8.8 14.9416V13.7416C9.95493 13.5077 10.9103 12.948 11.6662 12.0624C12.4221 11.1768 12.8 10.1499 12.8 8.98159C12.8 7.64826 12.3333 6.51493 11.4 5.58159C10.4667 4.64826 9.33333 4.18159 8 4.18159H7.717L8.797 5.26159L7.9538 6.10459L5.4308 3.58159L7.9538 1.05859L8.797 1.90159L7.717 2.98159H8C9.67387 2.98159 11.0923 3.56313 12.2554 4.72619C13.4185 5.88926 14 7.30773 14 8.98159C14 10.4872 13.5072 11.8011 12.5216 12.9232C11.5359 14.0452 10.2953 14.718 8.8 14.9416Z" fill="#FA4616" />
                                                            </svg>
                                                            Restart
                                                          </div>
                                                        ),
                                                        none: (
                                                          <div className='d-flex align-items-center text-primary'>
                                                            <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <path d="M7.99993 14.6673C7.07782 14.6673 6.2111 14.4923 5.39975 14.1424C4.58841 13.7925 3.88267 13.3176 3.28256 12.7177C2.68244 12.1178 2.20729 11.4123 1.85712 10.6014C1.50706 9.79036 1.33203 8.92387 1.33203 8.00188C1.33203 7.07977 1.507 6.21305 1.85694 5.4017C2.20689 4.59036 2.6818 3.88463 3.28168 3.28451C3.88156 2.68439 4.587 2.20925 5.398 1.85907C6.20899 1.50901 7.07548 1.33398 7.99747 1.33398C8.91958 1.33398 9.7863 1.50895 10.5976 1.8589C11.409 2.20884 12.1147 2.68375 12.7148 3.28363C13.315 3.88352 13.7901 4.58896 14.1403 5.39995C14.4903 6.21094 14.6654 7.07743 14.6654 7.99942C14.6654 8.92153 14.4904 9.78825 14.1405 10.5996C13.7905 11.4109 13.3156 12.1167 12.7157 12.7168C12.1158 13.3169 11.4104 13.7921 10.5994 14.1422C9.78841 14.4923 8.92191 14.6673 7.99993 14.6673ZM7.33747 11.334H8.65993C9.00881 11.334 9.30747 11.2098 9.55589 10.9614C9.80431 10.7129 9.92852 10.4143 9.92852 10.0654V5.93591C9.92852 5.58703 9.80431 5.28837 9.55589 5.03995C9.30747 4.79153 9.00881 4.66732 8.65993 4.66732H7.33747C6.98858 4.66732 6.68993 4.79153 6.4415 5.03995C6.19308 5.28837 6.06887 5.58703 6.06887 5.93591V10.0654C6.06887 10.4143 6.19308 10.7129 6.4415 10.9614C6.68993 11.2098 6.98858 11.334 7.33747 11.334ZM7.33747 5.71995H8.65993C8.72297 5.71995 8.77472 5.74018 8.81519 5.78065C8.85566 5.82112 8.87589 5.87287 8.87589 5.93591V10.0654C8.87589 10.1284 8.85566 10.1802 8.81519 10.2207C8.77472 10.2611 8.72297 10.2814 8.65993 10.0654V5.93591C8.65993 5.87287 8.64672 5.82112 8.61519 5.78065C8.57472 5.74018 8.52297 5.71995 8.45993 5.71995H7.13747C7.07443 5.71995 7.02267 5.74018 6.98221 5.78065C6.94174 5.82112 6.9215 5.87287 6.9215 5.93591V10.0654C6.9215 10.1284 6.94174 10.1802 6.98221 10.2207C7.02267 10.2611 7.07443 10.2814 7.13747 10.2814H8.45993C8.52297 10.2814 8.57472 10.2611 8.61519 10.2207C8.65566 10.1802 8.67589 10.1284 8.67589 10.0654V5.93591C8.67589 5.87287 8.65566 5.82112 8.61519 5.78065C8.57472 5.74018 8.52297 5.71995 8.45993 5.71995Z" fill="#6C757D" />
                                                            </svg>
                                                            None
                                                          </div>
                                                        ),
                                                        stage_failure_run_success: (
                                                          <div className='d-flex align-items-center text-success tw-w-[200px]'>
                                                            <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <path d="M10.6654 6.00065C8.08937 6.00065 5.9987 8.09132 5.9987 10.6673C5.9987 13.2433 8.08937 15.334 10.6654 15.334C13.2414 15.334 15.332 13.2433 15.332 10.6673C15.332 8.09132 13.2414 6.00065 10.6654 6.00065ZM9.4007 12.6693L7.72536 10.994C7.54337 10.812 7.54337 10.518 7.72536 10.336C7.90736 10.154 8.20136 10.154 8.38336 10.336L9.73203 11.68L12.9427 8.46932C13.1247 8.28732 13.4187 8.28732 13.6007 8.46932C13.7827 8.65132 13.7827 8.94532 13.6007 9.12732L10.0587 12.6693C9.88136 12.8513 9.5827 12.8513 9.4007 12.6693Z" fill="#50CD89" />
                                                              <path d="M4.66536 6.33398C4.75981 6.33398 4.83898 6.30204 4.90286 6.23815C4.96675 6.17426 4.9987 6.0951 4.9987 6.00065C4.9987 5.90621 4.96675 5.82704 4.90286 5.76315C4.83898 5.69926 4.75981 5.66732 4.66536 5.66732C4.57092 5.66732 4.49175 5.69926 4.42786 5.76315C4.36398 5.82704 4.33203 5.90621 4.33203 6.00065C4.33203 6.0951 4.36398 6.17426 4.42786 6.23815C4.49175 6.30204 4.57092 6.33398 4.66536 6.33398ZM4.33203 5.00065H4.9987V3.00065H4.33203V5.00065ZM4.66536 8.00065C4.20425 8.00065 3.77092 7.91315 3.36536 7.73815C2.95981 7.56315 2.60703 7.32565 2.30703 7.02565C2.00703 6.72565 1.76953 6.37287 1.59453 5.96732C1.41953 5.56176 1.33203 5.12843 1.33203 4.66732C1.33203 4.20621 1.41953 3.77287 1.59453 3.36732C1.76953 2.96176 2.00703 2.60898 2.30703 2.30898C2.60703 2.00898 2.95981 1.77148 3.36536 1.59648C3.77092 1.42148 4.20425 1.33398 4.66536 1.33398C5.12648 1.33398 5.55981 1.42148 5.96536 1.59648C6.37092 1.77148 6.7237 2.00898 7.0237 2.30898C7.3237 2.60898 7.5612 2.96176 7.7362 3.36732C7.9112 3.77287 7.9987 4.20621 7.9987 4.66732C7.9987 5.12843 7.9112 5.56176 7.7362 5.96732C7.5612 6.37287 7.3237 6.72565 7.0237 7.02565C6.7237 7.32565 6.37092 7.56315 5.96536 7.73815C5.55981 7.91315 5.12648 8.00065 4.66536 8.00065ZM4.66536 7.33398C5.40981 7.33398 6.04036 7.07565 6.55703 6.55898C7.0737 6.04232 7.33203 5.41176 7.33203 4.66732C7.33203 3.92287 7.0737 3.29232 6.55703 2.77565C6.04036 2.25898 5.40981 2.00065 4.66536 2.00065C3.92092 2.00065 3.29036 2.25898 2.7737 2.77565C2.25703 3.29232 1.9987 3.92287 1.9987 4.66732C1.9987 5.41176 2.25703 6.04232 2.7737 6.55898C3.29036 7.07565 3.92092 7.33398 4.66536 7.33398Z" fill="#F04438" />
                                                            </svg>  <span className='text-danger mr-1'>Stage Failure</span> Run Success
                                                          </div>
                                                        )
                                                      };

                                                      return statusMap[run_status] || "-";
                                                    })()}
                                                  </td>
                                                  <td>
                                                    <button class="btn btn-light" disabled={filteredPipeline.no_runs_found === true} onClick={() => this.setFullScreen(pipeline.p_integration_id, filteredPipeline.value, pipeline.integration_type, pipeline.label, filteredPipeline.label)}>
                                                      More
                                                      <i class="ml-1">
                                                        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><rect fill="none" height="24" width="16"></rect><path d="M15,5l-1.41,1.41L18.17,11H2V13h16.17l-4.59,4.59L15,19l7-7L15,5z"></path></svg>
                                                      </i>
                                                    </button>
                                                  </td>
                                                </tr>
                                              }
                                              {subIndex === this.state.visiblePipelineCount - 1 && piplineInfo?.pipelines?.[pipeline.p_integration_id]?.length > this.state.visiblePipelineCount &&
                                                <tr>
                                                  <td>
                                                    <div className="tbl-tree__expand-btn" onClick={() => this.loadMorePipelines(pipeline.p_integration_id)}>
                                                      <i>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                          <g clip-path="url(#clip0_18873_37011)">
                                                            <path d="M11.5265 3.80714C11.2665 3.54714 10.8465 3.54714 10.5865 3.80714L7.99982 6.38714L5.40648 3.80047C5.14648 3.54047 4.72648 3.54047 4.46648 3.80047C4.20648 4.06047 4.20648 4.48047 4.46648 4.74047L7.52648 7.80047C7.78648 8.06047 8.20648 8.06047 8.46648 7.80047L11.5265 4.74047C11.7865 4.48714 11.7865 4.06714 11.5265 3.80714Z" fill="currentColor" />
                                                            <path d="M11.5267 8.19971C11.2667 7.93971 10.8467 7.93971 10.5867 8.19971L7.99999 10.7797L5.41332 8.19305C5.15332 7.93305 4.73332 7.93305 4.47332 8.19305C4.21332 8.45305 4.21332 8.87305 4.47332 9.13305L7.53332 12.193C7.79332 12.453 8.21332 12.453 8.47332 12.193L11.5333 9.13305C11.7867 8.87971 11.7867 8.45971 11.5267 8.19971Z" fill="currentColor" />
                                                          </g>
                                                          <defs>
                                                            <clipPath id="clip0_18873_37011">
                                                              <rect width="16" height="16" fill="white" />
                                                            </clipPath>
                                                          </defs>
                                                        </svg>
                                                      </i>
                                                      {
                                                        (() => {
                                                          const visible = this.state.visiblePipelineCount;
                                                          const total = piplineInfo.pipelines[pipeline.p_integration_id]?.length || 0;
                                                          const remaining = total - visible;

                                                          if (remaining > 20) {
                                                            return `Load 20 More (Showing ${visible} of ${total})`;
                                                          } else if (remaining > 0) {
                                                            return `Show Remaining ${remaining} Job${remaining > 1 ? 's' : ''} (Showing ${visible} of ${total})`;
                                                          } else {
                                                            return `Showing ${total} of ${total}`;
                                                          }
                                                        })()
                                                      }
                                                    </div>
                                                  </td>
                                                  {this.state.initialendDate === this.state.endDate ?

                                                    <td class="border-bottom-0"><div class="tbl-time-range__content"><div class="tbl-time-range__cols"><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div></div>
                                                      <div className="tbl-time-range__now"></div>
                                                    </div></td> :
                                                    <td class="border-bottom-0"><div class="tbl-time-range__content"><div class="tbl-time-range__cols"><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div><div class="tbl-time-range__col"></div></div>
                                                    </div></td>
                                                  }
                                                  <td className="border-bottom-0"></td>
                                                  <td className="border-bottom-0"></td>
                                                  <td className="border-bottom-0"></td>
                                                  <td className="border-bottom-0"></td>
                                                  <td className="border-bottom-0"></td>
                                                  <td className="border-bottom-0"></td>
                                                  <td className="border-bottom-0"></td>
                                                </tr>}
                                              {this.state.expandedPipelineRows[filteredPipeline.value] && filteredPipeline.is_parent === true && Array.isArray(filteredPipeline.child_ids) &&
                                                (
                                                  <tr className="tbl-tree__nested has-no-caret">
                                                    <td colspan="9" className='p-0'>
                                                      <table className="table m-0">
                                                        <tbody>

                                                          {piplineInfo.pipelines[pipeline.p_integration_id] &&
                                                            filteredPipeline.is_parent &&
                                                            filteredPipeline.child_ids?.map((childId) => {

                                                              const filteredchildPipeline =
                                                                piplineInfo.pipelines[pipeline.p_integration_id]
                                                                  .find(p => p.label === childId || p.value === childId);

                                                              if (!filteredchildPipeline) return null;

                                                              return (
                                                                <React.Fragment key={filteredchildPipeline.value}>

                                                                  {/* Loader */}
                                                                  {this.state.fetchingJobsloader && this.state.searchText && (
                                                                    <tr>
                                                                      <td colSpan="10">
                                                                        <div className="tbl-tree__node">
                                                                          <Image width="12px" src={"icon_preloader"} alt="loader" className="ml-2" />
                                                                          <span className="text-light-gray">Fetching Jobs...</span>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                                                  )}

                                                                  {!this.state.fetchingJobsloader && (
                                                                    <tr
                                                                      className={`tbl-tree__parent ${this.state.selectedJobId === filteredchildPipeline.value ||
                                                                        (preSelectedDataset &&
                                                                          preSelectedDataset.label === filteredchildPipeline.label)
                                                                        ? "--is-active"
                                                                        : ""
                                                                        }`}
                                                                    >
                                                                      <td>
                                                                        <div class="tbl-tree__node">
                                                                          <div class="tbl-tree__node-label">
                                                                            <i class="tbl-tree__node-icon">
                                                                              <Image
                                                                                src={this.getConnectorIconSrc(
                                                                                  filteredchildPipeline.integration_type ||
                                                                                  filteredchildPipeline.pipeline_type ||
                                                                                  pipeline.integration_type ||
                                                                                  this.state.pipelineIconMapping?.[pipeline.p_integration_id]
                                                                                )}
                                                                                alt={filteredchildPipeline.integration_type || pipeline.integration_type || "default"}
                                                                                width="14"
                                                                                height="14"
                                                                              />
                                                                            </i>
                                                                            <div className="tbl-tree__node-text !tw-pr-0 !tw-flex !tw-overflow-visible !tw-items-center tw-w-full tw-whitespace-nowrap tw-flex-nowrap !tw-flex-row" onClick={() => {
                                                                              if (filteredchildPipeline.no_runs_found === true) {
                                                                                this.showToast("error", "No runs found");
                                                                                return;
                                                                              }
                                                                              if (this.state.isInFullScreenMode) {
                                                                                this.setFullScreen(pipeline.p_integration_id, filteredchildPipeline.value, pipeline.integration_type, pipeline.label, filteredchildPipeline.label)
                                                                              }
                                                                            }} style={{ cursor: 'pointer' }}>
                                                                              <RcTooltip
                                                                                placement="top"
                                                                                overlay={<span>{filteredPipeline.label}</span>}
                                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                              >
                                                                                <span class="portlet-table-value tw-truncate tw-w-[calc(100%-100px)] tw-inline-block">{filteredchildPipeline.label}</span>
                                                                              </RcTooltip>
                                                                              <span className="qd-badge-unmapped tw-inline-flex tw-items-center tw-px-1.5 tw-text-[10px] tw-font-medium tw-text-[#535862] dark:tw-text-[#B2B5BE] tw-bg-[#F4F4F5] dark:tw-bg-[#27272A] tw-border tw-border-solid tw-border-[#E4E4E7] dark:tw-border-[#3F3F46] tw-rounded tw-shrink-0 tw-whitespace-nowrap tw-ml-1.5">
                                                                                Suspended
                                                                              </span>
                                                                            </div>
                                                                          </div>
                                                                          <div className="tbl-tree__node-action d-none">
                                                                            <Dropdown alignRight className="wishlist-dropdown">
                                                                              <Dropdown.Toggle variant="" id="dropdown-basic" className="action-btn dropdown-caret-hide">
                                                                                <i className="action-icon"><FontAwesomeIcon icon={faEllipsisV} /></i>
                                                                              </Dropdown.Toggle>
                                                                              <Dropdown.Menu>
                                                                                <Dropdown.Item>
                                                                                  <i></i>Jobs Info
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item>
                                                                                  <i></i>All Runs
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item>
                                                                                  <i></i>Failed Runs
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item>
                                                                                  <i></i>Lineage
                                                                                </Dropdown.Item>
                                                                              </Dropdown.Menu>
                                                                            </Dropdown>
                                                                          </div>
                                                                        </div>
                                                                      </td>
                                                                      <td>
                                                                        <div class="tbl-time-range__content">
                                                                          <div class="tbl-time-range__cols">
                                                                            <div class="tbl-time-range__col">
                                                                              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M8 13.5H12V11.5H8V8.5L4 12.5L8 16.5V13.5ZM15 13.5C15.55 13.5 16 13.05 16 12.5C16 11.95 15.55 11.5 15 11.5C14.45 11.5 14 11.95 14 12.5C14 13.05 14.45 13.5 15 13.5Z" fill="#B5B8C2" />
                                                                                <path d="M18 4.5H20C20.5523 4.5 21 4.94772 21 5.5V19.5C21 20.0523 20.5523 20.5 20 20.5H18V4.5Z" fill="#B5B8C2" />
                                                                              </svg>
                                                                            </div>
                                                                            {(() => {



                                                                              /*
                                                                               Gannt Chart
                                                                              */

                                                                              const rawFilter = this.state.timefilter.replace("hr", "");
                                                                              const slotCount = ["12", "24"].includes(rawFilter) ? 13 : 7;

                                                                              return Array.from({ length: slotCount }).map((_, index) => {
                                                                                const { slotStart, slotEnd } = this.getGanttSlotBounds(index, slotCount);

                                                                                if (!filteredchildPipeline?.runs_list) {
                                                                                  return (
                                                                                    <div key={index} className="tbl-time-range__col" style={{ position: 'relative' }}>
                                                                                      <span />
                                                                                    </div>
                                                                                  );
                                                                                }

                                                                                const normalizedRuns = this.normalizeRunsList(filteredchildPipeline.runs_list);
                                                                                const runsInSlot = this.getRunsInTimeSlot(normalizedRuns, slotStart, slotEnd);
                                                                                const statusGroups = this.getRunStatusGroups(runsInSlot);

                                                                                if (!statusGroups.length) {
                                                                                  return (
                                                                                    <div key={index} className="tbl-time-range__col" style={{ position: 'relative' }}>
                                                                                      <span />
                                                                                    </div>
                                                                                  );
                                                                                }

                                                                                return (
                                                                                  !this.state.isInFullScreenMode && (
                                                                                    <div key={index} className="tbl-time-range__col" style={{ position: 'relative', overflow: 'hidden' }}>
                                                                                      {(() => {
                                                                                        const allSlotRuns = statusGroups.reduce((acc, group) => acc.concat(group.runs), []);
                                                                                        return (
                                                                                          <OverlayTrigger
                                                                                            trigger="click"
                                                                                            rootClose
                                                                                            placement="right"
                                                                                            overlay={
                                                                                              <Popover className="pipeline-popover">
                                                                                                <Popover.Title as="h3" id="pipeline_popover_title"></Popover.Title>
                                                                                                <Popover.Content>
                                                                                                  <div id="pipeline_popover_content"></div>
                                                                                                </Popover.Content>
                                                                                              </Popover>
                                                                                            }
                                                                                            onEntered={() => this.getGanttPopover(allSlotRuns, pipeline, filteredchildPipeline)}
                                                                                          >
                                                                                            <div
                                                                                              className={`pipeline-run-cell${statusGroups.length > 1 ? ' pipeline-run-cell--multi' : ''}`}
                                                                                              style={{
                                                                                                position: 'absolute',
                                                                                                left: '50%',
                                                                                                top: '50%',
                                                                                                transform: 'translate(-50%, -50%)',
                                                                                                cursor: 'pointer',
                                                                                                pointerEvents: 'auto',
                                                                                              }}
                                                                                            >
                                                                                              {statusGroups.map((group) => (
                                                                                                <span
                                                                                                  key={group.status}
                                                                                                  className={`pipeline-run-badge pipeline-run-badge--${group.status}`}
                                                                                                >
                                                                                                  {group.runs.length}
                                                                                                </span>
                                                                                              ))}
                                                                                            </div>
                                                                                          </OverlayTrigger>
                                                                                        );
                                                                                      })()}
                                                                                    </div>
                                                                                  )
                                                                                );
                                                                              });
                                                                            })()}

                                                                            <div class="tbl-time-range__col">
                                                                              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M16 13.5H12V11.5H16V8.5L20 12.5L16 16.5V13.5ZM9 13.5C8.45 13.5 8 13.05 8 12.5C8 11.95 8.45 11.5 9 11.5C9.55 11.5 10 11.95 10 12.5C10 13.05 9.55 13.5 9 13.5Z" fill="#B5B8C2" />
                                                                                <path d="M6 4.5H4C3.44772 4.5 3 4.94772 3 5.5V19.5C3 20.0523 3.44772 20.5 4 20.5H6V4.5Z" fill="#B5B8C2" />
                                                                              </svg>
                                                                            </div>
                                                                          </div>
                                                                          {
                                                                            this.state.initialendDate === this.state.endDate ?
                                                                              <div className="tbl-time-range__now"></div> : ""
                                                                          }
                                                                        </div>
                                                                      </td>
                                                                      <td>{this.formatUTCDate(filteredchildPipeline.job_runs_summary !== undefined && filteredchildPipeline.job_runs_summary.last_run)}</td>
                                                                      <td>{this.millisecondToMinutesAndSeconds(filteredchildPipeline.job_runs_summary !== undefined && filteredchildPipeline.job_runs_summary.last_run_duration)}</td>
                                                                      <td>{this.millisecondToMinutesAndSeconds(filteredchildPipeline.job_runs_summary !== undefined && filteredchildPipeline.job_runs_summary.avg_duration)}</td>
                                                                      <td>{this.formatUTCDate(filteredchildPipeline.job_runs_summary !== undefined && filteredchildPipeline.job_runs_summary.next_schedule_run)}</td>
                                                                      <td>
                                                                        <div class="tbl-job-attempts">
                                                                          <div class="badge success-attempt-badge">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor">
                                                                              <path d="M0 0h24v24H0z" fill="none"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path>
                                                                            </svg>
                                                                            <span class="text-dark">{this.getAttemptCountsFromPipeline(filteredchildPipeline).success}</span>
                                                                          </div>
                                                                          <div class="badge failed-attempt-badge ml-2">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor">
                                                                              <path d="M0 0h24v24H0z" fill="none"></path><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path>
                                                                            </svg>
                                                                            <span class="text-dark">{this.getAttemptCountsFromPipeline(filteredchildPipeline).failed}</span>
                                                                          </div>
                                                                        </div>
                                                                      </td>
                                                                      <td>
                                                                        {(() => {
                                                                          const status = filteredchildPipeline?.job_runs_summary?.last_run_status;
                                                                          if (!status) return "-";

                                                                          const run_status = status.toLowerCase();

                                                                          const statusMap = {
                                                                            succeeded: (
                                                                              <div class="d-flex align-items-center text-success">
                                                                                <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>
                                                                                Done
                                                                              </div>
                                                                            ),
                                                                            failed: (
                                                                              <div class="d-flex align-items-center text-danger"><svg class="mr-1" xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path></svg>Failed</div>

                                                                            ),
                                                                            running: (
                                                                              <div className="d-flex align-items-center text-info">
                                                                                <svg class="mr-1" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                  <g clip-path="url(#clip0_263_199)">
                                                                                    <path d="M16.24 7.76C15.07 6.59 13.54 6 12 6V12L7.76 16.24C10.1 18.58 13.9 18.58 16.25 16.24C18.59 13.9 18.59 10.1 16.24 7.76V7.76ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="#4CA3FF" />
                                                                                  </g>
                                                                                  <defs>
                                                                                    <clipPath id="clip0_263_199">
                                                                                      <rect width="24" height="24" fill="white" />
                                                                                    </clipPath>
                                                                                  </defs>
                                                                                </svg>
                                                                                &nbsp;Running
                                                                              </div>
                                                                            ),
                                                                            inprogress: (
                                                                              <div className='d-flex align-items-center text-primary'>
                                                                                <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="16px" viewBox="0 0 24 24" width="16px" fill="#495FB8"><g><rect fill="none" height="24" width="24" /></g><g><path d="M6,2l0.01,6L10,12l-3.99,4.01L6,22h12v-6l-4-4l4-3.99V2H6z M16,16.5V20H8v-3.5l4-4L16,16.5z" /></g></svg>
                                                                                In Progress
                                                                              </div>
                                                                            ),
                                                                            queued: (
                                                                              <div className='d-flex align-items-center text-primary'>
                                                                                <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#FFA800"><path d="M0 0h24v24H0z" fill="none" /><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z" /></svg>
                                                                                Queued
                                                                              </div>
                                                                            ),
                                                                            cancelled: (
                                                                              <div className='d-flex align-items-center text-primary'>
                                                                                <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#F64E60"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
                                                                                Cancelled
                                                                              </div>
                                                                            ),
                                                                            skipped: (
                                                                              <div className='d-flex align-items-center text-primary'>
                                                                                <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                  <path d="M11.4758 12.2096V3.79102H12.6654V12.2096H11.4758ZM3.33203 12.2096V3.79102L9.64585 8.00029L3.33203 12.2096Z" fill="#495FB8" />
                                                                                </svg>
                                                                                Skipped
                                                                              </div>
                                                                            ),
                                                                            restart: (
                                                                              <div className='d-flex align-items-center text-primary'>
                                                                                <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                  <path d="M7.2 14.9262C5.69947 14.7313 4.45767 14.0703 3.4746 12.9432C2.49153 11.816 2 10.4955 2 8.98159C2 8.16826 2.16053 7.38906 2.4816 6.64399C2.80267 5.89879 3.2524 5.24413 3.8308 4.67999L4.6862 5.53539C4.19487 5.98366 3.82433 6.50393 3.5746 7.09619C3.32487 7.68846 3.2 8.31693 3.2 8.98159C3.2 10.1549 3.5746 11.1891 4.3238 12.084C5.073 12.9788 6.03173 13.5262 7.2 13.7262V14.9262ZM8.8 14.9416V13.7416C9.95493 13.5077 10.9103 12.948 11.6662 12.0624C12.4221 11.1768 12.8 10.1499 12.8 8.98159C12.8 7.64826 12.3333 6.51493 11.4 5.58159C10.4667 4.64826 9.33333 4.18159 8 4.18159H7.717L8.797 5.26159L7.9538 6.10459L5.4308 3.58159L7.9538 1.05859L8.797 1.90159L7.717 2.98159H8C9.67387 2.98159 11.0923 3.56313 12.2554 4.72619C13.4185 5.88926 14 7.30773 14 8.98159C14 10.4872 13.5072 11.8011 12.5216 12.9232C11.5359 14.0452 10.2953 14.718 8.8 14.9416Z" fill="#FA4616" />
                                                                                </svg>
                                                                                Restart
                                                                              </div>
                                                                            ),
                                                                            none: (
                                                                              <div className='d-flex align-items-center text-primary'>
                                                                                <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                  <path d="M7.99993 14.6673C7.07782 14.6673 6.2111 14.4923 5.39975 14.1424C4.58841 13.7925 3.88267 13.3176 3.28256 12.7177C2.68244 12.1178 2.20729 11.4123 1.85712 10.6014C1.50706 9.79036 1.33203 8.92387 1.33203 8.00188C1.33203 7.07977 1.507 6.21305 1.85694 5.4017C2.20689 4.59036 2.6818 3.88463 3.28168 3.28451C3.88156 2.68439 4.587 2.20925 5.398 1.85907C6.20899 1.50901 7.07548 1.33398 7.99747 1.33398C8.91958 1.33398 9.7863 1.50895 10.5976 1.8589C11.409 2.20884 12.1147 2.68375 12.7148 3.28363C13.315 3.88352 13.7901 4.58896 14.1403 5.39995C14.4903 6.21094 14.6654 7.07743 14.6654 7.99942C14.6654 8.92153 14.4904 9.78825 14.1405 10.5996C13.7905 11.4109 13.3156 12.1167 12.7157 12.7168C12.1158 13.3169 11.4104 13.7921 10.5994 14.1422C9.78841 14.4923 8.92191 14.6673 7.99993 14.6673ZM7.33747 11.334H8.65993C9.00881 11.334 9.30747 11.2098 9.55589 10.9614C9.80431 10.7129 9.92852 10.4143 9.92852 10.0654V5.93591C9.92852 5.58703 9.80431 5.28837 9.55589 5.03995C9.30747 4.79153 9.00881 4.66732 8.65993 4.66732H7.33747C6.98858 4.66732 6.68993 4.79153 6.4415 5.03995C6.19308 5.28837 6.06887 5.58703 6.06887 5.93591V10.0654C6.06887 10.4143 6.19308 10.7129 6.4415 10.9614C6.68993 11.2098 6.98858 11.334 7.33747 11.334ZM7.33747 5.71995H8.65993C8.72297 5.71995 8.77472 5.74018 8.81519 5.78065C8.85566 5.82112 8.87589 5.87287 8.87589 5.93591V10.0654C8.87589 10.1284 8.85566 10.1802 8.81519 10.2207C8.77472 10.2611 8.72297 10.2814 8.65993 10.2814H7.33747C7.27443 10.2814 7.22267 10.2611 7.18221 10.2207C7.14174 10.1802 7.1215 10.1284 7.1215 10.0654V5.93591C7.1215 5.87287 7.14174 5.82112 7.18221 5.78065C7.22267 5.74018 7.27443 5.71995 7.33747 5.71995Z" fill="#6C757D" />
                                                                                </svg>
                                                                                None
                                                                              </div>
                                                                            ),
                                                                            stage_failure_run_success: (
                                                                              <div className='d-flex align-items-center text-success tw-w-[200px]'>
                                                                                <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                  <path d="M10.6654 6.00065C8.08937 6.00065 5.9987 8.09132 5.9987 10.6673C5.9987 13.2433 8.08937 15.334 10.6654 15.334C13.2414 15.334 15.332 13.2433 15.332 10.6673C15.332 8.09132 13.2414 6.00065 10.6654 6.00065ZM9.4007 12.6693L7.72536 10.994C7.54337 10.812 7.54337 10.518 7.72536 10.336C7.90736 10.154 8.20136 10.154 8.38336 10.336L9.73203 11.68L12.9427 8.46932C13.1247 8.28732 13.4187 8.28732 13.6007 8.46932C13.7827 8.65132 13.7827 8.94532 13.6007 9.12732L10.0587 12.6693C9.88136 12.8513 9.5827 12.8513 9.4007 12.6693Z" fill="#50CD89" />
                                                                                  <path d="M4.66536 6.33398C4.75981 6.33398 4.83898 6.30204 4.90286 6.23815C4.96675 6.17426 4.9987 6.0951 4.9987 6.00065C4.9987 5.90621 4.96675 5.82704 4.90286 5.76315C4.83898 5.69926 4.75981 5.66732 4.66536 5.66732C4.57092 5.66732 4.49175 5.69926 4.42786 5.76315C4.36398 5.82704 4.33203 5.90621 4.33203 6.00065C4.33203 6.0951 4.36398 6.17426 4.42786 6.23815C4.49175 6.30204 4.57092 6.33398 4.66536 6.33398ZM4.33203 5.00065H4.9987V3.00065H4.33203V5.00065ZM4.66536 8.00065C4.20425 8.00065 3.77092 7.91315 3.36536 7.73815C2.95981 7.56315 2.60703 7.32565 2.30703 7.02565C2.00703 6.72565 1.76953 6.37287 1.59453 5.96732C1.41953 5.56176 1.33203 5.12843 1.33203 4.66732C1.33203 4.20621 1.41953 3.77287 1.59453 3.36732C1.76953 2.96176 2.00703 2.60898 2.30703 2.30898C2.60703 2.00898 2.95981 1.77148 3.36536 1.59648C3.77092 1.42148 4.20425 1.33398 4.66536 1.33398C5.12648 1.33398 5.55981 1.42148 5.96536 1.59648C6.37092 1.77148 6.7237 2.00898 7.0237 2.30898C7.3237 2.60898 7.5612 2.96176 7.7362 3.36732C7.9112 3.77287 7.9987 4.20621 7.9987 4.66732C7.9987 5.12843 7.9112 5.56176 7.7362 5.96732C7.5612 6.37287 7.3237 6.72565 7.0237 7.02565C6.7237 7.32565 6.37092 7.56315 5.96536 7.73815C5.55981 7.91315 5.12648 8.00065 4.66536 8.00065ZM4.66536 7.33398C5.40981 7.33398 6.04036 7.07565 6.55703 6.55898C7.0737 6.04232 7.33203 5.41176 7.33203 4.66732C7.33203 3.92287 7.0737 3.29232 6.55703 2.77565C6.04036 2.25898 5.40981 2.00065 4.66536 2.00065C3.92092 2.00065 3.29036 2.25898 2.7737 2.77565C2.25703 3.29232 1.9987 3.92287 1.9987 4.66732C1.9987 5.41176 2.25703 6.04232 2.7737 6.55898C3.29036 7.07565 3.92092 7.33398 4.66536 7.33398Z" fill="#F04438" />
                                                                                </svg>  <span className='text-danger mr-1'>Stage Failure</span> Run Success
                                                                              </div>
                                                                            )
                                                                          };

                                                                          return statusMap[run_status] || "-";
                                                                        })()}
                                                                      </td>
                                                                      <td>
                                                                        <button class="btn btn-light" disabled={filteredchildPipeline.no_runs_found === true} onClick={() =>
                                                                          this.setFullScreen(pipeline.p_integration_id, filteredchildPipeline.value, pipeline.integration_type, pipeline.label, filteredchildPipeline.label)
                                                                        }
                                                                        >
                                                                          More
                                                                          <i class="ml-1">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="14px" viewBox="0 0 24 24" width="14px" fill="currentColor"><rect fill="none" height="24" width="16"></rect><path d="M15,5l-1.41,1.41L18.17,11H2V13h16.17l-4.59,4.59L15,19l7-7L15,5z"></path></svg>
                                                                          </i>
                                                                        </button>
                                                                      </td>
                                                                    </tr>
                                                                  )}

                                                                </React.Fragment>
                                                              );
                                                            })
                                                          }
                                                        </tbody>
                                                      </table>
                                                    </td>
                                                  </tr>
                                                )}

                                            </>

                                          )))}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>

                              <tr>
                                <td></td>
                                <td className="border-bottom-0">
                                  <div class="tbl-time-range__content">
                                    <div class="tbl-time-range__cols">
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                      <div class="tbl-time-range__col"></div>
                                    </div>
                                    {this.state.initialendDate === this.state.endDate ? <div className="tbl-time-range__now"></div> : ""}
                                  </div>
                                </td>
                                <td className="border-bottom-0"></td>
                                <td className="border-bottom-0"></td>
                                <td className="border-bottom-0"></td>
                                <td className="border-bottom-0"></td>
                                <td className="border-bottom-0"></td>
                                <td className="border-bottom-0"></td>
                                <td className="border-bottom-0"></td>
                              </tr>

                            </>)
                          )}
                      </tbody>
                      <tbody style={{ borderTop: '0' }} id="metaDataBody">
                        <tr className='tbl-tree__parent'>
                          <td colSpan={9} className='p-0 border-0'>
                            <table className='table m-0'>
                              <tbody>
                                <tr class="emptyrow tbl-tree__parent">
                                  <td></td>
                                  <td className="border-bottom-0">
                                    <div>
                                      <div class="tbl-time-range__content">
                                        <div class="tbl-time-range__cols">
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                          <div class="tbl-time-range__col"></div>
                                        </div>
                                        {/* <div className="tbl-time-range__now" style={{backgroundColor: '#007BFF'}}></div> */}
                                      </div>
                                    </div>
                                  </td>
                                  <td className="border-bottom-0"></td>
                                  <td className="border-bottom-0"></td>
                                  <td className="border-bottom-0"></td>
                                  <td className="border-bottom-0"></td>
                                  <td className="border-bottom-0"></td>
                                  <td className="border-bottom-0"></td>
                                  <td className="border-bottom-0"></td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>

                    </table>
                  </div>
                  <div class="rt-pipeline__bottom">
                    <div className="rt-pipeline__bottom-left">
                      <div className="react-bootstrap-table__footer">
                        {/* Pagination */}
                        {/* {this.state.totalItems > 0  && (piplineInfo.integrations !==undefined && piplineInfo.integrations.length !== 1) && this.state.selectedWatchListId === undefined && ( */}
                        {this.state.totalItems > 0 && (
                          <ul class="pagination react-bootstrap-table-page-btns-ul mb-0">
                            {/* Previous Button */}
                            <li
                              class={`page-item ${this.state.currentPage === 1 ? "disabled" : ""}`}
                              title="Previous Page"
                              onClick={() => this.changePage(this.state.currentPage - 1)}
                            >
                              <a href="#!" class="page-link">&lt;</a>
                            </li>

                            {/* Show only 5 page numbers dynamically */}
                            {(() => {
                              const maxPagesToShow = 5;
                              let startPage = Math.max(this.state.currentPage - Math.floor(maxPagesToShow / 2), 1);
                              let endPage = startPage + maxPagesToShow - 1;

                              // Ensure `endPage` doesn't exceed `totalPages`
                              if (endPage > this.state.totalPages) {
                                endPage = this.state.totalPages;
                                startPage = Math.max(endPage - maxPagesToShow + 1, 1);
                              }

                              const pageNumbers = [];
                              for (let i = startPage; i <= endPage; i++) {
                                pageNumbers.push(i);
                              }

                              return pageNumbers.map((pageNum) => (
                                <li
                                  key={pageNum}
                                  class={`page-item ${this.state.currentPage === pageNum ? "active" : ""}`}
                                  title={`Page ${pageNum}`}
                                  onClick={() => this.changePage(pageNum)}
                                >
                                  <a href="#!" class="page-link">{pageNum}</a>
                                </li>
                              ));
                            })()}

                            {/* Next Button */}
                            <li
                              className={`page-item ${this.state.currentPage === this.state.totalPages ? "disabled" : ""}`}
                              title="Next Page"
                              onClick={() => this.changePage(this.state.currentPage + 1)}
                            >
                              <a href="#!" className="page-link">&gt;</a>
                            </li>
                          </ul>
                        )}
                      </div>
                    </div>
                    <div className="rt-pipeline__bottom-right">
                      <div class="qd-rt_bottom-panel">
                        <div class="qd-rt_bp-head">
                          <div class="content">
                            <div class="caption">
                              <h6>
                                <i class="position-relative mx-2">
                                  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 9.5V7.91667H11.5V9.5H0ZM0 5.54167V3.95833H11.5V5.54167H0ZM0 1.58333V0H11.5V1.58333H0Z" fill="#333333"></path>
                                  </svg>
                                  <sup class="error-indicator">
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M5 7.26392C5.14167 7.26392 5.26042 7.21751 5.35625 7.1247C5.45208 7.03188 5.5 6.91687 5.5 6.77966C5.5 6.64245 5.45208 6.52744 5.35625 6.43462C5.26042 6.34181 5.14167 6.2954 5 6.2954C4.85833 6.2954 4.73958 6.34181 4.64375 6.43462C4.54792 6.52744 4.5 6.64245 4.5 6.77966C4.5 6.91687 4.54792 7.03188 4.64375 7.1247C4.73958 7.21751 4.85833 7.26392 5 7.26392ZM5 5.32688C5.14167 5.32688 5.26042 5.28047 5.35625 5.18765C5.45208 5.09483 5.5 4.97982 5.5 4.84262V2.90557C5.5 2.76836 5.45208 2.65335 5.35625 2.56053C5.26042 2.46772 5.14167 2.42131 5 2.42131C4.85833 2.42131 4.73958 2.46772 4.64375 2.56053C4.54792 2.65335 4.5 2.76836 4.5 2.90557V4.84262C4.5 4.97982 4.54792 5.09483 4.64375 5.18765C4.73958 5.28047 4.85833 5.32688 5 5.32688ZM5 9.68523C4.30833 9.68523 3.65833 9.55811 3.05 9.30387C2.44167 9.04964 1.9125 8.7046 1.4625 8.26877C1.0125 7.83293 0.65625 7.32042 0.39375 6.73124C0.13125 6.14205 0 5.51251 0 4.84262C0 4.17272 0.13125 3.54318 0.39375 2.95399C0.65625 2.36481 1.0125 1.8523 1.4625 1.41646C1.9125 0.98063 2.44167 0.635593 3.05 0.381356C3.65833 0.127119 4.30833 0 5 0C5.69167 0 6.34167 0.127119 6.95 0.381356C7.55833 0.635593 8.0875 0.98063 8.5375 1.41646C8.9875 1.8523 9.34375 2.36481 9.60625 2.95399C9.86875 3.54318 10 4.17272 10 4.84262C10 5.51251 9.86875 6.14205 9.60625 6.73124C9.34375 7.32042 8.9875 7.83293 8.5375 8.26877C8.0875 8.7046 7.55833 9.04964 6.95 9.30387C6.34167 9.55811 5.69167 9.68523 5 9.68523Z" fill="#F64E60"></path>
                                    </svg>
                                  </sup>
                                </i>Incidents
                              </h6>
                            </div>
                          </div>
                          <div class="actions">
                            <button class="btn">
                              <i>
                                {/* Panel FullScreen */}
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M8.4135 12.0695H15.5865L12 8.47348L8.4135 12.0695ZM5.30775 21.0215C4.80908 21.0215 4.38308 20.8449 4.02975 20.4917C3.67658 20.1384 3.5 19.7124 3.5 19.2137V5.82923C3.5 5.33057 3.67658 4.90457 4.02975 4.55123C4.38308 4.19807 4.80908 4.02148 5.30775 4.02148H18.6923C19.1909 4.02148 19.6169 4.19807 19.9703 4.55123C20.3234 4.90457 20.5 5.33057 20.5 5.82923V19.2137C20.5 19.7124 20.3234 20.1384 19.9703 20.4917C19.6169 20.8449 19.1909 21.0215 18.6923 21.0215H5.30775ZM5 16.5215V19.2137C5 19.2907 5.03208 19.3612 5.09625 19.4252C5.16025 19.4894 5.23075 19.5215 5.30775 19.5215H18.6923C18.7692 19.5215 18.8398 19.4894 18.9038 19.4252C18.9679 19.3612 19 19.2907 19 19.2137V16.5215H5ZM5 15.0215H19V5.82923C19 5.75223 18.9679 5.68173 18.9038 5.61773C18.8398 5.55357 18.7692 5.52148 18.6923 5.52148H5.30775C5.23075 5.52148 5.16025 5.55357 5.09625 5.61773C5.03208 5.68173 5 5.75223 5 5.82923V15.0215Z" fill="#484848" />
                                </svg>
                              </i>
                            </button>
                          </div>
                        </div>
                        <div class="qd-rt_bp-body">
                          <div class="d-flex align-items-center justify-content-center p-5 h-100">
                            <div class="spinner-border text-info" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {this.state.selectedJobId !== "" && this.state.lienage_graph_type !== "run-level" && <div className="rt-pipeline-panel">
                    {this.renderFullScreen(pipelinesource_data, piplineInfo, tableData)}
                  </div>
                  }
                  {this.state.lienage_graph_type === "run-level" &&
                    this.renderRunsPanel()
                  }

                  <div className="rt-dropdown_backdrop"></div>
                </div>)
        }

        {this.state.autocompletemodal === true && this.state.inputData !== null

          &&
          <AdvancedSearch
            tab_type={3}
            inputData={this.state.inputData}
            autocompletemodal={this.state.autocompletemodal}
            handleCloseAutoCompleteModal={this.handleCloseAutoCompleteModal}
            preSelectedDataset={preSelectedDataset}
            preSelectedDatasource={preSelectedDatasource}
            renderSearchData={this.renderSearchData}
            watchListMapping={this.state.watchListMapping}
            handleWatchlistChange={this.handleWatchlistChange}
            pipelineIconMapping={this.state.pipelineIconMapping}
            selectedEnvId={this.props.selectedEnvId}
            getPipelineResponse={this.getPipelineResponse}
            isCheackedActiveRuns={this.state.isCheackedActiveRuns}


          />
        }

        {this.state.toastStatus &&
          (
            <div id="toastMsg">
              <Toast className={this.state.toastClass}
                show={this.state.toastStatus}
                onClose={() => this.setState({ toastStatus: false })}
                delay={3000}
                autohide>
                <div className="d-flex align-items-center">
                  {this.state.toastStatus ?
                    <i className="toast-icon">
                      <FontAwesomeIcon icon={this.state.toastIcon} /></i> : ''}
                  <Toast.Body>
                    <div className="toast-content">
                      <strong className="toast-title">{this.state.toastHeading}</strong>
                      <p>{this.state.toastMsg}</p>
                    </div>
                  </Toast.Body>
                  <button type="button" onClick={this.closeToast} className="close" data-dismiss="toast" aria-label="Close" />
                </div>
              </Toast>
            </div>
          )
        }
        {<div className="position-fixed p-3" style={{ top: '100px', right: '0', zIndex: '5' }}>
          <Toast
            className='toast-dark p-0 m-0'
            show={this.state.showIncidentToast}
            onClose={this.handleCloseIncidentToast}
            delay={3000}
            autohide
          >
            <Toast.Body>
              <div className="d-flex align-items-center p-2">
                <div class="toast-icon-wrap">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.15571 26.3795C4.94135 26.3795 4.74649 26.3259 4.57111 26.2188C4.39573 26.1116 4.25932 25.9703 4.16189 25.7949C4.06446 25.6195 4.01087 25.4295 4.00112 25.2249C3.99138 25.0203 4.04497 24.8206 4.16189 24.6257L14.977 5.91858C15.0939 5.72372 15.2449 5.57757 15.43 5.48013C15.6151 5.3827 15.8051 5.33398 16 5.33398C16.1949 5.33398 16.3849 5.3827 16.57 5.48013C16.7551 5.57757 16.9061 5.72372 17.023 5.91858L27.8381 24.6257C27.955 24.8206 28.0086 25.0203 27.9989 25.2249C27.9891 25.4295 27.9355 25.6195 27.8381 25.7949C27.7407 25.9703 27.6043 26.1116 27.4289 26.2188C27.2535 26.3259 27.0586 26.3795 26.8443 26.3795H5.15571ZM16 22.8719C16.3313 22.8719 16.609 22.7599 16.8331 22.5358C17.0571 22.3117 17.1692 22.034 17.1692 21.7027C17.1692 21.3715 17.0571 21.0938 16.8331 20.8697C16.609 20.6456 16.3313 20.5335 16 20.5335C15.6687 20.5335 15.391 20.6456 15.1669 20.8697C14.9429 21.0938 14.8308 21.3715 14.8308 21.7027C14.8308 22.034 14.9429 22.3117 15.1669 22.5358C15.391 22.7599 15.6687 22.8719 16 22.8719ZM16 19.3643C16.3313 19.3643 16.609 19.2523 16.8331 19.0282C17.0571 18.8041 17.1692 18.5264 17.1692 18.1951V14.6876C17.1692 14.3563 17.0571 14.0786 16.8331 13.8545C16.609 13.6304 16.3313 13.5184 16 13.5184C15.6687 13.5184 15.391 13.6304 15.1669 13.8545C14.9429 14.0786 14.8308 14.3563 14.8308 14.6876V18.1951C14.8308 18.5264 14.9429 18.8041 15.1669 19.0282C15.391 19.2523 15.6687 19.3643 16 19.3643Z" fill="#FFD500" />
                  </svg>
                </div>
                <div class="toast-content px-3">
                  <h6 className='text-white'>No Active Runs Found</h6>
                  <p className='text-white'><span className='opacity-50'>No Active Runs were found in the pipeline</span></p>
                </div>
                <div class="toast-action mr-2">
                  <button type="button" class="close" onClick={this.handleCloseIncidentToast}></button>
                </div>
              </div>
            </Toast.Body>
          </Toast>
        </div>}
        {this.state.enableFadeLoader === true && <div className="qd-blur-loader show"></div>}
      </>
    )
  }
}
